/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type SendNewVolunteerMatchRequestEmailInput = {
  organizationID: string,
  volunteerProfileID: string,
};

export type SendInvitationEmailInput = {
  organizationName: string,
  fromEmail: string,
  fromName: string,
  toEmail: string,
  toPhoneNumber?: string | null,
  toName?: string | null,
  code: string,
  organizationId: string,
};

export type sendPhoneCallScriptEmailInput = {
  firstName: string,
  lastName: string,
  toEmail: string,
  phoneCallScript: string,
  organizationID?: string | null,
};

export type GetStreamKeyInput = {
  userId: string,
};

export type CreateVolunteerProfileInput = {
  id?: string | null,
  authAccountID: string,
  email: string,
  firstName?: string | null,
  lastName?: string | null,
  gender?: GenderType | null,
  dateOfBirth?: string | null,
  streetAddress?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: number | null,
  website?: string | null,
  enneagram?: number | null,
  enneagramWing?: number | null,
  myersBriggs?: string | null,
  additionalInformation?: string | null,
  availabilityStringified?: string | null,
  latitude?: number | null,
  longitude?: number | null,
};

export enum GenderType {
  male = "male",
  female = "female",
  other = "other",
}


export type ModelVolunteerProfileConditionInput = {
  authAccountID?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  gender?: ModelGenderTypeInput | null,
  dateOfBirth?: ModelStringInput | null,
  streetAddress?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  zip?: ModelIntInput | null,
  website?: ModelStringInput | null,
  enneagram?: ModelIntInput | null,
  enneagramWing?: ModelIntInput | null,
  myersBriggs?: ModelStringInput | null,
  additionalInformation?: ModelStringInput | null,
  availabilityStringified?: ModelStringInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  and?: Array< ModelVolunteerProfileConditionInput | null > | null,
  or?: Array< ModelVolunteerProfileConditionInput | null > | null,
  not?: ModelVolunteerProfileConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelGenderTypeInput = {
  eq?: GenderType | null,
  ne?: GenderType | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type VolunteerProfile = {
  __typename: "VolunteerProfile",
  id: string,
  authAccountID: string,
  email: string,
  firstName?: string | null,
  lastName?: string | null,
  gender?: GenderType | null,
  dateOfBirth?: string | null,
  streetAddress?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: number | null,
  website?: string | null,
  enneagram?: number | null,
  enneagramWing?: number | null,
  myersBriggs?: string | null,
  additionalInformation?: string | null,
  availabilityStringified?: string | null,
  latitude?: number | null,
  longitude?: number | null,
  skills?: ModelVolunteerSkillConnection | null,
  causes?: ModelVolunteerCauseConnection | null,
  createdAt: string,
  updatedAt: string,
  authAccount?: AuthAccount | null,
};

export type ModelVolunteerSkillConnection = {
  __typename: "ModelVolunteerSkillConnection",
  items:  Array<VolunteerSkill | null >,
  nextToken?: string | null,
};

export type VolunteerSkill = {
  __typename: "VolunteerSkill",
  id: string,
  skillID: string,
  volunteerProfileID: string,
  volunteerProfile: VolunteerProfile,
  createdAt: string,
  updatedAt: string,
  skill?: Skill | null,
};

export type Skill = {
  __typename: "Skill",
  id: string,
  key: string,
  name: string,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelVolunteerCauseConnection = {
  __typename: "ModelVolunteerCauseConnection",
  items:  Array<VolunteerCause | null >,
  nextToken?: string | null,
};

export type VolunteerCause = {
  __typename: "VolunteerCause",
  id: string,
  causeID: string,
  cause?: Cause | null,
  volunteerProfileID: string,
  volunteerProfile: VolunteerProfile,
  createdAt: string,
  updatedAt: string,
};

export type Cause = {
  __typename: "Cause",
  id: string,
  key: string,
  name: string,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type AuthAccount = {
  __typename: "AuthAccount",
  id: string,
  volunteerProfileID?: string | null,
  volunteerProfile?: VolunteerProfile | null,
  lastSelectedStaffProfileID?: string | null,
  lastSelectedFundraisingProfileID?: string | null,
  communicationsProfileID?: string | null,
  name?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  primaryEmail?: string | null,
  phoneNumber?: string | null,
  dateOfBirth?: string | null,
  gender?: string | null,
  selfDescribedGender?: string | null,
  addressID?: string | null,
  website?: string | null,
  resumeURI?: string | null,
  bio?: string | null,
  profilePictureURI?: string | null,
  headerVideoURI?: string | null,
  headerImageURI?: string | null,
  headerAssetShown?: string | null,
  flourishAdmin?: boolean | null,
  createdAt: string,
  updatedAt: string,
  cognitoAccounts?: ModelCognitoAccountConnection | null,
  owner?: string | null,
  staffProfile?: ModelStaffProfileConnection | null,
  lastSelectedStaffProfile?: StaffProfile | null,
  communicationsProfile?: CommunicationsProfile | null,
  fundraisingProfiles?: ModelFundraisingProfileConnection | null,
  lastSelectedFundraisingProfile?: FundraisingProfile | null,
  address?: Address | null,
};

export type ModelCognitoAccountConnection = {
  __typename: "ModelCognitoAccountConnection",
  items:  Array<CognitoAccount | null >,
  nextToken?: string | null,
};

export type CognitoAccount = {
  __typename: "CognitoAccount",
  id: string,
  cognitoID: string,
  authAccountID?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
  authAccount?: AuthAccount | null,
};

export type ModelStaffProfileConnection = {
  __typename: "ModelStaffProfileConnection",
  items:  Array<StaffProfile | null >,
  nextToken?: string | null,
};

export type StaffProfile = {
  __typename: "StaffProfile",
  id: string,
  authAccountID?: string | null,
  organizationID?: string | null,
  role?: StaffProfileRole | null,
  name?: string | null,
  nylasAccountID?: string | null,
  nylasCalendarToken?: string | null,
  nylasPrimaryCalendarID?: string | null,
  createdAt: string,
  updatedAt: string,
  authAccount?: AuthAccount | null,
  owner?: string | null,
  organization?: Organization | null,
};

export enum StaffProfileRole {
  admin = "admin",
  staff = "staff",
  superVolunteer = "superVolunteer",
}


export type Organization = {
  __typename: "Organization",
  id: string,
  name: string,
  shortName?: string | null,
  description?: string | null,
  locationID?: string | null,
  website?: string | null,
  phoneNumber?: string | null,
  stripeConnectedAccountID?: string | null,
  stripeConnectedAccountStatus?: string | null,
  headerImageURI?: string | null,
  ambassadorTermOverrideSingular?: string | null,
  ambassadorTermOverridePlural?: string | null,
  streamJwt?: string | null,
  latentSubscription?: number | null,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  designation?: string | null,
  detailsID?: string | null,
  details?: OrganizationDetails | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
  location?: Location | null,
};

export type OrganizationDetails = {
  __typename: "OrganizationDetails",
  id: string,
  organizationID: string,
  missionStatement?: string | null,
  serveStatement?: string | null,
  doStatement?: string | null,
  costToDoStatement?: string | null,
  missionArea?: string | null,
  annualBudget?: string | null,
  currentMonthlyRecurringDonors?: string | null,
  averageMonthlyRecurringDonation?: string | null,
  percentageOfBudgetFromIndividualDonors?: string | null,
  numberOfMajorDonors?: string | null,
  averageOneTimeDonation?: string | null,
  percentageOfBudgetFromGrants?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type Location = {
  __typename: "Location",
  id: string,
  type: LocationType,
  name: string,
  details?: string | null,
  addressID?: string | null,
  organizationID?: string | null,
  createdAt: string,
  updatedAt: string,
  organization?: Organization | null,
  owner?: string | null,
  address?: Address | null,
};

export enum LocationType {
  physical = "physical",
  remote = "remote",
  various = "various",
}


export type Address = {
  __typename: "Address",
  id: string,
  streetAddress?: string | null,
  unit?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  zipPlusFour?: string | null,
  longitude?: number | null,
  latitude?: number | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type CommunicationsProfile = {
  __typename: "CommunicationsProfile",
  id: string,
  authAccountID: string,
  streamJwt?: string | null,
  notificationSettingsID?: string | null,
  notificationSettings?: NotificationSettings | null,
  createdAt: string,
  updatedAt: string,
  authAccount?: AuthAccount | null,
  owner?: string | null,
};

export type NotificationSettings = {
  __typename: "NotificationSettings",
  id: string,
  communicationsProfileID: string,
  allowPushNotifications: boolean,
  allowTextMessages: boolean,
  allowEmail: boolean,
  preference?: NotificationPreference | null,
  createdAt: string,
  updatedAt: string,
  communicationsProfile?: CommunicationsProfile | null,
};

export enum NotificationPreference {
  pushNotification = "pushNotification",
  text = "text",
  email = "email",
}


export type ModelFundraisingProfileConnection = {
  __typename: "ModelFundraisingProfileConnection",
  items:  Array<FundraisingProfile | null >,
  nextToken?: string | null,
};

export type FundraisingProfile = {
  __typename: "FundraisingProfile",
  id: string,
  authAccountID?: string | null,
  organizationID?: string | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  classyMemberID?: string | null,
  createdAt: string,
  updatedAt: string,
  authAccount?: AuthAccount | null,
  owner?: string | null,
  organization?: Organization | null,
  campaigns?: ModelFundraisingCampaignAmbassadorConnection | null,
};

export type ModelFundraisingCampaignAmbassadorConnection = {
  __typename: "ModelFundraisingCampaignAmbassadorConnection",
  items:  Array<FundraisingCampaignAmbassador | null >,
  nextToken?: string | null,
};

export type FundraisingCampaignAmbassador = {
  __typename: "FundraisingCampaignAmbassador",
  id: string,
  status?: FundraisingCampaignAmbassadorStatus | null,
  commitment?: FundraisingCampaignAmbassadorCommitment | null,
  fundraisingProfileID: string,
  fundraisingCampaignID: string,
  discoveryCallParticipantID?: string | null,
  fundsRaised?: number | null,
  initialTransactionID?: string | null,
  initialTransactionAmount?: number | null,
  ambassadorSpecificCtaUrl?: string | null,
  ambassadorSpecificVideoUrl?: string | null,
  recruitedByCampaignAmbassadorID?: string | null,
  classyTeamID?: string | null,
  classySupporterID?: string | null,
  classyFundraiserPageID?: string | null,
  notificationsEnabled?: boolean | null,
  createdAt: string,
  updatedAt: string,
  fundraisingProfile?: FundraisingProfile | null,
  fundraisingCampaign?: FundraisingCampaign | null,
  discoveryCallParticipant?: DiscoveryCallParticipant | null,
  owner?: string | null,
  recruitedByCampaignAmbassador?: FundraisingCampaignAmbassador | null,
  fundraisingCampaignAmbassadorContacts?: ModelFundraisingCampaignAmbassadorContactConnection | null,
};

export enum FundraisingCampaignAmbassadorStatus {
  Connected = "Connected",
  Waiting = "Waiting",
  Accepted = "Accepted",
  Declined = "Declined",
}


export enum FundraisingCampaignAmbassadorCommitment {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}


export type FundraisingCampaign = {
  __typename: "FundraisingCampaign",
  id: string,
  type: FundraisingCampaignType,
  organizationID: string,
  staffLeadID?: string | null,
  campaignName?: string | null,
  introVideoURI?: string | null,
  textMessageTemplate?: string | null,
  initialMessageReminderTemplate?: string | null,
  phoneCallScriptTemplate?: string | null,
  followUpMessageTemplate?: string | null,
  followUpYesMessageTemplate?: string | null,
  followUpNoMessageTemplate?: string | null,
  followUpReminderMessageTemplate?: string | null,
  showVideo?: boolean | null,
  showText?: boolean | null,
  showCall?: boolean | null,
  showFollowUp?: boolean | null,
  active?: boolean | null,
  publicVideoID?: string | null,
  publicVideoProvider?: string | null,
  campaignStartDate?: string | null,
  campaignStartTime?: string | null,
  campaignTimeZone?: string | null,
  campaignEndDate?: string | null,
  campaignEndTime?: string | null,
  publicCampaignAbout?: string | null,
  publicCampaignIntro?: string | null,
  campaignGoal?: number | null,
  perAmbassadorGoal?: number | null,
  totalAmbassadorsGoal?: number | null,
  perContactDonationGoal?: number | null,
  progressChartType?: string | null,
  ctaURL?: string | null,
  pageLayout?: string | null,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  buttonBackgroundColor?: string | null,
  buttonTextColor?: string | null,
  customHeaderImageUploaded?: boolean | null,
  customLogoImageUploaded?: boolean | null,
  headerFont?: string | null,
  bodyFont?: string | null,
  ctaButtonText?: string | null,
  givingCircleBaseAmount?: number | null,
  givingCircleIncrements?: Array< number | null > | null,
  givingCircleAllowCustomAmounts?: boolean | null,
  ambassadorSpecificVideoUrlEnabled?: boolean | null,
  ambassadorCanUploadVideoUrl?: boolean | null,
  ambassadorSpecificCtaUrlEnabled?: boolean | null,
  ambassadorCanUploadCtaUrl?: boolean | null,
  crowbarVideoURL?: string | null,
  recruitmentForCampaignID?: string | null,
  classyCampaignID?: string | null,
  classyAutogenerateAmbassadorTeams?: boolean | null,
  classyDonationPageHostURL?: string | null,
  useClassyCtaURL?: boolean | null,
  useClassyFundraiserPage?: boolean | null,
  personalFundraisingCampaignID?: string | null,
  onDemandDiscoveryMeetingEnabled?: boolean | null,
  onDemandDiscoveryMeetingURL?: string | null,
  onDemandDiscoveryMeetingID?: string | null,
  onDemandDiscoveryMeetingInvitationCode?: string | null,
  CampaignConversationFlows?: ModelCampaignConversationFlowConnection | null,
  defaultConversationFlowID?: string | null,
  defaultConversationFlow?: CampaignConversationFlow | null,
  useConversationFlows?: boolean | null,
  campaignPageID?: string | null,
  ambassadorPageID?: string | null,
  donationPageID?: string | null,
  discoveryPageID?: string | null,
  projectID?: string | null,
  project?: Project | null,
  subscriptionDonationTiers?: ModelSubscriptionDonationTierConnection | null,
  useActionCardView?: boolean | null,
  createdAt: string,
  updatedAt: string,
  staffLead?: StaffProfile | null,
  organization?: Organization | null,
  owner?: string | null,
  recruitmentForCampaign?: FundraisingCampaign | null,
  personalFundraisingCampaign?: FundraisingCampaign | null,
  campaignPage?: CampaignPage | null,
  ambassadorPage?: CampaignPage | null,
  donationPage?: CampaignPage | null,
  discoveryPage?: CampaignPage | null,
  onDemandDiscoveryMeeting?: FundraisingCampaignDiscoveryCall | null,
};

export enum FundraisingCampaignType {
  AmbassadorRecruiting = "AmbassadorRecruiting",
  TenX = "TenX",
  GivingCircle = "GivingCircle",
  EventInvite = "EventInvite",
  ImmediateNeed = "ImmediateNeed",
  Encouragement = "Encouragement",
}


export type ModelCampaignConversationFlowConnection = {
  __typename: "ModelCampaignConversationFlowConnection",
  items:  Array<CampaignConversationFlow | null >,
  nextToken?: string | null,
};

export type CampaignConversationFlow = {
  __typename: "CampaignConversationFlow",
  id: string,
  fundraisingCampaignID: string,
  name: string,
  description?: string | null,
  default?: boolean | null,
  active: boolean,
  actionMessageDefinitions?: ModelActionMessageDefinitionConnection | null,
  restricted?: boolean | null,
  useDefaultCta?: boolean | null,
  customCta?: string | null,
  allowAmbassadorSpecificCrowbarVideos?: boolean | null,
  generalCrowbarVideoURI?: string | null,
  deleted?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelActionMessageDefinitionConnection = {
  __typename: "ModelActionMessageDefinitionConnection",
  items:  Array<ActionMessageDefinition | null >,
  nextToken?: string | null,
};

export type ActionMessageDefinition = {
  __typename: "ActionMessageDefinition",
  id: string,
  campaignConversationFlowID: string,
  fundraisingCampaignID: string,
  name?: string | null,
  description?: string | null,
  type: ActionMessageType,
  messageTemplate?: string | null,
  onPositiveResponse?: string | null,
  onNegativeResponse?: string | null,
  otherResponses?: ModelActionMessageDefinitionConnection | null,
  reminderActionMessageDefinitionID?: string | null,
  reminderActionMessageDefinition?: ActionMessageDefinition | null,
  reminderDelay?: number | null,
  sendReminderNotification?: boolean | null,
  reminderNotificationID?: string | null,
  beginningNode?: boolean | null,
  parentActionMessageDefinitionID?: string | null,
  parentActionMessageDefinition?: ActionMessageDefinition | null,
  viewType?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum ActionMessageType {
  TEXT_MESSAGE = "TEXT_MESSAGE",
  PHONE_CALL = "PHONE_CALL",
  EMAIL = "EMAIL",
}


export type Project = {
  __typename: "Project",
  id: string,
  status?: string | null,
  name: string,
  description?: string | null,
  tasks?: ModelTaskConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelTaskConnection = {
  __typename: "ModelTaskConnection",
  items:  Array<Task | null >,
  nextToken?: string | null,
};

export type Task = {
  __typename: "Task",
  id: string,
  projectID: string,
  project?: Project | null,
  isTopLevelTask?: boolean | null,
  name?: string | null,
  overview?: string | null,
  description?: string | null,
  descriptionRTE?: string | null,
  status?: string | null,
  complete?: boolean | null,
  assignments?: ModelTaskAssignmentConnection | null,
  comments?: ModelTaskCommentConnection | null,
  subTasks?: ModelSubTaskConnection | null,
  mediaURI?: Array< string | null > | null,
  attachments?: ModelTaskAttachmentConnection | null,
  createdByID?: string | null,
  actionURL?: string | null,
  dueDate?: string | null,
  blockedBy?: ModelTaskBlockerConnection | null,
  blocking?: ModelTaskBlockerConnection | null,
  createdAt: string,
  updatedAt: string,
  createdBy?: AuthAccount | null,
};

export type ModelTaskAssignmentConnection = {
  __typename: "ModelTaskAssignmentConnection",
  items:  Array<TaskAssignment | null >,
  nextToken?: string | null,
};

export type TaskAssignment = {
  __typename: "TaskAssignment",
  id: string,
  taskID: string,
  task?: Task | null,
  authAccountID: string,
  staffProfileID?: string | null,
  notes?: string | null,
  createdAt: string,
  updatedAt: string,
  authAccount?: AuthAccount | null,
  staffProfile?: StaffProfile | null,
};

export type ModelTaskCommentConnection = {
  __typename: "ModelTaskCommentConnection",
  items:  Array<TaskComment | null >,
  nextToken?: string | null,
};

export type TaskComment = {
  __typename: "TaskComment",
  id: string,
  taskID: string,
  task?: Task | null,
  comment?: string | null,
  mediaURI?: Array< string | null > | null,
  postedByID: string,
  createdAt: string,
  updatedAt: string,
  postedBy?: AuthAccount | null,
};

export type ModelSubTaskConnection = {
  __typename: "ModelSubTaskConnection",
  items:  Array<SubTask | null >,
  nextToken?: string | null,
};

export type SubTask = {
  __typename: "SubTask",
  id: string,
  parentTaskID: string,
  parentTask?: Task | null,
  subTaskID: string,
  subTask?: Task | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelTaskAttachmentConnection = {
  __typename: "ModelTaskAttachmentConnection",
  items:  Array<TaskAttachment | null >,
  nextToken?: string | null,
};

export type TaskAttachment = {
  __typename: "TaskAttachment",
  id: string,
  taskID: string,
  uploadedByID: string,
  name?: string | null,
  description?: string | null,
  contentType?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelTaskBlockerConnection = {
  __typename: "ModelTaskBlockerConnection",
  items:  Array<TaskBlocker | null >,
  nextToken?: string | null,
};

export type TaskBlocker = {
  __typename: "TaskBlocker",
  id: string,
  originTaskID: string,
  originTask?: Task | null,
  blockerTaskID: string,
  blockerTask?: Task | null,
  notes?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelSubscriptionDonationTierConnection = {
  __typename: "ModelSubscriptionDonationTierConnection",
  items:  Array<SubscriptionDonationTier | null >,
  nextToken?: string | null,
};

export type SubscriptionDonationTier = {
  __typename: "SubscriptionDonationTier",
  id: string,
  fundraisingCampaignID: string,
  name: string,
  description?: string | null,
  amount?: number | null,
  features?: Array< string | null > | null,
  buttonText?: string | null,
  buttonColor?: string | null,
  default?: boolean | null,
  highlighted?: boolean | null,
  highlightedColor?: string | null,
  promoText?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type CampaignPage = {
  __typename: "CampaignPage",
  id: string,
  name?: string | null,
  description?: string | null,
  type?: CampaignPageType | null,
  fundraisingCampaignID: string,
  campaignDisplayConfigurationID?: string | null,
  pageHtml?: string | null,
  pageJSON?: string | null,
  pageCssJSON?: string | null,
  pageAssetsJSON?: string | null,
  createdAt: string,
  updatedAt: string,
  fundraisingCampaign?: FundraisingCampaign | null,
  owner?: string | null,
  campaignDisplayConfiguration?: CampaignDisplayConfiguration | null,
};

export enum CampaignPageType {
  CampaignPage = "CampaignPage",
  DiscoveryCallPage = "DiscoveryCallPage",
  AmbassadorPage = "AmbassadorPage",
  DonationPage = "DonationPage",
}


export type CampaignDisplayConfiguration = {
  __typename: "CampaignDisplayConfiguration",
  id: string,
  campaignPageID: string,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  gradientLeftColor?: string | null,
  gradientRightColor?: string | null,
  buttonBackgroundColor?: string | null,
  buttonTextColor?: string | null,
  headerFont?: string | null,
  bodyFont?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type FundraisingCampaignDiscoveryCall = {
  __typename: "FundraisingCampaignDiscoveryCall",
  id: string,
  title?: string | null,
  organizationID: string,
  fundraisingCampaignID: string,
  staffProfileID: string,
  startTimestamp: string,
  endTimestamp: string,
  latentHosted: boolean,
  invitationURL?: string | null,
  nylasEventID?: string | null,
  virtualMeetingURL?: string | null,
  createdAt: string,
  updatedAt: string,
  staffProfile?: StaffProfile | null,
  organization?: Organization | null,
  fundraisingCampaign?: FundraisingCampaign | null,
  owner?: string | null,
};

export type DiscoveryCallParticipant = {
  __typename: "DiscoveryCallParticipant",
  id: string,
  email: string,
  phoneNumber: string,
  firstName: string,
  lastName: string,
  authAccountID?: string | null,
  fundraisingProfileID?: string | null,
  fundraisingCampaignDiscoveryCallID: string,
  fundraisingCampaignID: string,
  invitationSent?: boolean | null,
  icsString?: string | null,
  status?: string | null,
  recruitedByCampaignAmbassadorID?: string | null,
  confirmed?: boolean | null,
  notes?: string | null,
  createdAt: string,
  updatedAt: string,
  authAccount?: AuthAccount | null,
  fundraisingProfile?: FundraisingProfile | null,
  fundraisingCampaign?: FundraisingCampaign | null,
  fundraisingCampaignDiscoveryCall?: FundraisingCampaignDiscoveryCall | null,
  owner?: string | null,
  recruitedByCampaignAmbassador?: FundraisingCampaignAmbassador | null,
};

export type ModelFundraisingCampaignAmbassadorContactConnection = {
  __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
  items:  Array<FundraisingCampaignAmbassadorContact | null >,
  nextToken?: string | null,
};

export type FundraisingCampaignAmbassadorContact = {
  __typename: "FundraisingCampaignAmbassadorContact",
  id: string,
  deviceContactID: string,
  fundraisingProfileID: string,
  fundraisingCampaignID: string,
  fundraisingCampaignAmbassadorID: string,
  sentText?: boolean | null,
  sentTextTimestamp?: string | null,
  sentInitialTextReminder?: boolean | null,
  sentInitialTextReminderTimestamp?: string | null,
  sentPhoneCallScript?: boolean | null,
  sentPhoneCallScriptTimestamp?: string | null,
  called?: boolean | null,
  calledTimestamp?: string | null,
  sentFollowUp?: boolean | null,
  sentFollowUpTimestamp?: string | null,
  followUpResponse?: FollowUpResponse | null,
  sentReminder?: boolean | null,
  sentReminderTimestamp?: string | null,
  isDonating?: boolean | null,
  donationAmount?: number | null,
  discoveryCallParticipantID?: string | null,
  transactionID?: string | null,
  isActive?: boolean | null,
  notes?: string | null,
  birthday?: string | null,
  hasTakenAction?: boolean | null,
  hasTakenActionTimestamp?: string | null,
  occupation?: string | null,
  selectedPhoneNumberArrayIndex?: number | null,
  actionMessages?: ModelActionMessageConnection | null,
  createdAt: string,
  updatedAt: string,
  discoveryCallParticipant?: DiscoveryCallParticipant | null,
  fundraisingCampaignAmbassador?: FundraisingCampaignAmbassador | null,
  owner?: string | null,
};

export enum FollowUpResponse {
  Yes = "Yes",
  No = "No",
  Waiting = "Waiting",
  Reminded = "Reminded",
}


export type ModelActionMessageConnection = {
  __typename: "ModelActionMessageConnection",
  items:  Array<ActionMessage | null >,
  nextToken?: string | null,
};

export type ActionMessage = {
  __typename: "ActionMessage",
  id: string,
  fundraisingCampaignID: string,
  fundraisingCampaignAmbassadorID: string,
  fundraisingCampaignAmbassadorContactID: string,
  actionMessageDefinitionID: string,
  actionMessageDefinition?: ActionMessageDefinition | null,
  sent?: boolean | null,
  sentTimestamp?: string | null,
  response?: ActionMessageResponseType | null,
  responseTimestamp?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum ActionMessageResponseType {
  Positive = "Positive",
  Negative = "Negative",
}


export type UpdateVolunteerProfileInput = {
  id: string,
  authAccountID?: string | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  gender?: GenderType | null,
  dateOfBirth?: string | null,
  streetAddress?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: number | null,
  website?: string | null,
  enneagram?: number | null,
  enneagramWing?: number | null,
  myersBriggs?: string | null,
  additionalInformation?: string | null,
  availabilityStringified?: string | null,
  latitude?: number | null,
  longitude?: number | null,
};

export type DeleteVolunteerProfileInput = {
  id: string,
};

export type CreateOrganizationInvitationInput = {
  id?: string | null,
  code: string,
  email: string,
  name?: string | null,
  used: boolean,
  usedTimestamp?: string | null,
  invitationSent: boolean,
  invitationSentTimestamp?: string | null,
};

export type ModelOrganizationInvitationConditionInput = {
  code?: ModelIDInput | null,
  email?: ModelStringInput | null,
  name?: ModelStringInput | null,
  used?: ModelBooleanInput | null,
  usedTimestamp?: ModelStringInput | null,
  invitationSent?: ModelBooleanInput | null,
  invitationSentTimestamp?: ModelStringInput | null,
  and?: Array< ModelOrganizationInvitationConditionInput | null > | null,
  or?: Array< ModelOrganizationInvitationConditionInput | null > | null,
  not?: ModelOrganizationInvitationConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type OrganizationInvitation = {
  __typename: "OrganizationInvitation",
  id: string,
  code: string,
  email: string,
  name?: string | null,
  used: boolean,
  usedTimestamp?: string | null,
  invitationSent: boolean,
  invitationSentTimestamp?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOrganizationInvitationInput = {
  id: string,
  code?: string | null,
  email?: string | null,
  name?: string | null,
  used?: boolean | null,
  usedTimestamp?: string | null,
  invitationSent?: boolean | null,
  invitationSentTimestamp?: string | null,
};

export type DeleteOrganizationInvitationInput = {
  id: string,
};

export type CreateVolunteerSkillInput = {
  id?: string | null,
  skillID: string,
  volunteerProfileID: string,
};

export type ModelVolunteerSkillConditionInput = {
  skillID?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  and?: Array< ModelVolunteerSkillConditionInput | null > | null,
  or?: Array< ModelVolunteerSkillConditionInput | null > | null,
  not?: ModelVolunteerSkillConditionInput | null,
};

export type UpdateVolunteerSkillInput = {
  id: string,
  skillID?: string | null,
  volunteerProfileID?: string | null,
};

export type DeleteVolunteerSkillInput = {
  id: string,
};

export type CreateCauseInput = {
  id?: string | null,
  key: string,
  name: string,
  description?: string | null,
};

export type ModelCauseConditionInput = {
  key?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelCauseConditionInput | null > | null,
  or?: Array< ModelCauseConditionInput | null > | null,
  not?: ModelCauseConditionInput | null,
};

export type UpdateCauseInput = {
  id: string,
  key?: string | null,
  name?: string | null,
  description?: string | null,
};

export type DeleteCauseInput = {
  id: string,
};

export type CreateVolunteerCauseInput = {
  id?: string | null,
  causeID: string,
  volunteerProfileID: string,
};

export type ModelVolunteerCauseConditionInput = {
  causeID?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  and?: Array< ModelVolunteerCauseConditionInput | null > | null,
  or?: Array< ModelVolunteerCauseConditionInput | null > | null,
  not?: ModelVolunteerCauseConditionInput | null,
};

export type UpdateVolunteerCauseInput = {
  id: string,
  causeID?: string | null,
  volunteerProfileID?: string | null,
};

export type DeleteVolunteerCauseInput = {
  id: string,
};

export type CreateOrganizationDetailsInput = {
  id?: string | null,
  organizationID: string,
  missionStatement?: string | null,
  serveStatement?: string | null,
  doStatement?: string | null,
  costToDoStatement?: string | null,
  missionArea?: string | null,
  annualBudget?: string | null,
  currentMonthlyRecurringDonors?: string | null,
  averageMonthlyRecurringDonation?: string | null,
  percentageOfBudgetFromIndividualDonors?: string | null,
  numberOfMajorDonors?: string | null,
  averageOneTimeDonation?: string | null,
  percentageOfBudgetFromGrants?: string | null,
};

export type ModelOrganizationDetailsConditionInput = {
  organizationID?: ModelIDInput | null,
  missionStatement?: ModelStringInput | null,
  serveStatement?: ModelStringInput | null,
  doStatement?: ModelStringInput | null,
  costToDoStatement?: ModelStringInput | null,
  missionArea?: ModelStringInput | null,
  annualBudget?: ModelStringInput | null,
  currentMonthlyRecurringDonors?: ModelStringInput | null,
  averageMonthlyRecurringDonation?: ModelStringInput | null,
  percentageOfBudgetFromIndividualDonors?: ModelStringInput | null,
  numberOfMajorDonors?: ModelStringInput | null,
  averageOneTimeDonation?: ModelStringInput | null,
  percentageOfBudgetFromGrants?: ModelStringInput | null,
  and?: Array< ModelOrganizationDetailsConditionInput | null > | null,
  or?: Array< ModelOrganizationDetailsConditionInput | null > | null,
  not?: ModelOrganizationDetailsConditionInput | null,
};

export type UpdateOrganizationDetailsInput = {
  id: string,
  organizationID?: string | null,
  missionStatement?: string | null,
  serveStatement?: string | null,
  doStatement?: string | null,
  costToDoStatement?: string | null,
  missionArea?: string | null,
  annualBudget?: string | null,
  currentMonthlyRecurringDonors?: string | null,
  averageMonthlyRecurringDonation?: string | null,
  percentageOfBudgetFromIndividualDonors?: string | null,
  numberOfMajorDonors?: string | null,
  averageOneTimeDonation?: string | null,
  percentageOfBudgetFromGrants?: string | null,
};

export type DeleteOrganizationDetailsInput = {
  id: string,
};

export type CreateProgramInput = {
  id?: string | null,
  organizationID: string,
  name: string,
  description?: string | null,
  theWhy?: string | null,
  leadID?: string | null,
  stringifiedCauses?: string | null,
  archived: boolean,
};

export type ModelProgramConditionInput = {
  organizationID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  theWhy?: ModelStringInput | null,
  leadID?: ModelIDInput | null,
  stringifiedCauses?: ModelStringInput | null,
  archived?: ModelBooleanInput | null,
  and?: Array< ModelProgramConditionInput | null > | null,
  or?: Array< ModelProgramConditionInput | null > | null,
  not?: ModelProgramConditionInput | null,
};

export type Program = {
  __typename: "Program",
  id: string,
  organizationID: string,
  name: string,
  description?: string | null,
  theWhy?: string | null,
  leadID?: string | null,
  stringifiedCauses?: string | null,
  opportunities?: ModelOpportunityConnection | null,
  archived: boolean,
  createdAt: string,
  updatedAt: string,
  lead?: StaffProfile | null,
  organization?: Organization | null,
};

export type ModelOpportunityConnection = {
  __typename: "ModelOpportunityConnection",
  items:  Array<Opportunity | null >,
  nextToken?: string | null,
};

export type Opportunity = {
  __typename: "Opportunity",
  id: string,
  organizationID: string,
  programID?: string | null,
  program?: Program | null,
  opportunityLeadID: string,
  type?: OpportunityType | null,
  status: OpportunityStatus,
  startDate?: string | null,
  endDate?: string | null,
  startRecruitingDate?: string | null,
  headerImage?: string | null,
  title?: string | null,
  descriptionRTE?: string | null,
  theWhy?: string | null,
  expectedImpact?: string | null,
  whatWillHappen?: string | null,
  volunteerGain?: string | null,
  roles?: ModelRoleConnection | null,
  stringifiedCauses?: string | null,
  stringifiedCausesJSON?: string | null,
  application?: ModelApplicationConnection | null,
  createdAt: string,
  updatedAt: string,
  opportunityLead?: StaffProfile | null,
  organization?: Organization | null,
};

export enum OpportunityType {
  oneTime = "oneTime",
  recurring = "recurring",
  asNeeded = "asNeeded",
}


export enum OpportunityStatus {
  draft = "draft",
  open = "open",
  active = "active",
  cancelled = "cancelled",
  completed = "completed",
}


export type ModelRoleConnection = {
  __typename: "ModelRoleConnection",
  items:  Array<Role | null >,
  nextToken?: string | null,
};

export type Role = {
  __typename: "Role",
  id: string,
  opportunityID: string,
  opportunity?: Opportunity | null,
  organizationID: string,
  roleTitle: string,
  opportunityTitle?: string | null,
  live?: boolean | null,
  roleCoordinatorID?: string | null,
  recurrence?: RoleRecurrence | null,
  weeklyRecurrenceDays?: string | null,
  weeklyRecurrenceSameVolunteers?: boolean | null,
  volunteersPerShift?: number | null,
  differentNumberOfVolunteersPerShift?: boolean | null,
  volunteerCommitmentMonths?: number | null,
  volunteerCommitmentCanRenew?: boolean | null,
  roleRequirements?: string | null,
  ageRequirement?: string | null,
  minorsRequireSupervision?: boolean | null,
  stringifiedCauses?: string | null,
  stringifiedCausesJSON?: string | null,
  stringifiedSkills?: string | null,
  stringifiedSkillsJSON?: string | null,
  stringifiedCertifications?: string | null,
  shifts?: ModelShiftConnection | null,
  createdAt: string,
  updatedAt: string,
  roleCoordinator?: StaffProfile | null,
  organization?: Organization | null,
};

export enum RoleRecurrence {
  weekly = "weekly",
  monthly = "monthly",
}


export type ModelShiftConnection = {
  __typename: "ModelShiftConnection",
  items:  Array<Shift | null >,
  nextToken?: string | null,
};

export type Shift = {
  __typename: "Shift",
  id: string,
  type: ShiftType,
  live?: boolean | null,
  name?: string | null,
  summary?: string | null,
  startDate?: string | null,
  startTime?: string | null,
  endDate?: string | null,
  endTime?: string | null,
  timezone?: string | null,
  timeFrame?: TimeFrame | null,
  timeFrameString?: string | null,
  recurrence?: ShiftRecurrence | null,
  weeklyRecurringDay?: string | null,
  monthlyRecurrenceWeek?: string | null,
  monthlyRecurrenceDay?: string | null,
  flexibleHours?: number | null,
  flexibleTimePeriod?: string | null,
  volunteersNeeded?: number | null,
  volunteerCoordinatorID?: string | null,
  roleID?: string | null,
  role?: Role | null,
  roleStringifiedSkills?: string | null,
  roleStringifiedCauses?: string | null,
  locationID?: string | null,
  locationLongitude?: number | null,
  locationLatitude?: number | null,
  locationType?: LocationType | null,
  locationZipEstimate?: number | null,
  locationVariousDescription?: string | null,
  createdAt: string,
  updatedAt: string,
  volunteerCoordinator?: StaffProfile | null,
  location?: Location | null,
};

export enum ShiftType {
  fixed = "fixed",
  flexible = "flexible",
}


export enum TimeFrame {
  mondayMorning = "mondayMorning",
  mondayAfternoon = "mondayAfternoon",
  mondayEvening = "mondayEvening",
  tuesdayMorning = "tuesdayMorning",
  tuesdayAfternoon = "tuesdayAfternoon",
  tuesdayEvening = "tuesdayEvening",
  wednesdayMorning = "wednesdayMorning",
  wednesdayAfternoon = "wednesdayAfternoon",
  wednesdayEvening = "wednesdayEvening",
  thursdayMorning = "thursdayMorning",
  thursdayAfternoon = "thursdayAfternoon",
  thursdayEvening = "thursdayEvening",
  fridayMorning = "fridayMorning",
  fridayAfternoon = "fridayAfternoon",
  fridayEvening = "fridayEvening",
  saturdayMorning = "saturdayMorning",
  saturdayAfternoon = "saturdayAfternoon",
  saturdayEvening = "saturdayEvening",
  sundayMorning = "sundayMorning",
  sundayAfternoon = "sundayAfternoon",
  sundayEvening = "sundayEvening",
}


export enum ShiftRecurrence {
  oneTime = "oneTime",
  weekly = "weekly",
  monthly = "monthly",
  asNeeded = "asNeeded",
}


export type ModelApplicationConnection = {
  __typename: "ModelApplicationConnection",
  items:  Array<Application | null >,
  nextToken?: string | null,
};

export type Application = {
  __typename: "Application",
  id: string,
  opportunityID: string,
  opportunity?: Opportunity | null,
  roleID?: string | null,
  role?: Role | null,
  screeningCallRequired?: ScreeningCallRequiredOptions | null,
  signUpOnly?: boolean | null,
  requireScreeningCall?: boolean | null,
  requireBackgroundCheck?: boolean | null,
  recruitmentDeadlineForVolunteers?: string | null,
  targetNumberOfVolunteerHours?: number | null,
  minimumNumberOfVolunteersRequired?: number | null,
  customApplicationQuestions?: ModelCustomApplicationQuestionConnection | null,
  createdAt: string,
  updatedAt: string,
};

export enum ScreeningCallRequiredOptions {
  never = "never",
  newVolunteers = "newVolunteers",
  everyone = "everyone",
}


export type ModelCustomApplicationQuestionConnection = {
  __typename: "ModelCustomApplicationQuestionConnection",
  items:  Array<CustomApplicationQuestion | null >,
  nextToken?: string | null,
};

export type CustomApplicationQuestion = {
  __typename: "CustomApplicationQuestion",
  id: string,
  applicationID: string,
  application?: Application | null,
  questionText: string,
  questionType: string,
  required: boolean,
  createdAt: string,
  updatedAt: string,
};

export type UpdateProgramInput = {
  id: string,
  organizationID?: string | null,
  name?: string | null,
  description?: string | null,
  theWhy?: string | null,
  leadID?: string | null,
  stringifiedCauses?: string | null,
  archived?: boolean | null,
};

export type DeleteProgramInput = {
  id: string,
};

export type CreateOpportunityInput = {
  id?: string | null,
  organizationID: string,
  programID?: string | null,
  opportunityLeadID: string,
  type?: OpportunityType | null,
  status: OpportunityStatus,
  startDate?: string | null,
  endDate?: string | null,
  startRecruitingDate?: string | null,
  headerImage?: string | null,
  title?: string | null,
  descriptionRTE?: string | null,
  theWhy?: string | null,
  expectedImpact?: string | null,
  whatWillHappen?: string | null,
  volunteerGain?: string | null,
  stringifiedCauses?: string | null,
  stringifiedCausesJSON?: string | null,
};

export type ModelOpportunityConditionInput = {
  organizationID?: ModelIDInput | null,
  programID?: ModelIDInput | null,
  opportunityLeadID?: ModelIDInput | null,
  type?: ModelOpportunityTypeInput | null,
  status?: ModelOpportunityStatusInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  startRecruitingDate?: ModelStringInput | null,
  headerImage?: ModelStringInput | null,
  title?: ModelStringInput | null,
  descriptionRTE?: ModelStringInput | null,
  theWhy?: ModelStringInput | null,
  expectedImpact?: ModelStringInput | null,
  whatWillHappen?: ModelStringInput | null,
  volunteerGain?: ModelStringInput | null,
  stringifiedCauses?: ModelStringInput | null,
  stringifiedCausesJSON?: ModelStringInput | null,
  and?: Array< ModelOpportunityConditionInput | null > | null,
  or?: Array< ModelOpportunityConditionInput | null > | null,
  not?: ModelOpportunityConditionInput | null,
};

export type ModelOpportunityTypeInput = {
  eq?: OpportunityType | null,
  ne?: OpportunityType | null,
};

export type ModelOpportunityStatusInput = {
  eq?: OpportunityStatus | null,
  ne?: OpportunityStatus | null,
};

export type UpdateOpportunityInput = {
  id: string,
  organizationID?: string | null,
  programID?: string | null,
  opportunityLeadID?: string | null,
  type?: OpportunityType | null,
  status?: OpportunityStatus | null,
  startDate?: string | null,
  endDate?: string | null,
  startRecruitingDate?: string | null,
  headerImage?: string | null,
  title?: string | null,
  descriptionRTE?: string | null,
  theWhy?: string | null,
  expectedImpact?: string | null,
  whatWillHappen?: string | null,
  volunteerGain?: string | null,
  stringifiedCauses?: string | null,
  stringifiedCausesJSON?: string | null,
};

export type DeleteOpportunityInput = {
  id: string,
};

export type CreateApplicationInput = {
  id?: string | null,
  opportunityID: string,
  roleID?: string | null,
  screeningCallRequired?: ScreeningCallRequiredOptions | null,
  signUpOnly?: boolean | null,
  requireScreeningCall?: boolean | null,
  requireBackgroundCheck?: boolean | null,
  recruitmentDeadlineForVolunteers?: string | null,
  targetNumberOfVolunteerHours?: number | null,
  minimumNumberOfVolunteersRequired?: number | null,
};

export type ModelApplicationConditionInput = {
  opportunityID?: ModelIDInput | null,
  roleID?: ModelIDInput | null,
  screeningCallRequired?: ModelScreeningCallRequiredOptionsInput | null,
  signUpOnly?: ModelBooleanInput | null,
  requireScreeningCall?: ModelBooleanInput | null,
  requireBackgroundCheck?: ModelBooleanInput | null,
  recruitmentDeadlineForVolunteers?: ModelStringInput | null,
  targetNumberOfVolunteerHours?: ModelIntInput | null,
  minimumNumberOfVolunteersRequired?: ModelIntInput | null,
  and?: Array< ModelApplicationConditionInput | null > | null,
  or?: Array< ModelApplicationConditionInput | null > | null,
  not?: ModelApplicationConditionInput | null,
};

export type ModelScreeningCallRequiredOptionsInput = {
  eq?: ScreeningCallRequiredOptions | null,
  ne?: ScreeningCallRequiredOptions | null,
};

export type UpdateApplicationInput = {
  id: string,
  opportunityID?: string | null,
  roleID?: string | null,
  screeningCallRequired?: ScreeningCallRequiredOptions | null,
  signUpOnly?: boolean | null,
  requireScreeningCall?: boolean | null,
  requireBackgroundCheck?: boolean | null,
  recruitmentDeadlineForVolunteers?: string | null,
  targetNumberOfVolunteerHours?: number | null,
  minimumNumberOfVolunteersRequired?: number | null,
};

export type DeleteApplicationInput = {
  id: string,
};

export type CreateCustomApplicationQuestionInput = {
  id?: string | null,
  applicationID: string,
  questionText: string,
  questionType: string,
  required: boolean,
};

export type ModelCustomApplicationQuestionConditionInput = {
  applicationID?: ModelIDInput | null,
  questionText?: ModelStringInput | null,
  questionType?: ModelStringInput | null,
  required?: ModelBooleanInput | null,
  and?: Array< ModelCustomApplicationQuestionConditionInput | null > | null,
  or?: Array< ModelCustomApplicationQuestionConditionInput | null > | null,
  not?: ModelCustomApplicationQuestionConditionInput | null,
};

export type UpdateCustomApplicationQuestionInput = {
  id: string,
  applicationID?: string | null,
  questionText?: string | null,
  questionType?: string | null,
  required?: boolean | null,
};

export type DeleteCustomApplicationQuestionInput = {
  id: string,
};

export type CreateRoleInput = {
  id?: string | null,
  opportunityID: string,
  organizationID: string,
  roleTitle: string,
  opportunityTitle?: string | null,
  live?: boolean | null,
  roleCoordinatorID?: string | null,
  recurrence?: RoleRecurrence | null,
  weeklyRecurrenceDays?: string | null,
  weeklyRecurrenceSameVolunteers?: boolean | null,
  volunteersPerShift?: number | null,
  differentNumberOfVolunteersPerShift?: boolean | null,
  volunteerCommitmentMonths?: number | null,
  volunteerCommitmentCanRenew?: boolean | null,
  roleRequirements?: string | null,
  ageRequirement?: string | null,
  minorsRequireSupervision?: boolean | null,
  stringifiedCauses?: string | null,
  stringifiedCausesJSON?: string | null,
  stringifiedSkills?: string | null,
  stringifiedSkillsJSON?: string | null,
  stringifiedCertifications?: string | null,
};

export type ModelRoleConditionInput = {
  opportunityID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  roleTitle?: ModelStringInput | null,
  opportunityTitle?: ModelStringInput | null,
  live?: ModelBooleanInput | null,
  roleCoordinatorID?: ModelIDInput | null,
  recurrence?: ModelRoleRecurrenceInput | null,
  weeklyRecurrenceDays?: ModelStringInput | null,
  weeklyRecurrenceSameVolunteers?: ModelBooleanInput | null,
  volunteersPerShift?: ModelIntInput | null,
  differentNumberOfVolunteersPerShift?: ModelBooleanInput | null,
  volunteerCommitmentMonths?: ModelIntInput | null,
  volunteerCommitmentCanRenew?: ModelBooleanInput | null,
  roleRequirements?: ModelStringInput | null,
  ageRequirement?: ModelStringInput | null,
  minorsRequireSupervision?: ModelBooleanInput | null,
  stringifiedCauses?: ModelStringInput | null,
  stringifiedCausesJSON?: ModelStringInput | null,
  stringifiedSkills?: ModelStringInput | null,
  stringifiedSkillsJSON?: ModelStringInput | null,
  stringifiedCertifications?: ModelStringInput | null,
  and?: Array< ModelRoleConditionInput | null > | null,
  or?: Array< ModelRoleConditionInput | null > | null,
  not?: ModelRoleConditionInput | null,
};

export type ModelRoleRecurrenceInput = {
  eq?: RoleRecurrence | null,
  ne?: RoleRecurrence | null,
};

export type UpdateRoleInput = {
  id: string,
  opportunityID?: string | null,
  organizationID?: string | null,
  roleTitle?: string | null,
  opportunityTitle?: string | null,
  live?: boolean | null,
  roleCoordinatorID?: string | null,
  recurrence?: RoleRecurrence | null,
  weeklyRecurrenceDays?: string | null,
  weeklyRecurrenceSameVolunteers?: boolean | null,
  volunteersPerShift?: number | null,
  differentNumberOfVolunteersPerShift?: boolean | null,
  volunteerCommitmentMonths?: number | null,
  volunteerCommitmentCanRenew?: boolean | null,
  roleRequirements?: string | null,
  ageRequirement?: string | null,
  minorsRequireSupervision?: boolean | null,
  stringifiedCauses?: string | null,
  stringifiedCausesJSON?: string | null,
  stringifiedSkills?: string | null,
  stringifiedSkillsJSON?: string | null,
  stringifiedCertifications?: string | null,
};

export type DeleteRoleInput = {
  id: string,
};

export type CreateShiftInput = {
  id?: string | null,
  type: ShiftType,
  live?: boolean | null,
  name?: string | null,
  summary?: string | null,
  startDate?: string | null,
  startTime?: string | null,
  endDate?: string | null,
  endTime?: string | null,
  timezone?: string | null,
  timeFrame?: TimeFrame | null,
  timeFrameString?: string | null,
  recurrence?: ShiftRecurrence | null,
  weeklyRecurringDay?: string | null,
  monthlyRecurrenceWeek?: string | null,
  monthlyRecurrenceDay?: string | null,
  flexibleHours?: number | null,
  flexibleTimePeriod?: string | null,
  volunteersNeeded?: number | null,
  volunteerCoordinatorID?: string | null,
  roleID?: string | null,
  roleStringifiedSkills?: string | null,
  roleStringifiedCauses?: string | null,
  locationID?: string | null,
  locationLongitude?: number | null,
  locationLatitude?: number | null,
  locationType?: LocationType | null,
  locationZipEstimate?: number | null,
  locationVariousDescription?: string | null,
};

export type ModelShiftConditionInput = {
  type?: ModelShiftTypeInput | null,
  live?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  timeFrame?: ModelTimeFrameInput | null,
  timeFrameString?: ModelStringInput | null,
  recurrence?: ModelShiftRecurrenceInput | null,
  weeklyRecurringDay?: ModelStringInput | null,
  monthlyRecurrenceWeek?: ModelStringInput | null,
  monthlyRecurrenceDay?: ModelStringInput | null,
  flexibleHours?: ModelIntInput | null,
  flexibleTimePeriod?: ModelStringInput | null,
  volunteersNeeded?: ModelIntInput | null,
  volunteerCoordinatorID?: ModelIDInput | null,
  roleID?: ModelIDInput | null,
  roleStringifiedSkills?: ModelStringInput | null,
  roleStringifiedCauses?: ModelStringInput | null,
  locationID?: ModelIDInput | null,
  locationLongitude?: ModelFloatInput | null,
  locationLatitude?: ModelFloatInput | null,
  locationType?: ModelLocationTypeInput | null,
  locationZipEstimate?: ModelIntInput | null,
  locationVariousDescription?: ModelStringInput | null,
  and?: Array< ModelShiftConditionInput | null > | null,
  or?: Array< ModelShiftConditionInput | null > | null,
  not?: ModelShiftConditionInput | null,
};

export type ModelShiftTypeInput = {
  eq?: ShiftType | null,
  ne?: ShiftType | null,
};

export type ModelTimeFrameInput = {
  eq?: TimeFrame | null,
  ne?: TimeFrame | null,
};

export type ModelShiftRecurrenceInput = {
  eq?: ShiftRecurrence | null,
  ne?: ShiftRecurrence | null,
};

export type ModelLocationTypeInput = {
  eq?: LocationType | null,
  ne?: LocationType | null,
};

export type UpdateShiftInput = {
  id: string,
  type?: ShiftType | null,
  live?: boolean | null,
  name?: string | null,
  summary?: string | null,
  startDate?: string | null,
  startTime?: string | null,
  endDate?: string | null,
  endTime?: string | null,
  timezone?: string | null,
  timeFrame?: TimeFrame | null,
  timeFrameString?: string | null,
  recurrence?: ShiftRecurrence | null,
  weeklyRecurringDay?: string | null,
  monthlyRecurrenceWeek?: string | null,
  monthlyRecurrenceDay?: string | null,
  flexibleHours?: number | null,
  flexibleTimePeriod?: string | null,
  volunteersNeeded?: number | null,
  volunteerCoordinatorID?: string | null,
  roleID?: string | null,
  roleStringifiedSkills?: string | null,
  roleStringifiedCauses?: string | null,
  locationID?: string | null,
  locationLongitude?: number | null,
  locationLatitude?: number | null,
  locationType?: LocationType | null,
  locationZipEstimate?: number | null,
  locationVariousDescription?: string | null,
};

export type DeleteShiftInput = {
  id: string,
};

export type CreateOpportunityTemplateInput = {
  id?: string | null,
  organizationID: string,
  name: string,
  description?: string | null,
  templateJSON: string,
};

export type ModelOpportunityTemplateConditionInput = {
  organizationID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  templateJSON?: ModelStringInput | null,
  and?: Array< ModelOpportunityTemplateConditionInput | null > | null,
  or?: Array< ModelOpportunityTemplateConditionInput | null > | null,
  not?: ModelOpportunityTemplateConditionInput | null,
};

export type OpportunityTemplate = {
  __typename: "OpportunityTemplate",
  id: string,
  organizationID: string,
  name: string,
  description?: string | null,
  templateJSON: string,
  createdAt: string,
  updatedAt: string,
  organization?: Organization | null,
};

export type UpdateOpportunityTemplateInput = {
  id: string,
  organizationID?: string | null,
  name?: string | null,
  description?: string | null,
  templateJSON?: string | null,
};

export type DeleteOpportunityTemplateInput = {
  id: string,
};

export type CreateRoleTemplateInput = {
  id?: string | null,
  organizationID: string,
  name: string,
  description?: string | null,
  templateJSON: string,
};

export type ModelRoleTemplateConditionInput = {
  organizationID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  templateJSON?: ModelStringInput | null,
  and?: Array< ModelRoleTemplateConditionInput | null > | null,
  or?: Array< ModelRoleTemplateConditionInput | null > | null,
  not?: ModelRoleTemplateConditionInput | null,
};

export type RoleTemplate = {
  __typename: "RoleTemplate",
  id: string,
  organizationID: string,
  name: string,
  description?: string | null,
  templateJSON: string,
  createdAt: string,
  updatedAt: string,
  organization?: Organization | null,
};

export type UpdateRoleTemplateInput = {
  id: string,
  organizationID?: string | null,
  name?: string | null,
  description?: string | null,
  templateJSON?: string | null,
};

export type DeleteRoleTemplateInput = {
  id: string,
};

export type CreateOrganizationGroupInput = {
  id?: string | null,
  organizationID: string,
  groupName: string,
};

export type ModelOrganizationGroupConditionInput = {
  organizationID?: ModelIDInput | null,
  groupName?: ModelStringInput | null,
  and?: Array< ModelOrganizationGroupConditionInput | null > | null,
  or?: Array< ModelOrganizationGroupConditionInput | null > | null,
  not?: ModelOrganizationGroupConditionInput | null,
};

export type OrganizationGroup = {
  __typename: "OrganizationGroup",
  id: string,
  organizationID: string,
  groupName: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOrganizationGroupInput = {
  id: string,
  organizationID?: string | null,
  groupName?: string | null,
};

export type DeleteOrganizationGroupInput = {
  id: string,
};

export type CreateOrganizationVolunteerInput = {
  id?: string | null,
  organizationID: string,
  volunteerProfileID: string,
  status: OrganizationVolunteerStatus,
};

export enum OrganizationVolunteerStatus {
  requested = "requested",
  prescreen = "prescreen",
  volunteer = "volunteer",
  superVolunteer = "superVolunteer",
  blocked = "blocked",
  banned = "banned",
}


export type ModelOrganizationVolunteerConditionInput = {
  organizationID?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  status?: ModelOrganizationVolunteerStatusInput | null,
  and?: Array< ModelOrganizationVolunteerConditionInput | null > | null,
  or?: Array< ModelOrganizationVolunteerConditionInput | null > | null,
  not?: ModelOrganizationVolunteerConditionInput | null,
};

export type ModelOrganizationVolunteerStatusInput = {
  eq?: OrganizationVolunteerStatus | null,
  ne?: OrganizationVolunteerStatus | null,
};

export type OrganizationVolunteer = {
  __typename: "OrganizationVolunteer",
  id: string,
  organizationID: string,
  volunteerProfileID: string,
  status: OrganizationVolunteerStatus,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOrganizationVolunteerInput = {
  id: string,
  organizationID?: string | null,
  volunteerProfileID?: string | null,
  status?: OrganizationVolunteerStatus | null,
};

export type DeleteOrganizationVolunteerInput = {
  id: string,
};

export type CreateOrganizationGroupVolunteerInput = {
  id?: string | null,
};

export type ModelOrganizationGroupVolunteerConditionInput = {
  and?: Array< ModelOrganizationGroupVolunteerConditionInput | null > | null,
  or?: Array< ModelOrganizationGroupVolunteerConditionInput | null > | null,
  not?: ModelOrganizationGroupVolunteerConditionInput | null,
};

export type OrganizationGroupVolunteer = {
  __typename: "OrganizationGroupVolunteer",
  id: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOrganizationGroupVolunteerInput = {
  id: string,
};

export type DeleteOrganizationGroupVolunteerInput = {
  id: string,
};

export type CreateTimeCommitmentInput = {
  id?: string | null,
  amount: number,
  units: TimeUnitType,
  period: TimePeriodType,
};

export enum TimeUnitType {
  minutes = "minutes",
  hours = "hours",
  days = "days",
}


export enum TimePeriodType {
  daily = "daily",
  weekly = "weekly",
  monthly = "monthly",
  quarterly = "quarterly",
  yearly = "yearly",
}


export type ModelTimeCommitmentConditionInput = {
  amount?: ModelIntInput | null,
  units?: ModelTimeUnitTypeInput | null,
  period?: ModelTimePeriodTypeInput | null,
  and?: Array< ModelTimeCommitmentConditionInput | null > | null,
  or?: Array< ModelTimeCommitmentConditionInput | null > | null,
  not?: ModelTimeCommitmentConditionInput | null,
};

export type ModelTimeUnitTypeInput = {
  eq?: TimeUnitType | null,
  ne?: TimeUnitType | null,
};

export type ModelTimePeriodTypeInput = {
  eq?: TimePeriodType | null,
  ne?: TimePeriodType | null,
};

export type TimeCommitment = {
  __typename: "TimeCommitment",
  id: string,
  amount: number,
  units: TimeUnitType,
  period: TimePeriodType,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTimeCommitmentInput = {
  id: string,
  amount?: number | null,
  units?: TimeUnitType | null,
  period?: TimePeriodType | null,
};

export type DeleteTimeCommitmentInput = {
  id: string,
};

export type CreateVolunteerMatchRequestInput = {
  id?: string | null,
  status: VolunteerMatchRequestStatus,
  volunteerProfileID: string,
  opportunityID: string,
  roleRequestedID?: string | null,
  organizationID: string,
  volunteerComments?: string | null,
  administrativeNotes?: string | null,
  scheduledCallID?: string | null,
  roleAssignedID?: string | null,
  assignmentID?: string | null,
  organizationRejectionReason?: string | null,
  volunteerRejectionReason?: string | null,
};

export enum VolunteerMatchRequestStatus {
  submitted = "submitted",
  inReview = "inReview",
  collectAdditionalInformation = "collectAdditionalInformation",
  scheduleCall = "scheduleCall",
  callScheduled = "callScheduled",
  roleAssigned = "roleAssigned",
  rejected = "rejected",
}


export type ModelVolunteerMatchRequestConditionInput = {
  status?: ModelVolunteerMatchRequestStatusInput | null,
  volunteerProfileID?: ModelIDInput | null,
  opportunityID?: ModelIDInput | null,
  roleRequestedID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  volunteerComments?: ModelStringInput | null,
  administrativeNotes?: ModelStringInput | null,
  scheduledCallID?: ModelIDInput | null,
  roleAssignedID?: ModelIDInput | null,
  assignmentID?: ModelIDInput | null,
  organizationRejectionReason?: ModelStringInput | null,
  volunteerRejectionReason?: ModelStringInput | null,
  and?: Array< ModelVolunteerMatchRequestConditionInput | null > | null,
  or?: Array< ModelVolunteerMatchRequestConditionInput | null > | null,
  not?: ModelVolunteerMatchRequestConditionInput | null,
};

export type ModelVolunteerMatchRequestStatusInput = {
  eq?: VolunteerMatchRequestStatus | null,
  ne?: VolunteerMatchRequestStatus | null,
};

export type VolunteerMatchRequest = {
  __typename: "VolunteerMatchRequest",
  id: string,
  status: VolunteerMatchRequestStatus,
  volunteerProfileID: string,
  volunteerProfile?: VolunteerProfile | null,
  opportunityID: string,
  opportunity?: Opportunity | null,
  roleRequestedID?: string | null,
  roleRequested?: Role | null,
  organizationID: string,
  volunteerComments?: string | null,
  administrativeNotes?: string | null,
  scheduledCallID?: string | null,
  scheduledCall?: ScheduledCall | null,
  roleAssignedID?: string | null,
  roleAssigned?: Role | null,
  assignmentID?: string | null,
  assignment?: Assignment | null,
  organizationRejectionReason?: string | null,
  volunteerRejectionReason?: string | null,
  createdAt: string,
  updatedAt: string,
  organization?: Organization | null,
};

export type ScheduledCall = {
  __typename: "ScheduledCall",
  id: string,
  status: ScheduledCallStatus,
  volunteerProfileID: string,
  volunteerProfile?: VolunteerProfile | null,
  organizationID: string,
  startTime?: string | null,
  duration?: number | null,
  details?: string | null,
  createdAt: string,
  updatedAt: string,
  organization?: Organization | null,
};

export enum ScheduledCallStatus {
  scheduled = "scheduled",
  complete = "complete",
  rescheduled = "rescheduled",
  cancelled = "cancelled",
}


export type Assignment = {
  __typename: "Assignment",
  id: string,
  status: AssignmentStatusType,
  volunteerMatchRequestID: string,
  volunteerMatchRequest?: VolunteerMatchRequest | null,
  roleID: string,
  role?: Role | null,
  shiftID: string,
  shift?: Shift | null,
  volunteerProfileID: string,
  volunteerProfile?: VolunteerProfile | null,
  opportunityID: string,
  opportunity?: Opportunity | null,
  administrativeNotes?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum AssignmentStatusType {
  assigned = "assigned",
  withdrawn = "withdrawn",
  cancelled = "cancelled",
  completed = "completed",
}


export type UpdateVolunteerMatchRequestInput = {
  id: string,
  status?: VolunteerMatchRequestStatus | null,
  volunteerProfileID?: string | null,
  opportunityID?: string | null,
  roleRequestedID?: string | null,
  organizationID?: string | null,
  volunteerComments?: string | null,
  administrativeNotes?: string | null,
  scheduledCallID?: string | null,
  roleAssignedID?: string | null,
  assignmentID?: string | null,
  organizationRejectionReason?: string | null,
  volunteerRejectionReason?: string | null,
};

export type DeleteVolunteerMatchRequestInput = {
  id: string,
};

export type CreateScheduledCallInput = {
  id?: string | null,
  status: ScheduledCallStatus,
  volunteerProfileID: string,
  organizationID: string,
  startTime?: string | null,
  duration?: number | null,
  details?: string | null,
};

export type ModelScheduledCallConditionInput = {
  status?: ModelScheduledCallStatusInput | null,
  volunteerProfileID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  details?: ModelStringInput | null,
  and?: Array< ModelScheduledCallConditionInput | null > | null,
  or?: Array< ModelScheduledCallConditionInput | null > | null,
  not?: ModelScheduledCallConditionInput | null,
};

export type ModelScheduledCallStatusInput = {
  eq?: ScheduledCallStatus | null,
  ne?: ScheduledCallStatus | null,
};

export type UpdateScheduledCallInput = {
  id: string,
  status?: ScheduledCallStatus | null,
  volunteerProfileID?: string | null,
  organizationID?: string | null,
  startTime?: string | null,
  duration?: number | null,
  details?: string | null,
};

export type DeleteScheduledCallInput = {
  id: string,
};

export type CreateAssignmentInput = {
  id?: string | null,
  status: AssignmentStatusType,
  volunteerMatchRequestID: string,
  roleID: string,
  shiftID: string,
  volunteerProfileID: string,
  opportunityID: string,
  administrativeNotes?: string | null,
};

export type ModelAssignmentConditionInput = {
  status?: ModelAssignmentStatusTypeInput | null,
  volunteerMatchRequestID?: ModelIDInput | null,
  roleID?: ModelIDInput | null,
  shiftID?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  opportunityID?: ModelIDInput | null,
  administrativeNotes?: ModelStringInput | null,
  and?: Array< ModelAssignmentConditionInput | null > | null,
  or?: Array< ModelAssignmentConditionInput | null > | null,
  not?: ModelAssignmentConditionInput | null,
};

export type ModelAssignmentStatusTypeInput = {
  eq?: AssignmentStatusType | null,
  ne?: AssignmentStatusType | null,
};

export type UpdateAssignmentInput = {
  id: string,
  status?: AssignmentStatusType | null,
  volunteerMatchRequestID?: string | null,
  roleID?: string | null,
  shiftID?: string | null,
  volunteerProfileID?: string | null,
  opportunityID?: string | null,
  administrativeNotes?: string | null,
};

export type DeleteAssignmentInput = {
  id: string,
};

export type CreateCheckInInput = {
  id?: string | null,
  assignmentID: string,
  shiftID: string,
  opportunityID: string,
  timeIn?: string | null,
  timeOut?: string | null,
  checkedInByVolunteerProfileID?: string | null,
  checkedOutByVolunteerProfileID?: string | null,
};

export type ModelCheckInConditionInput = {
  assignmentID?: ModelIDInput | null,
  shiftID?: ModelIDInput | null,
  opportunityID?: ModelIDInput | null,
  timeIn?: ModelStringInput | null,
  timeOut?: ModelStringInput | null,
  checkedInByVolunteerProfileID?: ModelIDInput | null,
  checkedOutByVolunteerProfileID?: ModelIDInput | null,
  and?: Array< ModelCheckInConditionInput | null > | null,
  or?: Array< ModelCheckInConditionInput | null > | null,
  not?: ModelCheckInConditionInput | null,
};

export type CheckIn = {
  __typename: "CheckIn",
  id: string,
  assignmentID: string,
  shiftID: string,
  opportunityID: string,
  timeIn?: string | null,
  timeOut?: string | null,
  checkedInByVolunteerProfileID?: string | null,
  checkedInByVolunteer?: VolunteerProfile | null,
  checkedOutByVolunteerProfileID?: string | null,
  checkedOutByVolunteer?: VolunteerProfile | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCheckInInput = {
  id: string,
  assignmentID?: string | null,
  shiftID?: string | null,
  opportunityID?: string | null,
  timeIn?: string | null,
  timeOut?: string | null,
  checkedInByVolunteerProfileID?: string | null,
  checkedOutByVolunteerProfileID?: string | null,
};

export type DeleteCheckInInput = {
  id: string,
};

export type CreateNotificationSettingsInput = {
  id?: string | null,
  communicationsProfileID: string,
  allowPushNotifications: boolean,
  allowTextMessages: boolean,
  allowEmail: boolean,
  preference?: NotificationPreference | null,
};

export type ModelNotificationSettingsConditionInput = {
  communicationsProfileID?: ModelIDInput | null,
  allowPushNotifications?: ModelBooleanInput | null,
  allowTextMessages?: ModelBooleanInput | null,
  allowEmail?: ModelBooleanInput | null,
  preference?: ModelNotificationPreferenceInput | null,
  and?: Array< ModelNotificationSettingsConditionInput | null > | null,
  or?: Array< ModelNotificationSettingsConditionInput | null > | null,
  not?: ModelNotificationSettingsConditionInput | null,
};

export type ModelNotificationPreferenceInput = {
  eq?: NotificationPreference | null,
  ne?: NotificationPreference | null,
};

export type UpdateNotificationSettingsInput = {
  id: string,
  communicationsProfileID?: string | null,
  allowPushNotifications?: boolean | null,
  allowTextMessages?: boolean | null,
  allowEmail?: boolean | null,
  preference?: NotificationPreference | null,
};

export type DeleteNotificationSettingsInput = {
  id: string,
};

export type CreateLatentOrganizationCodeInput = {
  id?: string | null,
  code: string,
  organizationID: string,
  active: boolean,
  emailRestricted: boolean,
  emailHostRestriction?: string | null,
  fundraisingCampaignID?: string | null,
  presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
};

export type ModelLatentOrganizationCodeConditionInput = {
  code?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  active?: ModelBooleanInput | null,
  emailRestricted?: ModelBooleanInput | null,
  emailHostRestriction?: ModelStringInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  presetFundraisingCampaignAmbassadorStatus?: ModelFundraisingCampaignAmbassadorStatusInput | null,
  and?: Array< ModelLatentOrganizationCodeConditionInput | null > | null,
  or?: Array< ModelLatentOrganizationCodeConditionInput | null > | null,
  not?: ModelLatentOrganizationCodeConditionInput | null,
};

export type ModelFundraisingCampaignAmbassadorStatusInput = {
  eq?: FundraisingCampaignAmbassadorStatus | null,
  ne?: FundraisingCampaignAmbassadorStatus | null,
};

export type LatentOrganizationCode = {
  __typename: "LatentOrganizationCode",
  id: string,
  code: string,
  organizationID: string,
  active: boolean,
  emailRestricted: boolean,
  emailHostRestriction?: string | null,
  fundraisingCampaignID?: string | null,
  presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
  createdAt: string,
  updatedAt: string,
  organization?: Organization | null,
  fundraisingCampaign?: FundraisingCampaign | null,
};

export type UpdateLatentOrganizationCodeInput = {
  id: string,
  code?: string | null,
  organizationID?: string | null,
  active?: boolean | null,
  emailRestricted?: boolean | null,
  emailHostRestriction?: string | null,
  fundraisingCampaignID?: string | null,
  presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
};

export type DeleteLatentOrganizationCodeInput = {
  id: string,
};

export type CreateSubscriptionDonationTierInput = {
  id?: string | null,
  fundraisingCampaignID: string,
  name: string,
  description?: string | null,
  amount?: number | null,
  features?: Array< string | null > | null,
  buttonText?: string | null,
  buttonColor?: string | null,
  default?: boolean | null,
  highlighted?: boolean | null,
  highlightedColor?: string | null,
  promoText?: string | null,
};

export type ModelSubscriptionDonationTierConditionInput = {
  fundraisingCampaignID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  features?: ModelStringInput | null,
  buttonText?: ModelStringInput | null,
  buttonColor?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  highlighted?: ModelBooleanInput | null,
  highlightedColor?: ModelStringInput | null,
  promoText?: ModelStringInput | null,
  and?: Array< ModelSubscriptionDonationTierConditionInput | null > | null,
  or?: Array< ModelSubscriptionDonationTierConditionInput | null > | null,
  not?: ModelSubscriptionDonationTierConditionInput | null,
};

export type UpdateSubscriptionDonationTierInput = {
  id: string,
  fundraisingCampaignID?: string | null,
  name?: string | null,
  description?: string | null,
  amount?: number | null,
  features?: Array< string | null > | null,
  buttonText?: string | null,
  buttonColor?: string | null,
  default?: boolean | null,
  highlighted?: boolean | null,
  highlightedColor?: string | null,
  promoText?: string | null,
};

export type DeleteSubscriptionDonationTierInput = {
  id: string,
};

export type CreateCampaignConversationFlowInput = {
  id?: string | null,
  fundraisingCampaignID: string,
  name: string,
  description?: string | null,
  default?: boolean | null,
  active: boolean,
  restricted?: boolean | null,
  useDefaultCta?: boolean | null,
  customCta?: string | null,
  allowAmbassadorSpecificCrowbarVideos?: boolean | null,
  generalCrowbarVideoURI?: string | null,
  deleted?: boolean | null,
};

export type ModelCampaignConversationFlowConditionInput = {
  fundraisingCampaignID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  active?: ModelBooleanInput | null,
  restricted?: ModelBooleanInput | null,
  useDefaultCta?: ModelBooleanInput | null,
  customCta?: ModelStringInput | null,
  allowAmbassadorSpecificCrowbarVideos?: ModelBooleanInput | null,
  generalCrowbarVideoURI?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  and?: Array< ModelCampaignConversationFlowConditionInput | null > | null,
  or?: Array< ModelCampaignConversationFlowConditionInput | null > | null,
  not?: ModelCampaignConversationFlowConditionInput | null,
};

export type UpdateCampaignConversationFlowInput = {
  id: string,
  fundraisingCampaignID?: string | null,
  name?: string | null,
  description?: string | null,
  default?: boolean | null,
  active?: boolean | null,
  restricted?: boolean | null,
  useDefaultCta?: boolean | null,
  customCta?: string | null,
  allowAmbassadorSpecificCrowbarVideos?: boolean | null,
  generalCrowbarVideoURI?: string | null,
  deleted?: boolean | null,
};

export type DeleteCampaignConversationFlowInput = {
  id: string,
};

export type CreateActionMessageDefinitionInput = {
  id?: string | null,
  campaignConversationFlowID: string,
  fundraisingCampaignID: string,
  name?: string | null,
  description?: string | null,
  type: ActionMessageType,
  messageTemplate?: string | null,
  onPositiveResponse?: string | null,
  onNegativeResponse?: string | null,
  reminderActionMessageDefinitionID?: string | null,
  reminderDelay?: number | null,
  sendReminderNotification?: boolean | null,
  reminderNotificationID?: string | null,
  beginningNode?: boolean | null,
  parentActionMessageDefinitionID?: string | null,
  viewType?: string | null,
};

export type ModelActionMessageDefinitionConditionInput = {
  campaignConversationFlowID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelActionMessageTypeInput | null,
  messageTemplate?: ModelStringInput | null,
  onPositiveResponse?: ModelIDInput | null,
  onNegativeResponse?: ModelIDInput | null,
  reminderActionMessageDefinitionID?: ModelIDInput | null,
  reminderDelay?: ModelIntInput | null,
  sendReminderNotification?: ModelBooleanInput | null,
  reminderNotificationID?: ModelIDInput | null,
  beginningNode?: ModelBooleanInput | null,
  parentActionMessageDefinitionID?: ModelIDInput | null,
  viewType?: ModelStringInput | null,
  and?: Array< ModelActionMessageDefinitionConditionInput | null > | null,
  or?: Array< ModelActionMessageDefinitionConditionInput | null > | null,
  not?: ModelActionMessageDefinitionConditionInput | null,
};

export type ModelActionMessageTypeInput = {
  eq?: ActionMessageType | null,
  ne?: ActionMessageType | null,
};

export type UpdateActionMessageDefinitionInput = {
  id: string,
  campaignConversationFlowID?: string | null,
  fundraisingCampaignID?: string | null,
  name?: string | null,
  description?: string | null,
  type?: ActionMessageType | null,
  messageTemplate?: string | null,
  onPositiveResponse?: string | null,
  onNegativeResponse?: string | null,
  reminderActionMessageDefinitionID?: string | null,
  reminderDelay?: number | null,
  sendReminderNotification?: boolean | null,
  reminderNotificationID?: string | null,
  beginningNode?: boolean | null,
  parentActionMessageDefinitionID?: string | null,
  viewType?: string | null,
};

export type DeleteActionMessageDefinitionInput = {
  id: string,
};

export type CreateActionMessageInput = {
  id?: string | null,
  fundraisingCampaignID: string,
  fundraisingCampaignAmbassadorID: string,
  fundraisingCampaignAmbassadorContactID: string,
  actionMessageDefinitionID: string,
  sent?: boolean | null,
  sentTimestamp?: string | null,
  response?: ActionMessageResponseType | null,
  responseTimestamp?: string | null,
};

export type ModelActionMessageConditionInput = {
  fundraisingCampaignID?: ModelIDInput | null,
  fundraisingCampaignAmbassadorID?: ModelIDInput | null,
  fundraisingCampaignAmbassadorContactID?: ModelIDInput | null,
  actionMessageDefinitionID?: ModelIDInput | null,
  sent?: ModelBooleanInput | null,
  sentTimestamp?: ModelStringInput | null,
  response?: ModelActionMessageResponseTypeInput | null,
  responseTimestamp?: ModelStringInput | null,
  and?: Array< ModelActionMessageConditionInput | null > | null,
  or?: Array< ModelActionMessageConditionInput | null > | null,
  not?: ModelActionMessageConditionInput | null,
};

export type ModelActionMessageResponseTypeInput = {
  eq?: ActionMessageResponseType | null,
  ne?: ActionMessageResponseType | null,
};

export type UpdateActionMessageInput = {
  id: string,
  fundraisingCampaignID?: string | null,
  fundraisingCampaignAmbassadorID?: string | null,
  fundraisingCampaignAmbassadorContactID?: string | null,
  actionMessageDefinitionID?: string | null,
  sent?: boolean | null,
  sentTimestamp?: string | null,
  response?: ActionMessageResponseType | null,
  responseTimestamp?: string | null,
};

export type DeleteActionMessageInput = {
  id: string,
};

export type CreateProjectInput = {
  id?: string | null,
  status?: string | null,
  name: string,
  description?: string | null,
};

export type ModelProjectConditionInput = {
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelProjectConditionInput | null > | null,
  or?: Array< ModelProjectConditionInput | null > | null,
  not?: ModelProjectConditionInput | null,
};

export type UpdateProjectInput = {
  id: string,
  status?: string | null,
  name?: string | null,
  description?: string | null,
};

export type DeleteProjectInput = {
  id: string,
};

export type CreateTaskInput = {
  id?: string | null,
  projectID: string,
  isTopLevelTask?: boolean | null,
  name?: string | null,
  overview?: string | null,
  description?: string | null,
  descriptionRTE?: string | null,
  status?: string | null,
  complete?: boolean | null,
  mediaURI?: Array< string | null > | null,
  createdByID?: string | null,
  actionURL?: string | null,
  dueDate?: string | null,
};

export type ModelTaskConditionInput = {
  projectID?: ModelIDInput | null,
  isTopLevelTask?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  overview?: ModelStringInput | null,
  description?: ModelStringInput | null,
  descriptionRTE?: ModelStringInput | null,
  status?: ModelStringInput | null,
  complete?: ModelBooleanInput | null,
  mediaURI?: ModelStringInput | null,
  createdByID?: ModelIDInput | null,
  actionURL?: ModelStringInput | null,
  dueDate?: ModelStringInput | null,
  and?: Array< ModelTaskConditionInput | null > | null,
  or?: Array< ModelTaskConditionInput | null > | null,
  not?: ModelTaskConditionInput | null,
};

export type UpdateTaskInput = {
  id: string,
  projectID?: string | null,
  isTopLevelTask?: boolean | null,
  name?: string | null,
  overview?: string | null,
  description?: string | null,
  descriptionRTE?: string | null,
  status?: string | null,
  complete?: boolean | null,
  mediaURI?: Array< string | null > | null,
  createdByID?: string | null,
  actionURL?: string | null,
  dueDate?: string | null,
};

export type DeleteTaskInput = {
  id: string,
};

export type CreateTaskAttachmentInput = {
  id?: string | null,
  taskID: string,
  uploadedByID: string,
  name?: string | null,
  description?: string | null,
  contentType?: string | null,
};

export type ModelTaskAttachmentConditionInput = {
  taskID?: ModelIDInput | null,
  uploadedByID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  contentType?: ModelStringInput | null,
  and?: Array< ModelTaskAttachmentConditionInput | null > | null,
  or?: Array< ModelTaskAttachmentConditionInput | null > | null,
  not?: ModelTaskAttachmentConditionInput | null,
};

export type UpdateTaskAttachmentInput = {
  id: string,
  taskID?: string | null,
  uploadedByID?: string | null,
  name?: string | null,
  description?: string | null,
  contentType?: string | null,
};

export type DeleteTaskAttachmentInput = {
  id: string,
};

export type CreateTaskBlockerInput = {
  id?: string | null,
  originTaskID: string,
  blockerTaskID: string,
  notes?: string | null,
  taskBlockedById?: string | null,
  taskBlockingId?: string | null,
};

export type ModelTaskBlockerConditionInput = {
  originTaskID?: ModelIDInput | null,
  blockerTaskID?: ModelIDInput | null,
  notes?: ModelStringInput | null,
  and?: Array< ModelTaskBlockerConditionInput | null > | null,
  or?: Array< ModelTaskBlockerConditionInput | null > | null,
  not?: ModelTaskBlockerConditionInput | null,
};

export type UpdateTaskBlockerInput = {
  id: string,
  originTaskID?: string | null,
  blockerTaskID?: string | null,
  notes?: string | null,
  taskBlockedById?: string | null,
  taskBlockingId?: string | null,
};

export type DeleteTaskBlockerInput = {
  id: string,
};

export type CreateSubTaskInput = {
  id?: string | null,
  parentTaskID: string,
  subTaskID: string,
};

export type ModelSubTaskConditionInput = {
  parentTaskID?: ModelIDInput | null,
  subTaskID?: ModelIDInput | null,
  and?: Array< ModelSubTaskConditionInput | null > | null,
  or?: Array< ModelSubTaskConditionInput | null > | null,
  not?: ModelSubTaskConditionInput | null,
};

export type UpdateSubTaskInput = {
  id: string,
  parentTaskID?: string | null,
  subTaskID?: string | null,
};

export type DeleteSubTaskInput = {
  id: string,
};

export type CreateTaskCommentInput = {
  id?: string | null,
  taskID: string,
  comment?: string | null,
  mediaURI?: Array< string | null > | null,
  postedByID: string,
};

export type ModelTaskCommentConditionInput = {
  taskID?: ModelIDInput | null,
  comment?: ModelStringInput | null,
  mediaURI?: ModelStringInput | null,
  postedByID?: ModelIDInput | null,
  and?: Array< ModelTaskCommentConditionInput | null > | null,
  or?: Array< ModelTaskCommentConditionInput | null > | null,
  not?: ModelTaskCommentConditionInput | null,
};

export type UpdateTaskCommentInput = {
  id: string,
  taskID?: string | null,
  comment?: string | null,
  mediaURI?: Array< string | null > | null,
  postedByID?: string | null,
};

export type DeleteTaskCommentInput = {
  id: string,
};

export type CreateTaskAssignmentInput = {
  id?: string | null,
  taskID: string,
  authAccountID: string,
  staffProfileID?: string | null,
  notes?: string | null,
};

export type ModelTaskAssignmentConditionInput = {
  taskID?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  staffProfileID?: ModelIDInput | null,
  notes?: ModelStringInput | null,
  and?: Array< ModelTaskAssignmentConditionInput | null > | null,
  or?: Array< ModelTaskAssignmentConditionInput | null > | null,
  not?: ModelTaskAssignmentConditionInput | null,
};

export type UpdateTaskAssignmentInput = {
  id: string,
  taskID?: string | null,
  authAccountID?: string | null,
  staffProfileID?: string | null,
  notes?: string | null,
};

export type DeleteTaskAssignmentInput = {
  id: string,
};

export type CreateCognitoAccountInput = {
  id?: string | null,
  cognitoID: string,
  authAccountID?: string | null,
};

export type ModelCognitoAccountConditionInput = {
  cognitoID?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  and?: Array< ModelCognitoAccountConditionInput | null > | null,
  or?: Array< ModelCognitoAccountConditionInput | null > | null,
  not?: ModelCognitoAccountConditionInput | null,
};

export type UpdateCognitoAccountInput = {
  id: string,
  cognitoID?: string | null,
  authAccountID?: string | null,
};

export type DeleteCognitoAccountInput = {
  id: string,
};

export type CreateAuthAccountInput = {
  id?: string | null,
  volunteerProfileID?: string | null,
  lastSelectedStaffProfileID?: string | null,
  lastSelectedFundraisingProfileID?: string | null,
  communicationsProfileID?: string | null,
  name?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  primaryEmail?: string | null,
  phoneNumber?: string | null,
  dateOfBirth?: string | null,
  gender?: string | null,
  selfDescribedGender?: string | null,
  addressID?: string | null,
  website?: string | null,
  resumeURI?: string | null,
  bio?: string | null,
  profilePictureURI?: string | null,
  headerVideoURI?: string | null,
  headerImageURI?: string | null,
  headerAssetShown?: string | null,
  flourishAdmin?: boolean | null,
};

export type ModelAuthAccountConditionInput = {
  volunteerProfileID?: ModelIDInput | null,
  lastSelectedStaffProfileID?: ModelIDInput | null,
  lastSelectedFundraisingProfileID?: ModelIDInput | null,
  communicationsProfileID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  primaryEmail?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  selfDescribedGender?: ModelStringInput | null,
  addressID?: ModelIDInput | null,
  website?: ModelStringInput | null,
  resumeURI?: ModelStringInput | null,
  bio?: ModelStringInput | null,
  profilePictureURI?: ModelStringInput | null,
  headerVideoURI?: ModelStringInput | null,
  headerImageURI?: ModelStringInput | null,
  headerAssetShown?: ModelStringInput | null,
  flourishAdmin?: ModelBooleanInput | null,
  and?: Array< ModelAuthAccountConditionInput | null > | null,
  or?: Array< ModelAuthAccountConditionInput | null > | null,
  not?: ModelAuthAccountConditionInput | null,
};

export type UpdateAuthAccountInput = {
  id: string,
  volunteerProfileID?: string | null,
  lastSelectedStaffProfileID?: string | null,
  lastSelectedFundraisingProfileID?: string | null,
  communicationsProfileID?: string | null,
  name?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  primaryEmail?: string | null,
  phoneNumber?: string | null,
  dateOfBirth?: string | null,
  gender?: string | null,
  selfDescribedGender?: string | null,
  addressID?: string | null,
  website?: string | null,
  resumeURI?: string | null,
  bio?: string | null,
  profilePictureURI?: string | null,
  headerVideoURI?: string | null,
  headerImageURI?: string | null,
  headerAssetShown?: string | null,
  flourishAdmin?: boolean | null,
};

export type DeleteAuthAccountInput = {
  id: string,
};

export type CreateStaffProfileInput = {
  id?: string | null,
  authAccountID?: string | null,
  organizationID?: string | null,
  role?: StaffProfileRole | null,
  name?: string | null,
  nylasAccountID?: string | null,
  nylasCalendarToken?: string | null,
  nylasPrimaryCalendarID?: string | null,
};

export type ModelStaffProfileConditionInput = {
  authAccountID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  role?: ModelStaffProfileRoleInput | null,
  name?: ModelStringInput | null,
  nylasAccountID?: ModelStringInput | null,
  nylasCalendarToken?: ModelStringInput | null,
  nylasPrimaryCalendarID?: ModelStringInput | null,
  and?: Array< ModelStaffProfileConditionInput | null > | null,
  or?: Array< ModelStaffProfileConditionInput | null > | null,
  not?: ModelStaffProfileConditionInput | null,
};

export type ModelStaffProfileRoleInput = {
  eq?: StaffProfileRole | null,
  ne?: StaffProfileRole | null,
};

export type UpdateStaffProfileInput = {
  id: string,
  authAccountID?: string | null,
  organizationID?: string | null,
  role?: StaffProfileRole | null,
  name?: string | null,
  nylasAccountID?: string | null,
  nylasCalendarToken?: string | null,
  nylasPrimaryCalendarID?: string | null,
};

export type DeleteStaffProfileInput = {
  id: string,
};

export type CreateCommunicationsProfileInput = {
  id?: string | null,
  authAccountID: string,
  streamJwt?: string | null,
  notificationSettingsID?: string | null,
};

export type ModelCommunicationsProfileConditionInput = {
  authAccountID?: ModelIDInput | null,
  streamJwt?: ModelStringInput | null,
  notificationSettingsID?: ModelIDInput | null,
  and?: Array< ModelCommunicationsProfileConditionInput | null > | null,
  or?: Array< ModelCommunicationsProfileConditionInput | null > | null,
  not?: ModelCommunicationsProfileConditionInput | null,
};

export type UpdateCommunicationsProfileInput = {
  id: string,
  authAccountID?: string | null,
  streamJwt?: string | null,
  notificationSettingsID?: string | null,
};

export type DeleteCommunicationsProfileInput = {
  id: string,
};

export type CreateFundraisingProfileInput = {
  id?: string | null,
  authAccountID?: string | null,
  organizationID?: string | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  classyMemberID?: string | null,
};

export type ModelFundraisingProfileConditionInput = {
  authAccountID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  classyMemberID?: ModelStringInput | null,
  and?: Array< ModelFundraisingProfileConditionInput | null > | null,
  or?: Array< ModelFundraisingProfileConditionInput | null > | null,
  not?: ModelFundraisingProfileConditionInput | null,
};

export type UpdateFundraisingProfileInput = {
  id: string,
  authAccountID?: string | null,
  organizationID?: string | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  classyMemberID?: string | null,
};

export type DeleteFundraisingProfileInput = {
  id: string,
};

export type CreateStaffInvitationInput = {
  id?: string | null,
  code: string,
  type: StaffInvitationType,
  email?: string | null,
  domain?: string | null,
  name?: string | null,
  organizationID: string,
  authAccountID?: string | null,
  staffProfileID?: string | null,
  used?: boolean | null,
  usedTimestamp?: string | null,
  invitationSent?: boolean | null,
  invitationSentTimestamp?: string | null,
};

export enum StaffInvitationType {
  singleUse = "singleUse",
  unlimited = "unlimited",
  unlimitedWithDomain = "unlimitedWithDomain",
}


export type ModelStaffInvitationConditionInput = {
  code?: ModelIDInput | null,
  type?: ModelStaffInvitationTypeInput | null,
  email?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  name?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  staffProfileID?: ModelIDInput | null,
  used?: ModelBooleanInput | null,
  usedTimestamp?: ModelStringInput | null,
  invitationSent?: ModelBooleanInput | null,
  invitationSentTimestamp?: ModelStringInput | null,
  and?: Array< ModelStaffInvitationConditionInput | null > | null,
  or?: Array< ModelStaffInvitationConditionInput | null > | null,
  not?: ModelStaffInvitationConditionInput | null,
};

export type ModelStaffInvitationTypeInput = {
  eq?: StaffInvitationType | null,
  ne?: StaffInvitationType | null,
};

export type StaffInvitation = {
  __typename: "StaffInvitation",
  id: string,
  code: string,
  type: StaffInvitationType,
  email?: string | null,
  domain?: string | null,
  name?: string | null,
  organizationID: string,
  authAccountID?: string | null,
  staffProfileID?: string | null,
  used?: boolean | null,
  usedTimestamp?: string | null,
  invitationSent?: boolean | null,
  invitationSentTimestamp?: string | null,
  createdAt: string,
  updatedAt: string,
  authAccount?: AuthAccount | null,
  staffProfile?: StaffProfile | null,
  owner?: string | null,
  organization?: Organization | null,
};

export type UpdateStaffInvitationInput = {
  id: string,
  code?: string | null,
  type?: StaffInvitationType | null,
  email?: string | null,
  domain?: string | null,
  name?: string | null,
  organizationID?: string | null,
  authAccountID?: string | null,
  staffProfileID?: string | null,
  used?: boolean | null,
  usedTimestamp?: string | null,
  invitationSent?: boolean | null,
  invitationSentTimestamp?: string | null,
};

export type DeleteStaffInvitationInput = {
  id: string,
};

export type CreateFundraisingInvitationInput = {
  id?: string | null,
  code: string,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  domain?: string | null,
  name?: string | null,
  organizationID: string,
  authAccountID?: string | null,
  fundraisingProfileID?: string | null,
  used?: boolean | null,
  usedTimestamp?: string | null,
  invitationSent?: boolean | null,
  invitationSentTimestamp?: string | null,
};

export type ModelFundraisingInvitationConditionInput = {
  code?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  name?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  fundraisingProfileID?: ModelIDInput | null,
  used?: ModelBooleanInput | null,
  usedTimestamp?: ModelStringInput | null,
  invitationSent?: ModelBooleanInput | null,
  invitationSentTimestamp?: ModelStringInput | null,
  and?: Array< ModelFundraisingInvitationConditionInput | null > | null,
  or?: Array< ModelFundraisingInvitationConditionInput | null > | null,
  not?: ModelFundraisingInvitationConditionInput | null,
};

export type FundraisingInvitation = {
  __typename: "FundraisingInvitation",
  id: string,
  code: string,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  domain?: string | null,
  name?: string | null,
  organizationID: string,
  authAccountID?: string | null,
  fundraisingProfileID?: string | null,
  used?: boolean | null,
  usedTimestamp?: string | null,
  invitationSent?: boolean | null,
  invitationSentTimestamp?: string | null,
  createdAt: string,
  updatedAt: string,
  authAccount?: AuthAccount | null,
  fundraisingProfile?: FundraisingProfile | null,
  owner?: string | null,
  organization?: Organization | null,
};

export type UpdateFundraisingInvitationInput = {
  id: string,
  code?: string | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  domain?: string | null,
  name?: string | null,
  organizationID?: string | null,
  authAccountID?: string | null,
  fundraisingProfileID?: string | null,
  used?: boolean | null,
  usedTimestamp?: string | null,
  invitationSent?: boolean | null,
  invitationSentTimestamp?: string | null,
};

export type DeleteFundraisingInvitationInput = {
  id: string,
};

export type CreateVolunteerInvitationInput = {
  id?: string | null,
  code: string,
  email: string,
  name?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  organizationID?: string | null,
  used: boolean,
  usedTimestamp?: string | null,
  invitationSent: boolean,
  invitationSentTimestamp?: string | null,
};

export type ModelVolunteerInvitationConditionInput = {
  code?: ModelStringInput | null,
  email?: ModelStringInput | null,
  name?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  used?: ModelBooleanInput | null,
  usedTimestamp?: ModelStringInput | null,
  invitationSent?: ModelBooleanInput | null,
  invitationSentTimestamp?: ModelStringInput | null,
  and?: Array< ModelVolunteerInvitationConditionInput | null > | null,
  or?: Array< ModelVolunteerInvitationConditionInput | null > | null,
  not?: ModelVolunteerInvitationConditionInput | null,
};

export type VolunteerInvitation = {
  __typename: "VolunteerInvitation",
  id: string,
  code: string,
  email: string,
  name?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  organizationID?: string | null,
  used: boolean,
  usedTimestamp?: string | null,
  invitationSent: boolean,
  invitationSentTimestamp?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
  organization?: Organization | null,
};

export type UpdateVolunteerInvitationInput = {
  id: string,
  code?: string | null,
  email?: string | null,
  name?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  organizationID?: string | null,
  used?: boolean | null,
  usedTimestamp?: string | null,
  invitationSent?: boolean | null,
  invitationSentTimestamp?: string | null,
};

export type DeleteVolunteerInvitationInput = {
  id: string,
};

export type CreateVolunteerWaitlistInput = {
  id?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  zipCode?: number | null,
  about?: string | null,
  invited?: boolean | null,
};

export type ModelVolunteerWaitlistConditionInput = {
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  zipCode?: ModelFloatInput | null,
  about?: ModelStringInput | null,
  invited?: ModelBooleanInput | null,
  and?: Array< ModelVolunteerWaitlistConditionInput | null > | null,
  or?: Array< ModelVolunteerWaitlistConditionInput | null > | null,
  not?: ModelVolunteerWaitlistConditionInput | null,
};

export type VolunteerWaitlist = {
  __typename: "VolunteerWaitlist",
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  zipCode?: number | null,
  about?: string | null,
  invited?: boolean | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateVolunteerWaitlistInput = {
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  zipCode?: number | null,
  about?: string | null,
  invited?: boolean | null,
};

export type DeleteVolunteerWaitlistInput = {
  id: string,
};

export type CreateSkillInput = {
  id?: string | null,
  key: string,
  name: string,
  description?: string | null,
};

export type ModelSkillConditionInput = {
  key?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelSkillConditionInput | null > | null,
  or?: Array< ModelSkillConditionInput | null > | null,
  not?: ModelSkillConditionInput | null,
};

export type UpdateSkillInput = {
  id: string,
  key?: string | null,
  name?: string | null,
  description?: string | null,
};

export type DeleteSkillInput = {
  id: string,
};

export type CreateOrganizationInput = {
  id?: string | null,
  name: string,
  shortName?: string | null,
  description?: string | null,
  locationID?: string | null,
  website?: string | null,
  phoneNumber?: string | null,
  stripeConnectedAccountID?: string | null,
  stripeConnectedAccountStatus?: string | null,
  headerImageURI?: string | null,
  ambassadorTermOverrideSingular?: string | null,
  ambassadorTermOverridePlural?: string | null,
  streamJwt?: string | null,
  latentSubscription?: number | null,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  designation?: string | null,
  detailsID?: string | null,
};

export type ModelOrganizationConditionInput = {
  name?: ModelStringInput | null,
  shortName?: ModelStringInput | null,
  description?: ModelStringInput | null,
  locationID?: ModelIDInput | null,
  website?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  stripeConnectedAccountID?: ModelStringInput | null,
  stripeConnectedAccountStatus?: ModelStringInput | null,
  headerImageURI?: ModelStringInput | null,
  ambassadorTermOverrideSingular?: ModelStringInput | null,
  ambassadorTermOverridePlural?: ModelStringInput | null,
  streamJwt?: ModelStringInput | null,
  latentSubscription?: ModelIntInput | null,
  primaryColor?: ModelStringInput | null,
  secondaryColor?: ModelStringInput | null,
  designation?: ModelStringInput | null,
  detailsID?: ModelIDInput | null,
  and?: Array< ModelOrganizationConditionInput | null > | null,
  or?: Array< ModelOrganizationConditionInput | null > | null,
  not?: ModelOrganizationConditionInput | null,
};

export type UpdateOrganizationInput = {
  id: string,
  name?: string | null,
  shortName?: string | null,
  description?: string | null,
  locationID?: string | null,
  website?: string | null,
  phoneNumber?: string | null,
  stripeConnectedAccountID?: string | null,
  stripeConnectedAccountStatus?: string | null,
  headerImageURI?: string | null,
  ambassadorTermOverrideSingular?: string | null,
  ambassadorTermOverridePlural?: string | null,
  streamJwt?: string | null,
  latentSubscription?: number | null,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  designation?: string | null,
  detailsID?: string | null,
};

export type DeleteOrganizationInput = {
  id: string,
};

export type CreateLocationInput = {
  id?: string | null,
  type: LocationType,
  name: string,
  details?: string | null,
  addressID?: string | null,
  organizationID?: string | null,
};

export type ModelLocationConditionInput = {
  type?: ModelLocationTypeInput | null,
  name?: ModelStringInput | null,
  details?: ModelStringInput | null,
  addressID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  and?: Array< ModelLocationConditionInput | null > | null,
  or?: Array< ModelLocationConditionInput | null > | null,
  not?: ModelLocationConditionInput | null,
};

export type UpdateLocationInput = {
  id: string,
  type?: LocationType | null,
  name?: string | null,
  details?: string | null,
  addressID?: string | null,
  organizationID?: string | null,
};

export type DeleteLocationInput = {
  id: string,
};

export type CreateAddressInput = {
  id?: string | null,
  streetAddress?: string | null,
  unit?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  zipPlusFour?: string | null,
  longitude?: number | null,
  latitude?: number | null,
};

export type ModelAddressConditionInput = {
  streetAddress?: ModelStringInput | null,
  unit?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  zip?: ModelStringInput | null,
  zipPlusFour?: ModelStringInput | null,
  longitude?: ModelFloatInput | null,
  latitude?: ModelFloatInput | null,
  and?: Array< ModelAddressConditionInput | null > | null,
  or?: Array< ModelAddressConditionInput | null > | null,
  not?: ModelAddressConditionInput | null,
};

export type UpdateAddressInput = {
  id: string,
  streetAddress?: string | null,
  unit?: string | null,
  city?: string | null,
  state?: string | null,
  zip?: string | null,
  zipPlusFour?: string | null,
  longitude?: number | null,
  latitude?: number | null,
};

export type DeleteAddressInput = {
  id: string,
};

export type CreateFundraisingCampaignInput = {
  id?: string | null,
  type: FundraisingCampaignType,
  organizationID: string,
  staffLeadID?: string | null,
  campaignName?: string | null,
  introVideoURI?: string | null,
  textMessageTemplate?: string | null,
  initialMessageReminderTemplate?: string | null,
  phoneCallScriptTemplate?: string | null,
  followUpMessageTemplate?: string | null,
  followUpYesMessageTemplate?: string | null,
  followUpNoMessageTemplate?: string | null,
  followUpReminderMessageTemplate?: string | null,
  showVideo?: boolean | null,
  showText?: boolean | null,
  showCall?: boolean | null,
  showFollowUp?: boolean | null,
  active?: boolean | null,
  publicVideoID?: string | null,
  publicVideoProvider?: string | null,
  campaignStartDate?: string | null,
  campaignStartTime?: string | null,
  campaignTimeZone?: string | null,
  campaignEndDate?: string | null,
  campaignEndTime?: string | null,
  publicCampaignAbout?: string | null,
  publicCampaignIntro?: string | null,
  campaignGoal?: number | null,
  perAmbassadorGoal?: number | null,
  totalAmbassadorsGoal?: number | null,
  perContactDonationGoal?: number | null,
  progressChartType?: string | null,
  ctaURL?: string | null,
  pageLayout?: string | null,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  buttonBackgroundColor?: string | null,
  buttonTextColor?: string | null,
  customHeaderImageUploaded?: boolean | null,
  customLogoImageUploaded?: boolean | null,
  headerFont?: string | null,
  bodyFont?: string | null,
  ctaButtonText?: string | null,
  givingCircleBaseAmount?: number | null,
  givingCircleIncrements?: Array< number | null > | null,
  givingCircleAllowCustomAmounts?: boolean | null,
  ambassadorSpecificVideoUrlEnabled?: boolean | null,
  ambassadorCanUploadVideoUrl?: boolean | null,
  ambassadorSpecificCtaUrlEnabled?: boolean | null,
  ambassadorCanUploadCtaUrl?: boolean | null,
  crowbarVideoURL?: string | null,
  recruitmentForCampaignID?: string | null,
  classyCampaignID?: string | null,
  classyAutogenerateAmbassadorTeams?: boolean | null,
  classyDonationPageHostURL?: string | null,
  useClassyCtaURL?: boolean | null,
  useClassyFundraiserPage?: boolean | null,
  personalFundraisingCampaignID?: string | null,
  onDemandDiscoveryMeetingEnabled?: boolean | null,
  onDemandDiscoveryMeetingURL?: string | null,
  onDemandDiscoveryMeetingID?: string | null,
  onDemandDiscoveryMeetingInvitationCode?: string | null,
  defaultConversationFlowID?: string | null,
  useConversationFlows?: boolean | null,
  campaignPageID?: string | null,
  ambassadorPageID?: string | null,
  donationPageID?: string | null,
  discoveryPageID?: string | null,
  projectID?: string | null,
  useActionCardView?: boolean | null,
};

export type ModelFundraisingCampaignConditionInput = {
  type?: ModelFundraisingCampaignTypeInput | null,
  organizationID?: ModelIDInput | null,
  staffLeadID?: ModelIDInput | null,
  campaignName?: ModelStringInput | null,
  introVideoURI?: ModelStringInput | null,
  textMessageTemplate?: ModelStringInput | null,
  initialMessageReminderTemplate?: ModelStringInput | null,
  phoneCallScriptTemplate?: ModelStringInput | null,
  followUpMessageTemplate?: ModelStringInput | null,
  followUpYesMessageTemplate?: ModelStringInput | null,
  followUpNoMessageTemplate?: ModelStringInput | null,
  followUpReminderMessageTemplate?: ModelStringInput | null,
  showVideo?: ModelBooleanInput | null,
  showText?: ModelBooleanInput | null,
  showCall?: ModelBooleanInput | null,
  showFollowUp?: ModelBooleanInput | null,
  active?: ModelBooleanInput | null,
  publicVideoID?: ModelStringInput | null,
  publicVideoProvider?: ModelStringInput | null,
  campaignStartDate?: ModelStringInput | null,
  campaignStartTime?: ModelStringInput | null,
  campaignTimeZone?: ModelStringInput | null,
  campaignEndDate?: ModelStringInput | null,
  campaignEndTime?: ModelStringInput | null,
  publicCampaignAbout?: ModelStringInput | null,
  publicCampaignIntro?: ModelStringInput | null,
  campaignGoal?: ModelFloatInput | null,
  perAmbassadorGoal?: ModelFloatInput | null,
  totalAmbassadorsGoal?: ModelFloatInput | null,
  perContactDonationGoal?: ModelFloatInput | null,
  progressChartType?: ModelStringInput | null,
  ctaURL?: ModelStringInput | null,
  pageLayout?: ModelStringInput | null,
  primaryColor?: ModelStringInput | null,
  secondaryColor?: ModelStringInput | null,
  buttonBackgroundColor?: ModelStringInput | null,
  buttonTextColor?: ModelStringInput | null,
  customHeaderImageUploaded?: ModelBooleanInput | null,
  customLogoImageUploaded?: ModelBooleanInput | null,
  headerFont?: ModelStringInput | null,
  bodyFont?: ModelStringInput | null,
  ctaButtonText?: ModelStringInput | null,
  givingCircleBaseAmount?: ModelFloatInput | null,
  givingCircleIncrements?: ModelFloatInput | null,
  givingCircleAllowCustomAmounts?: ModelBooleanInput | null,
  ambassadorSpecificVideoUrlEnabled?: ModelBooleanInput | null,
  ambassadorCanUploadVideoUrl?: ModelBooleanInput | null,
  ambassadorSpecificCtaUrlEnabled?: ModelBooleanInput | null,
  ambassadorCanUploadCtaUrl?: ModelBooleanInput | null,
  crowbarVideoURL?: ModelStringInput | null,
  recruitmentForCampaignID?: ModelIDInput | null,
  classyCampaignID?: ModelStringInput | null,
  classyAutogenerateAmbassadorTeams?: ModelBooleanInput | null,
  classyDonationPageHostURL?: ModelStringInput | null,
  useClassyCtaURL?: ModelBooleanInput | null,
  useClassyFundraiserPage?: ModelBooleanInput | null,
  personalFundraisingCampaignID?: ModelIDInput | null,
  onDemandDiscoveryMeetingEnabled?: ModelBooleanInput | null,
  onDemandDiscoveryMeetingURL?: ModelStringInput | null,
  onDemandDiscoveryMeetingID?: ModelIDInput | null,
  onDemandDiscoveryMeetingInvitationCode?: ModelStringInput | null,
  defaultConversationFlowID?: ModelIDInput | null,
  useConversationFlows?: ModelBooleanInput | null,
  campaignPageID?: ModelIDInput | null,
  ambassadorPageID?: ModelIDInput | null,
  donationPageID?: ModelIDInput | null,
  discoveryPageID?: ModelIDInput | null,
  projectID?: ModelIDInput | null,
  useActionCardView?: ModelBooleanInput | null,
  and?: Array< ModelFundraisingCampaignConditionInput | null > | null,
  or?: Array< ModelFundraisingCampaignConditionInput | null > | null,
  not?: ModelFundraisingCampaignConditionInput | null,
};

export type ModelFundraisingCampaignTypeInput = {
  eq?: FundraisingCampaignType | null,
  ne?: FundraisingCampaignType | null,
};

export type UpdateFundraisingCampaignInput = {
  id: string,
  type?: FundraisingCampaignType | null,
  organizationID?: string | null,
  staffLeadID?: string | null,
  campaignName?: string | null,
  introVideoURI?: string | null,
  textMessageTemplate?: string | null,
  initialMessageReminderTemplate?: string | null,
  phoneCallScriptTemplate?: string | null,
  followUpMessageTemplate?: string | null,
  followUpYesMessageTemplate?: string | null,
  followUpNoMessageTemplate?: string | null,
  followUpReminderMessageTemplate?: string | null,
  showVideo?: boolean | null,
  showText?: boolean | null,
  showCall?: boolean | null,
  showFollowUp?: boolean | null,
  active?: boolean | null,
  publicVideoID?: string | null,
  publicVideoProvider?: string | null,
  campaignStartDate?: string | null,
  campaignStartTime?: string | null,
  campaignTimeZone?: string | null,
  campaignEndDate?: string | null,
  campaignEndTime?: string | null,
  publicCampaignAbout?: string | null,
  publicCampaignIntro?: string | null,
  campaignGoal?: number | null,
  perAmbassadorGoal?: number | null,
  totalAmbassadorsGoal?: number | null,
  perContactDonationGoal?: number | null,
  progressChartType?: string | null,
  ctaURL?: string | null,
  pageLayout?: string | null,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  buttonBackgroundColor?: string | null,
  buttonTextColor?: string | null,
  customHeaderImageUploaded?: boolean | null,
  customLogoImageUploaded?: boolean | null,
  headerFont?: string | null,
  bodyFont?: string | null,
  ctaButtonText?: string | null,
  givingCircleBaseAmount?: number | null,
  givingCircleIncrements?: Array< number | null > | null,
  givingCircleAllowCustomAmounts?: boolean | null,
  ambassadorSpecificVideoUrlEnabled?: boolean | null,
  ambassadorCanUploadVideoUrl?: boolean | null,
  ambassadorSpecificCtaUrlEnabled?: boolean | null,
  ambassadorCanUploadCtaUrl?: boolean | null,
  crowbarVideoURL?: string | null,
  recruitmentForCampaignID?: string | null,
  classyCampaignID?: string | null,
  classyAutogenerateAmbassadorTeams?: boolean | null,
  classyDonationPageHostURL?: string | null,
  useClassyCtaURL?: boolean | null,
  useClassyFundraiserPage?: boolean | null,
  personalFundraisingCampaignID?: string | null,
  onDemandDiscoveryMeetingEnabled?: boolean | null,
  onDemandDiscoveryMeetingURL?: string | null,
  onDemandDiscoveryMeetingID?: string | null,
  onDemandDiscoveryMeetingInvitationCode?: string | null,
  defaultConversationFlowID?: string | null,
  useConversationFlows?: boolean | null,
  campaignPageID?: string | null,
  ambassadorPageID?: string | null,
  donationPageID?: string | null,
  discoveryPageID?: string | null,
  projectID?: string | null,
  useActionCardView?: boolean | null,
};

export type DeleteFundraisingCampaignInput = {
  id: string,
};

export type CreateCampaignPageInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  type?: CampaignPageType | null,
  fundraisingCampaignID: string,
  campaignDisplayConfigurationID?: string | null,
  pageHtml?: string | null,
  pageJSON?: string | null,
  pageCssJSON?: string | null,
  pageAssetsJSON?: string | null,
};

export type ModelCampaignPageConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelCampaignPageTypeInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  campaignDisplayConfigurationID?: ModelIDInput | null,
  pageHtml?: ModelStringInput | null,
  pageJSON?: ModelStringInput | null,
  pageCssJSON?: ModelStringInput | null,
  pageAssetsJSON?: ModelStringInput | null,
  and?: Array< ModelCampaignPageConditionInput | null > | null,
  or?: Array< ModelCampaignPageConditionInput | null > | null,
  not?: ModelCampaignPageConditionInput | null,
};

export type ModelCampaignPageTypeInput = {
  eq?: CampaignPageType | null,
  ne?: CampaignPageType | null,
};

export type UpdateCampaignPageInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  type?: CampaignPageType | null,
  fundraisingCampaignID?: string | null,
  campaignDisplayConfigurationID?: string | null,
  pageHtml?: string | null,
  pageJSON?: string | null,
  pageCssJSON?: string | null,
  pageAssetsJSON?: string | null,
};

export type DeleteCampaignPageInput = {
  id: string,
};

export type CreateCampaignDisplayConfigurationInput = {
  id?: string | null,
  campaignPageID: string,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  gradientLeftColor?: string | null,
  gradientRightColor?: string | null,
  buttonBackgroundColor?: string | null,
  buttonTextColor?: string | null,
  headerFont?: string | null,
  bodyFont?: string | null,
};

export type ModelCampaignDisplayConfigurationConditionInput = {
  campaignPageID?: ModelIDInput | null,
  primaryColor?: ModelStringInput | null,
  secondaryColor?: ModelStringInput | null,
  gradientLeftColor?: ModelStringInput | null,
  gradientRightColor?: ModelStringInput | null,
  buttonBackgroundColor?: ModelStringInput | null,
  buttonTextColor?: ModelStringInput | null,
  headerFont?: ModelStringInput | null,
  bodyFont?: ModelStringInput | null,
  and?: Array< ModelCampaignDisplayConfigurationConditionInput | null > | null,
  or?: Array< ModelCampaignDisplayConfigurationConditionInput | null > | null,
  not?: ModelCampaignDisplayConfigurationConditionInput | null,
};

export type UpdateCampaignDisplayConfigurationInput = {
  id: string,
  campaignPageID?: string | null,
  primaryColor?: string | null,
  secondaryColor?: string | null,
  gradientLeftColor?: string | null,
  gradientRightColor?: string | null,
  buttonBackgroundColor?: string | null,
  buttonTextColor?: string | null,
  headerFont?: string | null,
  bodyFont?: string | null,
};

export type DeleteCampaignDisplayConfigurationInput = {
  id: string,
};

export type CreateNylasEventInput = {
  id?: string | null,
  calendarID?: string | null,
  owner?: string | null,
  fundraisingCampaignDiscoveryCallID?: string | null,
  status?: string | null,
};

export type ModelNylasEventConditionInput = {
  calendarID?: ModelStringInput | null,
  fundraisingCampaignDiscoveryCallID?: ModelIDInput | null,
  status?: ModelStringInput | null,
  and?: Array< ModelNylasEventConditionInput | null > | null,
  or?: Array< ModelNylasEventConditionInput | null > | null,
  not?: ModelNylasEventConditionInput | null,
};

export type NylasEvent = {
  __typename: "NylasEvent",
  id: string,
  calendarID?: string | null,
  owner?: string | null,
  fundraisingCampaignDiscoveryCallID?: string | null,
  status?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateNylasEventInput = {
  id: string,
  calendarID?: string | null,
  owner?: string | null,
  fundraisingCampaignDiscoveryCallID?: string | null,
  status?: string | null,
};

export type DeleteNylasEventInput = {
  id: string,
};

export type CreateFundraisingCampaignDiscoveryCallInput = {
  id?: string | null,
  title?: string | null,
  organizationID: string,
  fundraisingCampaignID: string,
  staffProfileID: string,
  startTimestamp: string,
  endTimestamp: string,
  latentHosted: boolean,
  invitationURL?: string | null,
  nylasEventID?: string | null,
  virtualMeetingURL?: string | null,
};

export type ModelFundraisingCampaignDiscoveryCallConditionInput = {
  title?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  staffProfileID?: ModelIDInput | null,
  startTimestamp?: ModelStringInput | null,
  endTimestamp?: ModelStringInput | null,
  latentHosted?: ModelBooleanInput | null,
  invitationURL?: ModelStringInput | null,
  nylasEventID?: ModelIDInput | null,
  virtualMeetingURL?: ModelStringInput | null,
  and?: Array< ModelFundraisingCampaignDiscoveryCallConditionInput | null > | null,
  or?: Array< ModelFundraisingCampaignDiscoveryCallConditionInput | null > | null,
  not?: ModelFundraisingCampaignDiscoveryCallConditionInput | null,
};

export type UpdateFundraisingCampaignDiscoveryCallInput = {
  id: string,
  title?: string | null,
  organizationID?: string | null,
  fundraisingCampaignID?: string | null,
  staffProfileID?: string | null,
  startTimestamp?: string | null,
  endTimestamp?: string | null,
  latentHosted?: boolean | null,
  invitationURL?: string | null,
  nylasEventID?: string | null,
  virtualMeetingURL?: string | null,
};

export type DeleteFundraisingCampaignDiscoveryCallInput = {
  id: string,
};

export type CreateDiscoveryCallParticipantInput = {
  id?: string | null,
  email: string,
  phoneNumber: string,
  firstName: string,
  lastName: string,
  authAccountID?: string | null,
  fundraisingProfileID?: string | null,
  fundraisingCampaignDiscoveryCallID: string,
  fundraisingCampaignID: string,
  invitationSent?: boolean | null,
  icsString?: string | null,
  status?: string | null,
  recruitedByCampaignAmbassadorID?: string | null,
  confirmed?: boolean | null,
  notes?: string | null,
};

export type ModelDiscoveryCallParticipantConditionInput = {
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  authAccountID?: ModelIDInput | null,
  fundraisingProfileID?: ModelIDInput | null,
  fundraisingCampaignDiscoveryCallID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  invitationSent?: ModelBooleanInput | null,
  icsString?: ModelStringInput | null,
  status?: ModelStringInput | null,
  recruitedByCampaignAmbassadorID?: ModelIDInput | null,
  confirmed?: ModelBooleanInput | null,
  notes?: ModelStringInput | null,
  and?: Array< ModelDiscoveryCallParticipantConditionInput | null > | null,
  or?: Array< ModelDiscoveryCallParticipantConditionInput | null > | null,
  not?: ModelDiscoveryCallParticipantConditionInput | null,
};

export type UpdateDiscoveryCallParticipantInput = {
  id: string,
  email?: string | null,
  phoneNumber?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  authAccountID?: string | null,
  fundraisingProfileID?: string | null,
  fundraisingCampaignDiscoveryCallID?: string | null,
  fundraisingCampaignID?: string | null,
  invitationSent?: boolean | null,
  icsString?: string | null,
  status?: string | null,
  recruitedByCampaignAmbassadorID?: string | null,
  confirmed?: boolean | null,
  notes?: string | null,
};

export type DeleteDiscoveryCallParticipantInput = {
  id: string,
};

export type CreateFundraisingCampaignAmbassadorInput = {
  id?: string | null,
  status?: FundraisingCampaignAmbassadorStatus | null,
  commitment?: FundraisingCampaignAmbassadorCommitment | null,
  fundraisingProfileID: string,
  fundraisingCampaignID: string,
  discoveryCallParticipantID?: string | null,
  fundsRaised?: number | null,
  initialTransactionID?: string | null,
  initialTransactionAmount?: number | null,
  ambassadorSpecificCtaUrl?: string | null,
  ambassadorSpecificVideoUrl?: string | null,
  recruitedByCampaignAmbassadorID?: string | null,
  classyTeamID?: string | null,
  classySupporterID?: string | null,
  classyFundraiserPageID?: string | null,
  notificationsEnabled?: boolean | null,
};

export type ModelFundraisingCampaignAmbassadorConditionInput = {
  status?: ModelFundraisingCampaignAmbassadorStatusInput | null,
  commitment?: ModelFundraisingCampaignAmbassadorCommitmentInput | null,
  fundraisingProfileID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  discoveryCallParticipantID?: ModelIDInput | null,
  fundsRaised?: ModelFloatInput | null,
  initialTransactionID?: ModelStringInput | null,
  initialTransactionAmount?: ModelFloatInput | null,
  ambassadorSpecificCtaUrl?: ModelStringInput | null,
  ambassadorSpecificVideoUrl?: ModelStringInput | null,
  recruitedByCampaignAmbassadorID?: ModelIDInput | null,
  classyTeamID?: ModelStringInput | null,
  classySupporterID?: ModelStringInput | null,
  classyFundraiserPageID?: ModelStringInput | null,
  notificationsEnabled?: ModelBooleanInput | null,
  and?: Array< ModelFundraisingCampaignAmbassadorConditionInput | null > | null,
  or?: Array< ModelFundraisingCampaignAmbassadorConditionInput | null > | null,
  not?: ModelFundraisingCampaignAmbassadorConditionInput | null,
};

export type ModelFundraisingCampaignAmbassadorCommitmentInput = {
  eq?: FundraisingCampaignAmbassadorCommitment | null,
  ne?: FundraisingCampaignAmbassadorCommitment | null,
};

export type UpdateFundraisingCampaignAmbassadorInput = {
  id: string,
  status?: FundraisingCampaignAmbassadorStatus | null,
  commitment?: FundraisingCampaignAmbassadorCommitment | null,
  fundraisingProfileID?: string | null,
  fundraisingCampaignID?: string | null,
  discoveryCallParticipantID?: string | null,
  fundsRaised?: number | null,
  initialTransactionID?: string | null,
  initialTransactionAmount?: number | null,
  ambassadorSpecificCtaUrl?: string | null,
  ambassadorSpecificVideoUrl?: string | null,
  recruitedByCampaignAmbassadorID?: string | null,
  classyTeamID?: string | null,
  classySupporterID?: string | null,
  classyFundraiserPageID?: string | null,
  notificationsEnabled?: boolean | null,
};

export type DeleteFundraisingCampaignAmbassadorInput = {
  id: string,
};

export type CreateFundraisingCampaignAmbassadorContactInput = {
  id?: string | null,
  deviceContactID: string,
  fundraisingProfileID: string,
  fundraisingCampaignID: string,
  fundraisingCampaignAmbassadorID: string,
  sentText?: boolean | null,
  sentTextTimestamp?: string | null,
  sentInitialTextReminder?: boolean | null,
  sentInitialTextReminderTimestamp?: string | null,
  sentPhoneCallScript?: boolean | null,
  sentPhoneCallScriptTimestamp?: string | null,
  called?: boolean | null,
  calledTimestamp?: string | null,
  sentFollowUp?: boolean | null,
  sentFollowUpTimestamp?: string | null,
  followUpResponse?: FollowUpResponse | null,
  sentReminder?: boolean | null,
  sentReminderTimestamp?: string | null,
  isDonating?: boolean | null,
  donationAmount?: number | null,
  discoveryCallParticipantID?: string | null,
  transactionID?: string | null,
  isActive?: boolean | null,
  notes?: string | null,
  birthday?: string | null,
  hasTakenAction?: boolean | null,
  hasTakenActionTimestamp?: string | null,
  occupation?: string | null,
  selectedPhoneNumberArrayIndex?: number | null,
};

export type ModelFundraisingCampaignAmbassadorContactConditionInput = {
  deviceContactID?: ModelIDInput | null,
  fundraisingProfileID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  fundraisingCampaignAmbassadorID?: ModelIDInput | null,
  sentText?: ModelBooleanInput | null,
  sentTextTimestamp?: ModelStringInput | null,
  sentInitialTextReminder?: ModelBooleanInput | null,
  sentInitialTextReminderTimestamp?: ModelStringInput | null,
  sentPhoneCallScript?: ModelBooleanInput | null,
  sentPhoneCallScriptTimestamp?: ModelStringInput | null,
  called?: ModelBooleanInput | null,
  calledTimestamp?: ModelStringInput | null,
  sentFollowUp?: ModelBooleanInput | null,
  sentFollowUpTimestamp?: ModelStringInput | null,
  followUpResponse?: ModelFollowUpResponseInput | null,
  sentReminder?: ModelBooleanInput | null,
  sentReminderTimestamp?: ModelStringInput | null,
  isDonating?: ModelBooleanInput | null,
  donationAmount?: ModelFloatInput | null,
  discoveryCallParticipantID?: ModelIDInput | null,
  transactionID?: ModelIDInput | null,
  isActive?: ModelBooleanInput | null,
  notes?: ModelStringInput | null,
  birthday?: ModelStringInput | null,
  hasTakenAction?: ModelBooleanInput | null,
  hasTakenActionTimestamp?: ModelStringInput | null,
  occupation?: ModelStringInput | null,
  selectedPhoneNumberArrayIndex?: ModelIntInput | null,
  and?: Array< ModelFundraisingCampaignAmbassadorContactConditionInput | null > | null,
  or?: Array< ModelFundraisingCampaignAmbassadorContactConditionInput | null > | null,
  not?: ModelFundraisingCampaignAmbassadorContactConditionInput | null,
};

export type ModelFollowUpResponseInput = {
  eq?: FollowUpResponse | null,
  ne?: FollowUpResponse | null,
};

export type UpdateFundraisingCampaignAmbassadorContactInput = {
  id: string,
  deviceContactID?: string | null,
  fundraisingProfileID?: string | null,
  fundraisingCampaignID?: string | null,
  fundraisingCampaignAmbassadorID?: string | null,
  sentText?: boolean | null,
  sentTextTimestamp?: string | null,
  sentInitialTextReminder?: boolean | null,
  sentInitialTextReminderTimestamp?: string | null,
  sentPhoneCallScript?: boolean | null,
  sentPhoneCallScriptTimestamp?: string | null,
  called?: boolean | null,
  calledTimestamp?: string | null,
  sentFollowUp?: boolean | null,
  sentFollowUpTimestamp?: string | null,
  followUpResponse?: FollowUpResponse | null,
  sentReminder?: boolean | null,
  sentReminderTimestamp?: string | null,
  isDonating?: boolean | null,
  donationAmount?: number | null,
  discoveryCallParticipantID?: string | null,
  transactionID?: string | null,
  isActive?: boolean | null,
  notes?: string | null,
  birthday?: string | null,
  hasTakenAction?: boolean | null,
  hasTakenActionTimestamp?: string | null,
  occupation?: string | null,
  selectedPhoneNumberArrayIndex?: number | null,
};

export type DeleteFundraisingCampaignAmbassadorContactInput = {
  id: string,
};

export type CreateFundraisingCampaignUpdateInput = {
  id?: string | null,
  fundraisingCampaignID: string,
  public: boolean,
  message?: string | null,
  assetsUploaded?: number | null,
  updateURL?: string | null,
  createdByStaffProfileID?: string | null,
  live: boolean,
  liveTimestamp?: string | null,
};

export type ModelFundraisingCampaignUpdateConditionInput = {
  fundraisingCampaignID?: ModelIDInput | null,
  public?: ModelBooleanInput | null,
  message?: ModelStringInput | null,
  assetsUploaded?: ModelIntInput | null,
  updateURL?: ModelStringInput | null,
  createdByStaffProfileID?: ModelIDInput | null,
  live?: ModelBooleanInput | null,
  liveTimestamp?: ModelStringInput | null,
  and?: Array< ModelFundraisingCampaignUpdateConditionInput | null > | null,
  or?: Array< ModelFundraisingCampaignUpdateConditionInput | null > | null,
  not?: ModelFundraisingCampaignUpdateConditionInput | null,
};

export type FundraisingCampaignUpdate = {
  __typename: "FundraisingCampaignUpdate",
  id: string,
  fundraisingCampaignID: string,
  public: boolean,
  message?: string | null,
  assetsUploaded?: number | null,
  updateURL?: string | null,
  createdByStaffProfileID?: string | null,
  live: boolean,
  liveTimestamp?: string | null,
  createdAt: string,
  updatedAt: string,
  createdByStaffProfile?: StaffProfile | null,
  fundraisingCampaign?: FundraisingCampaign | null,
  owner?: string | null,
};

export type UpdateFundraisingCampaignUpdateInput = {
  id: string,
  fundraisingCampaignID?: string | null,
  public?: boolean | null,
  message?: string | null,
  assetsUploaded?: number | null,
  updateURL?: string | null,
  createdByStaffProfileID?: string | null,
  live?: boolean | null,
  liveTimestamp?: string | null,
};

export type DeleteFundraisingCampaignUpdateInput = {
  id: string,
};

export type ModelVolunteerProfileFilterInput = {
  id?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  gender?: ModelGenderTypeInput | null,
  dateOfBirth?: ModelStringInput | null,
  streetAddress?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  zip?: ModelIntInput | null,
  website?: ModelStringInput | null,
  enneagram?: ModelIntInput | null,
  enneagramWing?: ModelIntInput | null,
  myersBriggs?: ModelStringInput | null,
  additionalInformation?: ModelStringInput | null,
  availabilityStringified?: ModelStringInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  and?: Array< ModelVolunteerProfileFilterInput | null > | null,
  or?: Array< ModelVolunteerProfileFilterInput | null > | null,
  not?: ModelVolunteerProfileFilterInput | null,
};

export type ModelVolunteerProfileConnection = {
  __typename: "ModelVolunteerProfileConnection",
  items:  Array<VolunteerProfile | null >,
  nextToken?: string | null,
};

export type ModelOrganizationInvitationFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelIDInput | null,
  email?: ModelStringInput | null,
  name?: ModelStringInput | null,
  used?: ModelBooleanInput | null,
  usedTimestamp?: ModelStringInput | null,
  invitationSent?: ModelBooleanInput | null,
  invitationSentTimestamp?: ModelStringInput | null,
  and?: Array< ModelOrganizationInvitationFilterInput | null > | null,
  or?: Array< ModelOrganizationInvitationFilterInput | null > | null,
  not?: ModelOrganizationInvitationFilterInput | null,
};

export type ModelOrganizationInvitationConnection = {
  __typename: "ModelOrganizationInvitationConnection",
  items:  Array<OrganizationInvitation | null >,
  nextToken?: string | null,
};

export type ModelVolunteerSkillFilterInput = {
  id?: ModelIDInput | null,
  skillID?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  and?: Array< ModelVolunteerSkillFilterInput | null > | null,
  or?: Array< ModelVolunteerSkillFilterInput | null > | null,
  not?: ModelVolunteerSkillFilterInput | null,
};

export type ModelCauseFilterInput = {
  id?: ModelIDInput | null,
  key?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelCauseFilterInput | null > | null,
  or?: Array< ModelCauseFilterInput | null > | null,
  not?: ModelCauseFilterInput | null,
};

export type ModelCauseConnection = {
  __typename: "ModelCauseConnection",
  items:  Array<Cause | null >,
  nextToken?: string | null,
};

export type ModelVolunteerCauseFilterInput = {
  id?: ModelIDInput | null,
  causeID?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  and?: Array< ModelVolunteerCauseFilterInput | null > | null,
  or?: Array< ModelVolunteerCauseFilterInput | null > | null,
  not?: ModelVolunteerCauseFilterInput | null,
};

export type ModelOrganizationDetailsFilterInput = {
  id?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  missionStatement?: ModelStringInput | null,
  serveStatement?: ModelStringInput | null,
  doStatement?: ModelStringInput | null,
  costToDoStatement?: ModelStringInput | null,
  missionArea?: ModelStringInput | null,
  annualBudget?: ModelStringInput | null,
  currentMonthlyRecurringDonors?: ModelStringInput | null,
  averageMonthlyRecurringDonation?: ModelStringInput | null,
  percentageOfBudgetFromIndividualDonors?: ModelStringInput | null,
  numberOfMajorDonors?: ModelStringInput | null,
  averageOneTimeDonation?: ModelStringInput | null,
  percentageOfBudgetFromGrants?: ModelStringInput | null,
  and?: Array< ModelOrganizationDetailsFilterInput | null > | null,
  or?: Array< ModelOrganizationDetailsFilterInput | null > | null,
  not?: ModelOrganizationDetailsFilterInput | null,
};

export type ModelOrganizationDetailsConnection = {
  __typename: "ModelOrganizationDetailsConnection",
  items:  Array<OrganizationDetails | null >,
  nextToken?: string | null,
};

export type ModelProgramFilterInput = {
  id?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  theWhy?: ModelStringInput | null,
  leadID?: ModelIDInput | null,
  stringifiedCauses?: ModelStringInput | null,
  archived?: ModelBooleanInput | null,
  and?: Array< ModelProgramFilterInput | null > | null,
  or?: Array< ModelProgramFilterInput | null > | null,
  not?: ModelProgramFilterInput | null,
};

export type ModelProgramConnection = {
  __typename: "ModelProgramConnection",
  items:  Array<Program | null >,
  nextToken?: string | null,
};

export type ModelOpportunityFilterInput = {
  id?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  programID?: ModelIDInput | null,
  opportunityLeadID?: ModelIDInput | null,
  type?: ModelOpportunityTypeInput | null,
  status?: ModelOpportunityStatusInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  startRecruitingDate?: ModelStringInput | null,
  headerImage?: ModelStringInput | null,
  title?: ModelStringInput | null,
  descriptionRTE?: ModelStringInput | null,
  theWhy?: ModelStringInput | null,
  expectedImpact?: ModelStringInput | null,
  whatWillHappen?: ModelStringInput | null,
  volunteerGain?: ModelStringInput | null,
  stringifiedCauses?: ModelStringInput | null,
  stringifiedCausesJSON?: ModelStringInput | null,
  and?: Array< ModelOpportunityFilterInput | null > | null,
  or?: Array< ModelOpportunityFilterInput | null > | null,
  not?: ModelOpportunityFilterInput | null,
};

export type ModelApplicationFilterInput = {
  id?: ModelIDInput | null,
  opportunityID?: ModelIDInput | null,
  roleID?: ModelIDInput | null,
  screeningCallRequired?: ModelScreeningCallRequiredOptionsInput | null,
  signUpOnly?: ModelBooleanInput | null,
  requireScreeningCall?: ModelBooleanInput | null,
  requireBackgroundCheck?: ModelBooleanInput | null,
  recruitmentDeadlineForVolunteers?: ModelStringInput | null,
  targetNumberOfVolunteerHours?: ModelIntInput | null,
  minimumNumberOfVolunteersRequired?: ModelIntInput | null,
  and?: Array< ModelApplicationFilterInput | null > | null,
  or?: Array< ModelApplicationFilterInput | null > | null,
  not?: ModelApplicationFilterInput | null,
};

export type ModelCustomApplicationQuestionFilterInput = {
  id?: ModelIDInput | null,
  applicationID?: ModelIDInput | null,
  questionText?: ModelStringInput | null,
  questionType?: ModelStringInput | null,
  required?: ModelBooleanInput | null,
  and?: Array< ModelCustomApplicationQuestionFilterInput | null > | null,
  or?: Array< ModelCustomApplicationQuestionFilterInput | null > | null,
  not?: ModelCustomApplicationQuestionFilterInput | null,
};

export type ModelRoleFilterInput = {
  id?: ModelIDInput | null,
  opportunityID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  roleTitle?: ModelStringInput | null,
  opportunityTitle?: ModelStringInput | null,
  live?: ModelBooleanInput | null,
  roleCoordinatorID?: ModelIDInput | null,
  recurrence?: ModelRoleRecurrenceInput | null,
  weeklyRecurrenceDays?: ModelStringInput | null,
  weeklyRecurrenceSameVolunteers?: ModelBooleanInput | null,
  volunteersPerShift?: ModelIntInput | null,
  differentNumberOfVolunteersPerShift?: ModelBooleanInput | null,
  volunteerCommitmentMonths?: ModelIntInput | null,
  volunteerCommitmentCanRenew?: ModelBooleanInput | null,
  roleRequirements?: ModelStringInput | null,
  ageRequirement?: ModelStringInput | null,
  minorsRequireSupervision?: ModelBooleanInput | null,
  stringifiedCauses?: ModelStringInput | null,
  stringifiedCausesJSON?: ModelStringInput | null,
  stringifiedSkills?: ModelStringInput | null,
  stringifiedSkillsJSON?: ModelStringInput | null,
  stringifiedCertifications?: ModelStringInput | null,
  and?: Array< ModelRoleFilterInput | null > | null,
  or?: Array< ModelRoleFilterInput | null > | null,
  not?: ModelRoleFilterInput | null,
};

export type ModelShiftFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelShiftTypeInput | null,
  live?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  timeFrame?: ModelTimeFrameInput | null,
  timeFrameString?: ModelStringInput | null,
  recurrence?: ModelShiftRecurrenceInput | null,
  weeklyRecurringDay?: ModelStringInput | null,
  monthlyRecurrenceWeek?: ModelStringInput | null,
  monthlyRecurrenceDay?: ModelStringInput | null,
  flexibleHours?: ModelIntInput | null,
  flexibleTimePeriod?: ModelStringInput | null,
  volunteersNeeded?: ModelIntInput | null,
  volunteerCoordinatorID?: ModelIDInput | null,
  roleID?: ModelIDInput | null,
  roleStringifiedSkills?: ModelStringInput | null,
  roleStringifiedCauses?: ModelStringInput | null,
  locationID?: ModelIDInput | null,
  locationLongitude?: ModelFloatInput | null,
  locationLatitude?: ModelFloatInput | null,
  locationType?: ModelLocationTypeInput | null,
  locationZipEstimate?: ModelIntInput | null,
  locationVariousDescription?: ModelStringInput | null,
  and?: Array< ModelShiftFilterInput | null > | null,
  or?: Array< ModelShiftFilterInput | null > | null,
  not?: ModelShiftFilterInput | null,
};

export type ModelOpportunityTemplateFilterInput = {
  id?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  templateJSON?: ModelStringInput | null,
  and?: Array< ModelOpportunityTemplateFilterInput | null > | null,
  or?: Array< ModelOpportunityTemplateFilterInput | null > | null,
  not?: ModelOpportunityTemplateFilterInput | null,
};

export type ModelOpportunityTemplateConnection = {
  __typename: "ModelOpportunityTemplateConnection",
  items:  Array<OpportunityTemplate | null >,
  nextToken?: string | null,
};

export type ModelRoleTemplateFilterInput = {
  id?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  templateJSON?: ModelStringInput | null,
  and?: Array< ModelRoleTemplateFilterInput | null > | null,
  or?: Array< ModelRoleTemplateFilterInput | null > | null,
  not?: ModelRoleTemplateFilterInput | null,
};

export type ModelRoleTemplateConnection = {
  __typename: "ModelRoleTemplateConnection",
  items:  Array<RoleTemplate | null >,
  nextToken?: string | null,
};

export type ModelOrganizationGroupFilterInput = {
  id?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  groupName?: ModelStringInput | null,
  and?: Array< ModelOrganizationGroupFilterInput | null > | null,
  or?: Array< ModelOrganizationGroupFilterInput | null > | null,
  not?: ModelOrganizationGroupFilterInput | null,
};

export type ModelOrganizationGroupConnection = {
  __typename: "ModelOrganizationGroupConnection",
  items:  Array<OrganizationGroup | null >,
  nextToken?: string | null,
};

export type ModelOrganizationVolunteerFilterInput = {
  id?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  status?: ModelOrganizationVolunteerStatusInput | null,
  and?: Array< ModelOrganizationVolunteerFilterInput | null > | null,
  or?: Array< ModelOrganizationVolunteerFilterInput | null > | null,
  not?: ModelOrganizationVolunteerFilterInput | null,
};

export type ModelOrganizationVolunteerConnection = {
  __typename: "ModelOrganizationVolunteerConnection",
  items:  Array<OrganizationVolunteer | null >,
  nextToken?: string | null,
};

export type ModelOrganizationGroupVolunteerFilterInput = {
  id?: ModelIDInput | null,
  and?: Array< ModelOrganizationGroupVolunteerFilterInput | null > | null,
  or?: Array< ModelOrganizationGroupVolunteerFilterInput | null > | null,
  not?: ModelOrganizationGroupVolunteerFilterInput | null,
};

export type ModelOrganizationGroupVolunteerConnection = {
  __typename: "ModelOrganizationGroupVolunteerConnection",
  items:  Array<OrganizationGroupVolunteer | null >,
  nextToken?: string | null,
};

export type ModelTimeCommitmentFilterInput = {
  id?: ModelIDInput | null,
  amount?: ModelIntInput | null,
  units?: ModelTimeUnitTypeInput | null,
  period?: ModelTimePeriodTypeInput | null,
  and?: Array< ModelTimeCommitmentFilterInput | null > | null,
  or?: Array< ModelTimeCommitmentFilterInput | null > | null,
  not?: ModelTimeCommitmentFilterInput | null,
};

export type ModelTimeCommitmentConnection = {
  __typename: "ModelTimeCommitmentConnection",
  items:  Array<TimeCommitment | null >,
  nextToken?: string | null,
};

export type ModelVolunteerMatchRequestFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelVolunteerMatchRequestStatusInput | null,
  volunteerProfileID?: ModelIDInput | null,
  opportunityID?: ModelIDInput | null,
  roleRequestedID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  volunteerComments?: ModelStringInput | null,
  administrativeNotes?: ModelStringInput | null,
  scheduledCallID?: ModelIDInput | null,
  roleAssignedID?: ModelIDInput | null,
  assignmentID?: ModelIDInput | null,
  organizationRejectionReason?: ModelStringInput | null,
  volunteerRejectionReason?: ModelStringInput | null,
  and?: Array< ModelVolunteerMatchRequestFilterInput | null > | null,
  or?: Array< ModelVolunteerMatchRequestFilterInput | null > | null,
  not?: ModelVolunteerMatchRequestFilterInput | null,
};

export type ModelVolunteerMatchRequestConnection = {
  __typename: "ModelVolunteerMatchRequestConnection",
  items:  Array<VolunteerMatchRequest | null >,
  nextToken?: string | null,
};

export type ModelScheduledCallFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelScheduledCallStatusInput | null,
  volunteerProfileID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  details?: ModelStringInput | null,
  and?: Array< ModelScheduledCallFilterInput | null > | null,
  or?: Array< ModelScheduledCallFilterInput | null > | null,
  not?: ModelScheduledCallFilterInput | null,
};

export type ModelScheduledCallConnection = {
  __typename: "ModelScheduledCallConnection",
  items:  Array<ScheduledCall | null >,
  nextToken?: string | null,
};

export type ModelAssignmentFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelAssignmentStatusTypeInput | null,
  volunteerMatchRequestID?: ModelIDInput | null,
  roleID?: ModelIDInput | null,
  shiftID?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  opportunityID?: ModelIDInput | null,
  administrativeNotes?: ModelStringInput | null,
  and?: Array< ModelAssignmentFilterInput | null > | null,
  or?: Array< ModelAssignmentFilterInput | null > | null,
  not?: ModelAssignmentFilterInput | null,
};

export type ModelAssignmentConnection = {
  __typename: "ModelAssignmentConnection",
  items:  Array<Assignment | null >,
  nextToken?: string | null,
};

export type ModelCheckInFilterInput = {
  id?: ModelIDInput | null,
  assignmentID?: ModelIDInput | null,
  shiftID?: ModelIDInput | null,
  opportunityID?: ModelIDInput | null,
  timeIn?: ModelStringInput | null,
  timeOut?: ModelStringInput | null,
  checkedInByVolunteerProfileID?: ModelIDInput | null,
  checkedOutByVolunteerProfileID?: ModelIDInput | null,
  and?: Array< ModelCheckInFilterInput | null > | null,
  or?: Array< ModelCheckInFilterInput | null > | null,
  not?: ModelCheckInFilterInput | null,
};

export type ModelCheckInConnection = {
  __typename: "ModelCheckInConnection",
  items:  Array<CheckIn | null >,
  nextToken?: string | null,
};

export type ModelNotificationSettingsFilterInput = {
  id?: ModelIDInput | null,
  communicationsProfileID?: ModelIDInput | null,
  allowPushNotifications?: ModelBooleanInput | null,
  allowTextMessages?: ModelBooleanInput | null,
  allowEmail?: ModelBooleanInput | null,
  preference?: ModelNotificationPreferenceInput | null,
  and?: Array< ModelNotificationSettingsFilterInput | null > | null,
  or?: Array< ModelNotificationSettingsFilterInput | null > | null,
  not?: ModelNotificationSettingsFilterInput | null,
};

export type ModelNotificationSettingsConnection = {
  __typename: "ModelNotificationSettingsConnection",
  items:  Array<NotificationSettings | null >,
  nextToken?: string | null,
};

export type ModelLatentOrganizationCodeFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  active?: ModelBooleanInput | null,
  emailRestricted?: ModelBooleanInput | null,
  emailHostRestriction?: ModelStringInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  presetFundraisingCampaignAmbassadorStatus?: ModelFundraisingCampaignAmbassadorStatusInput | null,
  and?: Array< ModelLatentOrganizationCodeFilterInput | null > | null,
  or?: Array< ModelLatentOrganizationCodeFilterInput | null > | null,
  not?: ModelLatentOrganizationCodeFilterInput | null,
};

export type ModelLatentOrganizationCodeConnection = {
  __typename: "ModelLatentOrganizationCodeConnection",
  items:  Array<LatentOrganizationCode | null >,
  nextToken?: string | null,
};

export type ModelSubscriptionDonationTierFilterInput = {
  id?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  features?: ModelStringInput | null,
  buttonText?: ModelStringInput | null,
  buttonColor?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  highlighted?: ModelBooleanInput | null,
  highlightedColor?: ModelStringInput | null,
  promoText?: ModelStringInput | null,
  and?: Array< ModelSubscriptionDonationTierFilterInput | null > | null,
  or?: Array< ModelSubscriptionDonationTierFilterInput | null > | null,
  not?: ModelSubscriptionDonationTierFilterInput | null,
};

export type ModelCampaignConversationFlowFilterInput = {
  id?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  default?: ModelBooleanInput | null,
  active?: ModelBooleanInput | null,
  restricted?: ModelBooleanInput | null,
  useDefaultCta?: ModelBooleanInput | null,
  customCta?: ModelStringInput | null,
  allowAmbassadorSpecificCrowbarVideos?: ModelBooleanInput | null,
  generalCrowbarVideoURI?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  and?: Array< ModelCampaignConversationFlowFilterInput | null > | null,
  or?: Array< ModelCampaignConversationFlowFilterInput | null > | null,
  not?: ModelCampaignConversationFlowFilterInput | null,
};

export type ModelActionMessageDefinitionFilterInput = {
  id?: ModelIDInput | null,
  campaignConversationFlowID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelActionMessageTypeInput | null,
  messageTemplate?: ModelStringInput | null,
  onPositiveResponse?: ModelIDInput | null,
  onNegativeResponse?: ModelIDInput | null,
  reminderActionMessageDefinitionID?: ModelIDInput | null,
  reminderDelay?: ModelIntInput | null,
  sendReminderNotification?: ModelBooleanInput | null,
  reminderNotificationID?: ModelIDInput | null,
  beginningNode?: ModelBooleanInput | null,
  parentActionMessageDefinitionID?: ModelIDInput | null,
  viewType?: ModelStringInput | null,
  and?: Array< ModelActionMessageDefinitionFilterInput | null > | null,
  or?: Array< ModelActionMessageDefinitionFilterInput | null > | null,
  not?: ModelActionMessageDefinitionFilterInput | null,
};

export type ModelActionMessageFilterInput = {
  id?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  fundraisingCampaignAmbassadorID?: ModelIDInput | null,
  fundraisingCampaignAmbassadorContactID?: ModelIDInput | null,
  actionMessageDefinitionID?: ModelIDInput | null,
  sent?: ModelBooleanInput | null,
  sentTimestamp?: ModelStringInput | null,
  response?: ModelActionMessageResponseTypeInput | null,
  responseTimestamp?: ModelStringInput | null,
  and?: Array< ModelActionMessageFilterInput | null > | null,
  or?: Array< ModelActionMessageFilterInput | null > | null,
  not?: ModelActionMessageFilterInput | null,
};

export type ModelProjectFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelProjectFilterInput | null > | null,
  or?: Array< ModelProjectFilterInput | null > | null,
  not?: ModelProjectFilterInput | null,
};

export type ModelProjectConnection = {
  __typename: "ModelProjectConnection",
  items:  Array<Project | null >,
  nextToken?: string | null,
};

export type ModelTaskFilterInput = {
  id?: ModelIDInput | null,
  projectID?: ModelIDInput | null,
  isTopLevelTask?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  overview?: ModelStringInput | null,
  description?: ModelStringInput | null,
  descriptionRTE?: ModelStringInput | null,
  status?: ModelStringInput | null,
  complete?: ModelBooleanInput | null,
  mediaURI?: ModelStringInput | null,
  createdByID?: ModelIDInput | null,
  actionURL?: ModelStringInput | null,
  dueDate?: ModelStringInput | null,
  and?: Array< ModelTaskFilterInput | null > | null,
  or?: Array< ModelTaskFilterInput | null > | null,
  not?: ModelTaskFilterInput | null,
};

export type ModelTaskAttachmentFilterInput = {
  id?: ModelIDInput | null,
  taskID?: ModelIDInput | null,
  uploadedByID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  contentType?: ModelStringInput | null,
  and?: Array< ModelTaskAttachmentFilterInput | null > | null,
  or?: Array< ModelTaskAttachmentFilterInput | null > | null,
  not?: ModelTaskAttachmentFilterInput | null,
};

export type ModelTaskBlockerFilterInput = {
  id?: ModelIDInput | null,
  originTaskID?: ModelIDInput | null,
  blockerTaskID?: ModelIDInput | null,
  notes?: ModelStringInput | null,
  and?: Array< ModelTaskBlockerFilterInput | null > | null,
  or?: Array< ModelTaskBlockerFilterInput | null > | null,
  not?: ModelTaskBlockerFilterInput | null,
};

export type ModelSubTaskFilterInput = {
  id?: ModelIDInput | null,
  parentTaskID?: ModelIDInput | null,
  subTaskID?: ModelIDInput | null,
  and?: Array< ModelSubTaskFilterInput | null > | null,
  or?: Array< ModelSubTaskFilterInput | null > | null,
  not?: ModelSubTaskFilterInput | null,
};

export type ModelTaskCommentFilterInput = {
  id?: ModelIDInput | null,
  taskID?: ModelIDInput | null,
  comment?: ModelStringInput | null,
  mediaURI?: ModelStringInput | null,
  postedByID?: ModelIDInput | null,
  and?: Array< ModelTaskCommentFilterInput | null > | null,
  or?: Array< ModelTaskCommentFilterInput | null > | null,
  not?: ModelTaskCommentFilterInput | null,
};

export type ModelTaskAssignmentFilterInput = {
  id?: ModelIDInput | null,
  taskID?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  staffProfileID?: ModelIDInput | null,
  notes?: ModelStringInput | null,
  and?: Array< ModelTaskAssignmentFilterInput | null > | null,
  or?: Array< ModelTaskAssignmentFilterInput | null > | null,
  not?: ModelTaskAssignmentFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type SearchableProgramFilterInput = {
  id?: SearchableIDFilterInput | null,
  organizationID?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  theWhy?: SearchableStringFilterInput | null,
  leadID?: SearchableIDFilterInput | null,
  stringifiedCauses?: SearchableStringFilterInput | null,
  archived?: SearchableBooleanFilterInput | null,
  and?: Array< SearchableProgramFilterInput | null > | null,
  or?: Array< SearchableProgramFilterInput | null > | null,
  not?: SearchableProgramFilterInput | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type SearchableProgramSortInput = {
  field?: SearchableProgramSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableProgramSortableFields {
  id = "id",
  organizationID = "organizationID",
  name = "name",
  description = "description",
  theWhy = "theWhy",
  leadID = "leadID",
  stringifiedCauses = "stringifiedCauses",
  archived = "archived",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableProgramConnection = {
  __typename: "SearchableProgramConnection",
  items:  Array<Program | null >,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchableOpportunityFilterInput = {
  id?: SearchableIDFilterInput | null,
  organizationID?: SearchableIDFilterInput | null,
  programID?: SearchableIDFilterInput | null,
  opportunityLeadID?: SearchableIDFilterInput | null,
  startDate?: SearchableStringFilterInput | null,
  endDate?: SearchableStringFilterInput | null,
  startRecruitingDate?: SearchableStringFilterInput | null,
  headerImage?: SearchableStringFilterInput | null,
  title?: SearchableStringFilterInput | null,
  descriptionRTE?: SearchableStringFilterInput | null,
  theWhy?: SearchableStringFilterInput | null,
  expectedImpact?: SearchableStringFilterInput | null,
  whatWillHappen?: SearchableStringFilterInput | null,
  volunteerGain?: SearchableStringFilterInput | null,
  stringifiedCauses?: SearchableStringFilterInput | null,
  stringifiedCausesJSON?: SearchableStringFilterInput | null,
  and?: Array< SearchableOpportunityFilterInput | null > | null,
  or?: Array< SearchableOpportunityFilterInput | null > | null,
  not?: SearchableOpportunityFilterInput | null,
};

export type SearchableOpportunitySortInput = {
  field?: SearchableOpportunitySortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableOpportunitySortableFields {
  id = "id",
  organizationID = "organizationID",
  programID = "programID",
  opportunityLeadID = "opportunityLeadID",
  startDate = "startDate",
  endDate = "endDate",
  startRecruitingDate = "startRecruitingDate",
  headerImage = "headerImage",
  title = "title",
  descriptionRTE = "descriptionRTE",
  theWhy = "theWhy",
  expectedImpact = "expectedImpact",
  whatWillHappen = "whatWillHappen",
  volunteerGain = "volunteerGain",
  stringifiedCauses = "stringifiedCauses",
  stringifiedCausesJSON = "stringifiedCausesJSON",
}


export type SearchableOpportunityConnection = {
  __typename: "SearchableOpportunityConnection",
  items:  Array<Opportunity | null >,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchableRoleFilterInput = {
  id?: SearchableIDFilterInput | null,
  opportunityID?: SearchableIDFilterInput | null,
  organizationID?: SearchableIDFilterInput | null,
  roleTitle?: SearchableStringFilterInput | null,
  opportunityTitle?: SearchableStringFilterInput | null,
  live?: SearchableBooleanFilterInput | null,
  roleCoordinatorID?: SearchableIDFilterInput | null,
  weeklyRecurrenceDays?: SearchableStringFilterInput | null,
  weeklyRecurrenceSameVolunteers?: SearchableBooleanFilterInput | null,
  volunteersPerShift?: SearchableIntFilterInput | null,
  differentNumberOfVolunteersPerShift?: SearchableBooleanFilterInput | null,
  volunteerCommitmentMonths?: SearchableIntFilterInput | null,
  volunteerCommitmentCanRenew?: SearchableBooleanFilterInput | null,
  roleRequirements?: SearchableStringFilterInput | null,
  ageRequirement?: SearchableStringFilterInput | null,
  minorsRequireSupervision?: SearchableBooleanFilterInput | null,
  stringifiedCauses?: SearchableStringFilterInput | null,
  stringifiedCausesJSON?: SearchableStringFilterInput | null,
  stringifiedSkills?: SearchableStringFilterInput | null,
  stringifiedSkillsJSON?: SearchableStringFilterInput | null,
  stringifiedCertifications?: SearchableStringFilterInput | null,
  and?: Array< SearchableRoleFilterInput | null > | null,
  or?: Array< SearchableRoleFilterInput | null > | null,
  not?: SearchableRoleFilterInput | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableRoleSortInput = {
  field?: SearchableRoleSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableRoleSortableFields {
  id = "id",
  opportunityID = "opportunityID",
  organizationID = "organizationID",
  roleTitle = "roleTitle",
  opportunityTitle = "opportunityTitle",
  live = "live",
  roleCoordinatorID = "roleCoordinatorID",
  weeklyRecurrenceDays = "weeklyRecurrenceDays",
  weeklyRecurrenceSameVolunteers = "weeklyRecurrenceSameVolunteers",
  volunteersPerShift = "volunteersPerShift",
  differentNumberOfVolunteersPerShift = "differentNumberOfVolunteersPerShift",
  volunteerCommitmentMonths = "volunteerCommitmentMonths",
  volunteerCommitmentCanRenew = "volunteerCommitmentCanRenew",
  roleRequirements = "roleRequirements",
  ageRequirement = "ageRequirement",
  minorsRequireSupervision = "minorsRequireSupervision",
  stringifiedCauses = "stringifiedCauses",
  stringifiedCausesJSON = "stringifiedCausesJSON",
  stringifiedSkills = "stringifiedSkills",
  stringifiedSkillsJSON = "stringifiedSkillsJSON",
  stringifiedCertifications = "stringifiedCertifications",
}


export type SearchableRoleConnection = {
  __typename: "SearchableRoleConnection",
  items:  Array<Role | null >,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchableShiftFilterInput = {
  id?: SearchableIDFilterInput | null,
  live?: SearchableBooleanFilterInput | null,
  name?: SearchableStringFilterInput | null,
  summary?: SearchableStringFilterInput | null,
  startDate?: SearchableStringFilterInput | null,
  startTime?: SearchableStringFilterInput | null,
  endDate?: SearchableStringFilterInput | null,
  endTime?: SearchableStringFilterInput | null,
  timezone?: SearchableStringFilterInput | null,
  timeFrameString?: SearchableStringFilterInput | null,
  weeklyRecurringDay?: SearchableStringFilterInput | null,
  monthlyRecurrenceWeek?: SearchableStringFilterInput | null,
  monthlyRecurrenceDay?: SearchableStringFilterInput | null,
  flexibleHours?: SearchableIntFilterInput | null,
  flexibleTimePeriod?: SearchableStringFilterInput | null,
  volunteersNeeded?: SearchableIntFilterInput | null,
  volunteerCoordinatorID?: SearchableIDFilterInput | null,
  roleID?: SearchableIDFilterInput | null,
  roleStringifiedSkills?: SearchableStringFilterInput | null,
  roleStringifiedCauses?: SearchableStringFilterInput | null,
  locationID?: SearchableIDFilterInput | null,
  locationLongitude?: SearchableFloatFilterInput | null,
  locationLatitude?: SearchableFloatFilterInput | null,
  locationZipEstimate?: SearchableIntFilterInput | null,
  locationVariousDescription?: SearchableStringFilterInput | null,
  and?: Array< SearchableShiftFilterInput | null > | null,
  or?: Array< SearchableShiftFilterInput | null > | null,
  not?: SearchableShiftFilterInput | null,
};

export type SearchableFloatFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableShiftSortInput = {
  field?: SearchableShiftSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableShiftSortableFields {
  id = "id",
  live = "live",
  name = "name",
  summary = "summary",
  startDate = "startDate",
  startTime = "startTime",
  endDate = "endDate",
  endTime = "endTime",
  timezone = "timezone",
  timeFrameString = "timeFrameString",
  weeklyRecurringDay = "weeklyRecurringDay",
  monthlyRecurrenceWeek = "monthlyRecurrenceWeek",
  monthlyRecurrenceDay = "monthlyRecurrenceDay",
  flexibleHours = "flexibleHours",
  flexibleTimePeriod = "flexibleTimePeriod",
  volunteersNeeded = "volunteersNeeded",
  volunteerCoordinatorID = "volunteerCoordinatorID",
  roleID = "roleID",
  roleStringifiedSkills = "roleStringifiedSkills",
  roleStringifiedCauses = "roleStringifiedCauses",
  locationID = "locationID",
  locationLongitude = "locationLongitude",
  locationLatitude = "locationLatitude",
  locationZipEstimate = "locationZipEstimate",
  locationVariousDescription = "locationVariousDescription",
}


export type SearchableShiftConnection = {
  __typename: "SearchableShiftConnection",
  items:  Array<Shift | null >,
  nextToken?: string | null,
  total?: number | null,
};

export type SearchableOrganizationVolunteerFilterInput = {
  id?: SearchableIDFilterInput | null,
  organizationID?: SearchableIDFilterInput | null,
  volunteerProfileID?: SearchableIDFilterInput | null,
  and?: Array< SearchableOrganizationVolunteerFilterInput | null > | null,
  or?: Array< SearchableOrganizationVolunteerFilterInput | null > | null,
  not?: SearchableOrganizationVolunteerFilterInput | null,
};

export type SearchableOrganizationVolunteerSortInput = {
  field?: SearchableOrganizationVolunteerSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableOrganizationVolunteerSortableFields {
  id = "id",
  organizationID = "organizationID",
  volunteerProfileID = "volunteerProfileID",
}


export type SearchableOrganizationVolunteerConnection = {
  __typename: "SearchableOrganizationVolunteerConnection",
  items:  Array<OrganizationVolunteer | null >,
  nextToken?: string | null,
  total?: number | null,
};

export type ModelCognitoAccountFilterInput = {
  id?: ModelIDInput | null,
  cognitoID?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  and?: Array< ModelCognitoAccountFilterInput | null > | null,
  or?: Array< ModelCognitoAccountFilterInput | null > | null,
  not?: ModelCognitoAccountFilterInput | null,
};

export type ModelAuthAccountFilterInput = {
  id?: ModelIDInput | null,
  volunteerProfileID?: ModelIDInput | null,
  lastSelectedStaffProfileID?: ModelIDInput | null,
  lastSelectedFundraisingProfileID?: ModelIDInput | null,
  communicationsProfileID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  primaryEmail?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  selfDescribedGender?: ModelStringInput | null,
  addressID?: ModelIDInput | null,
  website?: ModelStringInput | null,
  resumeURI?: ModelStringInput | null,
  bio?: ModelStringInput | null,
  profilePictureURI?: ModelStringInput | null,
  headerVideoURI?: ModelStringInput | null,
  headerImageURI?: ModelStringInput | null,
  headerAssetShown?: ModelStringInput | null,
  flourishAdmin?: ModelBooleanInput | null,
  and?: Array< ModelAuthAccountFilterInput | null > | null,
  or?: Array< ModelAuthAccountFilterInput | null > | null,
  not?: ModelAuthAccountFilterInput | null,
};

export type ModelAuthAccountConnection = {
  __typename: "ModelAuthAccountConnection",
  items:  Array<AuthAccount | null >,
  nextToken?: string | null,
};

export type ModelStaffProfileFilterInput = {
  id?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  role?: ModelStaffProfileRoleInput | null,
  name?: ModelStringInput | null,
  nylasAccountID?: ModelStringInput | null,
  nylasCalendarToken?: ModelStringInput | null,
  nylasPrimaryCalendarID?: ModelStringInput | null,
  and?: Array< ModelStaffProfileFilterInput | null > | null,
  or?: Array< ModelStaffProfileFilterInput | null > | null,
  not?: ModelStaffProfileFilterInput | null,
};

export type ModelCommunicationsProfileFilterInput = {
  id?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  streamJwt?: ModelStringInput | null,
  notificationSettingsID?: ModelIDInput | null,
  and?: Array< ModelCommunicationsProfileFilterInput | null > | null,
  or?: Array< ModelCommunicationsProfileFilterInput | null > | null,
  not?: ModelCommunicationsProfileFilterInput | null,
};

export type ModelCommunicationsProfileConnection = {
  __typename: "ModelCommunicationsProfileConnection",
  items:  Array<CommunicationsProfile | null >,
  nextToken?: string | null,
};

export type ModelFundraisingProfileFilterInput = {
  id?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  classyMemberID?: ModelStringInput | null,
  and?: Array< ModelFundraisingProfileFilterInput | null > | null,
  or?: Array< ModelFundraisingProfileFilterInput | null > | null,
  not?: ModelFundraisingProfileFilterInput | null,
};

export type ModelStaffInvitationFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelIDInput | null,
  type?: ModelStaffInvitationTypeInput | null,
  email?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  name?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  staffProfileID?: ModelIDInput | null,
  used?: ModelBooleanInput | null,
  usedTimestamp?: ModelStringInput | null,
  invitationSent?: ModelBooleanInput | null,
  invitationSentTimestamp?: ModelStringInput | null,
  and?: Array< ModelStaffInvitationFilterInput | null > | null,
  or?: Array< ModelStaffInvitationFilterInput | null > | null,
  not?: ModelStaffInvitationFilterInput | null,
};

export type ModelStaffInvitationConnection = {
  __typename: "ModelStaffInvitationConnection",
  items:  Array<StaffInvitation | null >,
  nextToken?: string | null,
};

export type ModelFundraisingInvitationFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  name?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  authAccountID?: ModelIDInput | null,
  fundraisingProfileID?: ModelIDInput | null,
  used?: ModelBooleanInput | null,
  usedTimestamp?: ModelStringInput | null,
  invitationSent?: ModelBooleanInput | null,
  invitationSentTimestamp?: ModelStringInput | null,
  and?: Array< ModelFundraisingInvitationFilterInput | null > | null,
  or?: Array< ModelFundraisingInvitationFilterInput | null > | null,
  not?: ModelFundraisingInvitationFilterInput | null,
};

export type ModelFundraisingInvitationConnection = {
  __typename: "ModelFundraisingInvitationConnection",
  items:  Array<FundraisingInvitation | null >,
  nextToken?: string | null,
};

export type ModelVolunteerInvitationFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelStringInput | null,
  email?: ModelStringInput | null,
  name?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  used?: ModelBooleanInput | null,
  usedTimestamp?: ModelStringInput | null,
  invitationSent?: ModelBooleanInput | null,
  invitationSentTimestamp?: ModelStringInput | null,
  and?: Array< ModelVolunteerInvitationFilterInput | null > | null,
  or?: Array< ModelVolunteerInvitationFilterInput | null > | null,
  not?: ModelVolunteerInvitationFilterInput | null,
};

export type ModelVolunteerInvitationConnection = {
  __typename: "ModelVolunteerInvitationConnection",
  items:  Array<VolunteerInvitation | null >,
  nextToken?: string | null,
};

export type ModelVolunteerWaitlistFilterInput = {
  id?: ModelIDInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  zipCode?: ModelFloatInput | null,
  about?: ModelStringInput | null,
  invited?: ModelBooleanInput | null,
  and?: Array< ModelVolunteerWaitlistFilterInput | null > | null,
  or?: Array< ModelVolunteerWaitlistFilterInput | null > | null,
  not?: ModelVolunteerWaitlistFilterInput | null,
};

export type ModelVolunteerWaitlistConnection = {
  __typename: "ModelVolunteerWaitlistConnection",
  items:  Array<VolunteerWaitlist | null >,
  nextToken?: string | null,
};

export type ModelSkillFilterInput = {
  id?: ModelIDInput | null,
  key?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelSkillFilterInput | null > | null,
  or?: Array< ModelSkillFilterInput | null > | null,
  not?: ModelSkillFilterInput | null,
};

export type ModelSkillConnection = {
  __typename: "ModelSkillConnection",
  items:  Array<Skill | null >,
  nextToken?: string | null,
};

export type ModelOrganizationFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  shortName?: ModelStringInput | null,
  description?: ModelStringInput | null,
  locationID?: ModelIDInput | null,
  website?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  stripeConnectedAccountID?: ModelStringInput | null,
  stripeConnectedAccountStatus?: ModelStringInput | null,
  headerImageURI?: ModelStringInput | null,
  ambassadorTermOverrideSingular?: ModelStringInput | null,
  ambassadorTermOverridePlural?: ModelStringInput | null,
  streamJwt?: ModelStringInput | null,
  latentSubscription?: ModelIntInput | null,
  primaryColor?: ModelStringInput | null,
  secondaryColor?: ModelStringInput | null,
  designation?: ModelStringInput | null,
  detailsID?: ModelIDInput | null,
  and?: Array< ModelOrganizationFilterInput | null > | null,
  or?: Array< ModelOrganizationFilterInput | null > | null,
  not?: ModelOrganizationFilterInput | null,
};

export type ModelOrganizationConnection = {
  __typename: "ModelOrganizationConnection",
  items:  Array<Organization | null >,
  nextToken?: string | null,
};

export type SearchableOrganizationFilterInput = {
  id?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  shortName?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  locationID?: SearchableIDFilterInput | null,
  website?: SearchableStringFilterInput | null,
  phoneNumber?: SearchableStringFilterInput | null,
  stripeConnectedAccountID?: SearchableStringFilterInput | null,
  stripeConnectedAccountStatus?: SearchableStringFilterInput | null,
  headerImageURI?: SearchableStringFilterInput | null,
  ambassadorTermOverrideSingular?: SearchableStringFilterInput | null,
  ambassadorTermOverridePlural?: SearchableStringFilterInput | null,
  streamJwt?: SearchableStringFilterInput | null,
  latentSubscription?: SearchableIntFilterInput | null,
  primaryColor?: SearchableStringFilterInput | null,
  secondaryColor?: SearchableStringFilterInput | null,
  designation?: SearchableStringFilterInput | null,
  detailsID?: SearchableIDFilterInput | null,
  and?: Array< SearchableOrganizationFilterInput | null > | null,
  or?: Array< SearchableOrganizationFilterInput | null > | null,
  not?: SearchableOrganizationFilterInput | null,
};

export type SearchableOrganizationSortInput = {
  field?: SearchableOrganizationSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableOrganizationSortableFields {
  id = "id",
  name = "name",
  shortName = "shortName",
  description = "description",
  locationID = "locationID",
  website = "website",
  phoneNumber = "phoneNumber",
  stripeConnectedAccountID = "stripeConnectedAccountID",
  stripeConnectedAccountStatus = "stripeConnectedAccountStatus",
  headerImageURI = "headerImageURI",
  ambassadorTermOverrideSingular = "ambassadorTermOverrideSingular",
  ambassadorTermOverridePlural = "ambassadorTermOverridePlural",
  streamJwt = "streamJwt",
  latentSubscription = "latentSubscription",
  primaryColor = "primaryColor",
  secondaryColor = "secondaryColor",
  designation = "designation",
  detailsID = "detailsID",
}


export type SearchableOrganizationConnection = {
  __typename: "SearchableOrganizationConnection",
  items:  Array<Organization | null >,
  nextToken?: string | null,
  total?: number | null,
};

export type ModelLocationFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelLocationTypeInput | null,
  name?: ModelStringInput | null,
  details?: ModelStringInput | null,
  addressID?: ModelIDInput | null,
  organizationID?: ModelIDInput | null,
  and?: Array< ModelLocationFilterInput | null > | null,
  or?: Array< ModelLocationFilterInput | null > | null,
  not?: ModelLocationFilterInput | null,
};

export type ModelLocationConnection = {
  __typename: "ModelLocationConnection",
  items:  Array<Location | null >,
  nextToken?: string | null,
};

export type ModelAddressFilterInput = {
  id?: ModelIDInput | null,
  streetAddress?: ModelStringInput | null,
  unit?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  zip?: ModelStringInput | null,
  zipPlusFour?: ModelStringInput | null,
  longitude?: ModelFloatInput | null,
  latitude?: ModelFloatInput | null,
  and?: Array< ModelAddressFilterInput | null > | null,
  or?: Array< ModelAddressFilterInput | null > | null,
  not?: ModelAddressFilterInput | null,
};

export type ModelAddressConnection = {
  __typename: "ModelAddressConnection",
  items:  Array<Address | null >,
  nextToken?: string | null,
};

export type ModelFundraisingCampaignFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelFundraisingCampaignTypeInput | null,
  organizationID?: ModelIDInput | null,
  staffLeadID?: ModelIDInput | null,
  campaignName?: ModelStringInput | null,
  introVideoURI?: ModelStringInput | null,
  textMessageTemplate?: ModelStringInput | null,
  initialMessageReminderTemplate?: ModelStringInput | null,
  phoneCallScriptTemplate?: ModelStringInput | null,
  followUpMessageTemplate?: ModelStringInput | null,
  followUpYesMessageTemplate?: ModelStringInput | null,
  followUpNoMessageTemplate?: ModelStringInput | null,
  followUpReminderMessageTemplate?: ModelStringInput | null,
  showVideo?: ModelBooleanInput | null,
  showText?: ModelBooleanInput | null,
  showCall?: ModelBooleanInput | null,
  showFollowUp?: ModelBooleanInput | null,
  active?: ModelBooleanInput | null,
  publicVideoID?: ModelStringInput | null,
  publicVideoProvider?: ModelStringInput | null,
  campaignStartDate?: ModelStringInput | null,
  campaignStartTime?: ModelStringInput | null,
  campaignTimeZone?: ModelStringInput | null,
  campaignEndDate?: ModelStringInput | null,
  campaignEndTime?: ModelStringInput | null,
  publicCampaignAbout?: ModelStringInput | null,
  publicCampaignIntro?: ModelStringInput | null,
  campaignGoal?: ModelFloatInput | null,
  perAmbassadorGoal?: ModelFloatInput | null,
  totalAmbassadorsGoal?: ModelFloatInput | null,
  perContactDonationGoal?: ModelFloatInput | null,
  progressChartType?: ModelStringInput | null,
  ctaURL?: ModelStringInput | null,
  pageLayout?: ModelStringInput | null,
  primaryColor?: ModelStringInput | null,
  secondaryColor?: ModelStringInput | null,
  buttonBackgroundColor?: ModelStringInput | null,
  buttonTextColor?: ModelStringInput | null,
  customHeaderImageUploaded?: ModelBooleanInput | null,
  customLogoImageUploaded?: ModelBooleanInput | null,
  headerFont?: ModelStringInput | null,
  bodyFont?: ModelStringInput | null,
  ctaButtonText?: ModelStringInput | null,
  givingCircleBaseAmount?: ModelFloatInput | null,
  givingCircleIncrements?: ModelFloatInput | null,
  givingCircleAllowCustomAmounts?: ModelBooleanInput | null,
  ambassadorSpecificVideoUrlEnabled?: ModelBooleanInput | null,
  ambassadorCanUploadVideoUrl?: ModelBooleanInput | null,
  ambassadorSpecificCtaUrlEnabled?: ModelBooleanInput | null,
  ambassadorCanUploadCtaUrl?: ModelBooleanInput | null,
  crowbarVideoURL?: ModelStringInput | null,
  recruitmentForCampaignID?: ModelIDInput | null,
  classyCampaignID?: ModelStringInput | null,
  classyAutogenerateAmbassadorTeams?: ModelBooleanInput | null,
  classyDonationPageHostURL?: ModelStringInput | null,
  useClassyCtaURL?: ModelBooleanInput | null,
  useClassyFundraiserPage?: ModelBooleanInput | null,
  personalFundraisingCampaignID?: ModelIDInput | null,
  onDemandDiscoveryMeetingEnabled?: ModelBooleanInput | null,
  onDemandDiscoveryMeetingURL?: ModelStringInput | null,
  onDemandDiscoveryMeetingID?: ModelIDInput | null,
  onDemandDiscoveryMeetingInvitationCode?: ModelStringInput | null,
  defaultConversationFlowID?: ModelIDInput | null,
  useConversationFlows?: ModelBooleanInput | null,
  campaignPageID?: ModelIDInput | null,
  ambassadorPageID?: ModelIDInput | null,
  donationPageID?: ModelIDInput | null,
  discoveryPageID?: ModelIDInput | null,
  projectID?: ModelIDInput | null,
  useActionCardView?: ModelBooleanInput | null,
  and?: Array< ModelFundraisingCampaignFilterInput | null > | null,
  or?: Array< ModelFundraisingCampaignFilterInput | null > | null,
  not?: ModelFundraisingCampaignFilterInput | null,
};

export type ModelFundraisingCampaignConnection = {
  __typename: "ModelFundraisingCampaignConnection",
  items:  Array<FundraisingCampaign | null >,
  nextToken?: string | null,
};

export type ModelCampaignPageFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelCampaignPageTypeInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  campaignDisplayConfigurationID?: ModelIDInput | null,
  pageHtml?: ModelStringInput | null,
  pageJSON?: ModelStringInput | null,
  pageCssJSON?: ModelStringInput | null,
  pageAssetsJSON?: ModelStringInput | null,
  and?: Array< ModelCampaignPageFilterInput | null > | null,
  or?: Array< ModelCampaignPageFilterInput | null > | null,
  not?: ModelCampaignPageFilterInput | null,
};

export type ModelCampaignPageConnection = {
  __typename: "ModelCampaignPageConnection",
  items:  Array<CampaignPage | null >,
  nextToken?: string | null,
};

export type ModelCampaignDisplayConfigurationFilterInput = {
  id?: ModelIDInput | null,
  campaignPageID?: ModelIDInput | null,
  primaryColor?: ModelStringInput | null,
  secondaryColor?: ModelStringInput | null,
  gradientLeftColor?: ModelStringInput | null,
  gradientRightColor?: ModelStringInput | null,
  buttonBackgroundColor?: ModelStringInput | null,
  buttonTextColor?: ModelStringInput | null,
  headerFont?: ModelStringInput | null,
  bodyFont?: ModelStringInput | null,
  and?: Array< ModelCampaignDisplayConfigurationFilterInput | null > | null,
  or?: Array< ModelCampaignDisplayConfigurationFilterInput | null > | null,
  not?: ModelCampaignDisplayConfigurationFilterInput | null,
};

export type ModelCampaignDisplayConfigurationConnection = {
  __typename: "ModelCampaignDisplayConfigurationConnection",
  items:  Array<CampaignDisplayConfiguration | null >,
  nextToken?: string | null,
};

export type ModelNylasEventFilterInput = {
  id?: ModelIDInput | null,
  calendarID?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  fundraisingCampaignDiscoveryCallID?: ModelIDInput | null,
  status?: ModelStringInput | null,
  and?: Array< ModelNylasEventFilterInput | null > | null,
  or?: Array< ModelNylasEventFilterInput | null > | null,
  not?: ModelNylasEventFilterInput | null,
};

export type ModelNylasEventConnection = {
  __typename: "ModelNylasEventConnection",
  items:  Array<NylasEvent | null >,
  nextToken?: string | null,
};

export type ModelFundraisingCampaignDiscoveryCallFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  organizationID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  staffProfileID?: ModelIDInput | null,
  startTimestamp?: ModelStringInput | null,
  endTimestamp?: ModelStringInput | null,
  latentHosted?: ModelBooleanInput | null,
  invitationURL?: ModelStringInput | null,
  nylasEventID?: ModelIDInput | null,
  virtualMeetingURL?: ModelStringInput | null,
  and?: Array< ModelFundraisingCampaignDiscoveryCallFilterInput | null > | null,
  or?: Array< ModelFundraisingCampaignDiscoveryCallFilterInput | null > | null,
  not?: ModelFundraisingCampaignDiscoveryCallFilterInput | null,
};

export type ModelFundraisingCampaignDiscoveryCallConnection = {
  __typename: "ModelFundraisingCampaignDiscoveryCallConnection",
  items:  Array<FundraisingCampaignDiscoveryCall | null >,
  nextToken?: string | null,
};

export type ModelDiscoveryCallParticipantFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  authAccountID?: ModelIDInput | null,
  fundraisingProfileID?: ModelIDInput | null,
  fundraisingCampaignDiscoveryCallID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  invitationSent?: ModelBooleanInput | null,
  icsString?: ModelStringInput | null,
  status?: ModelStringInput | null,
  recruitedByCampaignAmbassadorID?: ModelIDInput | null,
  confirmed?: ModelBooleanInput | null,
  notes?: ModelStringInput | null,
  and?: Array< ModelDiscoveryCallParticipantFilterInput | null > | null,
  or?: Array< ModelDiscoveryCallParticipantFilterInput | null > | null,
  not?: ModelDiscoveryCallParticipantFilterInput | null,
};

export type ModelDiscoveryCallParticipantConnection = {
  __typename: "ModelDiscoveryCallParticipantConnection",
  items:  Array<DiscoveryCallParticipant | null >,
  nextToken?: string | null,
};

export type ModelFundraisingCampaignAmbassadorFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelFundraisingCampaignAmbassadorStatusInput | null,
  commitment?: ModelFundraisingCampaignAmbassadorCommitmentInput | null,
  fundraisingProfileID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  discoveryCallParticipantID?: ModelIDInput | null,
  fundsRaised?: ModelFloatInput | null,
  initialTransactionID?: ModelStringInput | null,
  initialTransactionAmount?: ModelFloatInput | null,
  ambassadorSpecificCtaUrl?: ModelStringInput | null,
  ambassadorSpecificVideoUrl?: ModelStringInput | null,
  recruitedByCampaignAmbassadorID?: ModelIDInput | null,
  classyTeamID?: ModelStringInput | null,
  classySupporterID?: ModelStringInput | null,
  classyFundraiserPageID?: ModelStringInput | null,
  notificationsEnabled?: ModelBooleanInput | null,
  and?: Array< ModelFundraisingCampaignAmbassadorFilterInput | null > | null,
  or?: Array< ModelFundraisingCampaignAmbassadorFilterInput | null > | null,
  not?: ModelFundraisingCampaignAmbassadorFilterInput | null,
};

export type ModelFundraisingCampaignAmbassadorContactFilterInput = {
  id?: ModelIDInput | null,
  deviceContactID?: ModelIDInput | null,
  fundraisingProfileID?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  fundraisingCampaignAmbassadorID?: ModelIDInput | null,
  sentText?: ModelBooleanInput | null,
  sentTextTimestamp?: ModelStringInput | null,
  sentInitialTextReminder?: ModelBooleanInput | null,
  sentInitialTextReminderTimestamp?: ModelStringInput | null,
  sentPhoneCallScript?: ModelBooleanInput | null,
  sentPhoneCallScriptTimestamp?: ModelStringInput | null,
  called?: ModelBooleanInput | null,
  calledTimestamp?: ModelStringInput | null,
  sentFollowUp?: ModelBooleanInput | null,
  sentFollowUpTimestamp?: ModelStringInput | null,
  followUpResponse?: ModelFollowUpResponseInput | null,
  sentReminder?: ModelBooleanInput | null,
  sentReminderTimestamp?: ModelStringInput | null,
  isDonating?: ModelBooleanInput | null,
  donationAmount?: ModelFloatInput | null,
  discoveryCallParticipantID?: ModelIDInput | null,
  transactionID?: ModelIDInput | null,
  isActive?: ModelBooleanInput | null,
  notes?: ModelStringInput | null,
  birthday?: ModelStringInput | null,
  hasTakenAction?: ModelBooleanInput | null,
  hasTakenActionTimestamp?: ModelStringInput | null,
  occupation?: ModelStringInput | null,
  selectedPhoneNumberArrayIndex?: ModelIntInput | null,
  and?: Array< ModelFundraisingCampaignAmbassadorContactFilterInput | null > | null,
  or?: Array< ModelFundraisingCampaignAmbassadorContactFilterInput | null > | null,
  not?: ModelFundraisingCampaignAmbassadorContactFilterInput | null,
};

export type ModelFundraisingCampaignUpdateFilterInput = {
  id?: ModelIDInput | null,
  fundraisingCampaignID?: ModelIDInput | null,
  public?: ModelBooleanInput | null,
  message?: ModelStringInput | null,
  assetsUploaded?: ModelIntInput | null,
  updateURL?: ModelStringInput | null,
  createdByStaffProfileID?: ModelIDInput | null,
  live?: ModelBooleanInput | null,
  liveTimestamp?: ModelStringInput | null,
  and?: Array< ModelFundraisingCampaignUpdateFilterInput | null > | null,
  or?: Array< ModelFundraisingCampaignUpdateFilterInput | null > | null,
  not?: ModelFundraisingCampaignUpdateFilterInput | null,
};

export type ModelFundraisingCampaignUpdateConnection = {
  __typename: "ModelFundraisingCampaignUpdateConnection",
  items:  Array<FundraisingCampaignUpdate | null >,
  nextToken?: string | null,
};

export type SendNewVolunteerMatchRequestEmailMutationVariables = {
  input: SendNewVolunteerMatchRequestEmailInput,
};

export type SendNewVolunteerMatchRequestEmailMutation = {
  sendNewVolunteerMatchRequestEmail?: string | null,
};

export type SendStaffInvitationEmailMutationVariables = {
  input: SendInvitationEmailInput,
};

export type SendStaffInvitationEmailMutation = {
  sendStaffInvitationEmail?: string | null,
};

export type SendFundraisingInvitationEmailMutationVariables = {
  input: SendInvitationEmailInput,
};

export type SendFundraisingInvitationEmailMutation = {
  sendFundraisingInvitationEmail?: string | null,
};

export type SendVolunteerInvitationEmailMutationVariables = {
  input: SendInvitationEmailInput,
};

export type SendVolunteerInvitationEmailMutation = {
  sendVolunteerInvitationEmail?: string | null,
};

export type SendPhoneCallScriptEmailMutationVariables = {
  input: sendPhoneCallScriptEmailInput,
};

export type SendPhoneCallScriptEmailMutation = {
  sendPhoneCallScriptEmail?: string | null,
};

export type GetStreamKeyMutationVariables = {
  input: GetStreamKeyInput,
};

export type GetStreamKeyMutation = {
  getStreamKey?: string | null,
};

export type CreateVolunteerProfileMutationVariables = {
  input: CreateVolunteerProfileInput,
  condition?: ModelVolunteerProfileConditionInput | null,
};

export type CreateVolunteerProfileMutation = {
  createVolunteerProfile?:  {
    __typename: "VolunteerProfile",
    id: string,
    authAccountID: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    gender?: GenderType | null,
    dateOfBirth?: string | null,
    streetAddress?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: number | null,
    website?: string | null,
    enneagram?: number | null,
    enneagramWing?: number | null,
    myersBriggs?: string | null,
    additionalInformation?: string | null,
    availabilityStringified?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    skills?:  {
      __typename: "ModelVolunteerSkillConnection",
      items:  Array< {
        __typename: "VolunteerSkill",
        id: string,
        skillID: string,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        skill?:  {
          __typename: "Skill",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    causes?:  {
      __typename: "ModelVolunteerCauseConnection",
      items:  Array< {
        __typename: "VolunteerCause",
        id: string,
        causeID: string,
        cause?:  {
          __typename: "Cause",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateVolunteerProfileMutationVariables = {
  input: UpdateVolunteerProfileInput,
  condition?: ModelVolunteerProfileConditionInput | null,
};

export type UpdateVolunteerProfileMutation = {
  updateVolunteerProfile?:  {
    __typename: "VolunteerProfile",
    id: string,
    authAccountID: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    gender?: GenderType | null,
    dateOfBirth?: string | null,
    streetAddress?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: number | null,
    website?: string | null,
    enneagram?: number | null,
    enneagramWing?: number | null,
    myersBriggs?: string | null,
    additionalInformation?: string | null,
    availabilityStringified?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    skills?:  {
      __typename: "ModelVolunteerSkillConnection",
      items:  Array< {
        __typename: "VolunteerSkill",
        id: string,
        skillID: string,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        skill?:  {
          __typename: "Skill",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    causes?:  {
      __typename: "ModelVolunteerCauseConnection",
      items:  Array< {
        __typename: "VolunteerCause",
        id: string,
        causeID: string,
        cause?:  {
          __typename: "Cause",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteVolunteerProfileMutationVariables = {
  input: DeleteVolunteerProfileInput,
  condition?: ModelVolunteerProfileConditionInput | null,
};

export type DeleteVolunteerProfileMutation = {
  deleteVolunteerProfile?:  {
    __typename: "VolunteerProfile",
    id: string,
    authAccountID: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    gender?: GenderType | null,
    dateOfBirth?: string | null,
    streetAddress?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: number | null,
    website?: string | null,
    enneagram?: number | null,
    enneagramWing?: number | null,
    myersBriggs?: string | null,
    additionalInformation?: string | null,
    availabilityStringified?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    skills?:  {
      __typename: "ModelVolunteerSkillConnection",
      items:  Array< {
        __typename: "VolunteerSkill",
        id: string,
        skillID: string,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        skill?:  {
          __typename: "Skill",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    causes?:  {
      __typename: "ModelVolunteerCauseConnection",
      items:  Array< {
        __typename: "VolunteerCause",
        id: string,
        causeID: string,
        cause?:  {
          __typename: "Cause",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateOrganizationInvitationMutationVariables = {
  input: CreateOrganizationInvitationInput,
  condition?: ModelOrganizationInvitationConditionInput | null,
};

export type CreateOrganizationInvitationMutation = {
  createOrganizationInvitation?:  {
    __typename: "OrganizationInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrganizationInvitationMutationVariables = {
  input: UpdateOrganizationInvitationInput,
  condition?: ModelOrganizationInvitationConditionInput | null,
};

export type UpdateOrganizationInvitationMutation = {
  updateOrganizationInvitation?:  {
    __typename: "OrganizationInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrganizationInvitationMutationVariables = {
  input: DeleteOrganizationInvitationInput,
  condition?: ModelOrganizationInvitationConditionInput | null,
};

export type DeleteOrganizationInvitationMutation = {
  deleteOrganizationInvitation?:  {
    __typename: "OrganizationInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateVolunteerSkillMutationVariables = {
  input: CreateVolunteerSkillInput,
  condition?: ModelVolunteerSkillConditionInput | null,
};

export type CreateVolunteerSkillMutation = {
  createVolunteerSkill?:  {
    __typename: "VolunteerSkill",
    id: string,
    skillID: string,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
    skill?:  {
      __typename: "Skill",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateVolunteerSkillMutationVariables = {
  input: UpdateVolunteerSkillInput,
  condition?: ModelVolunteerSkillConditionInput | null,
};

export type UpdateVolunteerSkillMutation = {
  updateVolunteerSkill?:  {
    __typename: "VolunteerSkill",
    id: string,
    skillID: string,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
    skill?:  {
      __typename: "Skill",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteVolunteerSkillMutationVariables = {
  input: DeleteVolunteerSkillInput,
  condition?: ModelVolunteerSkillConditionInput | null,
};

export type DeleteVolunteerSkillMutation = {
  deleteVolunteerSkill?:  {
    __typename: "VolunteerSkill",
    id: string,
    skillID: string,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
    skill?:  {
      __typename: "Skill",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateCauseMutationVariables = {
  input: CreateCauseInput,
  condition?: ModelCauseConditionInput | null,
};

export type CreateCauseMutation = {
  createCause?:  {
    __typename: "Cause",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCauseMutationVariables = {
  input: UpdateCauseInput,
  condition?: ModelCauseConditionInput | null,
};

export type UpdateCauseMutation = {
  updateCause?:  {
    __typename: "Cause",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCauseMutationVariables = {
  input: DeleteCauseInput,
  condition?: ModelCauseConditionInput | null,
};

export type DeleteCauseMutation = {
  deleteCause?:  {
    __typename: "Cause",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateVolunteerCauseMutationVariables = {
  input: CreateVolunteerCauseInput,
  condition?: ModelVolunteerCauseConditionInput | null,
};

export type CreateVolunteerCauseMutation = {
  createVolunteerCause?:  {
    __typename: "VolunteerCause",
    id: string,
    causeID: string,
    cause?:  {
      __typename: "Cause",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateVolunteerCauseMutationVariables = {
  input: UpdateVolunteerCauseInput,
  condition?: ModelVolunteerCauseConditionInput | null,
};

export type UpdateVolunteerCauseMutation = {
  updateVolunteerCause?:  {
    __typename: "VolunteerCause",
    id: string,
    causeID: string,
    cause?:  {
      __typename: "Cause",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteVolunteerCauseMutationVariables = {
  input: DeleteVolunteerCauseInput,
  condition?: ModelVolunteerCauseConditionInput | null,
};

export type DeleteVolunteerCauseMutation = {
  deleteVolunteerCause?:  {
    __typename: "VolunteerCause",
    id: string,
    causeID: string,
    cause?:  {
      __typename: "Cause",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrganizationDetailsMutationVariables = {
  input: CreateOrganizationDetailsInput,
  condition?: ModelOrganizationDetailsConditionInput | null,
};

export type CreateOrganizationDetailsMutation = {
  createOrganizationDetails?:  {
    __typename: "OrganizationDetails",
    id: string,
    organizationID: string,
    missionStatement?: string | null,
    serveStatement?: string | null,
    doStatement?: string | null,
    costToDoStatement?: string | null,
    missionArea?: string | null,
    annualBudget?: string | null,
    currentMonthlyRecurringDonors?: string | null,
    averageMonthlyRecurringDonation?: string | null,
    percentageOfBudgetFromIndividualDonors?: string | null,
    numberOfMajorDonors?: string | null,
    averageOneTimeDonation?: string | null,
    percentageOfBudgetFromGrants?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrganizationDetailsMutationVariables = {
  input: UpdateOrganizationDetailsInput,
  condition?: ModelOrganizationDetailsConditionInput | null,
};

export type UpdateOrganizationDetailsMutation = {
  updateOrganizationDetails?:  {
    __typename: "OrganizationDetails",
    id: string,
    organizationID: string,
    missionStatement?: string | null,
    serveStatement?: string | null,
    doStatement?: string | null,
    costToDoStatement?: string | null,
    missionArea?: string | null,
    annualBudget?: string | null,
    currentMonthlyRecurringDonors?: string | null,
    averageMonthlyRecurringDonation?: string | null,
    percentageOfBudgetFromIndividualDonors?: string | null,
    numberOfMajorDonors?: string | null,
    averageOneTimeDonation?: string | null,
    percentageOfBudgetFromGrants?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrganizationDetailsMutationVariables = {
  input: DeleteOrganizationDetailsInput,
  condition?: ModelOrganizationDetailsConditionInput | null,
};

export type DeleteOrganizationDetailsMutation = {
  deleteOrganizationDetails?:  {
    __typename: "OrganizationDetails",
    id: string,
    organizationID: string,
    missionStatement?: string | null,
    serveStatement?: string | null,
    doStatement?: string | null,
    costToDoStatement?: string | null,
    missionArea?: string | null,
    annualBudget?: string | null,
    currentMonthlyRecurringDonors?: string | null,
    averageMonthlyRecurringDonation?: string | null,
    percentageOfBudgetFromIndividualDonors?: string | null,
    numberOfMajorDonors?: string | null,
    averageOneTimeDonation?: string | null,
    percentageOfBudgetFromGrants?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProgramMutationVariables = {
  input: CreateProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type CreateProgramMutation = {
  createProgram?:  {
    __typename: "Program",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    theWhy?: string | null,
    leadID?: string | null,
    stringifiedCauses?: string | null,
    opportunities?:  {
      __typename: "ModelOpportunityConnection",
      items:  Array< {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    archived: boolean,
    createdAt: string,
    updatedAt: string,
    lead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateProgramMutationVariables = {
  input: UpdateProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type UpdateProgramMutation = {
  updateProgram?:  {
    __typename: "Program",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    theWhy?: string | null,
    leadID?: string | null,
    stringifiedCauses?: string | null,
    opportunities?:  {
      __typename: "ModelOpportunityConnection",
      items:  Array< {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    archived: boolean,
    createdAt: string,
    updatedAt: string,
    lead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteProgramMutationVariables = {
  input: DeleteProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type DeleteProgramMutation = {
  deleteProgram?:  {
    __typename: "Program",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    theWhy?: string | null,
    leadID?: string | null,
    stringifiedCauses?: string | null,
    opportunities?:  {
      __typename: "ModelOpportunityConnection",
      items:  Array< {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    archived: boolean,
    createdAt: string,
    updatedAt: string,
    lead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateOpportunityMutationVariables = {
  input: CreateOpportunityInput,
  condition?: ModelOpportunityConditionInput | null,
};

export type CreateOpportunityMutation = {
  createOpportunity?:  {
    __typename: "Opportunity",
    id: string,
    organizationID: string,
    programID?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityLeadID: string,
    type?: OpportunityType | null,
    status: OpportunityStatus,
    startDate?: string | null,
    endDate?: string | null,
    startRecruitingDate?: string | null,
    headerImage?: string | null,
    title?: string | null,
    descriptionRTE?: string | null,
    theWhy?: string | null,
    expectedImpact?: string | null,
    whatWillHappen?: string | null,
    volunteerGain?: string | null,
    roles?:  {
      __typename: "ModelRoleConnection",
      items:  Array< {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    application?:  {
      __typename: "ModelApplicationConnection",
      items:  Array< {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    opportunityLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateOpportunityMutationVariables = {
  input: UpdateOpportunityInput,
  condition?: ModelOpportunityConditionInput | null,
};

export type UpdateOpportunityMutation = {
  updateOpportunity?:  {
    __typename: "Opportunity",
    id: string,
    organizationID: string,
    programID?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityLeadID: string,
    type?: OpportunityType | null,
    status: OpportunityStatus,
    startDate?: string | null,
    endDate?: string | null,
    startRecruitingDate?: string | null,
    headerImage?: string | null,
    title?: string | null,
    descriptionRTE?: string | null,
    theWhy?: string | null,
    expectedImpact?: string | null,
    whatWillHappen?: string | null,
    volunteerGain?: string | null,
    roles?:  {
      __typename: "ModelRoleConnection",
      items:  Array< {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    application?:  {
      __typename: "ModelApplicationConnection",
      items:  Array< {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    opportunityLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteOpportunityMutationVariables = {
  input: DeleteOpportunityInput,
  condition?: ModelOpportunityConditionInput | null,
};

export type DeleteOpportunityMutation = {
  deleteOpportunity?:  {
    __typename: "Opportunity",
    id: string,
    organizationID: string,
    programID?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityLeadID: string,
    type?: OpportunityType | null,
    status: OpportunityStatus,
    startDate?: string | null,
    endDate?: string | null,
    startRecruitingDate?: string | null,
    headerImage?: string | null,
    title?: string | null,
    descriptionRTE?: string | null,
    theWhy?: string | null,
    expectedImpact?: string | null,
    whatWillHappen?: string | null,
    volunteerGain?: string | null,
    roles?:  {
      __typename: "ModelRoleConnection",
      items:  Array< {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    application?:  {
      __typename: "ModelApplicationConnection",
      items:  Array< {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    opportunityLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateApplicationMutationVariables = {
  input: CreateApplicationInput,
  condition?: ModelApplicationConditionInput | null,
};

export type CreateApplicationMutation = {
  createApplication?:  {
    __typename: "Application",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    screeningCallRequired?: ScreeningCallRequiredOptions | null,
    signUpOnly?: boolean | null,
    requireScreeningCall?: boolean | null,
    requireBackgroundCheck?: boolean | null,
    recruitmentDeadlineForVolunteers?: string | null,
    targetNumberOfVolunteerHours?: number | null,
    minimumNumberOfVolunteersRequired?: number | null,
    customApplicationQuestions?:  {
      __typename: "ModelCustomApplicationQuestionConnection",
      items:  Array< {
        __typename: "CustomApplicationQuestion",
        id: string,
        applicationID: string,
        application?:  {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        questionText: string,
        questionType: string,
        required: boolean,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateApplicationMutationVariables = {
  input: UpdateApplicationInput,
  condition?: ModelApplicationConditionInput | null,
};

export type UpdateApplicationMutation = {
  updateApplication?:  {
    __typename: "Application",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    screeningCallRequired?: ScreeningCallRequiredOptions | null,
    signUpOnly?: boolean | null,
    requireScreeningCall?: boolean | null,
    requireBackgroundCheck?: boolean | null,
    recruitmentDeadlineForVolunteers?: string | null,
    targetNumberOfVolunteerHours?: number | null,
    minimumNumberOfVolunteersRequired?: number | null,
    customApplicationQuestions?:  {
      __typename: "ModelCustomApplicationQuestionConnection",
      items:  Array< {
        __typename: "CustomApplicationQuestion",
        id: string,
        applicationID: string,
        application?:  {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        questionText: string,
        questionType: string,
        required: boolean,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteApplicationMutationVariables = {
  input: DeleteApplicationInput,
  condition?: ModelApplicationConditionInput | null,
};

export type DeleteApplicationMutation = {
  deleteApplication?:  {
    __typename: "Application",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    screeningCallRequired?: ScreeningCallRequiredOptions | null,
    signUpOnly?: boolean | null,
    requireScreeningCall?: boolean | null,
    requireBackgroundCheck?: boolean | null,
    recruitmentDeadlineForVolunteers?: string | null,
    targetNumberOfVolunteerHours?: number | null,
    minimumNumberOfVolunteersRequired?: number | null,
    customApplicationQuestions?:  {
      __typename: "ModelCustomApplicationQuestionConnection",
      items:  Array< {
        __typename: "CustomApplicationQuestion",
        id: string,
        applicationID: string,
        application?:  {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        questionText: string,
        questionType: string,
        required: boolean,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCustomApplicationQuestionMutationVariables = {
  input: CreateCustomApplicationQuestionInput,
  condition?: ModelCustomApplicationQuestionConditionInput | null,
};

export type CreateCustomApplicationQuestionMutation = {
  createCustomApplicationQuestion?:  {
    __typename: "CustomApplicationQuestion",
    id: string,
    applicationID: string,
    application?:  {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    questionText: string,
    questionType: string,
    required: boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCustomApplicationQuestionMutationVariables = {
  input: UpdateCustomApplicationQuestionInput,
  condition?: ModelCustomApplicationQuestionConditionInput | null,
};

export type UpdateCustomApplicationQuestionMutation = {
  updateCustomApplicationQuestion?:  {
    __typename: "CustomApplicationQuestion",
    id: string,
    applicationID: string,
    application?:  {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    questionText: string,
    questionType: string,
    required: boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCustomApplicationQuestionMutationVariables = {
  input: DeleteCustomApplicationQuestionInput,
  condition?: ModelCustomApplicationQuestionConditionInput | null,
};

export type DeleteCustomApplicationQuestionMutation = {
  deleteCustomApplicationQuestion?:  {
    __typename: "CustomApplicationQuestion",
    id: string,
    applicationID: string,
    application?:  {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    questionText: string,
    questionType: string,
    required: boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRoleMutationVariables = {
  input: CreateRoleInput,
  condition?: ModelRoleConditionInput | null,
};

export type CreateRoleMutation = {
  createRole?:  {
    __typename: "Role",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    roleTitle: string,
    opportunityTitle?: string | null,
    live?: boolean | null,
    roleCoordinatorID?: string | null,
    recurrence?: RoleRecurrence | null,
    weeklyRecurrenceDays?: string | null,
    weeklyRecurrenceSameVolunteers?: boolean | null,
    volunteersPerShift?: number | null,
    differentNumberOfVolunteersPerShift?: boolean | null,
    volunteerCommitmentMonths?: number | null,
    volunteerCommitmentCanRenew?: boolean | null,
    roleRequirements?: string | null,
    ageRequirement?: string | null,
    minorsRequireSupervision?: boolean | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    stringifiedSkills?: string | null,
    stringifiedSkillsJSON?: string | null,
    stringifiedCertifications?: string | null,
    shifts?:  {
      __typename: "ModelShiftConnection",
      items:  Array< {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    roleCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateRoleMutationVariables = {
  input: UpdateRoleInput,
  condition?: ModelRoleConditionInput | null,
};

export type UpdateRoleMutation = {
  updateRole?:  {
    __typename: "Role",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    roleTitle: string,
    opportunityTitle?: string | null,
    live?: boolean | null,
    roleCoordinatorID?: string | null,
    recurrence?: RoleRecurrence | null,
    weeklyRecurrenceDays?: string | null,
    weeklyRecurrenceSameVolunteers?: boolean | null,
    volunteersPerShift?: number | null,
    differentNumberOfVolunteersPerShift?: boolean | null,
    volunteerCommitmentMonths?: number | null,
    volunteerCommitmentCanRenew?: boolean | null,
    roleRequirements?: string | null,
    ageRequirement?: string | null,
    minorsRequireSupervision?: boolean | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    stringifiedSkills?: string | null,
    stringifiedSkillsJSON?: string | null,
    stringifiedCertifications?: string | null,
    shifts?:  {
      __typename: "ModelShiftConnection",
      items:  Array< {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    roleCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteRoleMutationVariables = {
  input: DeleteRoleInput,
  condition?: ModelRoleConditionInput | null,
};

export type DeleteRoleMutation = {
  deleteRole?:  {
    __typename: "Role",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    roleTitle: string,
    opportunityTitle?: string | null,
    live?: boolean | null,
    roleCoordinatorID?: string | null,
    recurrence?: RoleRecurrence | null,
    weeklyRecurrenceDays?: string | null,
    weeklyRecurrenceSameVolunteers?: boolean | null,
    volunteersPerShift?: number | null,
    differentNumberOfVolunteersPerShift?: boolean | null,
    volunteerCommitmentMonths?: number | null,
    volunteerCommitmentCanRenew?: boolean | null,
    roleRequirements?: string | null,
    ageRequirement?: string | null,
    minorsRequireSupervision?: boolean | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    stringifiedSkills?: string | null,
    stringifiedSkillsJSON?: string | null,
    stringifiedCertifications?: string | null,
    shifts?:  {
      __typename: "ModelShiftConnection",
      items:  Array< {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    roleCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateShiftMutationVariables = {
  input: CreateShiftInput,
  condition?: ModelShiftConditionInput | null,
};

export type CreateShiftMutation = {
  createShift?:  {
    __typename: "Shift",
    id: string,
    type: ShiftType,
    live?: boolean | null,
    name?: string | null,
    summary?: string | null,
    startDate?: string | null,
    startTime?: string | null,
    endDate?: string | null,
    endTime?: string | null,
    timezone?: string | null,
    timeFrame?: TimeFrame | null,
    timeFrameString?: string | null,
    recurrence?: ShiftRecurrence | null,
    weeklyRecurringDay?: string | null,
    monthlyRecurrenceWeek?: string | null,
    monthlyRecurrenceDay?: string | null,
    flexibleHours?: number | null,
    flexibleTimePeriod?: string | null,
    volunteersNeeded?: number | null,
    volunteerCoordinatorID?: string | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleStringifiedSkills?: string | null,
    roleStringifiedCauses?: string | null,
    locationID?: string | null,
    locationLongitude?: number | null,
    locationLatitude?: number | null,
    locationType?: LocationType | null,
    locationZipEstimate?: number | null,
    locationVariousDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    volunteerCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateShiftMutationVariables = {
  input: UpdateShiftInput,
  condition?: ModelShiftConditionInput | null,
};

export type UpdateShiftMutation = {
  updateShift?:  {
    __typename: "Shift",
    id: string,
    type: ShiftType,
    live?: boolean | null,
    name?: string | null,
    summary?: string | null,
    startDate?: string | null,
    startTime?: string | null,
    endDate?: string | null,
    endTime?: string | null,
    timezone?: string | null,
    timeFrame?: TimeFrame | null,
    timeFrameString?: string | null,
    recurrence?: ShiftRecurrence | null,
    weeklyRecurringDay?: string | null,
    monthlyRecurrenceWeek?: string | null,
    monthlyRecurrenceDay?: string | null,
    flexibleHours?: number | null,
    flexibleTimePeriod?: string | null,
    volunteersNeeded?: number | null,
    volunteerCoordinatorID?: string | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleStringifiedSkills?: string | null,
    roleStringifiedCauses?: string | null,
    locationID?: string | null,
    locationLongitude?: number | null,
    locationLatitude?: number | null,
    locationType?: LocationType | null,
    locationZipEstimate?: number | null,
    locationVariousDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    volunteerCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteShiftMutationVariables = {
  input: DeleteShiftInput,
  condition?: ModelShiftConditionInput | null,
};

export type DeleteShiftMutation = {
  deleteShift?:  {
    __typename: "Shift",
    id: string,
    type: ShiftType,
    live?: boolean | null,
    name?: string | null,
    summary?: string | null,
    startDate?: string | null,
    startTime?: string | null,
    endDate?: string | null,
    endTime?: string | null,
    timezone?: string | null,
    timeFrame?: TimeFrame | null,
    timeFrameString?: string | null,
    recurrence?: ShiftRecurrence | null,
    weeklyRecurringDay?: string | null,
    monthlyRecurrenceWeek?: string | null,
    monthlyRecurrenceDay?: string | null,
    flexibleHours?: number | null,
    flexibleTimePeriod?: string | null,
    volunteersNeeded?: number | null,
    volunteerCoordinatorID?: string | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleStringifiedSkills?: string | null,
    roleStringifiedCauses?: string | null,
    locationID?: string | null,
    locationLongitude?: number | null,
    locationLatitude?: number | null,
    locationType?: LocationType | null,
    locationZipEstimate?: number | null,
    locationVariousDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    volunteerCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateOpportunityTemplateMutationVariables = {
  input: CreateOpportunityTemplateInput,
  condition?: ModelOpportunityTemplateConditionInput | null,
};

export type CreateOpportunityTemplateMutation = {
  createOpportunityTemplate?:  {
    __typename: "OpportunityTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateOpportunityTemplateMutationVariables = {
  input: UpdateOpportunityTemplateInput,
  condition?: ModelOpportunityTemplateConditionInput | null,
};

export type UpdateOpportunityTemplateMutation = {
  updateOpportunityTemplate?:  {
    __typename: "OpportunityTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteOpportunityTemplateMutationVariables = {
  input: DeleteOpportunityTemplateInput,
  condition?: ModelOpportunityTemplateConditionInput | null,
};

export type DeleteOpportunityTemplateMutation = {
  deleteOpportunityTemplate?:  {
    __typename: "OpportunityTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateRoleTemplateMutationVariables = {
  input: CreateRoleTemplateInput,
  condition?: ModelRoleTemplateConditionInput | null,
};

export type CreateRoleTemplateMutation = {
  createRoleTemplate?:  {
    __typename: "RoleTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateRoleTemplateMutationVariables = {
  input: UpdateRoleTemplateInput,
  condition?: ModelRoleTemplateConditionInput | null,
};

export type UpdateRoleTemplateMutation = {
  updateRoleTemplate?:  {
    __typename: "RoleTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteRoleTemplateMutationVariables = {
  input: DeleteRoleTemplateInput,
  condition?: ModelRoleTemplateConditionInput | null,
};

export type DeleteRoleTemplateMutation = {
  deleteRoleTemplate?:  {
    __typename: "RoleTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateOrganizationGroupMutationVariables = {
  input: CreateOrganizationGroupInput,
  condition?: ModelOrganizationGroupConditionInput | null,
};

export type CreateOrganizationGroupMutation = {
  createOrganizationGroup?:  {
    __typename: "OrganizationGroup",
    id: string,
    organizationID: string,
    groupName: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrganizationGroupMutationVariables = {
  input: UpdateOrganizationGroupInput,
  condition?: ModelOrganizationGroupConditionInput | null,
};

export type UpdateOrganizationGroupMutation = {
  updateOrganizationGroup?:  {
    __typename: "OrganizationGroup",
    id: string,
    organizationID: string,
    groupName: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrganizationGroupMutationVariables = {
  input: DeleteOrganizationGroupInput,
  condition?: ModelOrganizationGroupConditionInput | null,
};

export type DeleteOrganizationGroupMutation = {
  deleteOrganizationGroup?:  {
    __typename: "OrganizationGroup",
    id: string,
    organizationID: string,
    groupName: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrganizationVolunteerMutationVariables = {
  input: CreateOrganizationVolunteerInput,
  condition?: ModelOrganizationVolunteerConditionInput | null,
};

export type CreateOrganizationVolunteerMutation = {
  createOrganizationVolunteer?:  {
    __typename: "OrganizationVolunteer",
    id: string,
    organizationID: string,
    volunteerProfileID: string,
    status: OrganizationVolunteerStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrganizationVolunteerMutationVariables = {
  input: UpdateOrganizationVolunteerInput,
  condition?: ModelOrganizationVolunteerConditionInput | null,
};

export type UpdateOrganizationVolunteerMutation = {
  updateOrganizationVolunteer?:  {
    __typename: "OrganizationVolunteer",
    id: string,
    organizationID: string,
    volunteerProfileID: string,
    status: OrganizationVolunteerStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrganizationVolunteerMutationVariables = {
  input: DeleteOrganizationVolunteerInput,
  condition?: ModelOrganizationVolunteerConditionInput | null,
};

export type DeleteOrganizationVolunteerMutation = {
  deleteOrganizationVolunteer?:  {
    __typename: "OrganizationVolunteer",
    id: string,
    organizationID: string,
    volunteerProfileID: string,
    status: OrganizationVolunteerStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrganizationGroupVolunteerMutationVariables = {
  input: CreateOrganizationGroupVolunteerInput,
  condition?: ModelOrganizationGroupVolunteerConditionInput | null,
};

export type CreateOrganizationGroupVolunteerMutation = {
  createOrganizationGroupVolunteer?:  {
    __typename: "OrganizationGroupVolunteer",
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrganizationGroupVolunteerMutationVariables = {
  input: UpdateOrganizationGroupVolunteerInput,
  condition?: ModelOrganizationGroupVolunteerConditionInput | null,
};

export type UpdateOrganizationGroupVolunteerMutation = {
  updateOrganizationGroupVolunteer?:  {
    __typename: "OrganizationGroupVolunteer",
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrganizationGroupVolunteerMutationVariables = {
  input: DeleteOrganizationGroupVolunteerInput,
  condition?: ModelOrganizationGroupVolunteerConditionInput | null,
};

export type DeleteOrganizationGroupVolunteerMutation = {
  deleteOrganizationGroupVolunteer?:  {
    __typename: "OrganizationGroupVolunteer",
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTimeCommitmentMutationVariables = {
  input: CreateTimeCommitmentInput,
  condition?: ModelTimeCommitmentConditionInput | null,
};

export type CreateTimeCommitmentMutation = {
  createTimeCommitment?:  {
    __typename: "TimeCommitment",
    id: string,
    amount: number,
    units: TimeUnitType,
    period: TimePeriodType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTimeCommitmentMutationVariables = {
  input: UpdateTimeCommitmentInput,
  condition?: ModelTimeCommitmentConditionInput | null,
};

export type UpdateTimeCommitmentMutation = {
  updateTimeCommitment?:  {
    __typename: "TimeCommitment",
    id: string,
    amount: number,
    units: TimeUnitType,
    period: TimePeriodType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTimeCommitmentMutationVariables = {
  input: DeleteTimeCommitmentInput,
  condition?: ModelTimeCommitmentConditionInput | null,
};

export type DeleteTimeCommitmentMutation = {
  deleteTimeCommitment?:  {
    __typename: "TimeCommitment",
    id: string,
    amount: number,
    units: TimeUnitType,
    period: TimePeriodType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateVolunteerMatchRequestMutationVariables = {
  input: CreateVolunteerMatchRequestInput,
  condition?: ModelVolunteerMatchRequestConditionInput | null,
};

export type CreateVolunteerMatchRequestMutation = {
  createVolunteerMatchRequest?:  {
    __typename: "VolunteerMatchRequest",
    id: string,
    status: VolunteerMatchRequestStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleRequestedID?: string | null,
    roleRequested?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    volunteerComments?: string | null,
    administrativeNotes?: string | null,
    scheduledCallID?: string | null,
    scheduledCall?:  {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleAssignedID?: string | null,
    roleAssigned?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    assignmentID?: string | null,
    assignment?:  {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    organizationRejectionReason?: string | null,
    volunteerRejectionReason?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateVolunteerMatchRequestMutationVariables = {
  input: UpdateVolunteerMatchRequestInput,
  condition?: ModelVolunteerMatchRequestConditionInput | null,
};

export type UpdateVolunteerMatchRequestMutation = {
  updateVolunteerMatchRequest?:  {
    __typename: "VolunteerMatchRequest",
    id: string,
    status: VolunteerMatchRequestStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleRequestedID?: string | null,
    roleRequested?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    volunteerComments?: string | null,
    administrativeNotes?: string | null,
    scheduledCallID?: string | null,
    scheduledCall?:  {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleAssignedID?: string | null,
    roleAssigned?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    assignmentID?: string | null,
    assignment?:  {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    organizationRejectionReason?: string | null,
    volunteerRejectionReason?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteVolunteerMatchRequestMutationVariables = {
  input: DeleteVolunteerMatchRequestInput,
  condition?: ModelVolunteerMatchRequestConditionInput | null,
};

export type DeleteVolunteerMatchRequestMutation = {
  deleteVolunteerMatchRequest?:  {
    __typename: "VolunteerMatchRequest",
    id: string,
    status: VolunteerMatchRequestStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleRequestedID?: string | null,
    roleRequested?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    volunteerComments?: string | null,
    administrativeNotes?: string | null,
    scheduledCallID?: string | null,
    scheduledCall?:  {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleAssignedID?: string | null,
    roleAssigned?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    assignmentID?: string | null,
    assignment?:  {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    organizationRejectionReason?: string | null,
    volunteerRejectionReason?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateScheduledCallMutationVariables = {
  input: CreateScheduledCallInput,
  condition?: ModelScheduledCallConditionInput | null,
};

export type CreateScheduledCallMutation = {
  createScheduledCall?:  {
    __typename: "ScheduledCall",
    id: string,
    status: ScheduledCallStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    startTime?: string | null,
    duration?: number | null,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateScheduledCallMutationVariables = {
  input: UpdateScheduledCallInput,
  condition?: ModelScheduledCallConditionInput | null,
};

export type UpdateScheduledCallMutation = {
  updateScheduledCall?:  {
    __typename: "ScheduledCall",
    id: string,
    status: ScheduledCallStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    startTime?: string | null,
    duration?: number | null,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteScheduledCallMutationVariables = {
  input: DeleteScheduledCallInput,
  condition?: ModelScheduledCallConditionInput | null,
};

export type DeleteScheduledCallMutation = {
  deleteScheduledCall?:  {
    __typename: "ScheduledCall",
    id: string,
    status: ScheduledCallStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    startTime?: string | null,
    duration?: number | null,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateAssignmentMutationVariables = {
  input: CreateAssignmentInput,
  condition?: ModelAssignmentConditionInput | null,
};

export type CreateAssignmentMutation = {
  createAssignment?:  {
    __typename: "Assignment",
    id: string,
    status: AssignmentStatusType,
    volunteerMatchRequestID: string,
    volunteerMatchRequest?:  {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID: string,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    shiftID: string,
    shift?:  {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    administrativeNotes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAssignmentMutationVariables = {
  input: UpdateAssignmentInput,
  condition?: ModelAssignmentConditionInput | null,
};

export type UpdateAssignmentMutation = {
  updateAssignment?:  {
    __typename: "Assignment",
    id: string,
    status: AssignmentStatusType,
    volunteerMatchRequestID: string,
    volunteerMatchRequest?:  {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID: string,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    shiftID: string,
    shift?:  {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    administrativeNotes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAssignmentMutationVariables = {
  input: DeleteAssignmentInput,
  condition?: ModelAssignmentConditionInput | null,
};

export type DeleteAssignmentMutation = {
  deleteAssignment?:  {
    __typename: "Assignment",
    id: string,
    status: AssignmentStatusType,
    volunteerMatchRequestID: string,
    volunteerMatchRequest?:  {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID: string,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    shiftID: string,
    shift?:  {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    administrativeNotes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCheckInMutationVariables = {
  input: CreateCheckInInput,
  condition?: ModelCheckInConditionInput | null,
};

export type CreateCheckInMutation = {
  createCheckIn?:  {
    __typename: "CheckIn",
    id: string,
    assignmentID: string,
    shiftID: string,
    opportunityID: string,
    timeIn?: string | null,
    timeOut?: string | null,
    checkedInByVolunteerProfileID?: string | null,
    checkedInByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    checkedOutByVolunteerProfileID?: string | null,
    checkedOutByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCheckInMutationVariables = {
  input: UpdateCheckInInput,
  condition?: ModelCheckInConditionInput | null,
};

export type UpdateCheckInMutation = {
  updateCheckIn?:  {
    __typename: "CheckIn",
    id: string,
    assignmentID: string,
    shiftID: string,
    opportunityID: string,
    timeIn?: string | null,
    timeOut?: string | null,
    checkedInByVolunteerProfileID?: string | null,
    checkedInByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    checkedOutByVolunteerProfileID?: string | null,
    checkedOutByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCheckInMutationVariables = {
  input: DeleteCheckInInput,
  condition?: ModelCheckInConditionInput | null,
};

export type DeleteCheckInMutation = {
  deleteCheckIn?:  {
    __typename: "CheckIn",
    id: string,
    assignmentID: string,
    shiftID: string,
    opportunityID: string,
    timeIn?: string | null,
    timeOut?: string | null,
    checkedInByVolunteerProfileID?: string | null,
    checkedInByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    checkedOutByVolunteerProfileID?: string | null,
    checkedOutByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNotificationSettingsMutationVariables = {
  input: CreateNotificationSettingsInput,
  condition?: ModelNotificationSettingsConditionInput | null,
};

export type CreateNotificationSettingsMutation = {
  createNotificationSettings?:  {
    __typename: "NotificationSettings",
    id: string,
    communicationsProfileID: string,
    allowPushNotifications: boolean,
    allowTextMessages: boolean,
    allowEmail: boolean,
    preference?: NotificationPreference | null,
    createdAt: string,
    updatedAt: string,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type UpdateNotificationSettingsMutationVariables = {
  input: UpdateNotificationSettingsInput,
  condition?: ModelNotificationSettingsConditionInput | null,
};

export type UpdateNotificationSettingsMutation = {
  updateNotificationSettings?:  {
    __typename: "NotificationSettings",
    id: string,
    communicationsProfileID: string,
    allowPushNotifications: boolean,
    allowTextMessages: boolean,
    allowEmail: boolean,
    preference?: NotificationPreference | null,
    createdAt: string,
    updatedAt: string,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type DeleteNotificationSettingsMutationVariables = {
  input: DeleteNotificationSettingsInput,
  condition?: ModelNotificationSettingsConditionInput | null,
};

export type DeleteNotificationSettingsMutation = {
  deleteNotificationSettings?:  {
    __typename: "NotificationSettings",
    id: string,
    communicationsProfileID: string,
    allowPushNotifications: boolean,
    allowTextMessages: boolean,
    allowEmail: boolean,
    preference?: NotificationPreference | null,
    createdAt: string,
    updatedAt: string,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type CreateLatentOrganizationCodeMutationVariables = {
  input: CreateLatentOrganizationCodeInput,
  condition?: ModelLatentOrganizationCodeConditionInput | null,
};

export type CreateLatentOrganizationCodeMutation = {
  createLatentOrganizationCode?:  {
    __typename: "LatentOrganizationCode",
    id: string,
    code: string,
    organizationID: string,
    active: boolean,
    emailRestricted: boolean,
    emailHostRestriction?: string | null,
    fundraisingCampaignID?: string | null,
    presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateLatentOrganizationCodeMutationVariables = {
  input: UpdateLatentOrganizationCodeInput,
  condition?: ModelLatentOrganizationCodeConditionInput | null,
};

export type UpdateLatentOrganizationCodeMutation = {
  updateLatentOrganizationCode?:  {
    __typename: "LatentOrganizationCode",
    id: string,
    code: string,
    organizationID: string,
    active: boolean,
    emailRestricted: boolean,
    emailHostRestriction?: string | null,
    fundraisingCampaignID?: string | null,
    presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteLatentOrganizationCodeMutationVariables = {
  input: DeleteLatentOrganizationCodeInput,
  condition?: ModelLatentOrganizationCodeConditionInput | null,
};

export type DeleteLatentOrganizationCodeMutation = {
  deleteLatentOrganizationCode?:  {
    __typename: "LatentOrganizationCode",
    id: string,
    code: string,
    organizationID: string,
    active: boolean,
    emailRestricted: boolean,
    emailHostRestriction?: string | null,
    fundraisingCampaignID?: string | null,
    presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateSubscriptionDonationTierMutationVariables = {
  input: CreateSubscriptionDonationTierInput,
  condition?: ModelSubscriptionDonationTierConditionInput | null,
};

export type CreateSubscriptionDonationTierMutation = {
  createSubscriptionDonationTier?:  {
    __typename: "SubscriptionDonationTier",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    amount?: number | null,
    features?: Array< string | null > | null,
    buttonText?: string | null,
    buttonColor?: string | null,
    default?: boolean | null,
    highlighted?: boolean | null,
    highlightedColor?: string | null,
    promoText?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSubscriptionDonationTierMutationVariables = {
  input: UpdateSubscriptionDonationTierInput,
  condition?: ModelSubscriptionDonationTierConditionInput | null,
};

export type UpdateSubscriptionDonationTierMutation = {
  updateSubscriptionDonationTier?:  {
    __typename: "SubscriptionDonationTier",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    amount?: number | null,
    features?: Array< string | null > | null,
    buttonText?: string | null,
    buttonColor?: string | null,
    default?: boolean | null,
    highlighted?: boolean | null,
    highlightedColor?: string | null,
    promoText?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSubscriptionDonationTierMutationVariables = {
  input: DeleteSubscriptionDonationTierInput,
  condition?: ModelSubscriptionDonationTierConditionInput | null,
};

export type DeleteSubscriptionDonationTierMutation = {
  deleteSubscriptionDonationTier?:  {
    __typename: "SubscriptionDonationTier",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    amount?: number | null,
    features?: Array< string | null > | null,
    buttonText?: string | null,
    buttonColor?: string | null,
    default?: boolean | null,
    highlighted?: boolean | null,
    highlightedColor?: string | null,
    promoText?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCampaignConversationFlowMutationVariables = {
  input: CreateCampaignConversationFlowInput,
  condition?: ModelCampaignConversationFlowConditionInput | null,
};

export type CreateCampaignConversationFlowMutation = {
  createCampaignConversationFlow?:  {
    __typename: "CampaignConversationFlow",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    default?: boolean | null,
    active: boolean,
    actionMessageDefinitions?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    restricted?: boolean | null,
    useDefaultCta?: boolean | null,
    customCta?: string | null,
    allowAmbassadorSpecificCrowbarVideos?: boolean | null,
    generalCrowbarVideoURI?: string | null,
    deleted?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCampaignConversationFlowMutationVariables = {
  input: UpdateCampaignConversationFlowInput,
  condition?: ModelCampaignConversationFlowConditionInput | null,
};

export type UpdateCampaignConversationFlowMutation = {
  updateCampaignConversationFlow?:  {
    __typename: "CampaignConversationFlow",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    default?: boolean | null,
    active: boolean,
    actionMessageDefinitions?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    restricted?: boolean | null,
    useDefaultCta?: boolean | null,
    customCta?: string | null,
    allowAmbassadorSpecificCrowbarVideos?: boolean | null,
    generalCrowbarVideoURI?: string | null,
    deleted?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCampaignConversationFlowMutationVariables = {
  input: DeleteCampaignConversationFlowInput,
  condition?: ModelCampaignConversationFlowConditionInput | null,
};

export type DeleteCampaignConversationFlowMutation = {
  deleteCampaignConversationFlow?:  {
    __typename: "CampaignConversationFlow",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    default?: boolean | null,
    active: boolean,
    actionMessageDefinitions?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    restricted?: boolean | null,
    useDefaultCta?: boolean | null,
    customCta?: string | null,
    allowAmbassadorSpecificCrowbarVideos?: boolean | null,
    generalCrowbarVideoURI?: string | null,
    deleted?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateActionMessageDefinitionMutationVariables = {
  input: CreateActionMessageDefinitionInput,
  condition?: ModelActionMessageDefinitionConditionInput | null,
};

export type CreateActionMessageDefinitionMutation = {
  createActionMessageDefinition?:  {
    __typename: "ActionMessageDefinition",
    id: string,
    campaignConversationFlowID: string,
    fundraisingCampaignID: string,
    name?: string | null,
    description?: string | null,
    type: ActionMessageType,
    messageTemplate?: string | null,
    onPositiveResponse?: string | null,
    onNegativeResponse?: string | null,
    otherResponses?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    reminderActionMessageDefinitionID?: string | null,
    reminderActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reminderDelay?: number | null,
    sendReminderNotification?: boolean | null,
    reminderNotificationID?: string | null,
    beginningNode?: boolean | null,
    parentActionMessageDefinitionID?: string | null,
    parentActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    viewType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateActionMessageDefinitionMutationVariables = {
  input: UpdateActionMessageDefinitionInput,
  condition?: ModelActionMessageDefinitionConditionInput | null,
};

export type UpdateActionMessageDefinitionMutation = {
  updateActionMessageDefinition?:  {
    __typename: "ActionMessageDefinition",
    id: string,
    campaignConversationFlowID: string,
    fundraisingCampaignID: string,
    name?: string | null,
    description?: string | null,
    type: ActionMessageType,
    messageTemplate?: string | null,
    onPositiveResponse?: string | null,
    onNegativeResponse?: string | null,
    otherResponses?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    reminderActionMessageDefinitionID?: string | null,
    reminderActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reminderDelay?: number | null,
    sendReminderNotification?: boolean | null,
    reminderNotificationID?: string | null,
    beginningNode?: boolean | null,
    parentActionMessageDefinitionID?: string | null,
    parentActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    viewType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteActionMessageDefinitionMutationVariables = {
  input: DeleteActionMessageDefinitionInput,
  condition?: ModelActionMessageDefinitionConditionInput | null,
};

export type DeleteActionMessageDefinitionMutation = {
  deleteActionMessageDefinition?:  {
    __typename: "ActionMessageDefinition",
    id: string,
    campaignConversationFlowID: string,
    fundraisingCampaignID: string,
    name?: string | null,
    description?: string | null,
    type: ActionMessageType,
    messageTemplate?: string | null,
    onPositiveResponse?: string | null,
    onNegativeResponse?: string | null,
    otherResponses?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    reminderActionMessageDefinitionID?: string | null,
    reminderActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reminderDelay?: number | null,
    sendReminderNotification?: boolean | null,
    reminderNotificationID?: string | null,
    beginningNode?: boolean | null,
    parentActionMessageDefinitionID?: string | null,
    parentActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    viewType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateActionMessageMutationVariables = {
  input: CreateActionMessageInput,
  condition?: ModelActionMessageConditionInput | null,
};

export type CreateActionMessageMutation = {
  createActionMessage?:  {
    __typename: "ActionMessage",
    id: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    fundraisingCampaignAmbassadorContactID: string,
    actionMessageDefinitionID: string,
    actionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sent?: boolean | null,
    sentTimestamp?: string | null,
    response?: ActionMessageResponseType | null,
    responseTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateActionMessageMutationVariables = {
  input: UpdateActionMessageInput,
  condition?: ModelActionMessageConditionInput | null,
};

export type UpdateActionMessageMutation = {
  updateActionMessage?:  {
    __typename: "ActionMessage",
    id: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    fundraisingCampaignAmbassadorContactID: string,
    actionMessageDefinitionID: string,
    actionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sent?: boolean | null,
    sentTimestamp?: string | null,
    response?: ActionMessageResponseType | null,
    responseTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteActionMessageMutationVariables = {
  input: DeleteActionMessageInput,
  condition?: ModelActionMessageConditionInput | null,
};

export type DeleteActionMessageMutation = {
  deleteActionMessage?:  {
    __typename: "ActionMessage",
    id: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    fundraisingCampaignAmbassadorContactID: string,
    actionMessageDefinitionID: string,
    actionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sent?: boolean | null,
    sentTimestamp?: string | null,
    response?: ActionMessageResponseType | null,
    responseTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProjectMutationVariables = {
  input: CreateProjectInput,
  condition?: ModelProjectConditionInput | null,
};

export type CreateProjectMutation = {
  createProject?:  {
    __typename: "Project",
    id: string,
    status?: string | null,
    name: string,
    description?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProjectMutationVariables = {
  input: UpdateProjectInput,
  condition?: ModelProjectConditionInput | null,
};

export type UpdateProjectMutation = {
  updateProject?:  {
    __typename: "Project",
    id: string,
    status?: string | null,
    name: string,
    description?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProjectMutationVariables = {
  input: DeleteProjectInput,
  condition?: ModelProjectConditionInput | null,
};

export type DeleteProjectMutation = {
  deleteProject?:  {
    __typename: "Project",
    id: string,
    status?: string | null,
    name: string,
    description?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaskMutationVariables = {
  input: CreateTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type CreateTaskMutation = {
  createTask?:  {
    __typename: "Task",
    id: string,
    projectID: string,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isTopLevelTask?: boolean | null,
    name?: string | null,
    overview?: string | null,
    description?: string | null,
    descriptionRTE?: string | null,
    status?: string | null,
    complete?: boolean | null,
    assignments?:  {
      __typename: "ModelTaskAssignmentConnection",
      items:  Array< {
        __typename: "TaskAssignment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authAccountID: string,
        staffProfileID?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelTaskCommentConnection",
      items:  Array< {
        __typename: "TaskComment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        comment?: string | null,
        mediaURI?: Array< string | null > | null,
        postedByID: string,
        createdAt: string,
        updatedAt: string,
        postedBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    subTasks?:  {
      __typename: "ModelSubTaskConnection",
      items:  Array< {
        __typename: "SubTask",
        id: string,
        parentTaskID: string,
        parentTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subTaskID: string,
        subTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mediaURI?: Array< string | null > | null,
    attachments?:  {
      __typename: "ModelTaskAttachmentConnection",
      items:  Array< {
        __typename: "TaskAttachment",
        id: string,
        taskID: string,
        uploadedByID: string,
        name?: string | null,
        description?: string | null,
        contentType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdByID?: string | null,
    actionURL?: string | null,
    dueDate?: string | null,
    blockedBy?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    blocking?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    createdBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateTaskMutationVariables = {
  input: UpdateTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type UpdateTaskMutation = {
  updateTask?:  {
    __typename: "Task",
    id: string,
    projectID: string,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isTopLevelTask?: boolean | null,
    name?: string | null,
    overview?: string | null,
    description?: string | null,
    descriptionRTE?: string | null,
    status?: string | null,
    complete?: boolean | null,
    assignments?:  {
      __typename: "ModelTaskAssignmentConnection",
      items:  Array< {
        __typename: "TaskAssignment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authAccountID: string,
        staffProfileID?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelTaskCommentConnection",
      items:  Array< {
        __typename: "TaskComment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        comment?: string | null,
        mediaURI?: Array< string | null > | null,
        postedByID: string,
        createdAt: string,
        updatedAt: string,
        postedBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    subTasks?:  {
      __typename: "ModelSubTaskConnection",
      items:  Array< {
        __typename: "SubTask",
        id: string,
        parentTaskID: string,
        parentTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subTaskID: string,
        subTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mediaURI?: Array< string | null > | null,
    attachments?:  {
      __typename: "ModelTaskAttachmentConnection",
      items:  Array< {
        __typename: "TaskAttachment",
        id: string,
        taskID: string,
        uploadedByID: string,
        name?: string | null,
        description?: string | null,
        contentType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdByID?: string | null,
    actionURL?: string | null,
    dueDate?: string | null,
    blockedBy?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    blocking?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    createdBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteTaskMutationVariables = {
  input: DeleteTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type DeleteTaskMutation = {
  deleteTask?:  {
    __typename: "Task",
    id: string,
    projectID: string,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isTopLevelTask?: boolean | null,
    name?: string | null,
    overview?: string | null,
    description?: string | null,
    descriptionRTE?: string | null,
    status?: string | null,
    complete?: boolean | null,
    assignments?:  {
      __typename: "ModelTaskAssignmentConnection",
      items:  Array< {
        __typename: "TaskAssignment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authAccountID: string,
        staffProfileID?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelTaskCommentConnection",
      items:  Array< {
        __typename: "TaskComment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        comment?: string | null,
        mediaURI?: Array< string | null > | null,
        postedByID: string,
        createdAt: string,
        updatedAt: string,
        postedBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    subTasks?:  {
      __typename: "ModelSubTaskConnection",
      items:  Array< {
        __typename: "SubTask",
        id: string,
        parentTaskID: string,
        parentTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subTaskID: string,
        subTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mediaURI?: Array< string | null > | null,
    attachments?:  {
      __typename: "ModelTaskAttachmentConnection",
      items:  Array< {
        __typename: "TaskAttachment",
        id: string,
        taskID: string,
        uploadedByID: string,
        name?: string | null,
        description?: string | null,
        contentType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdByID?: string | null,
    actionURL?: string | null,
    dueDate?: string | null,
    blockedBy?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    blocking?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    createdBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateTaskAttachmentMutationVariables = {
  input: CreateTaskAttachmentInput,
  condition?: ModelTaskAttachmentConditionInput | null,
};

export type CreateTaskAttachmentMutation = {
  createTaskAttachment?:  {
    __typename: "TaskAttachment",
    id: string,
    taskID: string,
    uploadedByID: string,
    name?: string | null,
    description?: string | null,
    contentType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTaskAttachmentMutationVariables = {
  input: UpdateTaskAttachmentInput,
  condition?: ModelTaskAttachmentConditionInput | null,
};

export type UpdateTaskAttachmentMutation = {
  updateTaskAttachment?:  {
    __typename: "TaskAttachment",
    id: string,
    taskID: string,
    uploadedByID: string,
    name?: string | null,
    description?: string | null,
    contentType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTaskAttachmentMutationVariables = {
  input: DeleteTaskAttachmentInput,
  condition?: ModelTaskAttachmentConditionInput | null,
};

export type DeleteTaskAttachmentMutation = {
  deleteTaskAttachment?:  {
    __typename: "TaskAttachment",
    id: string,
    taskID: string,
    uploadedByID: string,
    name?: string | null,
    description?: string | null,
    contentType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaskBlockerMutationVariables = {
  input: CreateTaskBlockerInput,
  condition?: ModelTaskBlockerConditionInput | null,
};

export type CreateTaskBlockerMutation = {
  createTaskBlocker?:  {
    __typename: "TaskBlocker",
    id: string,
    originTaskID: string,
    originTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    blockerTaskID: string,
    blockerTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTaskBlockerMutationVariables = {
  input: UpdateTaskBlockerInput,
  condition?: ModelTaskBlockerConditionInput | null,
};

export type UpdateTaskBlockerMutation = {
  updateTaskBlocker?:  {
    __typename: "TaskBlocker",
    id: string,
    originTaskID: string,
    originTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    blockerTaskID: string,
    blockerTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTaskBlockerMutationVariables = {
  input: DeleteTaskBlockerInput,
  condition?: ModelTaskBlockerConditionInput | null,
};

export type DeleteTaskBlockerMutation = {
  deleteTaskBlocker?:  {
    __typename: "TaskBlocker",
    id: string,
    originTaskID: string,
    originTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    blockerTaskID: string,
    blockerTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSubTaskMutationVariables = {
  input: CreateSubTaskInput,
  condition?: ModelSubTaskConditionInput | null,
};

export type CreateSubTaskMutation = {
  createSubTask?:  {
    __typename: "SubTask",
    id: string,
    parentTaskID: string,
    parentTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    subTaskID: string,
    subTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSubTaskMutationVariables = {
  input: UpdateSubTaskInput,
  condition?: ModelSubTaskConditionInput | null,
};

export type UpdateSubTaskMutation = {
  updateSubTask?:  {
    __typename: "SubTask",
    id: string,
    parentTaskID: string,
    parentTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    subTaskID: string,
    subTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSubTaskMutationVariables = {
  input: DeleteSubTaskInput,
  condition?: ModelSubTaskConditionInput | null,
};

export type DeleteSubTaskMutation = {
  deleteSubTask?:  {
    __typename: "SubTask",
    id: string,
    parentTaskID: string,
    parentTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    subTaskID: string,
    subTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaskCommentMutationVariables = {
  input: CreateTaskCommentInput,
  condition?: ModelTaskCommentConditionInput | null,
};

export type CreateTaskCommentMutation = {
  createTaskComment?:  {
    __typename: "TaskComment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    comment?: string | null,
    mediaURI?: Array< string | null > | null,
    postedByID: string,
    createdAt: string,
    updatedAt: string,
    postedBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateTaskCommentMutationVariables = {
  input: UpdateTaskCommentInput,
  condition?: ModelTaskCommentConditionInput | null,
};

export type UpdateTaskCommentMutation = {
  updateTaskComment?:  {
    __typename: "TaskComment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    comment?: string | null,
    mediaURI?: Array< string | null > | null,
    postedByID: string,
    createdAt: string,
    updatedAt: string,
    postedBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteTaskCommentMutationVariables = {
  input: DeleteTaskCommentInput,
  condition?: ModelTaskCommentConditionInput | null,
};

export type DeleteTaskCommentMutation = {
  deleteTaskComment?:  {
    __typename: "TaskComment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    comment?: string | null,
    mediaURI?: Array< string | null > | null,
    postedByID: string,
    createdAt: string,
    updatedAt: string,
    postedBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateTaskAssignmentMutationVariables = {
  input: CreateTaskAssignmentInput,
  condition?: ModelTaskAssignmentConditionInput | null,
};

export type CreateTaskAssignmentMutation = {
  createTaskAssignment?:  {
    __typename: "TaskAssignment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    authAccountID: string,
    staffProfileID?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateTaskAssignmentMutationVariables = {
  input: UpdateTaskAssignmentInput,
  condition?: ModelTaskAssignmentConditionInput | null,
};

export type UpdateTaskAssignmentMutation = {
  updateTaskAssignment?:  {
    __typename: "TaskAssignment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    authAccountID: string,
    staffProfileID?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteTaskAssignmentMutationVariables = {
  input: DeleteTaskAssignmentInput,
  condition?: ModelTaskAssignmentConditionInput | null,
};

export type DeleteTaskAssignmentMutation = {
  deleteTaskAssignment?:  {
    __typename: "TaskAssignment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    authAccountID: string,
    staffProfileID?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateCognitoAccountMutationVariables = {
  input: CreateCognitoAccountInput,
  condition?: ModelCognitoAccountConditionInput | null,
};

export type CreateCognitoAccountMutation = {
  createCognitoAccount?:  {
    __typename: "CognitoAccount",
    id: string,
    cognitoID: string,
    authAccountID?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateCognitoAccountMutationVariables = {
  input: UpdateCognitoAccountInput,
  condition?: ModelCognitoAccountConditionInput | null,
};

export type UpdateCognitoAccountMutation = {
  updateCognitoAccount?:  {
    __typename: "CognitoAccount",
    id: string,
    cognitoID: string,
    authAccountID?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteCognitoAccountMutationVariables = {
  input: DeleteCognitoAccountInput,
  condition?: ModelCognitoAccountConditionInput | null,
};

export type DeleteCognitoAccountMutation = {
  deleteCognitoAccount?:  {
    __typename: "CognitoAccount",
    id: string,
    cognitoID: string,
    authAccountID?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateAuthAccountMutationVariables = {
  input: CreateAuthAccountInput,
  condition?: ModelAuthAccountConditionInput | null,
};

export type CreateAuthAccountMutation = {
  createAuthAccount?:  {
    __typename: "AuthAccount",
    id: string,
    volunteerProfileID?: string | null,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    lastSelectedStaffProfileID?: string | null,
    lastSelectedFundraisingProfileID?: string | null,
    communicationsProfileID?: string | null,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    primaryEmail?: string | null,
    phoneNumber?: string | null,
    dateOfBirth?: string | null,
    gender?: string | null,
    selfDescribedGender?: string | null,
    addressID?: string | null,
    website?: string | null,
    resumeURI?: string | null,
    bio?: string | null,
    profilePictureURI?: string | null,
    headerVideoURI?: string | null,
    headerImageURI?: string | null,
    headerAssetShown?: string | null,
    flourishAdmin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    cognitoAccounts?:  {
      __typename: "ModelCognitoAccountConnection",
      items:  Array< {
        __typename: "CognitoAccount",
        id: string,
        cognitoID: string,
        authAccountID?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    staffProfile?:  {
      __typename: "ModelStaffProfileConnection",
      items:  Array< {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    fundraisingProfiles?:  {
      __typename: "ModelFundraisingProfileConnection",
      items:  Array< {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedFundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type UpdateAuthAccountMutationVariables = {
  input: UpdateAuthAccountInput,
  condition?: ModelAuthAccountConditionInput | null,
};

export type UpdateAuthAccountMutation = {
  updateAuthAccount?:  {
    __typename: "AuthAccount",
    id: string,
    volunteerProfileID?: string | null,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    lastSelectedStaffProfileID?: string | null,
    lastSelectedFundraisingProfileID?: string | null,
    communicationsProfileID?: string | null,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    primaryEmail?: string | null,
    phoneNumber?: string | null,
    dateOfBirth?: string | null,
    gender?: string | null,
    selfDescribedGender?: string | null,
    addressID?: string | null,
    website?: string | null,
    resumeURI?: string | null,
    bio?: string | null,
    profilePictureURI?: string | null,
    headerVideoURI?: string | null,
    headerImageURI?: string | null,
    headerAssetShown?: string | null,
    flourishAdmin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    cognitoAccounts?:  {
      __typename: "ModelCognitoAccountConnection",
      items:  Array< {
        __typename: "CognitoAccount",
        id: string,
        cognitoID: string,
        authAccountID?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    staffProfile?:  {
      __typename: "ModelStaffProfileConnection",
      items:  Array< {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    fundraisingProfiles?:  {
      __typename: "ModelFundraisingProfileConnection",
      items:  Array< {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedFundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type DeleteAuthAccountMutationVariables = {
  input: DeleteAuthAccountInput,
  condition?: ModelAuthAccountConditionInput | null,
};

export type DeleteAuthAccountMutation = {
  deleteAuthAccount?:  {
    __typename: "AuthAccount",
    id: string,
    volunteerProfileID?: string | null,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    lastSelectedStaffProfileID?: string | null,
    lastSelectedFundraisingProfileID?: string | null,
    communicationsProfileID?: string | null,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    primaryEmail?: string | null,
    phoneNumber?: string | null,
    dateOfBirth?: string | null,
    gender?: string | null,
    selfDescribedGender?: string | null,
    addressID?: string | null,
    website?: string | null,
    resumeURI?: string | null,
    bio?: string | null,
    profilePictureURI?: string | null,
    headerVideoURI?: string | null,
    headerImageURI?: string | null,
    headerAssetShown?: string | null,
    flourishAdmin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    cognitoAccounts?:  {
      __typename: "ModelCognitoAccountConnection",
      items:  Array< {
        __typename: "CognitoAccount",
        id: string,
        cognitoID: string,
        authAccountID?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    staffProfile?:  {
      __typename: "ModelStaffProfileConnection",
      items:  Array< {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    fundraisingProfiles?:  {
      __typename: "ModelFundraisingProfileConnection",
      items:  Array< {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedFundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type CreateStaffProfileMutationVariables = {
  input: CreateStaffProfileInput,
  condition?: ModelStaffProfileConditionInput | null,
};

export type CreateStaffProfileMutation = {
  createStaffProfile?:  {
    __typename: "StaffProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    role?: StaffProfileRole | null,
    name?: string | null,
    nylasAccountID?: string | null,
    nylasCalendarToken?: string | null,
    nylasPrimaryCalendarID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateStaffProfileMutationVariables = {
  input: UpdateStaffProfileInput,
  condition?: ModelStaffProfileConditionInput | null,
};

export type UpdateStaffProfileMutation = {
  updateStaffProfile?:  {
    __typename: "StaffProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    role?: StaffProfileRole | null,
    name?: string | null,
    nylasAccountID?: string | null,
    nylasCalendarToken?: string | null,
    nylasPrimaryCalendarID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteStaffProfileMutationVariables = {
  input: DeleteStaffProfileInput,
  condition?: ModelStaffProfileConditionInput | null,
};

export type DeleteStaffProfileMutation = {
  deleteStaffProfile?:  {
    __typename: "StaffProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    role?: StaffProfileRole | null,
    name?: string | null,
    nylasAccountID?: string | null,
    nylasCalendarToken?: string | null,
    nylasPrimaryCalendarID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateCommunicationsProfileMutationVariables = {
  input: CreateCommunicationsProfileInput,
  condition?: ModelCommunicationsProfileConditionInput | null,
};

export type CreateCommunicationsProfileMutation = {
  createCommunicationsProfile?:  {
    __typename: "CommunicationsProfile",
    id: string,
    authAccountID: string,
    streamJwt?: string | null,
    notificationSettingsID?: string | null,
    notificationSettings?:  {
      __typename: "NotificationSettings",
      id: string,
      communicationsProfileID: string,
      allowPushNotifications: boolean,
      allowTextMessages: boolean,
      allowEmail: boolean,
      preference?: NotificationPreference | null,
      createdAt: string,
      updatedAt: string,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type UpdateCommunicationsProfileMutationVariables = {
  input: UpdateCommunicationsProfileInput,
  condition?: ModelCommunicationsProfileConditionInput | null,
};

export type UpdateCommunicationsProfileMutation = {
  updateCommunicationsProfile?:  {
    __typename: "CommunicationsProfile",
    id: string,
    authAccountID: string,
    streamJwt?: string | null,
    notificationSettingsID?: string | null,
    notificationSettings?:  {
      __typename: "NotificationSettings",
      id: string,
      communicationsProfileID: string,
      allowPushNotifications: boolean,
      allowTextMessages: boolean,
      allowEmail: boolean,
      preference?: NotificationPreference | null,
      createdAt: string,
      updatedAt: string,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type DeleteCommunicationsProfileMutationVariables = {
  input: DeleteCommunicationsProfileInput,
  condition?: ModelCommunicationsProfileConditionInput | null,
};

export type DeleteCommunicationsProfileMutation = {
  deleteCommunicationsProfile?:  {
    __typename: "CommunicationsProfile",
    id: string,
    authAccountID: string,
    streamJwt?: string | null,
    notificationSettingsID?: string | null,
    notificationSettings?:  {
      __typename: "NotificationSettings",
      id: string,
      communicationsProfileID: string,
      allowPushNotifications: boolean,
      allowTextMessages: boolean,
      allowEmail: boolean,
      preference?: NotificationPreference | null,
      createdAt: string,
      updatedAt: string,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type CreateFundraisingProfileMutationVariables = {
  input: CreateFundraisingProfileInput,
  condition?: ModelFundraisingProfileConditionInput | null,
};

export type CreateFundraisingProfileMutation = {
  createFundraisingProfile?:  {
    __typename: "FundraisingProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    classyMemberID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    campaigns?:  {
      __typename: "ModelFundraisingCampaignAmbassadorConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateFundraisingProfileMutationVariables = {
  input: UpdateFundraisingProfileInput,
  condition?: ModelFundraisingProfileConditionInput | null,
};

export type UpdateFundraisingProfileMutation = {
  updateFundraisingProfile?:  {
    __typename: "FundraisingProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    classyMemberID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    campaigns?:  {
      __typename: "ModelFundraisingCampaignAmbassadorConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteFundraisingProfileMutationVariables = {
  input: DeleteFundraisingProfileInput,
  condition?: ModelFundraisingProfileConditionInput | null,
};

export type DeleteFundraisingProfileMutation = {
  deleteFundraisingProfile?:  {
    __typename: "FundraisingProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    classyMemberID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    campaigns?:  {
      __typename: "ModelFundraisingCampaignAmbassadorConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateStaffInvitationMutationVariables = {
  input: CreateStaffInvitationInput,
  condition?: ModelStaffInvitationConditionInput | null,
};

export type CreateStaffInvitationMutation = {
  createStaffInvitation?:  {
    __typename: "StaffInvitation",
    id: string,
    code: string,
    type: StaffInvitationType,
    email?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    staffProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateStaffInvitationMutationVariables = {
  input: UpdateStaffInvitationInput,
  condition?: ModelStaffInvitationConditionInput | null,
};

export type UpdateStaffInvitationMutation = {
  updateStaffInvitation?:  {
    __typename: "StaffInvitation",
    id: string,
    code: string,
    type: StaffInvitationType,
    email?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    staffProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteStaffInvitationMutationVariables = {
  input: DeleteStaffInvitationInput,
  condition?: ModelStaffInvitationConditionInput | null,
};

export type DeleteStaffInvitationMutation = {
  deleteStaffInvitation?:  {
    __typename: "StaffInvitation",
    id: string,
    code: string,
    type: StaffInvitationType,
    email?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    staffProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateFundraisingInvitationMutationVariables = {
  input: CreateFundraisingInvitationInput,
  condition?: ModelFundraisingInvitationConditionInput | null,
};

export type CreateFundraisingInvitationMutation = {
  createFundraisingInvitation?:  {
    __typename: "FundraisingInvitation",
    id: string,
    code: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateFundraisingInvitationMutationVariables = {
  input: UpdateFundraisingInvitationInput,
  condition?: ModelFundraisingInvitationConditionInput | null,
};

export type UpdateFundraisingInvitationMutation = {
  updateFundraisingInvitation?:  {
    __typename: "FundraisingInvitation",
    id: string,
    code: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteFundraisingInvitationMutationVariables = {
  input: DeleteFundraisingInvitationInput,
  condition?: ModelFundraisingInvitationConditionInput | null,
};

export type DeleteFundraisingInvitationMutation = {
  deleteFundraisingInvitation?:  {
    __typename: "FundraisingInvitation",
    id: string,
    code: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateVolunteerInvitationMutationVariables = {
  input: CreateVolunteerInvitationInput,
  condition?: ModelVolunteerInvitationConditionInput | null,
};

export type CreateVolunteerInvitationMutation = {
  createVolunteerInvitation?:  {
    __typename: "VolunteerInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    organizationID?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateVolunteerInvitationMutationVariables = {
  input: UpdateVolunteerInvitationInput,
  condition?: ModelVolunteerInvitationConditionInput | null,
};

export type UpdateVolunteerInvitationMutation = {
  updateVolunteerInvitation?:  {
    __typename: "VolunteerInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    organizationID?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteVolunteerInvitationMutationVariables = {
  input: DeleteVolunteerInvitationInput,
  condition?: ModelVolunteerInvitationConditionInput | null,
};

export type DeleteVolunteerInvitationMutation = {
  deleteVolunteerInvitation?:  {
    __typename: "VolunteerInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    organizationID?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type CreateVolunteerWaitlistMutationVariables = {
  input: CreateVolunteerWaitlistInput,
  condition?: ModelVolunteerWaitlistConditionInput | null,
};

export type CreateVolunteerWaitlistMutation = {
  createVolunteerWaitlist?:  {
    __typename: "VolunteerWaitlist",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    zipCode?: number | null,
    about?: string | null,
    invited?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateVolunteerWaitlistMutationVariables = {
  input: UpdateVolunteerWaitlistInput,
  condition?: ModelVolunteerWaitlistConditionInput | null,
};

export type UpdateVolunteerWaitlistMutation = {
  updateVolunteerWaitlist?:  {
    __typename: "VolunteerWaitlist",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    zipCode?: number | null,
    about?: string | null,
    invited?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteVolunteerWaitlistMutationVariables = {
  input: DeleteVolunteerWaitlistInput,
  condition?: ModelVolunteerWaitlistConditionInput | null,
};

export type DeleteVolunteerWaitlistMutation = {
  deleteVolunteerWaitlist?:  {
    __typename: "VolunteerWaitlist",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    zipCode?: number | null,
    about?: string | null,
    invited?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateSkillMutationVariables = {
  input: CreateSkillInput,
  condition?: ModelSkillConditionInput | null,
};

export type CreateSkillMutation = {
  createSkill?:  {
    __typename: "Skill",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSkillMutationVariables = {
  input: UpdateSkillInput,
  condition?: ModelSkillConditionInput | null,
};

export type UpdateSkillMutation = {
  updateSkill?:  {
    __typename: "Skill",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSkillMutationVariables = {
  input: DeleteSkillInput,
  condition?: ModelSkillConditionInput | null,
};

export type DeleteSkillMutation = {
  deleteSkill?:  {
    __typename: "Skill",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrganizationMutationVariables = {
  input: CreateOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type CreateOrganizationMutation = {
  createOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    shortName?: string | null,
    description?: string | null,
    locationID?: string | null,
    website?: string | null,
    phoneNumber?: string | null,
    stripeConnectedAccountID?: string | null,
    stripeConnectedAccountStatus?: string | null,
    headerImageURI?: string | null,
    ambassadorTermOverrideSingular?: string | null,
    ambassadorTermOverridePlural?: string | null,
    streamJwt?: string | null,
    latentSubscription?: number | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    designation?: string | null,
    detailsID?: string | null,
    details?:  {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateOrganizationMutationVariables = {
  input: UpdateOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type UpdateOrganizationMutation = {
  updateOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    shortName?: string | null,
    description?: string | null,
    locationID?: string | null,
    website?: string | null,
    phoneNumber?: string | null,
    stripeConnectedAccountID?: string | null,
    stripeConnectedAccountStatus?: string | null,
    headerImageURI?: string | null,
    ambassadorTermOverrideSingular?: string | null,
    ambassadorTermOverridePlural?: string | null,
    streamJwt?: string | null,
    latentSubscription?: number | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    designation?: string | null,
    detailsID?: string | null,
    details?:  {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteOrganizationMutationVariables = {
  input: DeleteOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type DeleteOrganizationMutation = {
  deleteOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    shortName?: string | null,
    description?: string | null,
    locationID?: string | null,
    website?: string | null,
    phoneNumber?: string | null,
    stripeConnectedAccountID?: string | null,
    stripeConnectedAccountStatus?: string | null,
    headerImageURI?: string | null,
    ambassadorTermOverrideSingular?: string | null,
    ambassadorTermOverridePlural?: string | null,
    streamJwt?: string | null,
    latentSubscription?: number | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    designation?: string | null,
    detailsID?: string | null,
    details?:  {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateLocationMutationVariables = {
  input: CreateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type CreateLocationMutation = {
  createLocation?:  {
    __typename: "Location",
    id: string,
    type: LocationType,
    name: string,
    details?: string | null,
    addressID?: string | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type UpdateLocationMutationVariables = {
  input: UpdateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type UpdateLocationMutation = {
  updateLocation?:  {
    __typename: "Location",
    id: string,
    type: LocationType,
    name: string,
    details?: string | null,
    addressID?: string | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type DeleteLocationMutationVariables = {
  input: DeleteLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type DeleteLocationMutation = {
  deleteLocation?:  {
    __typename: "Location",
    id: string,
    type: LocationType,
    name: string,
    details?: string | null,
    addressID?: string | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type CreateAddressMutationVariables = {
  input: CreateAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type CreateAddressMutation = {
  createAddress?:  {
    __typename: "Address",
    id: string,
    streetAddress?: string | null,
    unit?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    zipPlusFour?: string | null,
    longitude?: number | null,
    latitude?: number | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateAddressMutationVariables = {
  input: UpdateAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type UpdateAddressMutation = {
  updateAddress?:  {
    __typename: "Address",
    id: string,
    streetAddress?: string | null,
    unit?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    zipPlusFour?: string | null,
    longitude?: number | null,
    latitude?: number | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteAddressMutationVariables = {
  input: DeleteAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type DeleteAddressMutation = {
  deleteAddress?:  {
    __typename: "Address",
    id: string,
    streetAddress?: string | null,
    unit?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    zipPlusFour?: string | null,
    longitude?: number | null,
    latitude?: number | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateFundraisingCampaignMutationVariables = {
  input: CreateFundraisingCampaignInput,
  condition?: ModelFundraisingCampaignConditionInput | null,
};

export type CreateFundraisingCampaignMutation = {
  createFundraisingCampaign?:  {
    __typename: "FundraisingCampaign",
    id: string,
    type: FundraisingCampaignType,
    organizationID: string,
    staffLeadID?: string | null,
    campaignName?: string | null,
    introVideoURI?: string | null,
    textMessageTemplate?: string | null,
    initialMessageReminderTemplate?: string | null,
    phoneCallScriptTemplate?: string | null,
    followUpMessageTemplate?: string | null,
    followUpYesMessageTemplate?: string | null,
    followUpNoMessageTemplate?: string | null,
    followUpReminderMessageTemplate?: string | null,
    showVideo?: boolean | null,
    showText?: boolean | null,
    showCall?: boolean | null,
    showFollowUp?: boolean | null,
    active?: boolean | null,
    publicVideoID?: string | null,
    publicVideoProvider?: string | null,
    campaignStartDate?: string | null,
    campaignStartTime?: string | null,
    campaignTimeZone?: string | null,
    campaignEndDate?: string | null,
    campaignEndTime?: string | null,
    publicCampaignAbout?: string | null,
    publicCampaignIntro?: string | null,
    campaignGoal?: number | null,
    perAmbassadorGoal?: number | null,
    totalAmbassadorsGoal?: number | null,
    perContactDonationGoal?: number | null,
    progressChartType?: string | null,
    ctaURL?: string | null,
    pageLayout?: string | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    customHeaderImageUploaded?: boolean | null,
    customLogoImageUploaded?: boolean | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    ctaButtonText?: string | null,
    givingCircleBaseAmount?: number | null,
    givingCircleIncrements?: Array< number | null > | null,
    givingCircleAllowCustomAmounts?: boolean | null,
    ambassadorSpecificVideoUrlEnabled?: boolean | null,
    ambassadorCanUploadVideoUrl?: boolean | null,
    ambassadorSpecificCtaUrlEnabled?: boolean | null,
    ambassadorCanUploadCtaUrl?: boolean | null,
    crowbarVideoURL?: string | null,
    recruitmentForCampaignID?: string | null,
    classyCampaignID?: string | null,
    classyAutogenerateAmbassadorTeams?: boolean | null,
    classyDonationPageHostURL?: string | null,
    useClassyCtaURL?: boolean | null,
    useClassyFundraiserPage?: boolean | null,
    personalFundraisingCampaignID?: string | null,
    onDemandDiscoveryMeetingEnabled?: boolean | null,
    onDemandDiscoveryMeetingURL?: string | null,
    onDemandDiscoveryMeetingID?: string | null,
    onDemandDiscoveryMeetingInvitationCode?: string | null,
    CampaignConversationFlows?:  {
      __typename: "ModelCampaignConversationFlowConnection",
      items:  Array< {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultConversationFlowID?: string | null,
    defaultConversationFlow?:  {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    useConversationFlows?: boolean | null,
    campaignPageID?: string | null,
    ambassadorPageID?: string | null,
    donationPageID?: string | null,
    discoveryPageID?: string | null,
    projectID?: string | null,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subscriptionDonationTiers?:  {
      __typename: "ModelSubscriptionDonationTierConnection",
      items:  Array< {
        __typename: "SubscriptionDonationTier",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        amount?: number | null,
        features?: Array< string | null > | null,
        buttonText?: string | null,
        buttonColor?: string | null,
        default?: boolean | null,
        highlighted?: boolean | null,
        highlightedColor?: string | null,
        promoText?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    useActionCardView?: boolean | null,
    createdAt: string,
    updatedAt: string,
    staffLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitmentForCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    personalFundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    campaignPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    ambassadorPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    donationPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    discoveryPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    onDemandDiscoveryMeeting?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type UpdateFundraisingCampaignMutationVariables = {
  input: UpdateFundraisingCampaignInput,
  condition?: ModelFundraisingCampaignConditionInput | null,
};

export type UpdateFundraisingCampaignMutation = {
  updateFundraisingCampaign?:  {
    __typename: "FundraisingCampaign",
    id: string,
    type: FundraisingCampaignType,
    organizationID: string,
    staffLeadID?: string | null,
    campaignName?: string | null,
    introVideoURI?: string | null,
    textMessageTemplate?: string | null,
    initialMessageReminderTemplate?: string | null,
    phoneCallScriptTemplate?: string | null,
    followUpMessageTemplate?: string | null,
    followUpYesMessageTemplate?: string | null,
    followUpNoMessageTemplate?: string | null,
    followUpReminderMessageTemplate?: string | null,
    showVideo?: boolean | null,
    showText?: boolean | null,
    showCall?: boolean | null,
    showFollowUp?: boolean | null,
    active?: boolean | null,
    publicVideoID?: string | null,
    publicVideoProvider?: string | null,
    campaignStartDate?: string | null,
    campaignStartTime?: string | null,
    campaignTimeZone?: string | null,
    campaignEndDate?: string | null,
    campaignEndTime?: string | null,
    publicCampaignAbout?: string | null,
    publicCampaignIntro?: string | null,
    campaignGoal?: number | null,
    perAmbassadorGoal?: number | null,
    totalAmbassadorsGoal?: number | null,
    perContactDonationGoal?: number | null,
    progressChartType?: string | null,
    ctaURL?: string | null,
    pageLayout?: string | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    customHeaderImageUploaded?: boolean | null,
    customLogoImageUploaded?: boolean | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    ctaButtonText?: string | null,
    givingCircleBaseAmount?: number | null,
    givingCircleIncrements?: Array< number | null > | null,
    givingCircleAllowCustomAmounts?: boolean | null,
    ambassadorSpecificVideoUrlEnabled?: boolean | null,
    ambassadorCanUploadVideoUrl?: boolean | null,
    ambassadorSpecificCtaUrlEnabled?: boolean | null,
    ambassadorCanUploadCtaUrl?: boolean | null,
    crowbarVideoURL?: string | null,
    recruitmentForCampaignID?: string | null,
    classyCampaignID?: string | null,
    classyAutogenerateAmbassadorTeams?: boolean | null,
    classyDonationPageHostURL?: string | null,
    useClassyCtaURL?: boolean | null,
    useClassyFundraiserPage?: boolean | null,
    personalFundraisingCampaignID?: string | null,
    onDemandDiscoveryMeetingEnabled?: boolean | null,
    onDemandDiscoveryMeetingURL?: string | null,
    onDemandDiscoveryMeetingID?: string | null,
    onDemandDiscoveryMeetingInvitationCode?: string | null,
    CampaignConversationFlows?:  {
      __typename: "ModelCampaignConversationFlowConnection",
      items:  Array< {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultConversationFlowID?: string | null,
    defaultConversationFlow?:  {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    useConversationFlows?: boolean | null,
    campaignPageID?: string | null,
    ambassadorPageID?: string | null,
    donationPageID?: string | null,
    discoveryPageID?: string | null,
    projectID?: string | null,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subscriptionDonationTiers?:  {
      __typename: "ModelSubscriptionDonationTierConnection",
      items:  Array< {
        __typename: "SubscriptionDonationTier",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        amount?: number | null,
        features?: Array< string | null > | null,
        buttonText?: string | null,
        buttonColor?: string | null,
        default?: boolean | null,
        highlighted?: boolean | null,
        highlightedColor?: string | null,
        promoText?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    useActionCardView?: boolean | null,
    createdAt: string,
    updatedAt: string,
    staffLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitmentForCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    personalFundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    campaignPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    ambassadorPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    donationPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    discoveryPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    onDemandDiscoveryMeeting?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type DeleteFundraisingCampaignMutationVariables = {
  input: DeleteFundraisingCampaignInput,
  condition?: ModelFundraisingCampaignConditionInput | null,
};

export type DeleteFundraisingCampaignMutation = {
  deleteFundraisingCampaign?:  {
    __typename: "FundraisingCampaign",
    id: string,
    type: FundraisingCampaignType,
    organizationID: string,
    staffLeadID?: string | null,
    campaignName?: string | null,
    introVideoURI?: string | null,
    textMessageTemplate?: string | null,
    initialMessageReminderTemplate?: string | null,
    phoneCallScriptTemplate?: string | null,
    followUpMessageTemplate?: string | null,
    followUpYesMessageTemplate?: string | null,
    followUpNoMessageTemplate?: string | null,
    followUpReminderMessageTemplate?: string | null,
    showVideo?: boolean | null,
    showText?: boolean | null,
    showCall?: boolean | null,
    showFollowUp?: boolean | null,
    active?: boolean | null,
    publicVideoID?: string | null,
    publicVideoProvider?: string | null,
    campaignStartDate?: string | null,
    campaignStartTime?: string | null,
    campaignTimeZone?: string | null,
    campaignEndDate?: string | null,
    campaignEndTime?: string | null,
    publicCampaignAbout?: string | null,
    publicCampaignIntro?: string | null,
    campaignGoal?: number | null,
    perAmbassadorGoal?: number | null,
    totalAmbassadorsGoal?: number | null,
    perContactDonationGoal?: number | null,
    progressChartType?: string | null,
    ctaURL?: string | null,
    pageLayout?: string | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    customHeaderImageUploaded?: boolean | null,
    customLogoImageUploaded?: boolean | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    ctaButtonText?: string | null,
    givingCircleBaseAmount?: number | null,
    givingCircleIncrements?: Array< number | null > | null,
    givingCircleAllowCustomAmounts?: boolean | null,
    ambassadorSpecificVideoUrlEnabled?: boolean | null,
    ambassadorCanUploadVideoUrl?: boolean | null,
    ambassadorSpecificCtaUrlEnabled?: boolean | null,
    ambassadorCanUploadCtaUrl?: boolean | null,
    crowbarVideoURL?: string | null,
    recruitmentForCampaignID?: string | null,
    classyCampaignID?: string | null,
    classyAutogenerateAmbassadorTeams?: boolean | null,
    classyDonationPageHostURL?: string | null,
    useClassyCtaURL?: boolean | null,
    useClassyFundraiserPage?: boolean | null,
    personalFundraisingCampaignID?: string | null,
    onDemandDiscoveryMeetingEnabled?: boolean | null,
    onDemandDiscoveryMeetingURL?: string | null,
    onDemandDiscoveryMeetingID?: string | null,
    onDemandDiscoveryMeetingInvitationCode?: string | null,
    CampaignConversationFlows?:  {
      __typename: "ModelCampaignConversationFlowConnection",
      items:  Array< {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultConversationFlowID?: string | null,
    defaultConversationFlow?:  {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    useConversationFlows?: boolean | null,
    campaignPageID?: string | null,
    ambassadorPageID?: string | null,
    donationPageID?: string | null,
    discoveryPageID?: string | null,
    projectID?: string | null,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subscriptionDonationTiers?:  {
      __typename: "ModelSubscriptionDonationTierConnection",
      items:  Array< {
        __typename: "SubscriptionDonationTier",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        amount?: number | null,
        features?: Array< string | null > | null,
        buttonText?: string | null,
        buttonColor?: string | null,
        default?: boolean | null,
        highlighted?: boolean | null,
        highlightedColor?: string | null,
        promoText?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    useActionCardView?: boolean | null,
    createdAt: string,
    updatedAt: string,
    staffLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitmentForCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    personalFundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    campaignPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    ambassadorPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    donationPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    discoveryPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    onDemandDiscoveryMeeting?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type CreateCampaignPageMutationVariables = {
  input: CreateCampaignPageInput,
  condition?: ModelCampaignPageConditionInput | null,
};

export type CreateCampaignPageMutation = {
  createCampaignPage?:  {
    __typename: "CampaignPage",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: CampaignPageType | null,
    fundraisingCampaignID: string,
    campaignDisplayConfigurationID?: string | null,
    pageHtml?: string | null,
    pageJSON?: string | null,
    pageCssJSON?: string | null,
    pageAssetsJSON?: string | null,
    createdAt: string,
    updatedAt: string,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    campaignDisplayConfiguration?:  {
      __typename: "CampaignDisplayConfiguration",
      id: string,
      campaignPageID: string,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      gradientLeftColor?: string | null,
      gradientRightColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type UpdateCampaignPageMutationVariables = {
  input: UpdateCampaignPageInput,
  condition?: ModelCampaignPageConditionInput | null,
};

export type UpdateCampaignPageMutation = {
  updateCampaignPage?:  {
    __typename: "CampaignPage",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: CampaignPageType | null,
    fundraisingCampaignID: string,
    campaignDisplayConfigurationID?: string | null,
    pageHtml?: string | null,
    pageJSON?: string | null,
    pageCssJSON?: string | null,
    pageAssetsJSON?: string | null,
    createdAt: string,
    updatedAt: string,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    campaignDisplayConfiguration?:  {
      __typename: "CampaignDisplayConfiguration",
      id: string,
      campaignPageID: string,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      gradientLeftColor?: string | null,
      gradientRightColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type DeleteCampaignPageMutationVariables = {
  input: DeleteCampaignPageInput,
  condition?: ModelCampaignPageConditionInput | null,
};

export type DeleteCampaignPageMutation = {
  deleteCampaignPage?:  {
    __typename: "CampaignPage",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: CampaignPageType | null,
    fundraisingCampaignID: string,
    campaignDisplayConfigurationID?: string | null,
    pageHtml?: string | null,
    pageJSON?: string | null,
    pageCssJSON?: string | null,
    pageAssetsJSON?: string | null,
    createdAt: string,
    updatedAt: string,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    campaignDisplayConfiguration?:  {
      __typename: "CampaignDisplayConfiguration",
      id: string,
      campaignPageID: string,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      gradientLeftColor?: string | null,
      gradientRightColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type CreateCampaignDisplayConfigurationMutationVariables = {
  input: CreateCampaignDisplayConfigurationInput,
  condition?: ModelCampaignDisplayConfigurationConditionInput | null,
};

export type CreateCampaignDisplayConfigurationMutation = {
  createCampaignDisplayConfiguration?:  {
    __typename: "CampaignDisplayConfiguration",
    id: string,
    campaignPageID: string,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    gradientLeftColor?: string | null,
    gradientRightColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateCampaignDisplayConfigurationMutationVariables = {
  input: UpdateCampaignDisplayConfigurationInput,
  condition?: ModelCampaignDisplayConfigurationConditionInput | null,
};

export type UpdateCampaignDisplayConfigurationMutation = {
  updateCampaignDisplayConfiguration?:  {
    __typename: "CampaignDisplayConfiguration",
    id: string,
    campaignPageID: string,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    gradientLeftColor?: string | null,
    gradientRightColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteCampaignDisplayConfigurationMutationVariables = {
  input: DeleteCampaignDisplayConfigurationInput,
  condition?: ModelCampaignDisplayConfigurationConditionInput | null,
};

export type DeleteCampaignDisplayConfigurationMutation = {
  deleteCampaignDisplayConfiguration?:  {
    __typename: "CampaignDisplayConfiguration",
    id: string,
    campaignPageID: string,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    gradientLeftColor?: string | null,
    gradientRightColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateNylasEventMutationVariables = {
  input: CreateNylasEventInput,
  condition?: ModelNylasEventConditionInput | null,
};

export type CreateNylasEventMutation = {
  createNylasEvent?:  {
    __typename: "NylasEvent",
    id: string,
    calendarID?: string | null,
    owner?: string | null,
    fundraisingCampaignDiscoveryCallID?: string | null,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateNylasEventMutationVariables = {
  input: UpdateNylasEventInput,
  condition?: ModelNylasEventConditionInput | null,
};

export type UpdateNylasEventMutation = {
  updateNylasEvent?:  {
    __typename: "NylasEvent",
    id: string,
    calendarID?: string | null,
    owner?: string | null,
    fundraisingCampaignDiscoveryCallID?: string | null,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteNylasEventMutationVariables = {
  input: DeleteNylasEventInput,
  condition?: ModelNylasEventConditionInput | null,
};

export type DeleteNylasEventMutation = {
  deleteNylasEvent?:  {
    __typename: "NylasEvent",
    id: string,
    calendarID?: string | null,
    owner?: string | null,
    fundraisingCampaignDiscoveryCallID?: string | null,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFundraisingCampaignDiscoveryCallMutationVariables = {
  input: CreateFundraisingCampaignDiscoveryCallInput,
  condition?: ModelFundraisingCampaignDiscoveryCallConditionInput | null,
};

export type CreateFundraisingCampaignDiscoveryCallMutation = {
  createFundraisingCampaignDiscoveryCall?:  {
    __typename: "FundraisingCampaignDiscoveryCall",
    id: string,
    title?: string | null,
    organizationID: string,
    fundraisingCampaignID: string,
    staffProfileID: string,
    startTimestamp: string,
    endTimestamp: string,
    latentHosted: boolean,
    invitationURL?: string | null,
    nylasEventID?: string | null,
    virtualMeetingURL?: string | null,
    createdAt: string,
    updatedAt: string,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type UpdateFundraisingCampaignDiscoveryCallMutationVariables = {
  input: UpdateFundraisingCampaignDiscoveryCallInput,
  condition?: ModelFundraisingCampaignDiscoveryCallConditionInput | null,
};

export type UpdateFundraisingCampaignDiscoveryCallMutation = {
  updateFundraisingCampaignDiscoveryCall?:  {
    __typename: "FundraisingCampaignDiscoveryCall",
    id: string,
    title?: string | null,
    organizationID: string,
    fundraisingCampaignID: string,
    staffProfileID: string,
    startTimestamp: string,
    endTimestamp: string,
    latentHosted: boolean,
    invitationURL?: string | null,
    nylasEventID?: string | null,
    virtualMeetingURL?: string | null,
    createdAt: string,
    updatedAt: string,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type DeleteFundraisingCampaignDiscoveryCallMutationVariables = {
  input: DeleteFundraisingCampaignDiscoveryCallInput,
  condition?: ModelFundraisingCampaignDiscoveryCallConditionInput | null,
};

export type DeleteFundraisingCampaignDiscoveryCallMutation = {
  deleteFundraisingCampaignDiscoveryCall?:  {
    __typename: "FundraisingCampaignDiscoveryCall",
    id: string,
    title?: string | null,
    organizationID: string,
    fundraisingCampaignID: string,
    staffProfileID: string,
    startTimestamp: string,
    endTimestamp: string,
    latentHosted: boolean,
    invitationURL?: string | null,
    nylasEventID?: string | null,
    virtualMeetingURL?: string | null,
    createdAt: string,
    updatedAt: string,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type CreateDiscoveryCallParticipantMutationVariables = {
  input: CreateDiscoveryCallParticipantInput,
  condition?: ModelDiscoveryCallParticipantConditionInput | null,
};

export type CreateDiscoveryCallParticipantMutation = {
  createDiscoveryCallParticipant?:  {
    __typename: "DiscoveryCallParticipant",
    id: string,
    email: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    fundraisingCampaignDiscoveryCallID: string,
    fundraisingCampaignID: string,
    invitationSent?: boolean | null,
    icsString?: string | null,
    status?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    confirmed?: boolean | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingCampaignDiscoveryCall?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateDiscoveryCallParticipantMutationVariables = {
  input: UpdateDiscoveryCallParticipantInput,
  condition?: ModelDiscoveryCallParticipantConditionInput | null,
};

export type UpdateDiscoveryCallParticipantMutation = {
  updateDiscoveryCallParticipant?:  {
    __typename: "DiscoveryCallParticipant",
    id: string,
    email: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    fundraisingCampaignDiscoveryCallID: string,
    fundraisingCampaignID: string,
    invitationSent?: boolean | null,
    icsString?: string | null,
    status?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    confirmed?: boolean | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingCampaignDiscoveryCall?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteDiscoveryCallParticipantMutationVariables = {
  input: DeleteDiscoveryCallParticipantInput,
  condition?: ModelDiscoveryCallParticipantConditionInput | null,
};

export type DeleteDiscoveryCallParticipantMutation = {
  deleteDiscoveryCallParticipant?:  {
    __typename: "DiscoveryCallParticipant",
    id: string,
    email: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    fundraisingCampaignDiscoveryCallID: string,
    fundraisingCampaignID: string,
    invitationSent?: boolean | null,
    icsString?: string | null,
    status?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    confirmed?: boolean | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingCampaignDiscoveryCall?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateFundraisingCampaignAmbassadorMutationVariables = {
  input: CreateFundraisingCampaignAmbassadorInput,
  condition?: ModelFundraisingCampaignAmbassadorConditionInput | null,
};

export type CreateFundraisingCampaignAmbassadorMutation = {
  createFundraisingCampaignAmbassador?:  {
    __typename: "FundraisingCampaignAmbassador",
    id: string,
    status?: FundraisingCampaignAmbassadorStatus | null,
    commitment?: FundraisingCampaignAmbassadorCommitment | null,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    discoveryCallParticipantID?: string | null,
    fundsRaised?: number | null,
    initialTransactionID?: string | null,
    initialTransactionAmount?: number | null,
    ambassadorSpecificCtaUrl?: string | null,
    ambassadorSpecificVideoUrl?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    classyTeamID?: string | null,
    classySupporterID?: string | null,
    classyFundraiserPageID?: string | null,
    notificationsEnabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassadorContacts?:  {
      __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassadorContact",
        id: string,
        deviceContactID: string,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        sentText?: boolean | null,
        sentTextTimestamp?: string | null,
        sentInitialTextReminder?: boolean | null,
        sentInitialTextReminderTimestamp?: string | null,
        sentPhoneCallScript?: boolean | null,
        sentPhoneCallScriptTimestamp?: string | null,
        called?: boolean | null,
        calledTimestamp?: string | null,
        sentFollowUp?: boolean | null,
        sentFollowUpTimestamp?: string | null,
        followUpResponse?: FollowUpResponse | null,
        sentReminder?: boolean | null,
        sentReminderTimestamp?: string | null,
        isDonating?: boolean | null,
        donationAmount?: number | null,
        discoveryCallParticipantID?: string | null,
        transactionID?: string | null,
        isActive?: boolean | null,
        notes?: string | null,
        birthday?: string | null,
        hasTakenAction?: boolean | null,
        hasTakenActionTimestamp?: string | null,
        occupation?: string | null,
        selectedPhoneNumberArrayIndex?: number | null,
        actionMessages?:  {
          __typename: "ModelActionMessageConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateFundraisingCampaignAmbassadorMutationVariables = {
  input: UpdateFundraisingCampaignAmbassadorInput,
  condition?: ModelFundraisingCampaignAmbassadorConditionInput | null,
};

export type UpdateFundraisingCampaignAmbassadorMutation = {
  updateFundraisingCampaignAmbassador?:  {
    __typename: "FundraisingCampaignAmbassador",
    id: string,
    status?: FundraisingCampaignAmbassadorStatus | null,
    commitment?: FundraisingCampaignAmbassadorCommitment | null,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    discoveryCallParticipantID?: string | null,
    fundsRaised?: number | null,
    initialTransactionID?: string | null,
    initialTransactionAmount?: number | null,
    ambassadorSpecificCtaUrl?: string | null,
    ambassadorSpecificVideoUrl?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    classyTeamID?: string | null,
    classySupporterID?: string | null,
    classyFundraiserPageID?: string | null,
    notificationsEnabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassadorContacts?:  {
      __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassadorContact",
        id: string,
        deviceContactID: string,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        sentText?: boolean | null,
        sentTextTimestamp?: string | null,
        sentInitialTextReminder?: boolean | null,
        sentInitialTextReminderTimestamp?: string | null,
        sentPhoneCallScript?: boolean | null,
        sentPhoneCallScriptTimestamp?: string | null,
        called?: boolean | null,
        calledTimestamp?: string | null,
        sentFollowUp?: boolean | null,
        sentFollowUpTimestamp?: string | null,
        followUpResponse?: FollowUpResponse | null,
        sentReminder?: boolean | null,
        sentReminderTimestamp?: string | null,
        isDonating?: boolean | null,
        donationAmount?: number | null,
        discoveryCallParticipantID?: string | null,
        transactionID?: string | null,
        isActive?: boolean | null,
        notes?: string | null,
        birthday?: string | null,
        hasTakenAction?: boolean | null,
        hasTakenActionTimestamp?: string | null,
        occupation?: string | null,
        selectedPhoneNumberArrayIndex?: number | null,
        actionMessages?:  {
          __typename: "ModelActionMessageConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteFundraisingCampaignAmbassadorMutationVariables = {
  input: DeleteFundraisingCampaignAmbassadorInput,
  condition?: ModelFundraisingCampaignAmbassadorConditionInput | null,
};

export type DeleteFundraisingCampaignAmbassadorMutation = {
  deleteFundraisingCampaignAmbassador?:  {
    __typename: "FundraisingCampaignAmbassador",
    id: string,
    status?: FundraisingCampaignAmbassadorStatus | null,
    commitment?: FundraisingCampaignAmbassadorCommitment | null,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    discoveryCallParticipantID?: string | null,
    fundsRaised?: number | null,
    initialTransactionID?: string | null,
    initialTransactionAmount?: number | null,
    ambassadorSpecificCtaUrl?: string | null,
    ambassadorSpecificVideoUrl?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    classyTeamID?: string | null,
    classySupporterID?: string | null,
    classyFundraiserPageID?: string | null,
    notificationsEnabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassadorContacts?:  {
      __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassadorContact",
        id: string,
        deviceContactID: string,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        sentText?: boolean | null,
        sentTextTimestamp?: string | null,
        sentInitialTextReminder?: boolean | null,
        sentInitialTextReminderTimestamp?: string | null,
        sentPhoneCallScript?: boolean | null,
        sentPhoneCallScriptTimestamp?: string | null,
        called?: boolean | null,
        calledTimestamp?: string | null,
        sentFollowUp?: boolean | null,
        sentFollowUpTimestamp?: string | null,
        followUpResponse?: FollowUpResponse | null,
        sentReminder?: boolean | null,
        sentReminderTimestamp?: string | null,
        isDonating?: boolean | null,
        donationAmount?: number | null,
        discoveryCallParticipantID?: string | null,
        transactionID?: string | null,
        isActive?: boolean | null,
        notes?: string | null,
        birthday?: string | null,
        hasTakenAction?: boolean | null,
        hasTakenActionTimestamp?: string | null,
        occupation?: string | null,
        selectedPhoneNumberArrayIndex?: number | null,
        actionMessages?:  {
          __typename: "ModelActionMessageConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateFundraisingCampaignAmbassadorContactMutationVariables = {
  input: CreateFundraisingCampaignAmbassadorContactInput,
  condition?: ModelFundraisingCampaignAmbassadorContactConditionInput | null,
};

export type CreateFundraisingCampaignAmbassadorContactMutation = {
  createFundraisingCampaignAmbassadorContact?:  {
    __typename: "FundraisingCampaignAmbassadorContact",
    id: string,
    deviceContactID: string,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    sentText?: boolean | null,
    sentTextTimestamp?: string | null,
    sentInitialTextReminder?: boolean | null,
    sentInitialTextReminderTimestamp?: string | null,
    sentPhoneCallScript?: boolean | null,
    sentPhoneCallScriptTimestamp?: string | null,
    called?: boolean | null,
    calledTimestamp?: string | null,
    sentFollowUp?: boolean | null,
    sentFollowUpTimestamp?: string | null,
    followUpResponse?: FollowUpResponse | null,
    sentReminder?: boolean | null,
    sentReminderTimestamp?: string | null,
    isDonating?: boolean | null,
    donationAmount?: number | null,
    discoveryCallParticipantID?: string | null,
    transactionID?: string | null,
    isActive?: boolean | null,
    notes?: string | null,
    birthday?: string | null,
    hasTakenAction?: boolean | null,
    hasTakenActionTimestamp?: string | null,
    occupation?: string | null,
    selectedPhoneNumberArrayIndex?: number | null,
    actionMessages?:  {
      __typename: "ModelActionMessageConnection",
      items:  Array< {
        __typename: "ActionMessage",
        id: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        fundraisingCampaignAmbassadorContactID: string,
        actionMessageDefinitionID: string,
        actionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sent?: boolean | null,
        sentTimestamp?: string | null,
        response?: ActionMessageResponseType | null,
        responseTimestamp?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type UpdateFundraisingCampaignAmbassadorContactMutationVariables = {
  input: UpdateFundraisingCampaignAmbassadorContactInput,
  condition?: ModelFundraisingCampaignAmbassadorContactConditionInput | null,
};

export type UpdateFundraisingCampaignAmbassadorContactMutation = {
  updateFundraisingCampaignAmbassadorContact?:  {
    __typename: "FundraisingCampaignAmbassadorContact",
    id: string,
    deviceContactID: string,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    sentText?: boolean | null,
    sentTextTimestamp?: string | null,
    sentInitialTextReminder?: boolean | null,
    sentInitialTextReminderTimestamp?: string | null,
    sentPhoneCallScript?: boolean | null,
    sentPhoneCallScriptTimestamp?: string | null,
    called?: boolean | null,
    calledTimestamp?: string | null,
    sentFollowUp?: boolean | null,
    sentFollowUpTimestamp?: string | null,
    followUpResponse?: FollowUpResponse | null,
    sentReminder?: boolean | null,
    sentReminderTimestamp?: string | null,
    isDonating?: boolean | null,
    donationAmount?: number | null,
    discoveryCallParticipantID?: string | null,
    transactionID?: string | null,
    isActive?: boolean | null,
    notes?: string | null,
    birthday?: string | null,
    hasTakenAction?: boolean | null,
    hasTakenActionTimestamp?: string | null,
    occupation?: string | null,
    selectedPhoneNumberArrayIndex?: number | null,
    actionMessages?:  {
      __typename: "ModelActionMessageConnection",
      items:  Array< {
        __typename: "ActionMessage",
        id: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        fundraisingCampaignAmbassadorContactID: string,
        actionMessageDefinitionID: string,
        actionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sent?: boolean | null,
        sentTimestamp?: string | null,
        response?: ActionMessageResponseType | null,
        responseTimestamp?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type DeleteFundraisingCampaignAmbassadorContactMutationVariables = {
  input: DeleteFundraisingCampaignAmbassadorContactInput,
  condition?: ModelFundraisingCampaignAmbassadorContactConditionInput | null,
};

export type DeleteFundraisingCampaignAmbassadorContactMutation = {
  deleteFundraisingCampaignAmbassadorContact?:  {
    __typename: "FundraisingCampaignAmbassadorContact",
    id: string,
    deviceContactID: string,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    sentText?: boolean | null,
    sentTextTimestamp?: string | null,
    sentInitialTextReminder?: boolean | null,
    sentInitialTextReminderTimestamp?: string | null,
    sentPhoneCallScript?: boolean | null,
    sentPhoneCallScriptTimestamp?: string | null,
    called?: boolean | null,
    calledTimestamp?: string | null,
    sentFollowUp?: boolean | null,
    sentFollowUpTimestamp?: string | null,
    followUpResponse?: FollowUpResponse | null,
    sentReminder?: boolean | null,
    sentReminderTimestamp?: string | null,
    isDonating?: boolean | null,
    donationAmount?: number | null,
    discoveryCallParticipantID?: string | null,
    transactionID?: string | null,
    isActive?: boolean | null,
    notes?: string | null,
    birthday?: string | null,
    hasTakenAction?: boolean | null,
    hasTakenActionTimestamp?: string | null,
    occupation?: string | null,
    selectedPhoneNumberArrayIndex?: number | null,
    actionMessages?:  {
      __typename: "ModelActionMessageConnection",
      items:  Array< {
        __typename: "ActionMessage",
        id: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        fundraisingCampaignAmbassadorContactID: string,
        actionMessageDefinitionID: string,
        actionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sent?: boolean | null,
        sentTimestamp?: string | null,
        response?: ActionMessageResponseType | null,
        responseTimestamp?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type CreateFundraisingCampaignUpdateMutationVariables = {
  input: CreateFundraisingCampaignUpdateInput,
  condition?: ModelFundraisingCampaignUpdateConditionInput | null,
};

export type CreateFundraisingCampaignUpdateMutation = {
  createFundraisingCampaignUpdate?:  {
    __typename: "FundraisingCampaignUpdate",
    id: string,
    fundraisingCampaignID: string,
    public: boolean,
    message?: string | null,
    assetsUploaded?: number | null,
    updateURL?: string | null,
    createdByStaffProfileID?: string | null,
    live: boolean,
    liveTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    createdByStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type UpdateFundraisingCampaignUpdateMutationVariables = {
  input: UpdateFundraisingCampaignUpdateInput,
  condition?: ModelFundraisingCampaignUpdateConditionInput | null,
};

export type UpdateFundraisingCampaignUpdateMutation = {
  updateFundraisingCampaignUpdate?:  {
    __typename: "FundraisingCampaignUpdate",
    id: string,
    fundraisingCampaignID: string,
    public: boolean,
    message?: string | null,
    assetsUploaded?: number | null,
    updateURL?: string | null,
    createdByStaffProfileID?: string | null,
    live: boolean,
    liveTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    createdByStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type DeleteFundraisingCampaignUpdateMutationVariables = {
  input: DeleteFundraisingCampaignUpdateInput,
  condition?: ModelFundraisingCampaignUpdateConditionInput | null,
};

export type DeleteFundraisingCampaignUpdateMutation = {
  deleteFundraisingCampaignUpdate?:  {
    __typename: "FundraisingCampaignUpdate",
    id: string,
    fundraisingCampaignID: string,
    public: boolean,
    message?: string | null,
    assetsUploaded?: number | null,
    updateURL?: string | null,
    createdByStaffProfileID?: string | null,
    live: boolean,
    liveTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    createdByStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type GetVolunteerProfileQueryVariables = {
  id: string,
};

export type GetVolunteerProfileQuery = {
  getVolunteerProfile?:  {
    __typename: "VolunteerProfile",
    id: string,
    authAccountID: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    gender?: GenderType | null,
    dateOfBirth?: string | null,
    streetAddress?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: number | null,
    website?: string | null,
    enneagram?: number | null,
    enneagramWing?: number | null,
    myersBriggs?: string | null,
    additionalInformation?: string | null,
    availabilityStringified?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    skills?:  {
      __typename: "ModelVolunteerSkillConnection",
      items:  Array< {
        __typename: "VolunteerSkill",
        id: string,
        skillID: string,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        skill?:  {
          __typename: "Skill",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    causes?:  {
      __typename: "ModelVolunteerCauseConnection",
      items:  Array< {
        __typename: "VolunteerCause",
        id: string,
        causeID: string,
        cause?:  {
          __typename: "Cause",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListVolunteerProfilesQueryVariables = {
  filter?: ModelVolunteerProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerProfilesQuery = {
  listVolunteerProfiles?:  {
    __typename: "ModelVolunteerProfileConnection",
    items:  Array< {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrganizationInvitationQueryVariables = {
  id: string,
};

export type GetOrganizationInvitationQuery = {
  getOrganizationInvitation?:  {
    __typename: "OrganizationInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrganizationInvitationsQueryVariables = {
  filter?: ModelOrganizationInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationInvitationsQuery = {
  listOrganizationInvitations?:  {
    __typename: "ModelOrganizationInvitationConnection",
    items:  Array< {
      __typename: "OrganizationInvitation",
      id: string,
      code: string,
      email: string,
      name?: string | null,
      used: boolean,
      usedTimestamp?: string | null,
      invitationSent: boolean,
      invitationSentTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVolunteerSkillQueryVariables = {
  id: string,
};

export type GetVolunteerSkillQuery = {
  getVolunteerSkill?:  {
    __typename: "VolunteerSkill",
    id: string,
    skillID: string,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
    skill?:  {
      __typename: "Skill",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListVolunteerSkillsQueryVariables = {
  filter?: ModelVolunteerSkillFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerSkillsQuery = {
  listVolunteerSkills?:  {
    __typename: "ModelVolunteerSkillConnection",
    items:  Array< {
      __typename: "VolunteerSkill",
      id: string,
      skillID: string,
      volunteerProfileID: string,
      volunteerProfile:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      },
      createdAt: string,
      updatedAt: string,
      skill?:  {
        __typename: "Skill",
        id: string,
        key: string,
        name: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCauseQueryVariables = {
  id: string,
};

export type GetCauseQuery = {
  getCause?:  {
    __typename: "Cause",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCausesQueryVariables = {
  filter?: ModelCauseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCausesQuery = {
  listCauses?:  {
    __typename: "ModelCauseConnection",
    items:  Array< {
      __typename: "Cause",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVolunteerCauseQueryVariables = {
  id: string,
};

export type GetVolunteerCauseQuery = {
  getVolunteerCause?:  {
    __typename: "VolunteerCause",
    id: string,
    causeID: string,
    cause?:  {
      __typename: "Cause",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListVolunteerCausesQueryVariables = {
  filter?: ModelVolunteerCauseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerCausesQuery = {
  listVolunteerCauses?:  {
    __typename: "ModelVolunteerCauseConnection",
    items:  Array< {
      __typename: "VolunteerCause",
      id: string,
      causeID: string,
      cause?:  {
        __typename: "Cause",
        id: string,
        key: string,
        name: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      volunteerProfileID: string,
      volunteerProfile:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrganizationDetailsQueryVariables = {
  id: string,
};

export type GetOrganizationDetailsQuery = {
  getOrganizationDetails?:  {
    __typename: "OrganizationDetails",
    id: string,
    organizationID: string,
    missionStatement?: string | null,
    serveStatement?: string | null,
    doStatement?: string | null,
    costToDoStatement?: string | null,
    missionArea?: string | null,
    annualBudget?: string | null,
    currentMonthlyRecurringDonors?: string | null,
    averageMonthlyRecurringDonation?: string | null,
    percentageOfBudgetFromIndividualDonors?: string | null,
    numberOfMajorDonors?: string | null,
    averageOneTimeDonation?: string | null,
    percentageOfBudgetFromGrants?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrganizationDetailsQueryVariables = {
  filter?: ModelOrganizationDetailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationDetailsQuery = {
  listOrganizationDetails?:  {
    __typename: "ModelOrganizationDetailsConnection",
    items:  Array< {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProgramQueryVariables = {
  id: string,
};

export type GetProgramQuery = {
  getProgram?:  {
    __typename: "Program",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    theWhy?: string | null,
    leadID?: string | null,
    stringifiedCauses?: string | null,
    opportunities?:  {
      __typename: "ModelOpportunityConnection",
      items:  Array< {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    archived: boolean,
    createdAt: string,
    updatedAt: string,
    lead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListProgramsQueryVariables = {
  filter?: ModelProgramFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProgramsQuery = {
  listPrograms?:  {
    __typename: "ModelProgramConnection",
    items:  Array< {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOpportunityQueryVariables = {
  id: string,
};

export type GetOpportunityQuery = {
  getOpportunity?:  {
    __typename: "Opportunity",
    id: string,
    organizationID: string,
    programID?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityLeadID: string,
    type?: OpportunityType | null,
    status: OpportunityStatus,
    startDate?: string | null,
    endDate?: string | null,
    startRecruitingDate?: string | null,
    headerImage?: string | null,
    title?: string | null,
    descriptionRTE?: string | null,
    theWhy?: string | null,
    expectedImpact?: string | null,
    whatWillHappen?: string | null,
    volunteerGain?: string | null,
    roles?:  {
      __typename: "ModelRoleConnection",
      items:  Array< {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    application?:  {
      __typename: "ModelApplicationConnection",
      items:  Array< {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    opportunityLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListOpportunitiesQueryVariables = {
  filter?: ModelOpportunityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOpportunitiesQuery = {
  listOpportunities?:  {
    __typename: "ModelOpportunityConnection",
    items:  Array< {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetApplicationQueryVariables = {
  id: string,
};

export type GetApplicationQuery = {
  getApplication?:  {
    __typename: "Application",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    screeningCallRequired?: ScreeningCallRequiredOptions | null,
    signUpOnly?: boolean | null,
    requireScreeningCall?: boolean | null,
    requireBackgroundCheck?: boolean | null,
    recruitmentDeadlineForVolunteers?: string | null,
    targetNumberOfVolunteerHours?: number | null,
    minimumNumberOfVolunteersRequired?: number | null,
    customApplicationQuestions?:  {
      __typename: "ModelCustomApplicationQuestionConnection",
      items:  Array< {
        __typename: "CustomApplicationQuestion",
        id: string,
        applicationID: string,
        application?:  {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        questionText: string,
        questionType: string,
        required: boolean,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListApplicationsQueryVariables = {
  filter?: ModelApplicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationsQuery = {
  listApplications?:  {
    __typename: "ModelApplicationConnection",
    items:  Array< {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCustomApplicationQuestionQueryVariables = {
  id: string,
};

export type GetCustomApplicationQuestionQuery = {
  getCustomApplicationQuestion?:  {
    __typename: "CustomApplicationQuestion",
    id: string,
    applicationID: string,
    application?:  {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    questionText: string,
    questionType: string,
    required: boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCustomApplicationQuestionsQueryVariables = {
  filter?: ModelCustomApplicationQuestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomApplicationQuestionsQuery = {
  listCustomApplicationQuestions?:  {
    __typename: "ModelCustomApplicationQuestionConnection",
    items:  Array< {
      __typename: "CustomApplicationQuestion",
      id: string,
      applicationID: string,
      application?:  {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      questionText: string,
      questionType: string,
      required: boolean,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRoleQueryVariables = {
  id: string,
};

export type GetRoleQuery = {
  getRole?:  {
    __typename: "Role",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    roleTitle: string,
    opportunityTitle?: string | null,
    live?: boolean | null,
    roleCoordinatorID?: string | null,
    recurrence?: RoleRecurrence | null,
    weeklyRecurrenceDays?: string | null,
    weeklyRecurrenceSameVolunteers?: boolean | null,
    volunteersPerShift?: number | null,
    differentNumberOfVolunteersPerShift?: boolean | null,
    volunteerCommitmentMonths?: number | null,
    volunteerCommitmentCanRenew?: boolean | null,
    roleRequirements?: string | null,
    ageRequirement?: string | null,
    minorsRequireSupervision?: boolean | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    stringifiedSkills?: string | null,
    stringifiedSkillsJSON?: string | null,
    stringifiedCertifications?: string | null,
    shifts?:  {
      __typename: "ModelShiftConnection",
      items:  Array< {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    roleCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListRolesQueryVariables = {
  filter?: ModelRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRolesQuery = {
  listRoles?:  {
    __typename: "ModelRoleConnection",
    items:  Array< {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetShiftQueryVariables = {
  id: string,
};

export type GetShiftQuery = {
  getShift?:  {
    __typename: "Shift",
    id: string,
    type: ShiftType,
    live?: boolean | null,
    name?: string | null,
    summary?: string | null,
    startDate?: string | null,
    startTime?: string | null,
    endDate?: string | null,
    endTime?: string | null,
    timezone?: string | null,
    timeFrame?: TimeFrame | null,
    timeFrameString?: string | null,
    recurrence?: ShiftRecurrence | null,
    weeklyRecurringDay?: string | null,
    monthlyRecurrenceWeek?: string | null,
    monthlyRecurrenceDay?: string | null,
    flexibleHours?: number | null,
    flexibleTimePeriod?: string | null,
    volunteersNeeded?: number | null,
    volunteerCoordinatorID?: string | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleStringifiedSkills?: string | null,
    roleStringifiedCauses?: string | null,
    locationID?: string | null,
    locationLongitude?: number | null,
    locationLatitude?: number | null,
    locationType?: LocationType | null,
    locationZipEstimate?: number | null,
    locationVariousDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    volunteerCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListShiftsQueryVariables = {
  filter?: ModelShiftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShiftsQuery = {
  listShifts?:  {
    __typename: "ModelShiftConnection",
    items:  Array< {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOpportunityTemplateQueryVariables = {
  id: string,
};

export type GetOpportunityTemplateQuery = {
  getOpportunityTemplate?:  {
    __typename: "OpportunityTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListOpportunityTemplatesQueryVariables = {
  filter?: ModelOpportunityTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOpportunityTemplatesQuery = {
  listOpportunityTemplates?:  {
    __typename: "ModelOpportunityTemplateConnection",
    items:  Array< {
      __typename: "OpportunityTemplate",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      templateJSON: string,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRoleTemplateQueryVariables = {
  id: string,
};

export type GetRoleTemplateQuery = {
  getRoleTemplate?:  {
    __typename: "RoleTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListRoleTemplatesQueryVariables = {
  filter?: ModelRoleTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRoleTemplatesQuery = {
  listRoleTemplates?:  {
    __typename: "ModelRoleTemplateConnection",
    items:  Array< {
      __typename: "RoleTemplate",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      templateJSON: string,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrganizationGroupQueryVariables = {
  id: string,
};

export type GetOrganizationGroupQuery = {
  getOrganizationGroup?:  {
    __typename: "OrganizationGroup",
    id: string,
    organizationID: string,
    groupName: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrganizationGroupsQueryVariables = {
  filter?: ModelOrganizationGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationGroupsQuery = {
  listOrganizationGroups?:  {
    __typename: "ModelOrganizationGroupConnection",
    items:  Array< {
      __typename: "OrganizationGroup",
      id: string,
      organizationID: string,
      groupName: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrganizationVolunteerQueryVariables = {
  id: string,
};

export type GetOrganizationVolunteerQuery = {
  getOrganizationVolunteer?:  {
    __typename: "OrganizationVolunteer",
    id: string,
    organizationID: string,
    volunteerProfileID: string,
    status: OrganizationVolunteerStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrganizationVolunteersQueryVariables = {
  filter?: ModelOrganizationVolunteerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationVolunteersQuery = {
  listOrganizationVolunteers?:  {
    __typename: "ModelOrganizationVolunteerConnection",
    items:  Array< {
      __typename: "OrganizationVolunteer",
      id: string,
      organizationID: string,
      volunteerProfileID: string,
      status: OrganizationVolunteerStatus,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrganizationGroupVolunteerQueryVariables = {
  id: string,
};

export type GetOrganizationGroupVolunteerQuery = {
  getOrganizationGroupVolunteer?:  {
    __typename: "OrganizationGroupVolunteer",
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrganizationGroupVolunteersQueryVariables = {
  filter?: ModelOrganizationGroupVolunteerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationGroupVolunteersQuery = {
  listOrganizationGroupVolunteers?:  {
    __typename: "ModelOrganizationGroupVolunteerConnection",
    items:  Array< {
      __typename: "OrganizationGroupVolunteer",
      id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTimeCommitmentQueryVariables = {
  id: string,
};

export type GetTimeCommitmentQuery = {
  getTimeCommitment?:  {
    __typename: "TimeCommitment",
    id: string,
    amount: number,
    units: TimeUnitType,
    period: TimePeriodType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTimeCommitmentsQueryVariables = {
  filter?: ModelTimeCommitmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTimeCommitmentsQuery = {
  listTimeCommitments?:  {
    __typename: "ModelTimeCommitmentConnection",
    items:  Array< {
      __typename: "TimeCommitment",
      id: string,
      amount: number,
      units: TimeUnitType,
      period: TimePeriodType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVolunteerMatchRequestQueryVariables = {
  id: string,
};

export type GetVolunteerMatchRequestQuery = {
  getVolunteerMatchRequest?:  {
    __typename: "VolunteerMatchRequest",
    id: string,
    status: VolunteerMatchRequestStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleRequestedID?: string | null,
    roleRequested?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    volunteerComments?: string | null,
    administrativeNotes?: string | null,
    scheduledCallID?: string | null,
    scheduledCall?:  {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleAssignedID?: string | null,
    roleAssigned?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    assignmentID?: string | null,
    assignment?:  {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    organizationRejectionReason?: string | null,
    volunteerRejectionReason?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListVolunteerMatchRequestsQueryVariables = {
  filter?: ModelVolunteerMatchRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerMatchRequestsQuery = {
  listVolunteerMatchRequests?:  {
    __typename: "ModelVolunteerMatchRequestConnection",
    items:  Array< {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetScheduledCallQueryVariables = {
  id: string,
};

export type GetScheduledCallQuery = {
  getScheduledCall?:  {
    __typename: "ScheduledCall",
    id: string,
    status: ScheduledCallStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    startTime?: string | null,
    duration?: number | null,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListScheduledCallsQueryVariables = {
  filter?: ModelScheduledCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScheduledCallsQuery = {
  listScheduledCalls?:  {
    __typename: "ModelScheduledCallConnection",
    items:  Array< {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAssignmentQueryVariables = {
  id: string,
};

export type GetAssignmentQuery = {
  getAssignment?:  {
    __typename: "Assignment",
    id: string,
    status: AssignmentStatusType,
    volunteerMatchRequestID: string,
    volunteerMatchRequest?:  {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID: string,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    shiftID: string,
    shift?:  {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    administrativeNotes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAssignmentsQueryVariables = {
  filter?: ModelAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssignmentsQuery = {
  listAssignments?:  {
    __typename: "ModelAssignmentConnection",
    items:  Array< {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCheckInQueryVariables = {
  id: string,
};

export type GetCheckInQuery = {
  getCheckIn?:  {
    __typename: "CheckIn",
    id: string,
    assignmentID: string,
    shiftID: string,
    opportunityID: string,
    timeIn?: string | null,
    timeOut?: string | null,
    checkedInByVolunteerProfileID?: string | null,
    checkedInByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    checkedOutByVolunteerProfileID?: string | null,
    checkedOutByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCheckInsQueryVariables = {
  filter?: ModelCheckInFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCheckInsQuery = {
  listCheckIns?:  {
    __typename: "ModelCheckInConnection",
    items:  Array< {
      __typename: "CheckIn",
      id: string,
      assignmentID: string,
      shiftID: string,
      opportunityID: string,
      timeIn?: string | null,
      timeOut?: string | null,
      checkedInByVolunteerProfileID?: string | null,
      checkedInByVolunteer?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      checkedOutByVolunteerProfileID?: string | null,
      checkedOutByVolunteer?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetNotificationSettingsQueryVariables = {
  id: string,
};

export type GetNotificationSettingsQuery = {
  getNotificationSettings?:  {
    __typename: "NotificationSettings",
    id: string,
    communicationsProfileID: string,
    allowPushNotifications: boolean,
    allowTextMessages: boolean,
    allowEmail: boolean,
    preference?: NotificationPreference | null,
    createdAt: string,
    updatedAt: string,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type ListNotificationSettingsQueryVariables = {
  filter?: ModelNotificationSettingsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationSettingsQuery = {
  listNotificationSettings?:  {
    __typename: "ModelNotificationSettingsConnection",
    items:  Array< {
      __typename: "NotificationSettings",
      id: string,
      communicationsProfileID: string,
      allowPushNotifications: boolean,
      allowTextMessages: boolean,
      allowEmail: boolean,
      preference?: NotificationPreference | null,
      createdAt: string,
      updatedAt: string,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLatentOrganizationCodeQueryVariables = {
  id: string,
};

export type GetLatentOrganizationCodeQuery = {
  getLatentOrganizationCode?:  {
    __typename: "LatentOrganizationCode",
    id: string,
    code: string,
    organizationID: string,
    active: boolean,
    emailRestricted: boolean,
    emailHostRestriction?: string | null,
    fundraisingCampaignID?: string | null,
    presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListLatentOrganizationCodesQueryVariables = {
  filter?: ModelLatentOrganizationCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLatentOrganizationCodesQuery = {
  listLatentOrganizationCodes?:  {
    __typename: "ModelLatentOrganizationCodeConnection",
    items:  Array< {
      __typename: "LatentOrganizationCode",
      id: string,
      code: string,
      organizationID: string,
      active: boolean,
      emailRestricted: boolean,
      emailHostRestriction?: string | null,
      fundraisingCampaignID?: string | null,
      presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSubscriptionDonationTierQueryVariables = {
  id: string,
};

export type GetSubscriptionDonationTierQuery = {
  getSubscriptionDonationTier?:  {
    __typename: "SubscriptionDonationTier",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    amount?: number | null,
    features?: Array< string | null > | null,
    buttonText?: string | null,
    buttonColor?: string | null,
    default?: boolean | null,
    highlighted?: boolean | null,
    highlightedColor?: string | null,
    promoText?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSubscriptionDonationTiersQueryVariables = {
  filter?: ModelSubscriptionDonationTierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubscriptionDonationTiersQuery = {
  listSubscriptionDonationTiers?:  {
    __typename: "ModelSubscriptionDonationTierConnection",
    items:  Array< {
      __typename: "SubscriptionDonationTier",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      amount?: number | null,
      features?: Array< string | null > | null,
      buttonText?: string | null,
      buttonColor?: string | null,
      default?: boolean | null,
      highlighted?: boolean | null,
      highlightedColor?: string | null,
      promoText?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCampaignConversationFlowQueryVariables = {
  id: string,
};

export type GetCampaignConversationFlowQuery = {
  getCampaignConversationFlow?:  {
    __typename: "CampaignConversationFlow",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    default?: boolean | null,
    active: boolean,
    actionMessageDefinitions?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    restricted?: boolean | null,
    useDefaultCta?: boolean | null,
    customCta?: string | null,
    allowAmbassadorSpecificCrowbarVideos?: boolean | null,
    generalCrowbarVideoURI?: string | null,
    deleted?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCampaignConversationFlowsQueryVariables = {
  filter?: ModelCampaignConversationFlowFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCampaignConversationFlowsQuery = {
  listCampaignConversationFlows?:  {
    __typename: "ModelCampaignConversationFlowConnection",
    items:  Array< {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetActionMessageDefinitionQueryVariables = {
  id: string,
};

export type GetActionMessageDefinitionQuery = {
  getActionMessageDefinition?:  {
    __typename: "ActionMessageDefinition",
    id: string,
    campaignConversationFlowID: string,
    fundraisingCampaignID: string,
    name?: string | null,
    description?: string | null,
    type: ActionMessageType,
    messageTemplate?: string | null,
    onPositiveResponse?: string | null,
    onNegativeResponse?: string | null,
    otherResponses?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    reminderActionMessageDefinitionID?: string | null,
    reminderActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reminderDelay?: number | null,
    sendReminderNotification?: boolean | null,
    reminderNotificationID?: string | null,
    beginningNode?: boolean | null,
    parentActionMessageDefinitionID?: string | null,
    parentActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    viewType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListActionMessageDefinitionsQueryVariables = {
  filter?: ModelActionMessageDefinitionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessageDefinitionsQuery = {
  listActionMessageDefinitions?:  {
    __typename: "ModelActionMessageDefinitionConnection",
    items:  Array< {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetActionMessageQueryVariables = {
  id: string,
};

export type GetActionMessageQuery = {
  getActionMessage?:  {
    __typename: "ActionMessage",
    id: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    fundraisingCampaignAmbassadorContactID: string,
    actionMessageDefinitionID: string,
    actionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sent?: boolean | null,
    sentTimestamp?: string | null,
    response?: ActionMessageResponseType | null,
    responseTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListActionMessagesQueryVariables = {
  filter?: ModelActionMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessagesQuery = {
  listActionMessages?:  {
    __typename: "ModelActionMessageConnection",
    items:  Array< {
      __typename: "ActionMessage",
      id: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      fundraisingCampaignAmbassadorContactID: string,
      actionMessageDefinitionID: string,
      actionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sent?: boolean | null,
      sentTimestamp?: string | null,
      response?: ActionMessageResponseType | null,
      responseTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProjectQueryVariables = {
  id: string,
};

export type GetProjectQuery = {
  getProject?:  {
    __typename: "Project",
    id: string,
    status?: string | null,
    name: string,
    description?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProjectsQueryVariables = {
  filter?: ModelProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProjectsQuery = {
  listProjects?:  {
    __typename: "ModelProjectConnection",
    items:  Array< {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTaskQueryVariables = {
  id: string,
};

export type GetTaskQuery = {
  getTask?:  {
    __typename: "Task",
    id: string,
    projectID: string,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isTopLevelTask?: boolean | null,
    name?: string | null,
    overview?: string | null,
    description?: string | null,
    descriptionRTE?: string | null,
    status?: string | null,
    complete?: boolean | null,
    assignments?:  {
      __typename: "ModelTaskAssignmentConnection",
      items:  Array< {
        __typename: "TaskAssignment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authAccountID: string,
        staffProfileID?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelTaskCommentConnection",
      items:  Array< {
        __typename: "TaskComment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        comment?: string | null,
        mediaURI?: Array< string | null > | null,
        postedByID: string,
        createdAt: string,
        updatedAt: string,
        postedBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    subTasks?:  {
      __typename: "ModelSubTaskConnection",
      items:  Array< {
        __typename: "SubTask",
        id: string,
        parentTaskID: string,
        parentTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subTaskID: string,
        subTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mediaURI?: Array< string | null > | null,
    attachments?:  {
      __typename: "ModelTaskAttachmentConnection",
      items:  Array< {
        __typename: "TaskAttachment",
        id: string,
        taskID: string,
        uploadedByID: string,
        name?: string | null,
        description?: string | null,
        contentType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdByID?: string | null,
    actionURL?: string | null,
    dueDate?: string | null,
    blockedBy?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    blocking?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    createdBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListTasksQueryVariables = {
  filter?: ModelTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTasksQuery = {
  listTasks?:  {
    __typename: "ModelTaskConnection",
    items:  Array< {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTaskAttachmentQueryVariables = {
  id: string,
};

export type GetTaskAttachmentQuery = {
  getTaskAttachment?:  {
    __typename: "TaskAttachment",
    id: string,
    taskID: string,
    uploadedByID: string,
    name?: string | null,
    description?: string | null,
    contentType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTaskAttachmentsQueryVariables = {
  filter?: ModelTaskAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskAttachmentsQuery = {
  listTaskAttachments?:  {
    __typename: "ModelTaskAttachmentConnection",
    items:  Array< {
      __typename: "TaskAttachment",
      id: string,
      taskID: string,
      uploadedByID: string,
      name?: string | null,
      description?: string | null,
      contentType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTaskBlockerQueryVariables = {
  id: string,
};

export type GetTaskBlockerQuery = {
  getTaskBlocker?:  {
    __typename: "TaskBlocker",
    id: string,
    originTaskID: string,
    originTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    blockerTaskID: string,
    blockerTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTaskBlockersQueryVariables = {
  filter?: ModelTaskBlockerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskBlockersQuery = {
  listTaskBlockers?:  {
    __typename: "ModelTaskBlockerConnection",
    items:  Array< {
      __typename: "TaskBlocker",
      id: string,
      originTaskID: string,
      originTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      blockerTaskID: string,
      blockerTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSubTaskQueryVariables = {
  id: string,
};

export type GetSubTaskQuery = {
  getSubTask?:  {
    __typename: "SubTask",
    id: string,
    parentTaskID: string,
    parentTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    subTaskID: string,
    subTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSubTasksQueryVariables = {
  filter?: ModelSubTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubTasksQuery = {
  listSubTasks?:  {
    __typename: "ModelSubTaskConnection",
    items:  Array< {
      __typename: "SubTask",
      id: string,
      parentTaskID: string,
      parentTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      subTaskID: string,
      subTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTaskCommentQueryVariables = {
  id: string,
};

export type GetTaskCommentQuery = {
  getTaskComment?:  {
    __typename: "TaskComment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    comment?: string | null,
    mediaURI?: Array< string | null > | null,
    postedByID: string,
    createdAt: string,
    updatedAt: string,
    postedBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListTaskCommentsQueryVariables = {
  filter?: ModelTaskCommentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskCommentsQuery = {
  listTaskComments?:  {
    __typename: "ModelTaskCommentConnection",
    items:  Array< {
      __typename: "TaskComment",
      id: string,
      taskID: string,
      task?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      comment?: string | null,
      mediaURI?: Array< string | null > | null,
      postedByID: string,
      createdAt: string,
      updatedAt: string,
      postedBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTaskAssignmentQueryVariables = {
  id: string,
};

export type GetTaskAssignmentQuery = {
  getTaskAssignment?:  {
    __typename: "TaskAssignment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    authAccountID: string,
    staffProfileID?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListTaskAssignmentsQueryVariables = {
  filter?: ModelTaskAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskAssignmentsQuery = {
  listTaskAssignments?:  {
    __typename: "ModelTaskAssignmentConnection",
    items:  Array< {
      __typename: "TaskAssignment",
      id: string,
      taskID: string,
      task?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      authAccountID: string,
      staffProfileID?: string | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVolunteerProfileByEmailQueryVariables = {
  email?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVolunteerProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetVolunteerProfileByEmailQuery = {
  getVolunteerProfileByEmail?:  {
    __typename: "ModelVolunteerProfileConnection",
    items:  Array< {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrganizationInvitationByCodeQueryVariables = {
  code?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrganizationInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetOrganizationInvitationByCodeQuery = {
  getOrganizationInvitationByCode?:  {
    __typename: "ModelOrganizationInvitationConnection",
    items:  Array< {
      __typename: "OrganizationInvitation",
      id: string,
      code: string,
      email: string,
      name?: string | null,
      used: boolean,
      usedTimestamp?: string | null,
      invitationSent: boolean,
      invitationSentTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVolunteerSkillsByVolunteerQueryVariables = {
  volunteerProfileID?: string | null,
  skillID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVolunteerSkillFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerSkillsByVolunteerQuery = {
  listVolunteerSkillsByVolunteer?:  {
    __typename: "ModelVolunteerSkillConnection",
    items:  Array< {
      __typename: "VolunteerSkill",
      id: string,
      skillID: string,
      volunteerProfileID: string,
      volunteerProfile:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      },
      createdAt: string,
      updatedAt: string,
      skill?:  {
        __typename: "Skill",
        id: string,
        key: string,
        name: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVolunteerCausesByVolunteerQueryVariables = {
  volunteerProfileID?: string | null,
  causeID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVolunteerCauseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerCausesByVolunteerQuery = {
  listVolunteerCausesByVolunteer?:  {
    __typename: "ModelVolunteerCauseConnection",
    items:  Array< {
      __typename: "VolunteerCause",
      id: string,
      causeID: string,
      cause?:  {
        __typename: "Cause",
        id: string,
        key: string,
        name: string,
        description?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      volunteerProfileID: string,
      volunteerProfile:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOrganizationDetailsByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrganizationDetailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationDetailsByOrganizationQuery = {
  listOrganizationDetailsByOrganization?:  {
    __typename: "ModelOrganizationDetailsConnection",
    items:  Array< {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProgramsByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProgramFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProgramsByOrganizationQuery = {
  listProgramsByOrganization?:  {
    __typename: "ModelProgramConnection",
    items:  Array< {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOpportunitiesByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOpportunityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOpportunitiesByOrganizationQuery = {
  listOpportunitiesByOrganization?:  {
    __typename: "ModelOpportunityConnection",
    items:  Array< {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOpportunitiesByProgramQueryVariables = {
  programID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOpportunityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOpportunitiesByProgramQuery = {
  listOpportunitiesByProgram?:  {
    __typename: "ModelOpportunityConnection",
    items:  Array< {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListApplicationsByOpportunityQueryVariables = {
  opportunityID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelApplicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationsByOpportunityQuery = {
  listApplicationsByOpportunity?:  {
    __typename: "ModelApplicationConnection",
    items:  Array< {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCustomQuestionsByApplicationQueryVariables = {
  applicationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCustomApplicationQuestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomQuestionsByApplicationQuery = {
  listCustomQuestionsByApplication?:  {
    __typename: "ModelCustomApplicationQuestionConnection",
    items:  Array< {
      __typename: "CustomApplicationQuestion",
      id: string,
      applicationID: string,
      application?:  {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      questionText: string,
      questionType: string,
      required: boolean,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRolesByOpportunityQueryVariables = {
  opportunityID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRolesByOpportunityQuery = {
  listRolesByOpportunity?:  {
    __typename: "ModelRoleConnection",
    items:  Array< {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListShiftsByRoleQueryVariables = {
  roleID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelShiftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShiftsByRoleQuery = {
  listShiftsByRole?:  {
    __typename: "ModelShiftConnection",
    items:  Array< {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListShiftsByRoleAndLocationQueryVariables = {
  roleID?: string | null,
  locationID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelShiftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShiftsByRoleAndLocationQuery = {
  listShiftsByRoleAndLocation?:  {
    __typename: "ModelShiftConnection",
    items:  Array< {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOpportunityTemplatesByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOpportunityTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOpportunityTemplatesByOrganizationQuery = {
  listOpportunityTemplatesByOrganization?:  {
    __typename: "ModelOpportunityTemplateConnection",
    items:  Array< {
      __typename: "OpportunityTemplate",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      templateJSON: string,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRoleTemplatesByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRoleTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRoleTemplatesByOrganizationQuery = {
  listRoleTemplatesByOrganization?:  {
    __typename: "ModelRoleTemplateConnection",
    items:  Array< {
      __typename: "RoleTemplate",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      templateJSON: string,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVolunteerMatchRequestsByVolunteerQueryVariables = {
  volunteerProfileID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVolunteerMatchRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerMatchRequestsByVolunteerQuery = {
  listVolunteerMatchRequestsByVolunteer?:  {
    __typename: "ModelVolunteerMatchRequestConnection",
    items:  Array< {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVolunteerMatchRequestsByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVolunteerMatchRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerMatchRequestsByOrganizationQuery = {
  listVolunteerMatchRequestsByOrganization?:  {
    __typename: "ModelVolunteerMatchRequestConnection",
    items:  Array< {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVolunteerMatchRequestsByOpportunityQueryVariables = {
  opportunityID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVolunteerMatchRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerMatchRequestsByOpportunityQuery = {
  listVolunteerMatchRequestsByOpportunity?:  {
    __typename: "ModelVolunteerMatchRequestConnection",
    items:  Array< {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVolunteerScheduledCallsQueryVariables = {
  volunteerProfileID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerScheduledCallsQuery = {
  listVolunteerScheduledCalls?:  {
    __typename: "ModelScheduledCallConnection",
    items:  Array< {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOrganizationScheduledCallsQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScheduledCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationScheduledCallsQuery = {
  listOrganizationScheduledCalls?:  {
    __typename: "ModelScheduledCallConnection",
    items:  Array< {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssignmentsByVolunteerQueryVariables = {
  volunteerProfileID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssignmentsByVolunteerQuery = {
  listAssignmentsByVolunteer?:  {
    __typename: "ModelAssignmentConnection",
    items:  Array< {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssignmentsByShiftQueryVariables = {
  shiftID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssignmentsByShiftQuery = {
  listAssignmentsByShift?:  {
    __typename: "ModelAssignmentConnection",
    items:  Array< {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAssignmentsByOpportunityQueryVariables = {
  opportunityID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssignmentsByOpportunityQuery = {
  listAssignmentsByOpportunity?:  {
    __typename: "ModelAssignmentConnection",
    items:  Array< {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCheckInsByAssignmentQueryVariables = {
  assignmentID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCheckInFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCheckInsByAssignmentQuery = {
  listCheckInsByAssignment?:  {
    __typename: "ModelCheckInConnection",
    items:  Array< {
      __typename: "CheckIn",
      id: string,
      assignmentID: string,
      shiftID: string,
      opportunityID: string,
      timeIn?: string | null,
      timeOut?: string | null,
      checkedInByVolunteerProfileID?: string | null,
      checkedInByVolunteer?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      checkedOutByVolunteerProfileID?: string | null,
      checkedOutByVolunteer?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCheckInsByShiftQueryVariables = {
  shiftID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCheckInFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCheckInsByShiftQuery = {
  listCheckInsByShift?:  {
    __typename: "ModelCheckInConnection",
    items:  Array< {
      __typename: "CheckIn",
      id: string,
      assignmentID: string,
      shiftID: string,
      opportunityID: string,
      timeIn?: string | null,
      timeOut?: string | null,
      checkedInByVolunteerProfileID?: string | null,
      checkedInByVolunteer?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      checkedOutByVolunteerProfileID?: string | null,
      checkedOutByVolunteer?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOrganizationsByCodeQueryVariables = {
  code?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLatentOrganizationCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationsByCodeQuery = {
  listOrganizationsByCode?:  {
    __typename: "ModelLatentOrganizationCodeConnection",
    items:  Array< {
      __typename: "LatentOrganizationCode",
      id: string,
      code: string,
      organizationID: string,
      active: boolean,
      emailRestricted: boolean,
      emailHostRestriction?: string | null,
      fundraisingCampaignID?: string | null,
      presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListOrganizationCodesByOrganizationIDQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLatentOrganizationCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationCodesByOrganizationIDQuery = {
  listOrganizationCodesByOrganizationID?:  {
    __typename: "ModelLatentOrganizationCodeConnection",
    items:  Array< {
      __typename: "LatentOrganizationCode",
      id: string,
      code: string,
      organizationID: string,
      active: boolean,
      emailRestricted: boolean,
      emailHostRestriction?: string | null,
      fundraisingCampaignID?: string | null,
      presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSubscriptionDonationTiersByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSubscriptionDonationTierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubscriptionDonationTiersByFundraisingCampaignQuery = {
  listSubscriptionDonationTiersByFundraisingCampaign?:  {
    __typename: "ModelSubscriptionDonationTierConnection",
    items:  Array< {
      __typename: "SubscriptionDonationTier",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      amount?: number | null,
      features?: Array< string | null > | null,
      buttonText?: string | null,
      buttonColor?: string | null,
      default?: boolean | null,
      highlighted?: boolean | null,
      highlightedColor?: string | null,
      promoText?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCampaignConversationFlowsByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCampaignConversationFlowFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCampaignConversationFlowsByFundraisingCampaignQuery = {
  listCampaignConversationFlowsByFundraisingCampaign?:  {
    __typename: "ModelCampaignConversationFlowConnection",
    items:  Array< {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActionMessageDefinitionsByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActionMessageDefinitionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessageDefinitionsByFundraisingCampaignQuery = {
  listActionMessageDefinitionsByFundraisingCampaign?:  {
    __typename: "ModelActionMessageDefinitionConnection",
    items:  Array< {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActionMessageDefinitionsByCampaignConversationFlowQueryVariables = {
  campaignConversationFlowID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActionMessageDefinitionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessageDefinitionsByCampaignConversationFlowQuery = {
  listActionMessageDefinitionsByCampaignConversationFlow?:  {
    __typename: "ModelActionMessageDefinitionConnection",
    items:  Array< {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActionMessageDefinitionsByParentActionMessageDefinitionQueryVariables = {
  parentActionMessageDefinitionID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActionMessageDefinitionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessageDefinitionsByParentActionMessageDefinitionQuery = {
  listActionMessageDefinitionsByParentActionMessageDefinition?:  {
    __typename: "ModelActionMessageDefinitionConnection",
    items:  Array< {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActionMessagesByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActionMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessagesByFundraisingCampaignQuery = {
  listActionMessagesByFundraisingCampaign?:  {
    __typename: "ModelActionMessageConnection",
    items:  Array< {
      __typename: "ActionMessage",
      id: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      fundraisingCampaignAmbassadorContactID: string,
      actionMessageDefinitionID: string,
      actionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sent?: boolean | null,
      sentTimestamp?: string | null,
      response?: ActionMessageResponseType | null,
      responseTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActionMessagesByFundraisingCampaignAmbassadorIDQueryVariables = {
  fundraisingCampaignAmbassadorID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActionMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessagesByFundraisingCampaignAmbassadorIDQuery = {
  listActionMessagesByFundraisingCampaignAmbassadorID?:  {
    __typename: "ModelActionMessageConnection",
    items:  Array< {
      __typename: "ActionMessage",
      id: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      fundraisingCampaignAmbassadorContactID: string,
      actionMessageDefinitionID: string,
      actionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sent?: boolean | null,
      sentTimestamp?: string | null,
      response?: ActionMessageResponseType | null,
      responseTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActionMessagesByFundraisingCampaignAmbassadorContactIDQueryVariables = {
  fundraisingCampaignAmbassadorContactID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActionMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessagesByFundraisingCampaignAmbassadorContactIDQuery = {
  listActionMessagesByFundraisingCampaignAmbassadorContactID?:  {
    __typename: "ModelActionMessageConnection",
    items:  Array< {
      __typename: "ActionMessage",
      id: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      fundraisingCampaignAmbassadorContactID: string,
      actionMessageDefinitionID: string,
      actionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sent?: boolean | null,
      sentTimestamp?: string | null,
      response?: ActionMessageResponseType | null,
      responseTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListActionMessagesByDefinitionQueryVariables = {
  actionMessageDefinitionID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActionMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActionMessagesByDefinitionQuery = {
  listActionMessagesByDefinition?:  {
    __typename: "ModelActionMessageConnection",
    items:  Array< {
      __typename: "ActionMessage",
      id: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      fundraisingCampaignAmbassadorContactID: string,
      actionMessageDefinitionID: string,
      actionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      sent?: boolean | null,
      sentTimestamp?: string | null,
      response?: ActionMessageResponseType | null,
      responseTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTasksByProjectQueryVariables = {
  projectID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTasksByProjectQuery = {
  listTasksByProject?:  {
    __typename: "ModelTaskConnection",
    items:  Array< {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaskAttachmentsByTaskQueryVariables = {
  taskID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskAttachmentsByTaskQuery = {
  listTaskAttachmentsByTask?:  {
    __typename: "ModelTaskAttachmentConnection",
    items:  Array< {
      __typename: "TaskAttachment",
      id: string,
      taskID: string,
      uploadedByID: string,
      name?: string | null,
      description?: string | null,
      contentType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaskBlockersByOriginTaskQueryVariables = {
  originTaskID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskBlockerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskBlockersByOriginTaskQuery = {
  listTaskBlockersByOriginTask?:  {
    __typename: "ModelTaskBlockerConnection",
    items:  Array< {
      __typename: "TaskBlocker",
      id: string,
      originTaskID: string,
      originTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      blockerTaskID: string,
      blockerTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaskBlockersByBlockerTaskQueryVariables = {
  blockerTaskID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskBlockerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskBlockersByBlockerTaskQuery = {
  listTaskBlockersByBlockerTask?:  {
    __typename: "ModelTaskBlockerConnection",
    items:  Array< {
      __typename: "TaskBlocker",
      id: string,
      originTaskID: string,
      originTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      blockerTaskID: string,
      blockerTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSubTasksByParentTaskQueryVariables = {
  parentTaskID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSubTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubTasksByParentTaskQuery = {
  listSubTasksByParentTask?:  {
    __typename: "ModelSubTaskConnection",
    items:  Array< {
      __typename: "SubTask",
      id: string,
      parentTaskID: string,
      parentTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      subTaskID: string,
      subTask?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaskCommentsByTaskQueryVariables = {
  taskID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskCommentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskCommentsByTaskQuery = {
  listTaskCommentsByTask?:  {
    __typename: "ModelTaskCommentConnection",
    items:  Array< {
      __typename: "TaskComment",
      id: string,
      taskID: string,
      task?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      comment?: string | null,
      mediaURI?: Array< string | null > | null,
      postedByID: string,
      createdAt: string,
      updatedAt: string,
      postedBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaskAssignmentsByTaskQueryVariables = {
  taskID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskAssignmentsByTaskQuery = {
  listTaskAssignmentsByTask?:  {
    __typename: "ModelTaskAssignmentConnection",
    items:  Array< {
      __typename: "TaskAssignment",
      id: string,
      taskID: string,
      task?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      authAccountID: string,
      staffProfileID?: string | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaskAssignmentsByAuthAccountQueryVariables = {
  authAccountID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskAssignmentsByAuthAccountQuery = {
  listTaskAssignmentsByAuthAccount?:  {
    __typename: "ModelTaskAssignmentConnection",
    items:  Array< {
      __typename: "TaskAssignment",
      id: string,
      taskID: string,
      task?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      authAccountID: string,
      staffProfileID?: string | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTaskAssignmentsByStaffProfileQueryVariables = {
  staffProfileID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskAssignmentsByStaffProfileQuery = {
  listTaskAssignmentsByStaffProfile?:  {
    __typename: "ModelTaskAssignmentConnection",
    items:  Array< {
      __typename: "TaskAssignment",
      id: string,
      taskID: string,
      task?:  {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      authAccountID: string,
      staffProfileID?: string | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchProgramsQueryVariables = {
  filter?: SearchableProgramFilterInput | null,
  sort?: SearchableProgramSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchProgramsQuery = {
  searchPrograms?:  {
    __typename: "SearchableProgramConnection",
    items:  Array< {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type SearchOpportunitiesQueryVariables = {
  filter?: SearchableOpportunityFilterInput | null,
  sort?: SearchableOpportunitySortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchOpportunitiesQuery = {
  searchOpportunities?:  {
    __typename: "SearchableOpportunityConnection",
    items:  Array< {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type SearchRolesQueryVariables = {
  filter?: SearchableRoleFilterInput | null,
  sort?: SearchableRoleSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchRolesQuery = {
  searchRoles?:  {
    __typename: "SearchableRoleConnection",
    items:  Array< {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type SearchShiftsQueryVariables = {
  filter?: SearchableShiftFilterInput | null,
  sort?: SearchableShiftSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchShiftsQuery = {
  searchShifts?:  {
    __typename: "SearchableShiftConnection",
    items:  Array< {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type SearchOrganizationVolunteersQueryVariables = {
  filter?: SearchableOrganizationVolunteerFilterInput | null,
  sort?: SearchableOrganizationVolunteerSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchOrganizationVolunteersQuery = {
  searchOrganizationVolunteers?:  {
    __typename: "SearchableOrganizationVolunteerConnection",
    items:  Array< {
      __typename: "OrganizationVolunteer",
      id: string,
      organizationID: string,
      volunteerProfileID: string,
      status: OrganizationVolunteerStatus,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetCognitoAccountQueryVariables = {
  id: string,
};

export type GetCognitoAccountQuery = {
  getCognitoAccount?:  {
    __typename: "CognitoAccount",
    id: string,
    cognitoID: string,
    authAccountID?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListCognitoAccountsQueryVariables = {
  filter?: ModelCognitoAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCognitoAccountsQuery = {
  listCognitoAccounts?:  {
    __typename: "ModelCognitoAccountConnection",
    items:  Array< {
      __typename: "CognitoAccount",
      id: string,
      cognitoID: string,
      authAccountID?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCognitoAccountsByAuthAccountQueryVariables = {
  authAccountID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCognitoAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCognitoAccountsByAuthAccountQuery = {
  listCognitoAccountsByAuthAccount?:  {
    __typename: "ModelCognitoAccountConnection",
    items:  Array< {
      __typename: "CognitoAccount",
      id: string,
      cognitoID: string,
      authAccountID?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCognitoAccountByCognitoIDQueryVariables = {
  cognitoID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCognitoAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetCognitoAccountByCognitoIDQuery = {
  getCognitoAccountByCognitoID?:  {
    __typename: "ModelCognitoAccountConnection",
    items:  Array< {
      __typename: "CognitoAccount",
      id: string,
      cognitoID: string,
      authAccountID?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAuthAccountQueryVariables = {
  id: string,
};

export type GetAuthAccountQuery = {
  getAuthAccount?:  {
    __typename: "AuthAccount",
    id: string,
    volunteerProfileID?: string | null,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    lastSelectedStaffProfileID?: string | null,
    lastSelectedFundraisingProfileID?: string | null,
    communicationsProfileID?: string | null,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    primaryEmail?: string | null,
    phoneNumber?: string | null,
    dateOfBirth?: string | null,
    gender?: string | null,
    selfDescribedGender?: string | null,
    addressID?: string | null,
    website?: string | null,
    resumeURI?: string | null,
    bio?: string | null,
    profilePictureURI?: string | null,
    headerVideoURI?: string | null,
    headerImageURI?: string | null,
    headerAssetShown?: string | null,
    flourishAdmin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    cognitoAccounts?:  {
      __typename: "ModelCognitoAccountConnection",
      items:  Array< {
        __typename: "CognitoAccount",
        id: string,
        cognitoID: string,
        authAccountID?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    staffProfile?:  {
      __typename: "ModelStaffProfileConnection",
      items:  Array< {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    fundraisingProfiles?:  {
      __typename: "ModelFundraisingProfileConnection",
      items:  Array< {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedFundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type ListAuthAccountsQueryVariables = {
  filter?: ModelAuthAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAuthAccountsQuery = {
  listAuthAccounts?:  {
    __typename: "ModelAuthAccountConnection",
    items:  Array< {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAuthAccountByVolunteerProfileIDQueryVariables = {
  volunteerProfileID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAuthAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAuthAccountByVolunteerProfileIDQuery = {
  getAuthAccountByVolunteerProfileID?:  {
    __typename: "ModelAuthAccountConnection",
    items:  Array< {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAuthAccountsByEmailQueryVariables = {
  primaryEmail?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAuthAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAuthAccountsByEmailQuery = {
  listAuthAccountsByEmail?:  {
    __typename: "ModelAuthAccountConnection",
    items:  Array< {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAuthAccountsByPhoneNumberQueryVariables = {
  phoneNumber?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAuthAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAuthAccountsByPhoneNumberQuery = {
  listAuthAccountsByPhoneNumber?:  {
    __typename: "ModelAuthAccountConnection",
    items:  Array< {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStaffProfileQueryVariables = {
  id: string,
};

export type GetStaffProfileQuery = {
  getStaffProfile?:  {
    __typename: "StaffProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    role?: StaffProfileRole | null,
    name?: string | null,
    nylasAccountID?: string | null,
    nylasCalendarToken?: string | null,
    nylasPrimaryCalendarID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListStaffProfilesQueryVariables = {
  filter?: ModelStaffProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStaffProfilesQuery = {
  listStaffProfiles?:  {
    __typename: "ModelStaffProfileConnection",
    items:  Array< {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStaffProfilesByAuthAccountQueryVariables = {
  authAccountID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStaffProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStaffProfilesByAuthAccountQuery = {
  listStaffProfilesByAuthAccount?:  {
    __typename: "ModelStaffProfileConnection",
    items:  Array< {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStaffProfilesByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStaffProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStaffProfilesByOrganizationQuery = {
  listStaffProfilesByOrganization?:  {
    __typename: "ModelStaffProfileConnection",
    items:  Array< {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCommunicationsProfileQueryVariables = {
  id: string,
};

export type GetCommunicationsProfileQuery = {
  getCommunicationsProfile?:  {
    __typename: "CommunicationsProfile",
    id: string,
    authAccountID: string,
    streamJwt?: string | null,
    notificationSettingsID?: string | null,
    notificationSettings?:  {
      __typename: "NotificationSettings",
      id: string,
      communicationsProfileID: string,
      allowPushNotifications: boolean,
      allowTextMessages: boolean,
      allowEmail: boolean,
      preference?: NotificationPreference | null,
      createdAt: string,
      updatedAt: string,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type ListCommunicationsProfilesQueryVariables = {
  filter?: ModelCommunicationsProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCommunicationsProfilesQuery = {
  listCommunicationsProfiles?:  {
    __typename: "ModelCommunicationsProfileConnection",
    items:  Array< {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCommunicationsProfileByAuthAccountQueryVariables = {
  authAccountID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCommunicationsProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetCommunicationsProfileByAuthAccountQuery = {
  getCommunicationsProfileByAuthAccount?:  {
    __typename: "ModelCommunicationsProfileConnection",
    items:  Array< {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingProfileQueryVariables = {
  id: string,
};

export type GetFundraisingProfileQuery = {
  getFundraisingProfile?:  {
    __typename: "FundraisingProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    classyMemberID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    campaigns?:  {
      __typename: "ModelFundraisingCampaignAmbassadorConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListFundraisingProfilesQueryVariables = {
  filter?: ModelFundraisingProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingProfilesQuery = {
  listFundraisingProfiles?:  {
    __typename: "ModelFundraisingProfileConnection",
    items:  Array< {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFundraisingProfilesByAuthAccountQueryVariables = {
  authAccountID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingProfilesByAuthAccountQuery = {
  listFundraisingProfilesByAuthAccount?:  {
    __typename: "ModelFundraisingProfileConnection",
    items:  Array< {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFundraisingProfilesByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingProfilesByOrganizationQuery = {
  listFundraisingProfilesByOrganization?:  {
    __typename: "ModelFundraisingProfileConnection",
    items:  Array< {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingProfileByAuthAccountAndOrganizationQueryVariables = {
  authAccountID?: string | null,
  organizationID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetFundraisingProfileByAuthAccountAndOrganizationQuery = {
  getFundraisingProfileByAuthAccountAndOrganization?:  {
    __typename: "ModelFundraisingProfileConnection",
    items:  Array< {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStaffInvitationQueryVariables = {
  id: string,
};

export type GetStaffInvitationQuery = {
  getStaffInvitation?:  {
    __typename: "StaffInvitation",
    id: string,
    code: string,
    type: StaffInvitationType,
    email?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    staffProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListStaffInvitationsQueryVariables = {
  filter?: ModelStaffInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStaffInvitationsQuery = {
  listStaffInvitations?:  {
    __typename: "ModelStaffInvitationConnection",
    items:  Array< {
      __typename: "StaffInvitation",
      id: string,
      code: string,
      type: StaffInvitationType,
      email?: string | null,
      domain?: string | null,
      name?: string | null,
      organizationID: string,
      authAccountID?: string | null,
      staffProfileID?: string | null,
      used?: boolean | null,
      usedTimestamp?: string | null,
      invitationSent?: boolean | null,
      invitationSentTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStaffInvitationByCodeQueryVariables = {
  code?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStaffInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetStaffInvitationByCodeQuery = {
  getStaffInvitationByCode?:  {
    __typename: "ModelStaffInvitationConnection",
    items:  Array< {
      __typename: "StaffInvitation",
      id: string,
      code: string,
      type: StaffInvitationType,
      email?: string | null,
      domain?: string | null,
      name?: string | null,
      organizationID: string,
      authAccountID?: string | null,
      staffProfileID?: string | null,
      used?: boolean | null,
      usedTimestamp?: string | null,
      invitationSent?: boolean | null,
      invitationSentTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingInvitationQueryVariables = {
  id: string,
};

export type GetFundraisingInvitationQuery = {
  getFundraisingInvitation?:  {
    __typename: "FundraisingInvitation",
    id: string,
    code: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListFundraisingInvitationsQueryVariables = {
  filter?: ModelFundraisingInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingInvitationsQuery = {
  listFundraisingInvitations?:  {
    __typename: "ModelFundraisingInvitationConnection",
    items:  Array< {
      __typename: "FundraisingInvitation",
      id: string,
      code: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      domain?: string | null,
      name?: string | null,
      organizationID: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      used?: boolean | null,
      usedTimestamp?: string | null,
      invitationSent?: boolean | null,
      invitationSentTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingInvitationByCodeQueryVariables = {
  code?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetFundraisingInvitationByCodeQuery = {
  getFundraisingInvitationByCode?:  {
    __typename: "ModelFundraisingInvitationConnection",
    items:  Array< {
      __typename: "FundraisingInvitation",
      id: string,
      code: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      domain?: string | null,
      name?: string | null,
      organizationID: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      used?: boolean | null,
      usedTimestamp?: string | null,
      invitationSent?: boolean | null,
      invitationSentTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVolunteerInvitationQueryVariables = {
  id: string,
};

export type GetVolunteerInvitationQuery = {
  getVolunteerInvitation?:  {
    __typename: "VolunteerInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    organizationID?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type ListVolunteerInvitationsQueryVariables = {
  filter?: ModelVolunteerInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerInvitationsQuery = {
  listVolunteerInvitations?:  {
    __typename: "ModelVolunteerInvitationConnection",
    items:  Array< {
      __typename: "VolunteerInvitation",
      id: string,
      code: string,
      email: string,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      organizationID?: string | null,
      used: boolean,
      usedTimestamp?: string | null,
      invitationSent: boolean,
      invitationSentTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VolunteerInvitationByCodeQueryVariables = {
  code?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVolunteerInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VolunteerInvitationByCodeQuery = {
  volunteerInvitationByCode?:  {
    __typename: "ModelVolunteerInvitationConnection",
    items:  Array< {
      __typename: "VolunteerInvitation",
      id: string,
      code: string,
      email: string,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      organizationID?: string | null,
      used: boolean,
      usedTimestamp?: string | null,
      invitationSent: boolean,
      invitationSentTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVolunteerWaitlistQueryVariables = {
  id: string,
};

export type GetVolunteerWaitlistQuery = {
  getVolunteerWaitlist?:  {
    __typename: "VolunteerWaitlist",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    zipCode?: number | null,
    about?: string | null,
    invited?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListVolunteerWaitlistsQueryVariables = {
  filter?: ModelVolunteerWaitlistFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolunteerWaitlistsQuery = {
  listVolunteerWaitlists?:  {
    __typename: "ModelVolunteerWaitlistConnection",
    items:  Array< {
      __typename: "VolunteerWaitlist",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      zipCode?: number | null,
      about?: string | null,
      invited?: boolean | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSkillQueryVariables = {
  id: string,
};

export type GetSkillQuery = {
  getSkill?:  {
    __typename: "Skill",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSkillsQueryVariables = {
  filter?: ModelSkillFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSkillsQuery = {
  listSkills?:  {
    __typename: "ModelSkillConnection",
    items:  Array< {
      __typename: "Skill",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrganizationQueryVariables = {
  id: string,
};

export type GetOrganizationQuery = {
  getOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    shortName?: string | null,
    description?: string | null,
    locationID?: string | null,
    website?: string | null,
    phoneNumber?: string | null,
    stripeConnectedAccountID?: string | null,
    stripeConnectedAccountStatus?: string | null,
    headerImageURI?: string | null,
    ambassadorTermOverrideSingular?: string | null,
    ambassadorTermOverridePlural?: string | null,
    streamJwt?: string | null,
    latentSubscription?: number | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    designation?: string | null,
    detailsID?: string | null,
    details?:  {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListOrganizationsQueryVariables = {
  filter?: ModelOrganizationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationsQuery = {
  listOrganizations?:  {
    __typename: "ModelOrganizationConnection",
    items:  Array< {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchOrganizationsQueryVariables = {
  filter?: SearchableOrganizationFilterInput | null,
  sort?: SearchableOrganizationSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchOrganizationsQuery = {
  searchOrganizations?:  {
    __typename: "SearchableOrganizationConnection",
    items:  Array< {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetLocationQueryVariables = {
  id: string,
};

export type GetLocationQuery = {
  getLocation?:  {
    __typename: "Location",
    id: string,
    type: LocationType,
    name: string,
    details?: string | null,
    addressID?: string | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type ListLocationsQueryVariables = {
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLocationsQuery = {
  listLocations?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLocationsByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLocationsByOrganizationQuery = {
  listLocationsByOrganization?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAddressQueryVariables = {
  id: string,
};

export type GetAddressQuery = {
  getAddress?:  {
    __typename: "Address",
    id: string,
    streetAddress?: string | null,
    unit?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    zipPlusFour?: string | null,
    longitude?: number | null,
    latitude?: number | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListAddressesQueryVariables = {
  filter?: ModelAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAddressesQuery = {
  listAddresses?:  {
    __typename: "ModelAddressConnection",
    items:  Array< {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingCampaignQueryVariables = {
  id: string,
};

export type GetFundraisingCampaignQuery = {
  getFundraisingCampaign?:  {
    __typename: "FundraisingCampaign",
    id: string,
    type: FundraisingCampaignType,
    organizationID: string,
    staffLeadID?: string | null,
    campaignName?: string | null,
    introVideoURI?: string | null,
    textMessageTemplate?: string | null,
    initialMessageReminderTemplate?: string | null,
    phoneCallScriptTemplate?: string | null,
    followUpMessageTemplate?: string | null,
    followUpYesMessageTemplate?: string | null,
    followUpNoMessageTemplate?: string | null,
    followUpReminderMessageTemplate?: string | null,
    showVideo?: boolean | null,
    showText?: boolean | null,
    showCall?: boolean | null,
    showFollowUp?: boolean | null,
    active?: boolean | null,
    publicVideoID?: string | null,
    publicVideoProvider?: string | null,
    campaignStartDate?: string | null,
    campaignStartTime?: string | null,
    campaignTimeZone?: string | null,
    campaignEndDate?: string | null,
    campaignEndTime?: string | null,
    publicCampaignAbout?: string | null,
    publicCampaignIntro?: string | null,
    campaignGoal?: number | null,
    perAmbassadorGoal?: number | null,
    totalAmbassadorsGoal?: number | null,
    perContactDonationGoal?: number | null,
    progressChartType?: string | null,
    ctaURL?: string | null,
    pageLayout?: string | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    customHeaderImageUploaded?: boolean | null,
    customLogoImageUploaded?: boolean | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    ctaButtonText?: string | null,
    givingCircleBaseAmount?: number | null,
    givingCircleIncrements?: Array< number | null > | null,
    givingCircleAllowCustomAmounts?: boolean | null,
    ambassadorSpecificVideoUrlEnabled?: boolean | null,
    ambassadorCanUploadVideoUrl?: boolean | null,
    ambassadorSpecificCtaUrlEnabled?: boolean | null,
    ambassadorCanUploadCtaUrl?: boolean | null,
    crowbarVideoURL?: string | null,
    recruitmentForCampaignID?: string | null,
    classyCampaignID?: string | null,
    classyAutogenerateAmbassadorTeams?: boolean | null,
    classyDonationPageHostURL?: string | null,
    useClassyCtaURL?: boolean | null,
    useClassyFundraiserPage?: boolean | null,
    personalFundraisingCampaignID?: string | null,
    onDemandDiscoveryMeetingEnabled?: boolean | null,
    onDemandDiscoveryMeetingURL?: string | null,
    onDemandDiscoveryMeetingID?: string | null,
    onDemandDiscoveryMeetingInvitationCode?: string | null,
    CampaignConversationFlows?:  {
      __typename: "ModelCampaignConversationFlowConnection",
      items:  Array< {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultConversationFlowID?: string | null,
    defaultConversationFlow?:  {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    useConversationFlows?: boolean | null,
    campaignPageID?: string | null,
    ambassadorPageID?: string | null,
    donationPageID?: string | null,
    discoveryPageID?: string | null,
    projectID?: string | null,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subscriptionDonationTiers?:  {
      __typename: "ModelSubscriptionDonationTierConnection",
      items:  Array< {
        __typename: "SubscriptionDonationTier",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        amount?: number | null,
        features?: Array< string | null > | null,
        buttonText?: string | null,
        buttonColor?: string | null,
        default?: boolean | null,
        highlighted?: boolean | null,
        highlightedColor?: string | null,
        promoText?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    useActionCardView?: boolean | null,
    createdAt: string,
    updatedAt: string,
    staffLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitmentForCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    personalFundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    campaignPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    ambassadorPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    donationPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    discoveryPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    onDemandDiscoveryMeeting?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type ListFundraisingCampaignsQueryVariables = {
  filter?: ModelFundraisingCampaignFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignsQuery = {
  listFundraisingCampaigns?:  {
    __typename: "ModelFundraisingCampaignConnection",
    items:  Array< {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFundraisingCampaignsByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignsByOrganizationQuery = {
  listFundraisingCampaignsByOrganization?:  {
    __typename: "ModelFundraisingCampaignConnection",
    items:  Array< {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCampaignPageQueryVariables = {
  id: string,
};

export type GetCampaignPageQuery = {
  getCampaignPage?:  {
    __typename: "CampaignPage",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: CampaignPageType | null,
    fundraisingCampaignID: string,
    campaignDisplayConfigurationID?: string | null,
    pageHtml?: string | null,
    pageJSON?: string | null,
    pageCssJSON?: string | null,
    pageAssetsJSON?: string | null,
    createdAt: string,
    updatedAt: string,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    campaignDisplayConfiguration?:  {
      __typename: "CampaignDisplayConfiguration",
      id: string,
      campaignPageID: string,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      gradientLeftColor?: string | null,
      gradientRightColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type ListCampaignPagesQueryVariables = {
  filter?: ModelCampaignPageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCampaignPagesQuery = {
  listCampaignPages?:  {
    __typename: "ModelCampaignPageConnection",
    items:  Array< {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCampaignPagesByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCampaignPageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCampaignPagesByFundraisingCampaignQuery = {
  listCampaignPagesByFundraisingCampaign?:  {
    __typename: "ModelCampaignPageConnection",
    items:  Array< {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCampaignDisplayConfigurationQueryVariables = {
  id: string,
};

export type GetCampaignDisplayConfigurationQuery = {
  getCampaignDisplayConfiguration?:  {
    __typename: "CampaignDisplayConfiguration",
    id: string,
    campaignPageID: string,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    gradientLeftColor?: string | null,
    gradientRightColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListCampaignDisplayConfigurationsQueryVariables = {
  filter?: ModelCampaignDisplayConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCampaignDisplayConfigurationsQuery = {
  listCampaignDisplayConfigurations?:  {
    __typename: "ModelCampaignDisplayConfigurationConnection",
    items:  Array< {
      __typename: "CampaignDisplayConfiguration",
      id: string,
      campaignPageID: string,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      gradientLeftColor?: string | null,
      gradientRightColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetNylasEventQueryVariables = {
  id: string,
};

export type GetNylasEventQuery = {
  getNylasEvent?:  {
    __typename: "NylasEvent",
    id: string,
    calendarID?: string | null,
    owner?: string | null,
    fundraisingCampaignDiscoveryCallID?: string | null,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListNylasEventsQueryVariables = {
  filter?: ModelNylasEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNylasEventsQuery = {
  listNylasEvents?:  {
    __typename: "ModelNylasEventConnection",
    items:  Array< {
      __typename: "NylasEvent",
      id: string,
      calendarID?: string | null,
      owner?: string | null,
      fundraisingCampaignDiscoveryCallID?: string | null,
      status?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingCampaignDiscoveryCallQueryVariables = {
  id: string,
};

export type GetFundraisingCampaignDiscoveryCallQuery = {
  getFundraisingCampaignDiscoveryCall?:  {
    __typename: "FundraisingCampaignDiscoveryCall",
    id: string,
    title?: string | null,
    organizationID: string,
    fundraisingCampaignID: string,
    staffProfileID: string,
    startTimestamp: string,
    endTimestamp: string,
    latentHosted: boolean,
    invitationURL?: string | null,
    nylasEventID?: string | null,
    virtualMeetingURL?: string | null,
    createdAt: string,
    updatedAt: string,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type ListFundraisingCampaignDiscoveryCallsQueryVariables = {
  filter?: ModelFundraisingCampaignDiscoveryCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignDiscoveryCallsQuery = {
  listFundraisingCampaignDiscoveryCalls?:  {
    __typename: "ModelFundraisingCampaignDiscoveryCallConnection",
    items:  Array< {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFundraisingCampaignDiscoveryCallsByOrganizationQueryVariables = {
  organizationID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignDiscoveryCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignDiscoveryCallsByOrganizationQuery = {
  listFundraisingCampaignDiscoveryCallsByOrganization?:  {
    __typename: "ModelFundraisingCampaignDiscoveryCallConnection",
    items:  Array< {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFundraisingCampaignDiscoveryCallsByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignDiscoveryCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignDiscoveryCallsByFundraisingCampaignQuery = {
  listFundraisingCampaignDiscoveryCallsByFundraisingCampaign?:  {
    __typename: "ModelFundraisingCampaignDiscoveryCallConnection",
    items:  Array< {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingCampaignDiscoveryCallByNylasEventIDQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignDiscoveryCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetFundraisingCampaignDiscoveryCallByNylasEventIDQuery = {
  getFundraisingCampaignDiscoveryCallByNylasEventID?:  {
    __typename: "ModelFundraisingCampaignDiscoveryCallConnection",
    items:  Array< {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDiscoveryCallParticipantQueryVariables = {
  id: string,
};

export type GetDiscoveryCallParticipantQuery = {
  getDiscoveryCallParticipant?:  {
    __typename: "DiscoveryCallParticipant",
    id: string,
    email: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    fundraisingCampaignDiscoveryCallID: string,
    fundraisingCampaignID: string,
    invitationSent?: boolean | null,
    icsString?: string | null,
    status?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    confirmed?: boolean | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingCampaignDiscoveryCall?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListDiscoveryCallParticipantsQueryVariables = {
  filter?: ModelDiscoveryCallParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDiscoveryCallParticipantsQuery = {
  listDiscoveryCallParticipants?:  {
    __typename: "ModelDiscoveryCallParticipantConnection",
    items:  Array< {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscoveryCallParticipationByEmailQueryVariables = {
  email?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDiscoveryCallParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDiscoveryCallParticipationByEmailQuery = {
  listDiscoveryCallParticipationByEmail?:  {
    __typename: "ModelDiscoveryCallParticipantConnection",
    items:  Array< {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscoveryCallParticipationByPhoneNumberQueryVariables = {
  phoneNumber?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDiscoveryCallParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDiscoveryCallParticipationByPhoneNumberQuery = {
  listDiscoveryCallParticipationByPhoneNumber?:  {
    __typename: "ModelDiscoveryCallParticipantConnection",
    items:  Array< {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscoveryCallParticipationByAuthAccountQueryVariables = {
  authAccountID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDiscoveryCallParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDiscoveryCallParticipationByAuthAccountQuery = {
  listDiscoveryCallParticipationByAuthAccount?:  {
    __typename: "ModelDiscoveryCallParticipantConnection",
    items:  Array< {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscoveryCallParticipationByFundraisingProfileQueryVariables = {
  fundraisingProfileID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDiscoveryCallParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDiscoveryCallParticipationByFundraisingProfileQuery = {
  listDiscoveryCallParticipationByFundraisingProfile?:  {
    __typename: "ModelDiscoveryCallParticipantConnection",
    items:  Array< {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscoveryCallParticipationByDiscoveryCallQueryVariables = {
  fundraisingCampaignDiscoveryCallID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDiscoveryCallParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDiscoveryCallParticipationByDiscoveryCallQuery = {
  listDiscoveryCallParticipationByDiscoveryCall?:  {
    __typename: "ModelDiscoveryCallParticipantConnection",
    items:  Array< {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListDiscoveryCallParticipationByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDiscoveryCallParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDiscoveryCallParticipationByFundraisingCampaignQuery = {
  listDiscoveryCallParticipationByFundraisingCampaign?:  {
    __typename: "ModelDiscoveryCallParticipantConnection",
    items:  Array< {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingCampaignAmbassadorQueryVariables = {
  id: string,
};

export type GetFundraisingCampaignAmbassadorQuery = {
  getFundraisingCampaignAmbassador?:  {
    __typename: "FundraisingCampaignAmbassador",
    id: string,
    status?: FundraisingCampaignAmbassadorStatus | null,
    commitment?: FundraisingCampaignAmbassadorCommitment | null,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    discoveryCallParticipantID?: string | null,
    fundsRaised?: number | null,
    initialTransactionID?: string | null,
    initialTransactionAmount?: number | null,
    ambassadorSpecificCtaUrl?: string | null,
    ambassadorSpecificVideoUrl?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    classyTeamID?: string | null,
    classySupporterID?: string | null,
    classyFundraiserPageID?: string | null,
    notificationsEnabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassadorContacts?:  {
      __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassadorContact",
        id: string,
        deviceContactID: string,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        sentText?: boolean | null,
        sentTextTimestamp?: string | null,
        sentInitialTextReminder?: boolean | null,
        sentInitialTextReminderTimestamp?: string | null,
        sentPhoneCallScript?: boolean | null,
        sentPhoneCallScriptTimestamp?: string | null,
        called?: boolean | null,
        calledTimestamp?: string | null,
        sentFollowUp?: boolean | null,
        sentFollowUpTimestamp?: string | null,
        followUpResponse?: FollowUpResponse | null,
        sentReminder?: boolean | null,
        sentReminderTimestamp?: string | null,
        isDonating?: boolean | null,
        donationAmount?: number | null,
        discoveryCallParticipantID?: string | null,
        transactionID?: string | null,
        isActive?: boolean | null,
        notes?: string | null,
        birthday?: string | null,
        hasTakenAction?: boolean | null,
        hasTakenActionTimestamp?: string | null,
        occupation?: string | null,
        selectedPhoneNumberArrayIndex?: number | null,
        actionMessages?:  {
          __typename: "ModelActionMessageConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListFundraisingCampaignAmbassadorsQueryVariables = {
  filter?: ModelFundraisingCampaignAmbassadorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignAmbassadorsQuery = {
  listFundraisingCampaignAmbassadors?:  {
    __typename: "ModelFundraisingCampaignAmbassadorConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFundraisingCampaignAmbassadorsByFundraisingProfileQueryVariables = {
  fundraisingProfileID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignAmbassadorsByFundraisingProfileQuery = {
  listFundraisingCampaignAmbassadorsByFundraisingProfile?:  {
    __typename: "ModelFundraisingCampaignAmbassadorConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFundraisingCampaignAmbassadorsByCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignAmbassadorsByCampaignQuery = {
  listFundraisingCampaignAmbassadorsByCampaign?:  {
    __typename: "ModelFundraisingCampaignAmbassadorConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingCampaignAmbassadorByFundraisingProfileAndFundraisingCampaignQueryVariables = {
  fundraisingProfileID?: string | null,
  fundraisingCampaignID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetFundraisingCampaignAmbassadorByFundraisingProfileAndFundraisingCampaignQuery = {
  getFundraisingCampaignAmbassadorByFundraisingProfileAndFundraisingCampaign?:  {
    __typename: "ModelFundraisingCampaignAmbassadorConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingCampaignAmbassadorContactQueryVariables = {
  id: string,
};

export type GetFundraisingCampaignAmbassadorContactQuery = {
  getFundraisingCampaignAmbassadorContact?:  {
    __typename: "FundraisingCampaignAmbassadorContact",
    id: string,
    deviceContactID: string,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    sentText?: boolean | null,
    sentTextTimestamp?: string | null,
    sentInitialTextReminder?: boolean | null,
    sentInitialTextReminderTimestamp?: string | null,
    sentPhoneCallScript?: boolean | null,
    sentPhoneCallScriptTimestamp?: string | null,
    called?: boolean | null,
    calledTimestamp?: string | null,
    sentFollowUp?: boolean | null,
    sentFollowUpTimestamp?: string | null,
    followUpResponse?: FollowUpResponse | null,
    sentReminder?: boolean | null,
    sentReminderTimestamp?: string | null,
    isDonating?: boolean | null,
    donationAmount?: number | null,
    discoveryCallParticipantID?: string | null,
    transactionID?: string | null,
    isActive?: boolean | null,
    notes?: string | null,
    birthday?: string | null,
    hasTakenAction?: boolean | null,
    hasTakenActionTimestamp?: string | null,
    occupation?: string | null,
    selectedPhoneNumberArrayIndex?: number | null,
    actionMessages?:  {
      __typename: "ModelActionMessageConnection",
      items:  Array< {
        __typename: "ActionMessage",
        id: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        fundraisingCampaignAmbassadorContactID: string,
        actionMessageDefinitionID: string,
        actionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sent?: boolean | null,
        sentTimestamp?: string | null,
        response?: ActionMessageResponseType | null,
        responseTimestamp?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type ListFundraisingCampaignAmbassadorContactsQueryVariables = {
  filter?: ModelFundraisingCampaignAmbassadorContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignAmbassadorContactsQuery = {
  listFundraisingCampaignAmbassadorContacts?:  {
    __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassadorContact",
      id: string,
      deviceContactID: string,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      sentText?: boolean | null,
      sentTextTimestamp?: string | null,
      sentInitialTextReminder?: boolean | null,
      sentInitialTextReminderTimestamp?: string | null,
      sentPhoneCallScript?: boolean | null,
      sentPhoneCallScriptTimestamp?: string | null,
      called?: boolean | null,
      calledTimestamp?: string | null,
      sentFollowUp?: boolean | null,
      sentFollowUpTimestamp?: string | null,
      followUpResponse?: FollowUpResponse | null,
      sentReminder?: boolean | null,
      sentReminderTimestamp?: string | null,
      isDonating?: boolean | null,
      donationAmount?: number | null,
      discoveryCallParticipantID?: string | null,
      transactionID?: string | null,
      isActive?: boolean | null,
      notes?: string | null,
      birthday?: string | null,
      hasTakenAction?: boolean | null,
      hasTakenActionTimestamp?: string | null,
      occupation?: string | null,
      selectedPhoneNumberArrayIndex?: number | null,
      actionMessages?:  {
        __typename: "ModelActionMessageConnection",
        items:  Array< {
          __typename: "ActionMessage",
          id: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          fundraisingCampaignAmbassadorContactID: string,
          actionMessageDefinitionID: string,
          sent?: boolean | null,
          sentTimestamp?: string | null,
          response?: ActionMessageResponseType | null,
          responseTimestamp?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListContactsByFundraisingProfileCampaignQueryVariables = {
  fundraisingProfileID?: string | null,
  fundraisingCampaignID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsByFundraisingProfileCampaignQuery = {
  listContactsByFundraisingProfileCampaign?:  {
    __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassadorContact",
      id: string,
      deviceContactID: string,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      sentText?: boolean | null,
      sentTextTimestamp?: string | null,
      sentInitialTextReminder?: boolean | null,
      sentInitialTextReminderTimestamp?: string | null,
      sentPhoneCallScript?: boolean | null,
      sentPhoneCallScriptTimestamp?: string | null,
      called?: boolean | null,
      calledTimestamp?: string | null,
      sentFollowUp?: boolean | null,
      sentFollowUpTimestamp?: string | null,
      followUpResponse?: FollowUpResponse | null,
      sentReminder?: boolean | null,
      sentReminderTimestamp?: string | null,
      isDonating?: boolean | null,
      donationAmount?: number | null,
      discoveryCallParticipantID?: string | null,
      transactionID?: string | null,
      isActive?: boolean | null,
      notes?: string | null,
      birthday?: string | null,
      hasTakenAction?: boolean | null,
      hasTakenActionTimestamp?: string | null,
      occupation?: string | null,
      selectedPhoneNumberArrayIndex?: number | null,
      actionMessages?:  {
        __typename: "ModelActionMessageConnection",
        items:  Array< {
          __typename: "ActionMessage",
          id: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          fundraisingCampaignAmbassadorContactID: string,
          actionMessageDefinitionID: string,
          sent?: boolean | null,
          sentTimestamp?: string | null,
          response?: ActionMessageResponseType | null,
          responseTimestamp?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListContactsByFundraisingCampaignAmbassadorQueryVariables = {
  fundraisingCampaignAmbassadorID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsByFundraisingCampaignAmbassadorQuery = {
  listContactsByFundraisingCampaignAmbassador?:  {
    __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassadorContact",
      id: string,
      deviceContactID: string,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      sentText?: boolean | null,
      sentTextTimestamp?: string | null,
      sentInitialTextReminder?: boolean | null,
      sentInitialTextReminderTimestamp?: string | null,
      sentPhoneCallScript?: boolean | null,
      sentPhoneCallScriptTimestamp?: string | null,
      called?: boolean | null,
      calledTimestamp?: string | null,
      sentFollowUp?: boolean | null,
      sentFollowUpTimestamp?: string | null,
      followUpResponse?: FollowUpResponse | null,
      sentReminder?: boolean | null,
      sentReminderTimestamp?: string | null,
      isDonating?: boolean | null,
      donationAmount?: number | null,
      discoveryCallParticipantID?: string | null,
      transactionID?: string | null,
      isActive?: boolean | null,
      notes?: string | null,
      birthday?: string | null,
      hasTakenAction?: boolean | null,
      hasTakenActionTimestamp?: string | null,
      occupation?: string | null,
      selectedPhoneNumberArrayIndex?: number | null,
      actionMessages?:  {
        __typename: "ModelActionMessageConnection",
        items:  Array< {
          __typename: "ActionMessage",
          id: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          fundraisingCampaignAmbassadorContactID: string,
          actionMessageDefinitionID: string,
          sent?: boolean | null,
          sentTimestamp?: string | null,
          response?: ActionMessageResponseType | null,
          responseTimestamp?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListContactsByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsByFundraisingCampaignQuery = {
  listContactsByFundraisingCampaign?:  {
    __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassadorContact",
      id: string,
      deviceContactID: string,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      sentText?: boolean | null,
      sentTextTimestamp?: string | null,
      sentInitialTextReminder?: boolean | null,
      sentInitialTextReminderTimestamp?: string | null,
      sentPhoneCallScript?: boolean | null,
      sentPhoneCallScriptTimestamp?: string | null,
      called?: boolean | null,
      calledTimestamp?: string | null,
      sentFollowUp?: boolean | null,
      sentFollowUpTimestamp?: string | null,
      followUpResponse?: FollowUpResponse | null,
      sentReminder?: boolean | null,
      sentReminderTimestamp?: string | null,
      isDonating?: boolean | null,
      donationAmount?: number | null,
      discoveryCallParticipantID?: string | null,
      transactionID?: string | null,
      isActive?: boolean | null,
      notes?: string | null,
      birthday?: string | null,
      hasTakenAction?: boolean | null,
      hasTakenActionTimestamp?: string | null,
      occupation?: string | null,
      selectedPhoneNumberArrayIndex?: number | null,
      actionMessages?:  {
        __typename: "ModelActionMessageConnection",
        items:  Array< {
          __typename: "ActionMessage",
          id: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          fundraisingCampaignAmbassadorContactID: string,
          actionMessageDefinitionID: string,
          sent?: boolean | null,
          sentTimestamp?: string | null,
          response?: ActionMessageResponseType | null,
          responseTimestamp?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListContactsByDeviceContactQueryVariables = {
  deviceContactID?: string | null,
  fundraisingCampaignAmbassadorID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsByDeviceContactQuery = {
  listContactsByDeviceContact?:  {
    __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassadorContact",
      id: string,
      deviceContactID: string,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      sentText?: boolean | null,
      sentTextTimestamp?: string | null,
      sentInitialTextReminder?: boolean | null,
      sentInitialTextReminderTimestamp?: string | null,
      sentPhoneCallScript?: boolean | null,
      sentPhoneCallScriptTimestamp?: string | null,
      called?: boolean | null,
      calledTimestamp?: string | null,
      sentFollowUp?: boolean | null,
      sentFollowUpTimestamp?: string | null,
      followUpResponse?: FollowUpResponse | null,
      sentReminder?: boolean | null,
      sentReminderTimestamp?: string | null,
      isDonating?: boolean | null,
      donationAmount?: number | null,
      discoveryCallParticipantID?: string | null,
      transactionID?: string | null,
      isActive?: boolean | null,
      notes?: string | null,
      birthday?: string | null,
      hasTakenAction?: boolean | null,
      hasTakenActionTimestamp?: string | null,
      occupation?: string | null,
      selectedPhoneNumberArrayIndex?: number | null,
      actionMessages?:  {
        __typename: "ModelActionMessageConnection",
        items:  Array< {
          __typename: "ActionMessage",
          id: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          fundraisingCampaignAmbassadorContactID: string,
          actionMessageDefinitionID: string,
          sent?: boolean | null,
          sentTimestamp?: string | null,
          response?: ActionMessageResponseType | null,
          responseTimestamp?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListContactsByInitialTextTimestampQueryVariables = {
  sentTextTimestamp?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsByInitialTextTimestampQuery = {
  listContactsByInitialTextTimestamp?:  {
    __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassadorContact",
      id: string,
      deviceContactID: string,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      sentText?: boolean | null,
      sentTextTimestamp?: string | null,
      sentInitialTextReminder?: boolean | null,
      sentInitialTextReminderTimestamp?: string | null,
      sentPhoneCallScript?: boolean | null,
      sentPhoneCallScriptTimestamp?: string | null,
      called?: boolean | null,
      calledTimestamp?: string | null,
      sentFollowUp?: boolean | null,
      sentFollowUpTimestamp?: string | null,
      followUpResponse?: FollowUpResponse | null,
      sentReminder?: boolean | null,
      sentReminderTimestamp?: string | null,
      isDonating?: boolean | null,
      donationAmount?: number | null,
      discoveryCallParticipantID?: string | null,
      transactionID?: string | null,
      isActive?: boolean | null,
      notes?: string | null,
      birthday?: string | null,
      hasTakenAction?: boolean | null,
      hasTakenActionTimestamp?: string | null,
      occupation?: string | null,
      selectedPhoneNumberArrayIndex?: number | null,
      actionMessages?:  {
        __typename: "ModelActionMessageConnection",
        items:  Array< {
          __typename: "ActionMessage",
          id: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          fundraisingCampaignAmbassadorContactID: string,
          actionMessageDefinitionID: string,
          sent?: boolean | null,
          sentTimestamp?: string | null,
          response?: ActionMessageResponseType | null,
          responseTimestamp?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListContactsByFollowUpMessageTimestampQueryVariables = {
  sentFollowUpTimestamp?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignAmbassadorContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsByFollowUpMessageTimestampQuery = {
  listContactsByFollowUpMessageTimestamp?:  {
    __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
    items:  Array< {
      __typename: "FundraisingCampaignAmbassadorContact",
      id: string,
      deviceContactID: string,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      fundraisingCampaignAmbassadorID: string,
      sentText?: boolean | null,
      sentTextTimestamp?: string | null,
      sentInitialTextReminder?: boolean | null,
      sentInitialTextReminderTimestamp?: string | null,
      sentPhoneCallScript?: boolean | null,
      sentPhoneCallScriptTimestamp?: string | null,
      called?: boolean | null,
      calledTimestamp?: string | null,
      sentFollowUp?: boolean | null,
      sentFollowUpTimestamp?: string | null,
      followUpResponse?: FollowUpResponse | null,
      sentReminder?: boolean | null,
      sentReminderTimestamp?: string | null,
      isDonating?: boolean | null,
      donationAmount?: number | null,
      discoveryCallParticipantID?: string | null,
      transactionID?: string | null,
      isActive?: boolean | null,
      notes?: string | null,
      birthday?: string | null,
      hasTakenAction?: boolean | null,
      hasTakenActionTimestamp?: string | null,
      occupation?: string | null,
      selectedPhoneNumberArrayIndex?: number | null,
      actionMessages?:  {
        __typename: "ModelActionMessageConnection",
        items:  Array< {
          __typename: "ActionMessage",
          id: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          fundraisingCampaignAmbassadorContactID: string,
          actionMessageDefinitionID: string,
          sent?: boolean | null,
          sentTimestamp?: string | null,
          response?: ActionMessageResponseType | null,
          responseTimestamp?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFundraisingCampaignUpdateQueryVariables = {
  id: string,
};

export type GetFundraisingCampaignUpdateQuery = {
  getFundraisingCampaignUpdate?:  {
    __typename: "FundraisingCampaignUpdate",
    id: string,
    fundraisingCampaignID: string,
    public: boolean,
    message?: string | null,
    assetsUploaded?: number | null,
    updateURL?: string | null,
    createdByStaffProfileID?: string | null,
    live: boolean,
    liveTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    createdByStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type ListFundraisingCampaignUpdatesQueryVariables = {
  filter?: ModelFundraisingCampaignUpdateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignUpdatesQuery = {
  listFundraisingCampaignUpdates?:  {
    __typename: "ModelFundraisingCampaignUpdateConnection",
    items:  Array< {
      __typename: "FundraisingCampaignUpdate",
      id: string,
      fundraisingCampaignID: string,
      public: boolean,
      message?: string | null,
      assetsUploaded?: number | null,
      updateURL?: string | null,
      createdByStaffProfileID?: string | null,
      live: boolean,
      liveTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
      createdByStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFundraisingCampaignUpdatesByFundraisingCampaignQueryVariables = {
  fundraisingCampaignID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFundraisingCampaignUpdateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFundraisingCampaignUpdatesByFundraisingCampaignQuery = {
  listFundraisingCampaignUpdatesByFundraisingCampaign?:  {
    __typename: "ModelFundraisingCampaignUpdateConnection",
    items:  Array< {
      __typename: "FundraisingCampaignUpdate",
      id: string,
      fundraisingCampaignID: string,
      public: boolean,
      message?: string | null,
      assetsUploaded?: number | null,
      updateURL?: string | null,
      createdByStaffProfileID?: string | null,
      live: boolean,
      liveTimestamp?: string | null,
      createdAt: string,
      updatedAt: string,
      createdByStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateVolunteerProfileSubscription = {
  onCreateVolunteerProfile?:  {
    __typename: "VolunteerProfile",
    id: string,
    authAccountID: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    gender?: GenderType | null,
    dateOfBirth?: string | null,
    streetAddress?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: number | null,
    website?: string | null,
    enneagram?: number | null,
    enneagramWing?: number | null,
    myersBriggs?: string | null,
    additionalInformation?: string | null,
    availabilityStringified?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    skills?:  {
      __typename: "ModelVolunteerSkillConnection",
      items:  Array< {
        __typename: "VolunteerSkill",
        id: string,
        skillID: string,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        skill?:  {
          __typename: "Skill",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    causes?:  {
      __typename: "ModelVolunteerCauseConnection",
      items:  Array< {
        __typename: "VolunteerCause",
        id: string,
        causeID: string,
        cause?:  {
          __typename: "Cause",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateVolunteerProfileSubscription = {
  onUpdateVolunteerProfile?:  {
    __typename: "VolunteerProfile",
    id: string,
    authAccountID: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    gender?: GenderType | null,
    dateOfBirth?: string | null,
    streetAddress?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: number | null,
    website?: string | null,
    enneagram?: number | null,
    enneagramWing?: number | null,
    myersBriggs?: string | null,
    additionalInformation?: string | null,
    availabilityStringified?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    skills?:  {
      __typename: "ModelVolunteerSkillConnection",
      items:  Array< {
        __typename: "VolunteerSkill",
        id: string,
        skillID: string,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        skill?:  {
          __typename: "Skill",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    causes?:  {
      __typename: "ModelVolunteerCauseConnection",
      items:  Array< {
        __typename: "VolunteerCause",
        id: string,
        causeID: string,
        cause?:  {
          __typename: "Cause",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteVolunteerProfileSubscription = {
  onDeleteVolunteerProfile?:  {
    __typename: "VolunteerProfile",
    id: string,
    authAccountID: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    gender?: GenderType | null,
    dateOfBirth?: string | null,
    streetAddress?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: number | null,
    website?: string | null,
    enneagram?: number | null,
    enneagramWing?: number | null,
    myersBriggs?: string | null,
    additionalInformation?: string | null,
    availabilityStringified?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    skills?:  {
      __typename: "ModelVolunteerSkillConnection",
      items:  Array< {
        __typename: "VolunteerSkill",
        id: string,
        skillID: string,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
        skill?:  {
          __typename: "Skill",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    causes?:  {
      __typename: "ModelVolunteerCauseConnection",
      items:  Array< {
        __typename: "VolunteerCause",
        id: string,
        causeID: string,
        cause?:  {
          __typename: "Cause",
          id: string,
          key: string,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateOrganizationInvitationSubscription = {
  onCreateOrganizationInvitation?:  {
    __typename: "OrganizationInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrganizationInvitationSubscription = {
  onUpdateOrganizationInvitation?:  {
    __typename: "OrganizationInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrganizationInvitationSubscription = {
  onDeleteOrganizationInvitation?:  {
    __typename: "OrganizationInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateVolunteerSkillSubscription = {
  onCreateVolunteerSkill?:  {
    __typename: "VolunteerSkill",
    id: string,
    skillID: string,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
    skill?:  {
      __typename: "Skill",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateVolunteerSkillSubscription = {
  onUpdateVolunteerSkill?:  {
    __typename: "VolunteerSkill",
    id: string,
    skillID: string,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
    skill?:  {
      __typename: "Skill",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteVolunteerSkillSubscription = {
  onDeleteVolunteerSkill?:  {
    __typename: "VolunteerSkill",
    id: string,
    skillID: string,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
    skill?:  {
      __typename: "Skill",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateCauseSubscription = {
  onCreateCause?:  {
    __typename: "Cause",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCauseSubscription = {
  onUpdateCause?:  {
    __typename: "Cause",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCauseSubscription = {
  onDeleteCause?:  {
    __typename: "Cause",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateVolunteerCauseSubscription = {
  onCreateVolunteerCause?:  {
    __typename: "VolunteerCause",
    id: string,
    causeID: string,
    cause?:  {
      __typename: "Cause",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateVolunteerCauseSubscription = {
  onUpdateVolunteerCause?:  {
    __typename: "VolunteerCause",
    id: string,
    causeID: string,
    cause?:  {
      __typename: "Cause",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteVolunteerCauseSubscription = {
  onDeleteVolunteerCause?:  {
    __typename: "VolunteerCause",
    id: string,
    causeID: string,
    cause?:  {
      __typename: "Cause",
      id: string,
      key: string,
      name: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    volunteerProfileID: string,
    volunteerProfile:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrganizationDetailsSubscription = {
  onCreateOrganizationDetails?:  {
    __typename: "OrganizationDetails",
    id: string,
    organizationID: string,
    missionStatement?: string | null,
    serveStatement?: string | null,
    doStatement?: string | null,
    costToDoStatement?: string | null,
    missionArea?: string | null,
    annualBudget?: string | null,
    currentMonthlyRecurringDonors?: string | null,
    averageMonthlyRecurringDonation?: string | null,
    percentageOfBudgetFromIndividualDonors?: string | null,
    numberOfMajorDonors?: string | null,
    averageOneTimeDonation?: string | null,
    percentageOfBudgetFromGrants?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrganizationDetailsSubscription = {
  onUpdateOrganizationDetails?:  {
    __typename: "OrganizationDetails",
    id: string,
    organizationID: string,
    missionStatement?: string | null,
    serveStatement?: string | null,
    doStatement?: string | null,
    costToDoStatement?: string | null,
    missionArea?: string | null,
    annualBudget?: string | null,
    currentMonthlyRecurringDonors?: string | null,
    averageMonthlyRecurringDonation?: string | null,
    percentageOfBudgetFromIndividualDonors?: string | null,
    numberOfMajorDonors?: string | null,
    averageOneTimeDonation?: string | null,
    percentageOfBudgetFromGrants?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrganizationDetailsSubscription = {
  onDeleteOrganizationDetails?:  {
    __typename: "OrganizationDetails",
    id: string,
    organizationID: string,
    missionStatement?: string | null,
    serveStatement?: string | null,
    doStatement?: string | null,
    costToDoStatement?: string | null,
    missionArea?: string | null,
    annualBudget?: string | null,
    currentMonthlyRecurringDonors?: string | null,
    averageMonthlyRecurringDonation?: string | null,
    percentageOfBudgetFromIndividualDonors?: string | null,
    numberOfMajorDonors?: string | null,
    averageOneTimeDonation?: string | null,
    percentageOfBudgetFromGrants?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProgramSubscription = {
  onCreateProgram?:  {
    __typename: "Program",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    theWhy?: string | null,
    leadID?: string | null,
    stringifiedCauses?: string | null,
    opportunities?:  {
      __typename: "ModelOpportunityConnection",
      items:  Array< {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    archived: boolean,
    createdAt: string,
    updatedAt: string,
    lead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateProgramSubscription = {
  onUpdateProgram?:  {
    __typename: "Program",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    theWhy?: string | null,
    leadID?: string | null,
    stringifiedCauses?: string | null,
    opportunities?:  {
      __typename: "ModelOpportunityConnection",
      items:  Array< {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    archived: boolean,
    createdAt: string,
    updatedAt: string,
    lead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteProgramSubscription = {
  onDeleteProgram?:  {
    __typename: "Program",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    theWhy?: string | null,
    leadID?: string | null,
    stringifiedCauses?: string | null,
    opportunities?:  {
      __typename: "ModelOpportunityConnection",
      items:  Array< {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    archived: boolean,
    createdAt: string,
    updatedAt: string,
    lead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateOpportunitySubscription = {
  onCreateOpportunity?:  {
    __typename: "Opportunity",
    id: string,
    organizationID: string,
    programID?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityLeadID: string,
    type?: OpportunityType | null,
    status: OpportunityStatus,
    startDate?: string | null,
    endDate?: string | null,
    startRecruitingDate?: string | null,
    headerImage?: string | null,
    title?: string | null,
    descriptionRTE?: string | null,
    theWhy?: string | null,
    expectedImpact?: string | null,
    whatWillHappen?: string | null,
    volunteerGain?: string | null,
    roles?:  {
      __typename: "ModelRoleConnection",
      items:  Array< {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    application?:  {
      __typename: "ModelApplicationConnection",
      items:  Array< {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    opportunityLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateOpportunitySubscription = {
  onUpdateOpportunity?:  {
    __typename: "Opportunity",
    id: string,
    organizationID: string,
    programID?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityLeadID: string,
    type?: OpportunityType | null,
    status: OpportunityStatus,
    startDate?: string | null,
    endDate?: string | null,
    startRecruitingDate?: string | null,
    headerImage?: string | null,
    title?: string | null,
    descriptionRTE?: string | null,
    theWhy?: string | null,
    expectedImpact?: string | null,
    whatWillHappen?: string | null,
    volunteerGain?: string | null,
    roles?:  {
      __typename: "ModelRoleConnection",
      items:  Array< {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    application?:  {
      __typename: "ModelApplicationConnection",
      items:  Array< {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    opportunityLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteOpportunitySubscription = {
  onDeleteOpportunity?:  {
    __typename: "Opportunity",
    id: string,
    organizationID: string,
    programID?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      organizationID: string,
      name: string,
      description?: string | null,
      theWhy?: string | null,
      leadID?: string | null,
      stringifiedCauses?: string | null,
      opportunities?:  {
        __typename: "ModelOpportunityConnection",
        items:  Array< {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      archived: boolean,
      createdAt: string,
      updatedAt: string,
      lead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityLeadID: string,
    type?: OpportunityType | null,
    status: OpportunityStatus,
    startDate?: string | null,
    endDate?: string | null,
    startRecruitingDate?: string | null,
    headerImage?: string | null,
    title?: string | null,
    descriptionRTE?: string | null,
    theWhy?: string | null,
    expectedImpact?: string | null,
    whatWillHappen?: string | null,
    volunteerGain?: string | null,
    roles?:  {
      __typename: "ModelRoleConnection",
      items:  Array< {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    application?:  {
      __typename: "ModelApplicationConnection",
      items:  Array< {
        __typename: "Application",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        screeningCallRequired?: ScreeningCallRequiredOptions | null,
        signUpOnly?: boolean | null,
        requireScreeningCall?: boolean | null,
        requireBackgroundCheck?: boolean | null,
        recruitmentDeadlineForVolunteers?: string | null,
        targetNumberOfVolunteerHours?: number | null,
        minimumNumberOfVolunteersRequired?: number | null,
        customApplicationQuestions?:  {
          __typename: "ModelCustomApplicationQuestionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    opportunityLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateApplicationSubscription = {
  onCreateApplication?:  {
    __typename: "Application",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    screeningCallRequired?: ScreeningCallRequiredOptions | null,
    signUpOnly?: boolean | null,
    requireScreeningCall?: boolean | null,
    requireBackgroundCheck?: boolean | null,
    recruitmentDeadlineForVolunteers?: string | null,
    targetNumberOfVolunteerHours?: number | null,
    minimumNumberOfVolunteersRequired?: number | null,
    customApplicationQuestions?:  {
      __typename: "ModelCustomApplicationQuestionConnection",
      items:  Array< {
        __typename: "CustomApplicationQuestion",
        id: string,
        applicationID: string,
        application?:  {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        questionText: string,
        questionType: string,
        required: boolean,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateApplicationSubscription = {
  onUpdateApplication?:  {
    __typename: "Application",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    screeningCallRequired?: ScreeningCallRequiredOptions | null,
    signUpOnly?: boolean | null,
    requireScreeningCall?: boolean | null,
    requireBackgroundCheck?: boolean | null,
    recruitmentDeadlineForVolunteers?: string | null,
    targetNumberOfVolunteerHours?: number | null,
    minimumNumberOfVolunteersRequired?: number | null,
    customApplicationQuestions?:  {
      __typename: "ModelCustomApplicationQuestionConnection",
      items:  Array< {
        __typename: "CustomApplicationQuestion",
        id: string,
        applicationID: string,
        application?:  {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        questionText: string,
        questionType: string,
        required: boolean,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteApplicationSubscription = {
  onDeleteApplication?:  {
    __typename: "Application",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    screeningCallRequired?: ScreeningCallRequiredOptions | null,
    signUpOnly?: boolean | null,
    requireScreeningCall?: boolean | null,
    requireBackgroundCheck?: boolean | null,
    recruitmentDeadlineForVolunteers?: string | null,
    targetNumberOfVolunteerHours?: number | null,
    minimumNumberOfVolunteersRequired?: number | null,
    customApplicationQuestions?:  {
      __typename: "ModelCustomApplicationQuestionConnection",
      items:  Array< {
        __typename: "CustomApplicationQuestion",
        id: string,
        applicationID: string,
        application?:  {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        questionText: string,
        questionType: string,
        required: boolean,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCustomApplicationQuestionSubscription = {
  onCreateCustomApplicationQuestion?:  {
    __typename: "CustomApplicationQuestion",
    id: string,
    applicationID: string,
    application?:  {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    questionText: string,
    questionType: string,
    required: boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCustomApplicationQuestionSubscription = {
  onUpdateCustomApplicationQuestion?:  {
    __typename: "CustomApplicationQuestion",
    id: string,
    applicationID: string,
    application?:  {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    questionText: string,
    questionType: string,
    required: boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCustomApplicationQuestionSubscription = {
  onDeleteCustomApplicationQuestion?:  {
    __typename: "CustomApplicationQuestion",
    id: string,
    applicationID: string,
    application?:  {
      __typename: "Application",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      screeningCallRequired?: ScreeningCallRequiredOptions | null,
      signUpOnly?: boolean | null,
      requireScreeningCall?: boolean | null,
      requireBackgroundCheck?: boolean | null,
      recruitmentDeadlineForVolunteers?: string | null,
      targetNumberOfVolunteerHours?: number | null,
      minimumNumberOfVolunteersRequired?: number | null,
      customApplicationQuestions?:  {
        __typename: "ModelCustomApplicationQuestionConnection",
        items:  Array< {
          __typename: "CustomApplicationQuestion",
          id: string,
          applicationID: string,
          questionText: string,
          questionType: string,
          required: boolean,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    questionText: string,
    questionType: string,
    required: boolean,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRoleSubscription = {
  onCreateRole?:  {
    __typename: "Role",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    roleTitle: string,
    opportunityTitle?: string | null,
    live?: boolean | null,
    roleCoordinatorID?: string | null,
    recurrence?: RoleRecurrence | null,
    weeklyRecurrenceDays?: string | null,
    weeklyRecurrenceSameVolunteers?: boolean | null,
    volunteersPerShift?: number | null,
    differentNumberOfVolunteersPerShift?: boolean | null,
    volunteerCommitmentMonths?: number | null,
    volunteerCommitmentCanRenew?: boolean | null,
    roleRequirements?: string | null,
    ageRequirement?: string | null,
    minorsRequireSupervision?: boolean | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    stringifiedSkills?: string | null,
    stringifiedSkillsJSON?: string | null,
    stringifiedCertifications?: string | null,
    shifts?:  {
      __typename: "ModelShiftConnection",
      items:  Array< {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    roleCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateRoleSubscription = {
  onUpdateRole?:  {
    __typename: "Role",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    roleTitle: string,
    opportunityTitle?: string | null,
    live?: boolean | null,
    roleCoordinatorID?: string | null,
    recurrence?: RoleRecurrence | null,
    weeklyRecurrenceDays?: string | null,
    weeklyRecurrenceSameVolunteers?: boolean | null,
    volunteersPerShift?: number | null,
    differentNumberOfVolunteersPerShift?: boolean | null,
    volunteerCommitmentMonths?: number | null,
    volunteerCommitmentCanRenew?: boolean | null,
    roleRequirements?: string | null,
    ageRequirement?: string | null,
    minorsRequireSupervision?: boolean | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    stringifiedSkills?: string | null,
    stringifiedSkillsJSON?: string | null,
    stringifiedCertifications?: string | null,
    shifts?:  {
      __typename: "ModelShiftConnection",
      items:  Array< {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    roleCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteRoleSubscription = {
  onDeleteRole?:  {
    __typename: "Role",
    id: string,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    roleTitle: string,
    opportunityTitle?: string | null,
    live?: boolean | null,
    roleCoordinatorID?: string | null,
    recurrence?: RoleRecurrence | null,
    weeklyRecurrenceDays?: string | null,
    weeklyRecurrenceSameVolunteers?: boolean | null,
    volunteersPerShift?: number | null,
    differentNumberOfVolunteersPerShift?: boolean | null,
    volunteerCommitmentMonths?: number | null,
    volunteerCommitmentCanRenew?: boolean | null,
    roleRequirements?: string | null,
    ageRequirement?: string | null,
    minorsRequireSupervision?: boolean | null,
    stringifiedCauses?: string | null,
    stringifiedCausesJSON?: string | null,
    stringifiedSkills?: string | null,
    stringifiedSkillsJSON?: string | null,
    stringifiedCertifications?: string | null,
    shifts?:  {
      __typename: "ModelShiftConnection",
      items:  Array< {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    roleCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateShiftSubscription = {
  onCreateShift?:  {
    __typename: "Shift",
    id: string,
    type: ShiftType,
    live?: boolean | null,
    name?: string | null,
    summary?: string | null,
    startDate?: string | null,
    startTime?: string | null,
    endDate?: string | null,
    endTime?: string | null,
    timezone?: string | null,
    timeFrame?: TimeFrame | null,
    timeFrameString?: string | null,
    recurrence?: ShiftRecurrence | null,
    weeklyRecurringDay?: string | null,
    monthlyRecurrenceWeek?: string | null,
    monthlyRecurrenceDay?: string | null,
    flexibleHours?: number | null,
    flexibleTimePeriod?: string | null,
    volunteersNeeded?: number | null,
    volunteerCoordinatorID?: string | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleStringifiedSkills?: string | null,
    roleStringifiedCauses?: string | null,
    locationID?: string | null,
    locationLongitude?: number | null,
    locationLatitude?: number | null,
    locationType?: LocationType | null,
    locationZipEstimate?: number | null,
    locationVariousDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    volunteerCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateShiftSubscription = {
  onUpdateShift?:  {
    __typename: "Shift",
    id: string,
    type: ShiftType,
    live?: boolean | null,
    name?: string | null,
    summary?: string | null,
    startDate?: string | null,
    startTime?: string | null,
    endDate?: string | null,
    endTime?: string | null,
    timezone?: string | null,
    timeFrame?: TimeFrame | null,
    timeFrameString?: string | null,
    recurrence?: ShiftRecurrence | null,
    weeklyRecurringDay?: string | null,
    monthlyRecurrenceWeek?: string | null,
    monthlyRecurrenceDay?: string | null,
    flexibleHours?: number | null,
    flexibleTimePeriod?: string | null,
    volunteersNeeded?: number | null,
    volunteerCoordinatorID?: string | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleStringifiedSkills?: string | null,
    roleStringifiedCauses?: string | null,
    locationID?: string | null,
    locationLongitude?: number | null,
    locationLatitude?: number | null,
    locationType?: LocationType | null,
    locationZipEstimate?: number | null,
    locationVariousDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    volunteerCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteShiftSubscription = {
  onDeleteShift?:  {
    __typename: "Shift",
    id: string,
    type: ShiftType,
    live?: boolean | null,
    name?: string | null,
    summary?: string | null,
    startDate?: string | null,
    startTime?: string | null,
    endDate?: string | null,
    endTime?: string | null,
    timezone?: string | null,
    timeFrame?: TimeFrame | null,
    timeFrameString?: string | null,
    recurrence?: ShiftRecurrence | null,
    weeklyRecurringDay?: string | null,
    monthlyRecurrenceWeek?: string | null,
    monthlyRecurrenceDay?: string | null,
    flexibleHours?: number | null,
    flexibleTimePeriod?: string | null,
    volunteersNeeded?: number | null,
    volunteerCoordinatorID?: string | null,
    roleID?: string | null,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleStringifiedSkills?: string | null,
    roleStringifiedCauses?: string | null,
    locationID?: string | null,
    locationLongitude?: number | null,
    locationLatitude?: number | null,
    locationType?: LocationType | null,
    locationZipEstimate?: number | null,
    locationVariousDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    volunteerCoordinator?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateOpportunityTemplateSubscription = {
  onCreateOpportunityTemplate?:  {
    __typename: "OpportunityTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateOpportunityTemplateSubscription = {
  onUpdateOpportunityTemplate?:  {
    __typename: "OpportunityTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteOpportunityTemplateSubscription = {
  onDeleteOpportunityTemplate?:  {
    __typename: "OpportunityTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateRoleTemplateSubscription = {
  onCreateRoleTemplate?:  {
    __typename: "RoleTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateRoleTemplateSubscription = {
  onUpdateRoleTemplate?:  {
    __typename: "RoleTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteRoleTemplateSubscription = {
  onDeleteRoleTemplate?:  {
    __typename: "RoleTemplate",
    id: string,
    organizationID: string,
    name: string,
    description?: string | null,
    templateJSON: string,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateOrganizationGroupSubscription = {
  onCreateOrganizationGroup?:  {
    __typename: "OrganizationGroup",
    id: string,
    organizationID: string,
    groupName: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrganizationGroupSubscription = {
  onUpdateOrganizationGroup?:  {
    __typename: "OrganizationGroup",
    id: string,
    organizationID: string,
    groupName: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrganizationGroupSubscription = {
  onDeleteOrganizationGroup?:  {
    __typename: "OrganizationGroup",
    id: string,
    organizationID: string,
    groupName: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrganizationVolunteerSubscription = {
  onCreateOrganizationVolunteer?:  {
    __typename: "OrganizationVolunteer",
    id: string,
    organizationID: string,
    volunteerProfileID: string,
    status: OrganizationVolunteerStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrganizationVolunteerSubscription = {
  onUpdateOrganizationVolunteer?:  {
    __typename: "OrganizationVolunteer",
    id: string,
    organizationID: string,
    volunteerProfileID: string,
    status: OrganizationVolunteerStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrganizationVolunteerSubscription = {
  onDeleteOrganizationVolunteer?:  {
    __typename: "OrganizationVolunteer",
    id: string,
    organizationID: string,
    volunteerProfileID: string,
    status: OrganizationVolunteerStatus,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrganizationGroupVolunteerSubscription = {
  onCreateOrganizationGroupVolunteer?:  {
    __typename: "OrganizationGroupVolunteer",
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrganizationGroupVolunteerSubscription = {
  onUpdateOrganizationGroupVolunteer?:  {
    __typename: "OrganizationGroupVolunteer",
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrganizationGroupVolunteerSubscription = {
  onDeleteOrganizationGroupVolunteer?:  {
    __typename: "OrganizationGroupVolunteer",
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTimeCommitmentSubscription = {
  onCreateTimeCommitment?:  {
    __typename: "TimeCommitment",
    id: string,
    amount: number,
    units: TimeUnitType,
    period: TimePeriodType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTimeCommitmentSubscription = {
  onUpdateTimeCommitment?:  {
    __typename: "TimeCommitment",
    id: string,
    amount: number,
    units: TimeUnitType,
    period: TimePeriodType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTimeCommitmentSubscription = {
  onDeleteTimeCommitment?:  {
    __typename: "TimeCommitment",
    id: string,
    amount: number,
    units: TimeUnitType,
    period: TimePeriodType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateVolunteerMatchRequestSubscription = {
  onCreateVolunteerMatchRequest?:  {
    __typename: "VolunteerMatchRequest",
    id: string,
    status: VolunteerMatchRequestStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleRequestedID?: string | null,
    roleRequested?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    volunteerComments?: string | null,
    administrativeNotes?: string | null,
    scheduledCallID?: string | null,
    scheduledCall?:  {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleAssignedID?: string | null,
    roleAssigned?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    assignmentID?: string | null,
    assignment?:  {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    organizationRejectionReason?: string | null,
    volunteerRejectionReason?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateVolunteerMatchRequestSubscription = {
  onUpdateVolunteerMatchRequest?:  {
    __typename: "VolunteerMatchRequest",
    id: string,
    status: VolunteerMatchRequestStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleRequestedID?: string | null,
    roleRequested?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    volunteerComments?: string | null,
    administrativeNotes?: string | null,
    scheduledCallID?: string | null,
    scheduledCall?:  {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleAssignedID?: string | null,
    roleAssigned?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    assignmentID?: string | null,
    assignment?:  {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    organizationRejectionReason?: string | null,
    volunteerRejectionReason?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteVolunteerMatchRequestSubscription = {
  onDeleteVolunteerMatchRequest?:  {
    __typename: "VolunteerMatchRequest",
    id: string,
    status: VolunteerMatchRequestStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleRequestedID?: string | null,
    roleRequested?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    volunteerComments?: string | null,
    administrativeNotes?: string | null,
    scheduledCallID?: string | null,
    scheduledCall?:  {
      __typename: "ScheduledCall",
      id: string,
      status: ScheduledCallStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      startTime?: string | null,
      duration?: number | null,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleAssignedID?: string | null,
    roleAssigned?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    assignmentID?: string | null,
    assignment?:  {
      __typename: "Assignment",
      id: string,
      status: AssignmentStatusType,
      volunteerMatchRequestID: string,
      volunteerMatchRequest?:  {
        __typename: "VolunteerMatchRequest",
        id: string,
        status: VolunteerMatchRequestStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleRequestedID?: string | null,
        roleRequested?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        volunteerComments?: string | null,
        administrativeNotes?: string | null,
        scheduledCallID?: string | null,
        scheduledCall?:  {
          __typename: "ScheduledCall",
          id: string,
          status: ScheduledCallStatus,
          volunteerProfileID: string,
          organizationID: string,
          startTime?: string | null,
          duration?: number | null,
          details?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleAssignedID?: string | null,
        roleAssigned?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignmentID?: string | null,
        assignment?:  {
          __typename: "Assignment",
          id: string,
          status: AssignmentStatusType,
          volunteerMatchRequestID: string,
          roleID: string,
          shiftID: string,
          volunteerProfileID: string,
          opportunityID: string,
          administrativeNotes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationRejectionReason?: string | null,
        volunteerRejectionReason?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleID: string,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      shiftID: string,
      shift?:  {
        __typename: "Shift",
        id: string,
        type: ShiftType,
        live?: boolean | null,
        name?: string | null,
        summary?: string | null,
        startDate?: string | null,
        startTime?: string | null,
        endDate?: string | null,
        endTime?: string | null,
        timezone?: string | null,
        timeFrame?: TimeFrame | null,
        timeFrameString?: string | null,
        recurrence?: ShiftRecurrence | null,
        weeklyRecurringDay?: string | null,
        monthlyRecurrenceWeek?: string | null,
        monthlyRecurrenceDay?: string | null,
        flexibleHours?: number | null,
        flexibleTimePeriod?: string | null,
        volunteersNeeded?: number | null,
        volunteerCoordinatorID?: string | null,
        roleID?: string | null,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleStringifiedSkills?: string | null,
        roleStringifiedCauses?: string | null,
        locationID?: string | null,
        locationLongitude?: number | null,
        locationLatitude?: number | null,
        locationType?: LocationType | null,
        locationZipEstimate?: number | null,
        locationVariousDescription?: string | null,
        createdAt: string,
        updatedAt: string,
        volunteerCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      administrativeNotes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    organizationRejectionReason?: string | null,
    volunteerRejectionReason?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateScheduledCallSubscription = {
  onCreateScheduledCall?:  {
    __typename: "ScheduledCall",
    id: string,
    status: ScheduledCallStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    startTime?: string | null,
    duration?: number | null,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateScheduledCallSubscription = {
  onUpdateScheduledCall?:  {
    __typename: "ScheduledCall",
    id: string,
    status: ScheduledCallStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    startTime?: string | null,
    duration?: number | null,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteScheduledCallSubscription = {
  onDeleteScheduledCall?:  {
    __typename: "ScheduledCall",
    id: string,
    status: ScheduledCallStatus,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organizationID: string,
    startTime?: string | null,
    duration?: number | null,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateAssignmentSubscription = {
  onCreateAssignment?:  {
    __typename: "Assignment",
    id: string,
    status: AssignmentStatusType,
    volunteerMatchRequestID: string,
    volunteerMatchRequest?:  {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID: string,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    shiftID: string,
    shift?:  {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    administrativeNotes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAssignmentSubscription = {
  onUpdateAssignment?:  {
    __typename: "Assignment",
    id: string,
    status: AssignmentStatusType,
    volunteerMatchRequestID: string,
    volunteerMatchRequest?:  {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID: string,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    shiftID: string,
    shift?:  {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    administrativeNotes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAssignmentSubscription = {
  onDeleteAssignment?:  {
    __typename: "Assignment",
    id: string,
    status: AssignmentStatusType,
    volunteerMatchRequestID: string,
    volunteerMatchRequest?:  {
      __typename: "VolunteerMatchRequest",
      id: string,
      status: VolunteerMatchRequestStatus,
      volunteerProfileID: string,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleRequestedID?: string | null,
      roleRequested?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      volunteerComments?: string | null,
      administrativeNotes?: string | null,
      scheduledCallID?: string | null,
      scheduledCall?:  {
        __typename: "ScheduledCall",
        id: string,
        status: ScheduledCallStatus,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        startTime?: string | null,
        duration?: number | null,
        details?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleAssignedID?: string | null,
      roleAssigned?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      assignmentID?: string | null,
      assignment?:  {
        __typename: "Assignment",
        id: string,
        status: AssignmentStatusType,
        volunteerMatchRequestID: string,
        volunteerMatchRequest?:  {
          __typename: "VolunteerMatchRequest",
          id: string,
          status: VolunteerMatchRequestStatus,
          volunteerProfileID: string,
          opportunityID: string,
          roleRequestedID?: string | null,
          organizationID: string,
          volunteerComments?: string | null,
          administrativeNotes?: string | null,
          scheduledCallID?: string | null,
          roleAssignedID?: string | null,
          assignmentID?: string | null,
          organizationRejectionReason?: string | null,
          volunteerRejectionReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        roleID: string,
        role?:  {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        shiftID: string,
        shift?:  {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        volunteerProfileID: string,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        administrativeNotes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      organizationRejectionReason?: string | null,
      volunteerRejectionReason?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    roleID: string,
    role?:  {
      __typename: "Role",
      id: string,
      opportunityID: string,
      opportunity?:  {
        __typename: "Opportunity",
        id: string,
        organizationID: string,
        programID?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          organizationID: string,
          name: string,
          description?: string | null,
          theWhy?: string | null,
          leadID?: string | null,
          stringifiedCauses?: string | null,
          archived: boolean,
          createdAt: string,
          updatedAt: string,
        } | null,
        opportunityLeadID: string,
        type?: OpportunityType | null,
        status: OpportunityStatus,
        startDate?: string | null,
        endDate?: string | null,
        startRecruitingDate?: string | null,
        headerImage?: string | null,
        title?: string | null,
        descriptionRTE?: string | null,
        theWhy?: string | null,
        expectedImpact?: string | null,
        whatWillHappen?: string | null,
        volunteerGain?: string | null,
        roles?:  {
          __typename: "ModelRoleConnection",
          nextToken?: string | null,
        } | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        application?:  {
          __typename: "ModelApplicationConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        opportunityLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organizationID: string,
      roleTitle: string,
      opportunityTitle?: string | null,
      live?: boolean | null,
      roleCoordinatorID?: string | null,
      recurrence?: RoleRecurrence | null,
      weeklyRecurrenceDays?: string | null,
      weeklyRecurrenceSameVolunteers?: boolean | null,
      volunteersPerShift?: number | null,
      differentNumberOfVolunteersPerShift?: boolean | null,
      volunteerCommitmentMonths?: number | null,
      volunteerCommitmentCanRenew?: boolean | null,
      roleRequirements?: string | null,
      ageRequirement?: string | null,
      minorsRequireSupervision?: boolean | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      stringifiedSkills?: string | null,
      stringifiedSkillsJSON?: string | null,
      stringifiedCertifications?: string | null,
      shifts?:  {
        __typename: "ModelShiftConnection",
        items:  Array< {
          __typename: "Shift",
          id: string,
          type: ShiftType,
          live?: boolean | null,
          name?: string | null,
          summary?: string | null,
          startDate?: string | null,
          startTime?: string | null,
          endDate?: string | null,
          endTime?: string | null,
          timezone?: string | null,
          timeFrame?: TimeFrame | null,
          timeFrameString?: string | null,
          recurrence?: ShiftRecurrence | null,
          weeklyRecurringDay?: string | null,
          monthlyRecurrenceWeek?: string | null,
          monthlyRecurrenceDay?: string | null,
          flexibleHours?: number | null,
          flexibleTimePeriod?: string | null,
          volunteersNeeded?: number | null,
          volunteerCoordinatorID?: string | null,
          roleID?: string | null,
          roleStringifiedSkills?: string | null,
          roleStringifiedCauses?: string | null,
          locationID?: string | null,
          locationLongitude?: number | null,
          locationLatitude?: number | null,
          locationType?: LocationType | null,
          locationZipEstimate?: number | null,
          locationVariousDescription?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      roleCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    shiftID: string,
    shift?:  {
      __typename: "Shift",
      id: string,
      type: ShiftType,
      live?: boolean | null,
      name?: string | null,
      summary?: string | null,
      startDate?: string | null,
      startTime?: string | null,
      endDate?: string | null,
      endTime?: string | null,
      timezone?: string | null,
      timeFrame?: TimeFrame | null,
      timeFrameString?: string | null,
      recurrence?: ShiftRecurrence | null,
      weeklyRecurringDay?: string | null,
      monthlyRecurrenceWeek?: string | null,
      monthlyRecurrenceDay?: string | null,
      flexibleHours?: number | null,
      flexibleTimePeriod?: string | null,
      volunteersNeeded?: number | null,
      volunteerCoordinatorID?: string | null,
      roleID?: string | null,
      role?:  {
        __typename: "Role",
        id: string,
        opportunityID: string,
        opportunity?:  {
          __typename: "Opportunity",
          id: string,
          organizationID: string,
          programID?: string | null,
          opportunityLeadID: string,
          type?: OpportunityType | null,
          status: OpportunityStatus,
          startDate?: string | null,
          endDate?: string | null,
          startRecruitingDate?: string | null,
          headerImage?: string | null,
          title?: string | null,
          descriptionRTE?: string | null,
          theWhy?: string | null,
          expectedImpact?: string | null,
          whatWillHappen?: string | null,
          volunteerGain?: string | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        organizationID: string,
        roleTitle: string,
        opportunityTitle?: string | null,
        live?: boolean | null,
        roleCoordinatorID?: string | null,
        recurrence?: RoleRecurrence | null,
        weeklyRecurrenceDays?: string | null,
        weeklyRecurrenceSameVolunteers?: boolean | null,
        volunteersPerShift?: number | null,
        differentNumberOfVolunteersPerShift?: boolean | null,
        volunteerCommitmentMonths?: number | null,
        volunteerCommitmentCanRenew?: boolean | null,
        roleRequirements?: string | null,
        ageRequirement?: string | null,
        minorsRequireSupervision?: boolean | null,
        stringifiedCauses?: string | null,
        stringifiedCausesJSON?: string | null,
        stringifiedSkills?: string | null,
        stringifiedSkillsJSON?: string | null,
        stringifiedCertifications?: string | null,
        shifts?:  {
          __typename: "ModelShiftConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        roleCoordinator?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      roleStringifiedSkills?: string | null,
      roleStringifiedCauses?: string | null,
      locationID?: string | null,
      locationLongitude?: number | null,
      locationLatitude?: number | null,
      locationType?: LocationType | null,
      locationZipEstimate?: number | null,
      locationVariousDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      volunteerCoordinator?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    volunteerProfileID: string,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    opportunityID: string,
    opportunity?:  {
      __typename: "Opportunity",
      id: string,
      organizationID: string,
      programID?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        organizationID: string,
        name: string,
        description?: string | null,
        theWhy?: string | null,
        leadID?: string | null,
        stringifiedCauses?: string | null,
        opportunities?:  {
          __typename: "ModelOpportunityConnection",
          nextToken?: string | null,
        } | null,
        archived: boolean,
        createdAt: string,
        updatedAt: string,
        lead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      opportunityLeadID: string,
      type?: OpportunityType | null,
      status: OpportunityStatus,
      startDate?: string | null,
      endDate?: string | null,
      startRecruitingDate?: string | null,
      headerImage?: string | null,
      title?: string | null,
      descriptionRTE?: string | null,
      theWhy?: string | null,
      expectedImpact?: string | null,
      whatWillHappen?: string | null,
      volunteerGain?: string | null,
      roles?:  {
        __typename: "ModelRoleConnection",
        items:  Array< {
          __typename: "Role",
          id: string,
          opportunityID: string,
          organizationID: string,
          roleTitle: string,
          opportunityTitle?: string | null,
          live?: boolean | null,
          roleCoordinatorID?: string | null,
          recurrence?: RoleRecurrence | null,
          weeklyRecurrenceDays?: string | null,
          weeklyRecurrenceSameVolunteers?: boolean | null,
          volunteersPerShift?: number | null,
          differentNumberOfVolunteersPerShift?: boolean | null,
          volunteerCommitmentMonths?: number | null,
          volunteerCommitmentCanRenew?: boolean | null,
          roleRequirements?: string | null,
          ageRequirement?: string | null,
          minorsRequireSupervision?: boolean | null,
          stringifiedCauses?: string | null,
          stringifiedCausesJSON?: string | null,
          stringifiedSkills?: string | null,
          stringifiedSkillsJSON?: string | null,
          stringifiedCertifications?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stringifiedCauses?: string | null,
      stringifiedCausesJSON?: string | null,
      application?:  {
        __typename: "ModelApplicationConnection",
        items:  Array< {
          __typename: "Application",
          id: string,
          opportunityID: string,
          roleID?: string | null,
          screeningCallRequired?: ScreeningCallRequiredOptions | null,
          signUpOnly?: boolean | null,
          requireScreeningCall?: boolean | null,
          requireBackgroundCheck?: boolean | null,
          recruitmentDeadlineForVolunteers?: string | null,
          targetNumberOfVolunteerHours?: number | null,
          minimumNumberOfVolunteersRequired?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      opportunityLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    administrativeNotes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCheckInSubscription = {
  onCreateCheckIn?:  {
    __typename: "CheckIn",
    id: string,
    assignmentID: string,
    shiftID: string,
    opportunityID: string,
    timeIn?: string | null,
    timeOut?: string | null,
    checkedInByVolunteerProfileID?: string | null,
    checkedInByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    checkedOutByVolunteerProfileID?: string | null,
    checkedOutByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCheckInSubscription = {
  onUpdateCheckIn?:  {
    __typename: "CheckIn",
    id: string,
    assignmentID: string,
    shiftID: string,
    opportunityID: string,
    timeIn?: string | null,
    timeOut?: string | null,
    checkedInByVolunteerProfileID?: string | null,
    checkedInByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    checkedOutByVolunteerProfileID?: string | null,
    checkedOutByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCheckInSubscription = {
  onDeleteCheckIn?:  {
    __typename: "CheckIn",
    id: string,
    assignmentID: string,
    shiftID: string,
    opportunityID: string,
    timeIn?: string | null,
    timeOut?: string | null,
    checkedInByVolunteerProfileID?: string | null,
    checkedInByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    checkedOutByVolunteerProfileID?: string | null,
    checkedOutByVolunteer?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateNotificationSettingsSubscription = {
  onCreateNotificationSettings?:  {
    __typename: "NotificationSettings",
    id: string,
    communicationsProfileID: string,
    allowPushNotifications: boolean,
    allowTextMessages: boolean,
    allowEmail: boolean,
    preference?: NotificationPreference | null,
    createdAt: string,
    updatedAt: string,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnUpdateNotificationSettingsSubscription = {
  onUpdateNotificationSettings?:  {
    __typename: "NotificationSettings",
    id: string,
    communicationsProfileID: string,
    allowPushNotifications: boolean,
    allowTextMessages: boolean,
    allowEmail: boolean,
    preference?: NotificationPreference | null,
    createdAt: string,
    updatedAt: string,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnDeleteNotificationSettingsSubscription = {
  onDeleteNotificationSettings?:  {
    __typename: "NotificationSettings",
    id: string,
    communicationsProfileID: string,
    allowPushNotifications: boolean,
    allowTextMessages: boolean,
    allowEmail: boolean,
    preference?: NotificationPreference | null,
    createdAt: string,
    updatedAt: string,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnCreateLatentOrganizationCodeSubscription = {
  onCreateLatentOrganizationCode?:  {
    __typename: "LatentOrganizationCode",
    id: string,
    code: string,
    organizationID: string,
    active: boolean,
    emailRestricted: boolean,
    emailHostRestriction?: string | null,
    fundraisingCampaignID?: string | null,
    presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateLatentOrganizationCodeSubscription = {
  onUpdateLatentOrganizationCode?:  {
    __typename: "LatentOrganizationCode",
    id: string,
    code: string,
    organizationID: string,
    active: boolean,
    emailRestricted: boolean,
    emailHostRestriction?: string | null,
    fundraisingCampaignID?: string | null,
    presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteLatentOrganizationCodeSubscription = {
  onDeleteLatentOrganizationCode?:  {
    __typename: "LatentOrganizationCode",
    id: string,
    code: string,
    organizationID: string,
    active: boolean,
    emailRestricted: boolean,
    emailHostRestriction?: string | null,
    fundraisingCampaignID?: string | null,
    presetFundraisingCampaignAmbassadorStatus?: FundraisingCampaignAmbassadorStatus | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateSubscriptionDonationTierSubscription = {
  onCreateSubscriptionDonationTier?:  {
    __typename: "SubscriptionDonationTier",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    amount?: number | null,
    features?: Array< string | null > | null,
    buttonText?: string | null,
    buttonColor?: string | null,
    default?: boolean | null,
    highlighted?: boolean | null,
    highlightedColor?: string | null,
    promoText?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSubscriptionDonationTierSubscription = {
  onUpdateSubscriptionDonationTier?:  {
    __typename: "SubscriptionDonationTier",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    amount?: number | null,
    features?: Array< string | null > | null,
    buttonText?: string | null,
    buttonColor?: string | null,
    default?: boolean | null,
    highlighted?: boolean | null,
    highlightedColor?: string | null,
    promoText?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSubscriptionDonationTierSubscription = {
  onDeleteSubscriptionDonationTier?:  {
    __typename: "SubscriptionDonationTier",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    amount?: number | null,
    features?: Array< string | null > | null,
    buttonText?: string | null,
    buttonColor?: string | null,
    default?: boolean | null,
    highlighted?: boolean | null,
    highlightedColor?: string | null,
    promoText?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCampaignConversationFlowSubscription = {
  onCreateCampaignConversationFlow?:  {
    __typename: "CampaignConversationFlow",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    default?: boolean | null,
    active: boolean,
    actionMessageDefinitions?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    restricted?: boolean | null,
    useDefaultCta?: boolean | null,
    customCta?: string | null,
    allowAmbassadorSpecificCrowbarVideos?: boolean | null,
    generalCrowbarVideoURI?: string | null,
    deleted?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCampaignConversationFlowSubscription = {
  onUpdateCampaignConversationFlow?:  {
    __typename: "CampaignConversationFlow",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    default?: boolean | null,
    active: boolean,
    actionMessageDefinitions?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    restricted?: boolean | null,
    useDefaultCta?: boolean | null,
    customCta?: string | null,
    allowAmbassadorSpecificCrowbarVideos?: boolean | null,
    generalCrowbarVideoURI?: string | null,
    deleted?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCampaignConversationFlowSubscription = {
  onDeleteCampaignConversationFlow?:  {
    __typename: "CampaignConversationFlow",
    id: string,
    fundraisingCampaignID: string,
    name: string,
    description?: string | null,
    default?: boolean | null,
    active: boolean,
    actionMessageDefinitions?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    restricted?: boolean | null,
    useDefaultCta?: boolean | null,
    customCta?: string | null,
    allowAmbassadorSpecificCrowbarVideos?: boolean | null,
    generalCrowbarVideoURI?: string | null,
    deleted?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateActionMessageDefinitionSubscription = {
  onCreateActionMessageDefinition?:  {
    __typename: "ActionMessageDefinition",
    id: string,
    campaignConversationFlowID: string,
    fundraisingCampaignID: string,
    name?: string | null,
    description?: string | null,
    type: ActionMessageType,
    messageTemplate?: string | null,
    onPositiveResponse?: string | null,
    onNegativeResponse?: string | null,
    otherResponses?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    reminderActionMessageDefinitionID?: string | null,
    reminderActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reminderDelay?: number | null,
    sendReminderNotification?: boolean | null,
    reminderNotificationID?: string | null,
    beginningNode?: boolean | null,
    parentActionMessageDefinitionID?: string | null,
    parentActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    viewType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateActionMessageDefinitionSubscription = {
  onUpdateActionMessageDefinition?:  {
    __typename: "ActionMessageDefinition",
    id: string,
    campaignConversationFlowID: string,
    fundraisingCampaignID: string,
    name?: string | null,
    description?: string | null,
    type: ActionMessageType,
    messageTemplate?: string | null,
    onPositiveResponse?: string | null,
    onNegativeResponse?: string | null,
    otherResponses?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    reminderActionMessageDefinitionID?: string | null,
    reminderActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reminderDelay?: number | null,
    sendReminderNotification?: boolean | null,
    reminderNotificationID?: string | null,
    beginningNode?: boolean | null,
    parentActionMessageDefinitionID?: string | null,
    parentActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    viewType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteActionMessageDefinitionSubscription = {
  onDeleteActionMessageDefinition?:  {
    __typename: "ActionMessageDefinition",
    id: string,
    campaignConversationFlowID: string,
    fundraisingCampaignID: string,
    name?: string | null,
    description?: string | null,
    type: ActionMessageType,
    messageTemplate?: string | null,
    onPositiveResponse?: string | null,
    onNegativeResponse?: string | null,
    otherResponses?:  {
      __typename: "ModelActionMessageDefinitionConnection",
      items:  Array< {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    reminderActionMessageDefinitionID?: string | null,
    reminderActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reminderDelay?: number | null,
    sendReminderNotification?: boolean | null,
    reminderNotificationID?: string | null,
    beginningNode?: boolean | null,
    parentActionMessageDefinitionID?: string | null,
    parentActionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    viewType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateActionMessageSubscription = {
  onCreateActionMessage?:  {
    __typename: "ActionMessage",
    id: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    fundraisingCampaignAmbassadorContactID: string,
    actionMessageDefinitionID: string,
    actionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sent?: boolean | null,
    sentTimestamp?: string | null,
    response?: ActionMessageResponseType | null,
    responseTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateActionMessageSubscription = {
  onUpdateActionMessage?:  {
    __typename: "ActionMessage",
    id: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    fundraisingCampaignAmbassadorContactID: string,
    actionMessageDefinitionID: string,
    actionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sent?: boolean | null,
    sentTimestamp?: string | null,
    response?: ActionMessageResponseType | null,
    responseTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteActionMessageSubscription = {
  onDeleteActionMessage?:  {
    __typename: "ActionMessage",
    id: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    fundraisingCampaignAmbassadorContactID: string,
    actionMessageDefinitionID: string,
    actionMessageDefinition?:  {
      __typename: "ActionMessageDefinition",
      id: string,
      campaignConversationFlowID: string,
      fundraisingCampaignID: string,
      name?: string | null,
      description?: string | null,
      type: ActionMessageType,
      messageTemplate?: string | null,
      onPositiveResponse?: string | null,
      onNegativeResponse?: string | null,
      otherResponses?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      reminderActionMessageDefinitionID?: string | null,
      reminderActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      reminderDelay?: number | null,
      sendReminderNotification?: boolean | null,
      reminderNotificationID?: string | null,
      beginningNode?: boolean | null,
      parentActionMessageDefinitionID?: string | null,
      parentActionMessageDefinition?:  {
        __typename: "ActionMessageDefinition",
        id: string,
        campaignConversationFlowID: string,
        fundraisingCampaignID: string,
        name?: string | null,
        description?: string | null,
        type: ActionMessageType,
        messageTemplate?: string | null,
        onPositiveResponse?: string | null,
        onNegativeResponse?: string | null,
        otherResponses?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        reminderActionMessageDefinitionID?: string | null,
        reminderActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        reminderDelay?: number | null,
        sendReminderNotification?: boolean | null,
        reminderNotificationID?: string | null,
        beginningNode?: boolean | null,
        parentActionMessageDefinitionID?: string | null,
        parentActionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        viewType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      viewType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sent?: boolean | null,
    sentTimestamp?: string | null,
    response?: ActionMessageResponseType | null,
    responseTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProjectSubscription = {
  onCreateProject?:  {
    __typename: "Project",
    id: string,
    status?: string | null,
    name: string,
    description?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProjectSubscription = {
  onUpdateProject?:  {
    __typename: "Project",
    id: string,
    status?: string | null,
    name: string,
    description?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProjectSubscription = {
  onDeleteProject?:  {
    __typename: "Project",
    id: string,
    status?: string | null,
    name: string,
    description?: string | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        projectID: string,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        isTopLevelTask?: boolean | null,
        name?: string | null,
        overview?: string | null,
        description?: string | null,
        descriptionRTE?: string | null,
        status?: string | null,
        complete?: boolean | null,
        assignments?:  {
          __typename: "ModelTaskAssignmentConnection",
          nextToken?: string | null,
        } | null,
        comments?:  {
          __typename: "ModelTaskCommentConnection",
          nextToken?: string | null,
        } | null,
        subTasks?:  {
          __typename: "ModelSubTaskConnection",
          nextToken?: string | null,
        } | null,
        mediaURI?: Array< string | null > | null,
        attachments?:  {
          __typename: "ModelTaskAttachmentConnection",
          nextToken?: string | null,
        } | null,
        createdByID?: string | null,
        actionURL?: string | null,
        dueDate?: string | null,
        blockedBy?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        blocking?:  {
          __typename: "ModelTaskBlockerConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        createdBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTaskSubscription = {
  onCreateTask?:  {
    __typename: "Task",
    id: string,
    projectID: string,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isTopLevelTask?: boolean | null,
    name?: string | null,
    overview?: string | null,
    description?: string | null,
    descriptionRTE?: string | null,
    status?: string | null,
    complete?: boolean | null,
    assignments?:  {
      __typename: "ModelTaskAssignmentConnection",
      items:  Array< {
        __typename: "TaskAssignment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authAccountID: string,
        staffProfileID?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelTaskCommentConnection",
      items:  Array< {
        __typename: "TaskComment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        comment?: string | null,
        mediaURI?: Array< string | null > | null,
        postedByID: string,
        createdAt: string,
        updatedAt: string,
        postedBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    subTasks?:  {
      __typename: "ModelSubTaskConnection",
      items:  Array< {
        __typename: "SubTask",
        id: string,
        parentTaskID: string,
        parentTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subTaskID: string,
        subTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mediaURI?: Array< string | null > | null,
    attachments?:  {
      __typename: "ModelTaskAttachmentConnection",
      items:  Array< {
        __typename: "TaskAttachment",
        id: string,
        taskID: string,
        uploadedByID: string,
        name?: string | null,
        description?: string | null,
        contentType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdByID?: string | null,
    actionURL?: string | null,
    dueDate?: string | null,
    blockedBy?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    blocking?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    createdBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateTaskSubscription = {
  onUpdateTask?:  {
    __typename: "Task",
    id: string,
    projectID: string,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isTopLevelTask?: boolean | null,
    name?: string | null,
    overview?: string | null,
    description?: string | null,
    descriptionRTE?: string | null,
    status?: string | null,
    complete?: boolean | null,
    assignments?:  {
      __typename: "ModelTaskAssignmentConnection",
      items:  Array< {
        __typename: "TaskAssignment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authAccountID: string,
        staffProfileID?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelTaskCommentConnection",
      items:  Array< {
        __typename: "TaskComment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        comment?: string | null,
        mediaURI?: Array< string | null > | null,
        postedByID: string,
        createdAt: string,
        updatedAt: string,
        postedBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    subTasks?:  {
      __typename: "ModelSubTaskConnection",
      items:  Array< {
        __typename: "SubTask",
        id: string,
        parentTaskID: string,
        parentTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subTaskID: string,
        subTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mediaURI?: Array< string | null > | null,
    attachments?:  {
      __typename: "ModelTaskAttachmentConnection",
      items:  Array< {
        __typename: "TaskAttachment",
        id: string,
        taskID: string,
        uploadedByID: string,
        name?: string | null,
        description?: string | null,
        contentType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdByID?: string | null,
    actionURL?: string | null,
    dueDate?: string | null,
    blockedBy?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    blocking?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    createdBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteTaskSubscription = {
  onDeleteTask?:  {
    __typename: "Task",
    id: string,
    projectID: string,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isTopLevelTask?: boolean | null,
    name?: string | null,
    overview?: string | null,
    description?: string | null,
    descriptionRTE?: string | null,
    status?: string | null,
    complete?: boolean | null,
    assignments?:  {
      __typename: "ModelTaskAssignmentConnection",
      items:  Array< {
        __typename: "TaskAssignment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authAccountID: string,
        staffProfileID?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelTaskCommentConnection",
      items:  Array< {
        __typename: "TaskComment",
        id: string,
        taskID: string,
        task?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        comment?: string | null,
        mediaURI?: Array< string | null > | null,
        postedByID: string,
        createdAt: string,
        updatedAt: string,
        postedBy?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    subTasks?:  {
      __typename: "ModelSubTaskConnection",
      items:  Array< {
        __typename: "SubTask",
        id: string,
        parentTaskID: string,
        parentTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subTaskID: string,
        subTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mediaURI?: Array< string | null > | null,
    attachments?:  {
      __typename: "ModelTaskAttachmentConnection",
      items:  Array< {
        __typename: "TaskAttachment",
        id: string,
        taskID: string,
        uploadedByID: string,
        name?: string | null,
        description?: string | null,
        contentType?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdByID?: string | null,
    actionURL?: string | null,
    dueDate?: string | null,
    blockedBy?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    blocking?:  {
      __typename: "ModelTaskBlockerConnection",
      items:  Array< {
        __typename: "TaskBlocker",
        id: string,
        originTaskID: string,
        originTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        blockerTaskID: string,
        blockerTask?:  {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    createdBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateTaskAttachmentSubscription = {
  onCreateTaskAttachment?:  {
    __typename: "TaskAttachment",
    id: string,
    taskID: string,
    uploadedByID: string,
    name?: string | null,
    description?: string | null,
    contentType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTaskAttachmentSubscription = {
  onUpdateTaskAttachment?:  {
    __typename: "TaskAttachment",
    id: string,
    taskID: string,
    uploadedByID: string,
    name?: string | null,
    description?: string | null,
    contentType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTaskAttachmentSubscription = {
  onDeleteTaskAttachment?:  {
    __typename: "TaskAttachment",
    id: string,
    taskID: string,
    uploadedByID: string,
    name?: string | null,
    description?: string | null,
    contentType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTaskBlockerSubscription = {
  onCreateTaskBlocker?:  {
    __typename: "TaskBlocker",
    id: string,
    originTaskID: string,
    originTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    blockerTaskID: string,
    blockerTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTaskBlockerSubscription = {
  onUpdateTaskBlocker?:  {
    __typename: "TaskBlocker",
    id: string,
    originTaskID: string,
    originTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    blockerTaskID: string,
    blockerTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTaskBlockerSubscription = {
  onDeleteTaskBlocker?:  {
    __typename: "TaskBlocker",
    id: string,
    originTaskID: string,
    originTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    blockerTaskID: string,
    blockerTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSubTaskSubscription = {
  onCreateSubTask?:  {
    __typename: "SubTask",
    id: string,
    parentTaskID: string,
    parentTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    subTaskID: string,
    subTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSubTaskSubscription = {
  onUpdateSubTask?:  {
    __typename: "SubTask",
    id: string,
    parentTaskID: string,
    parentTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    subTaskID: string,
    subTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSubTaskSubscription = {
  onDeleteSubTask?:  {
    __typename: "SubTask",
    id: string,
    parentTaskID: string,
    parentTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    subTaskID: string,
    subTask?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTaskCommentSubscription = {
  onCreateTaskComment?:  {
    __typename: "TaskComment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    comment?: string | null,
    mediaURI?: Array< string | null > | null,
    postedByID: string,
    createdAt: string,
    updatedAt: string,
    postedBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateTaskCommentSubscription = {
  onUpdateTaskComment?:  {
    __typename: "TaskComment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    comment?: string | null,
    mediaURI?: Array< string | null > | null,
    postedByID: string,
    createdAt: string,
    updatedAt: string,
    postedBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteTaskCommentSubscription = {
  onDeleteTaskComment?:  {
    __typename: "TaskComment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    comment?: string | null,
    mediaURI?: Array< string | null > | null,
    postedByID: string,
    createdAt: string,
    updatedAt: string,
    postedBy?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateTaskAssignmentSubscription = {
  onCreateTaskAssignment?:  {
    __typename: "TaskAssignment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    authAccountID: string,
    staffProfileID?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateTaskAssignmentSubscription = {
  onUpdateTaskAssignment?:  {
    __typename: "TaskAssignment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    authAccountID: string,
    staffProfileID?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteTaskAssignmentSubscription = {
  onDeleteTaskAssignment?:  {
    __typename: "TaskAssignment",
    id: string,
    taskID: string,
    task?:  {
      __typename: "Task",
      id: string,
      projectID: string,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      isTopLevelTask?: boolean | null,
      name?: string | null,
      overview?: string | null,
      description?: string | null,
      descriptionRTE?: string | null,
      status?: string | null,
      complete?: boolean | null,
      assignments?:  {
        __typename: "ModelTaskAssignmentConnection",
        items:  Array< {
          __typename: "TaskAssignment",
          id: string,
          taskID: string,
          authAccountID: string,
          staffProfileID?: string | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelTaskCommentConnection",
        items:  Array< {
          __typename: "TaskComment",
          id: string,
          taskID: string,
          comment?: string | null,
          mediaURI?: Array< string | null > | null,
          postedByID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      subTasks?:  {
        __typename: "ModelSubTaskConnection",
        items:  Array< {
          __typename: "SubTask",
          id: string,
          parentTaskID: string,
          subTaskID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mediaURI?: Array< string | null > | null,
      attachments?:  {
        __typename: "ModelTaskAttachmentConnection",
        items:  Array< {
          __typename: "TaskAttachment",
          id: string,
          taskID: string,
          uploadedByID: string,
          name?: string | null,
          description?: string | null,
          contentType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdByID?: string | null,
      actionURL?: string | null,
      dueDate?: string | null,
      blockedBy?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      blocking?:  {
        __typename: "ModelTaskBlockerConnection",
        items:  Array< {
          __typename: "TaskBlocker",
          id: string,
          originTaskID: string,
          blockerTaskID: string,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      createdBy?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    authAccountID: string,
    staffProfileID?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateCognitoAccountSubscription = {
  onCreateCognitoAccount?:  {
    __typename: "CognitoAccount",
    id: string,
    cognitoID: string,
    authAccountID?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateCognitoAccountSubscription = {
  onUpdateCognitoAccount?:  {
    __typename: "CognitoAccount",
    id: string,
    cognitoID: string,
    authAccountID?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteCognitoAccountSubscription = {
  onDeleteCognitoAccount?:  {
    __typename: "CognitoAccount",
    id: string,
    cognitoID: string,
    authAccountID?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateAuthAccountSubscription = {
  onCreateAuthAccount?:  {
    __typename: "AuthAccount",
    id: string,
    volunteerProfileID?: string | null,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    lastSelectedStaffProfileID?: string | null,
    lastSelectedFundraisingProfileID?: string | null,
    communicationsProfileID?: string | null,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    primaryEmail?: string | null,
    phoneNumber?: string | null,
    dateOfBirth?: string | null,
    gender?: string | null,
    selfDescribedGender?: string | null,
    addressID?: string | null,
    website?: string | null,
    resumeURI?: string | null,
    bio?: string | null,
    profilePictureURI?: string | null,
    headerVideoURI?: string | null,
    headerImageURI?: string | null,
    headerAssetShown?: string | null,
    flourishAdmin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    cognitoAccounts?:  {
      __typename: "ModelCognitoAccountConnection",
      items:  Array< {
        __typename: "CognitoAccount",
        id: string,
        cognitoID: string,
        authAccountID?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    staffProfile?:  {
      __typename: "ModelStaffProfileConnection",
      items:  Array< {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    fundraisingProfiles?:  {
      __typename: "ModelFundraisingProfileConnection",
      items:  Array< {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedFundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnUpdateAuthAccountSubscription = {
  onUpdateAuthAccount?:  {
    __typename: "AuthAccount",
    id: string,
    volunteerProfileID?: string | null,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    lastSelectedStaffProfileID?: string | null,
    lastSelectedFundraisingProfileID?: string | null,
    communicationsProfileID?: string | null,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    primaryEmail?: string | null,
    phoneNumber?: string | null,
    dateOfBirth?: string | null,
    gender?: string | null,
    selfDescribedGender?: string | null,
    addressID?: string | null,
    website?: string | null,
    resumeURI?: string | null,
    bio?: string | null,
    profilePictureURI?: string | null,
    headerVideoURI?: string | null,
    headerImageURI?: string | null,
    headerAssetShown?: string | null,
    flourishAdmin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    cognitoAccounts?:  {
      __typename: "ModelCognitoAccountConnection",
      items:  Array< {
        __typename: "CognitoAccount",
        id: string,
        cognitoID: string,
        authAccountID?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    staffProfile?:  {
      __typename: "ModelStaffProfileConnection",
      items:  Array< {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    fundraisingProfiles?:  {
      __typename: "ModelFundraisingProfileConnection",
      items:  Array< {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedFundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnDeleteAuthAccountSubscription = {
  onDeleteAuthAccount?:  {
    __typename: "AuthAccount",
    id: string,
    volunteerProfileID?: string | null,
    volunteerProfile?:  {
      __typename: "VolunteerProfile",
      id: string,
      authAccountID: string,
      email: string,
      firstName?: string | null,
      lastName?: string | null,
      gender?: GenderType | null,
      dateOfBirth?: string | null,
      streetAddress?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: number | null,
      website?: string | null,
      enneagram?: number | null,
      enneagramWing?: number | null,
      myersBriggs?: string | null,
      additionalInformation?: string | null,
      availabilityStringified?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      skills?:  {
        __typename: "ModelVolunteerSkillConnection",
        items:  Array< {
          __typename: "VolunteerSkill",
          id: string,
          skillID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      causes?:  {
        __typename: "ModelVolunteerCauseConnection",
        items:  Array< {
          __typename: "VolunteerCause",
          id: string,
          causeID: string,
          volunteerProfileID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    lastSelectedStaffProfileID?: string | null,
    lastSelectedFundraisingProfileID?: string | null,
    communicationsProfileID?: string | null,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    primaryEmail?: string | null,
    phoneNumber?: string | null,
    dateOfBirth?: string | null,
    gender?: string | null,
    selfDescribedGender?: string | null,
    addressID?: string | null,
    website?: string | null,
    resumeURI?: string | null,
    bio?: string | null,
    profilePictureURI?: string | null,
    headerVideoURI?: string | null,
    headerImageURI?: string | null,
    headerAssetShown?: string | null,
    flourishAdmin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    cognitoAccounts?:  {
      __typename: "ModelCognitoAccountConnection",
      items:  Array< {
        __typename: "CognitoAccount",
        id: string,
        cognitoID: string,
        authAccountID?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    owner?: string | null,
    staffProfile?:  {
      __typename: "ModelStaffProfileConnection",
      items:  Array< {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    communicationsProfile?:  {
      __typename: "CommunicationsProfile",
      id: string,
      authAccountID: string,
      streamJwt?: string | null,
      notificationSettingsID?: string | null,
      notificationSettings?:  {
        __typename: "NotificationSettings",
        id: string,
        communicationsProfileID: string,
        allowPushNotifications: boolean,
        allowTextMessages: boolean,
        allowEmail: boolean,
        preference?: NotificationPreference | null,
        createdAt: string,
        updatedAt: string,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    fundraisingProfiles?:  {
      __typename: "ModelFundraisingProfileConnection",
      items:  Array< {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    lastSelectedFundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnCreateStaffProfileSubscription = {
  onCreateStaffProfile?:  {
    __typename: "StaffProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    role?: StaffProfileRole | null,
    name?: string | null,
    nylasAccountID?: string | null,
    nylasCalendarToken?: string | null,
    nylasPrimaryCalendarID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateStaffProfileSubscription = {
  onUpdateStaffProfile?:  {
    __typename: "StaffProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    role?: StaffProfileRole | null,
    name?: string | null,
    nylasAccountID?: string | null,
    nylasCalendarToken?: string | null,
    nylasPrimaryCalendarID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteStaffProfileSubscription = {
  onDeleteStaffProfile?:  {
    __typename: "StaffProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    role?: StaffProfileRole | null,
    name?: string | null,
    nylasAccountID?: string | null,
    nylasCalendarToken?: string | null,
    nylasPrimaryCalendarID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateCommunicationsProfileSubscription = {
  onCreateCommunicationsProfile?:  {
    __typename: "CommunicationsProfile",
    id: string,
    authAccountID: string,
    streamJwt?: string | null,
    notificationSettingsID?: string | null,
    notificationSettings?:  {
      __typename: "NotificationSettings",
      id: string,
      communicationsProfileID: string,
      allowPushNotifications: boolean,
      allowTextMessages: boolean,
      allowEmail: boolean,
      preference?: NotificationPreference | null,
      createdAt: string,
      updatedAt: string,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateCommunicationsProfileSubscription = {
  onUpdateCommunicationsProfile?:  {
    __typename: "CommunicationsProfile",
    id: string,
    authAccountID: string,
    streamJwt?: string | null,
    notificationSettingsID?: string | null,
    notificationSettings?:  {
      __typename: "NotificationSettings",
      id: string,
      communicationsProfileID: string,
      allowPushNotifications: boolean,
      allowTextMessages: boolean,
      allowEmail: boolean,
      preference?: NotificationPreference | null,
      createdAt: string,
      updatedAt: string,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteCommunicationsProfileSubscription = {
  onDeleteCommunicationsProfile?:  {
    __typename: "CommunicationsProfile",
    id: string,
    authAccountID: string,
    streamJwt?: string | null,
    notificationSettingsID?: string | null,
    notificationSettings?:  {
      __typename: "NotificationSettings",
      id: string,
      communicationsProfileID: string,
      allowPushNotifications: boolean,
      allowTextMessages: boolean,
      allowEmail: boolean,
      preference?: NotificationPreference | null,
      createdAt: string,
      updatedAt: string,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnCreateFundraisingProfileSubscription = {
  onCreateFundraisingProfile?:  {
    __typename: "FundraisingProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    classyMemberID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    campaigns?:  {
      __typename: "ModelFundraisingCampaignAmbassadorConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateFundraisingProfileSubscription = {
  onUpdateFundraisingProfile?:  {
    __typename: "FundraisingProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    classyMemberID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    campaigns?:  {
      __typename: "ModelFundraisingCampaignAmbassadorConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteFundraisingProfileSubscription = {
  onDeleteFundraisingProfile?:  {
    __typename: "FundraisingProfile",
    id: string,
    authAccountID?: string | null,
    organizationID?: string | null,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    classyMemberID?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    campaigns?:  {
      __typename: "ModelFundraisingCampaignAmbassadorConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateStaffInvitationSubscription = {
  onCreateStaffInvitation?:  {
    __typename: "StaffInvitation",
    id: string,
    code: string,
    type: StaffInvitationType,
    email?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    staffProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateStaffInvitationSubscription = {
  onUpdateStaffInvitation?:  {
    __typename: "StaffInvitation",
    id: string,
    code: string,
    type: StaffInvitationType,
    email?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    staffProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteStaffInvitationSubscription = {
  onDeleteStaffInvitation?:  {
    __typename: "StaffInvitation",
    id: string,
    code: string,
    type: StaffInvitationType,
    email?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    staffProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateFundraisingInvitationSubscription = {
  onCreateFundraisingInvitation?:  {
    __typename: "FundraisingInvitation",
    id: string,
    code: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateFundraisingInvitationSubscription = {
  onUpdateFundraisingInvitation?:  {
    __typename: "FundraisingInvitation",
    id: string,
    code: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteFundraisingInvitationSubscription = {
  onDeleteFundraisingInvitation?:  {
    __typename: "FundraisingInvitation",
    id: string,
    code: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    domain?: string | null,
    name?: string | null,
    organizationID: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    used?: boolean | null,
    usedTimestamp?: string | null,
    invitationSent?: boolean | null,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateVolunteerInvitationSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateVolunteerInvitationSubscription = {
  onCreateVolunteerInvitation?:  {
    __typename: "VolunteerInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    organizationID?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateVolunteerInvitationSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateVolunteerInvitationSubscription = {
  onUpdateVolunteerInvitation?:  {
    __typename: "VolunteerInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    organizationID?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteVolunteerInvitationSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteVolunteerInvitationSubscription = {
  onDeleteVolunteerInvitation?:  {
    __typename: "VolunteerInvitation",
    id: string,
    code: string,
    email: string,
    name?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    organizationID?: string | null,
    used: boolean,
    usedTimestamp?: string | null,
    invitationSent: boolean,
    invitationSentTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateVolunteerWaitlistSubscription = {
  onCreateVolunteerWaitlist?:  {
    __typename: "VolunteerWaitlist",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    zipCode?: number | null,
    about?: string | null,
    invited?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateVolunteerWaitlistSubscription = {
  onUpdateVolunteerWaitlist?:  {
    __typename: "VolunteerWaitlist",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    zipCode?: number | null,
    about?: string | null,
    invited?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteVolunteerWaitlistSubscription = {
  onDeleteVolunteerWaitlist?:  {
    __typename: "VolunteerWaitlist",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    zipCode?: number | null,
    about?: string | null,
    invited?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateSkillSubscription = {
  onCreateSkill?:  {
    __typename: "Skill",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSkillSubscription = {
  onUpdateSkill?:  {
    __typename: "Skill",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSkillSubscription = {
  onDeleteSkill?:  {
    __typename: "Skill",
    id: string,
    key: string,
    name: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrganizationSubscription = {
  onCreateOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    shortName?: string | null,
    description?: string | null,
    locationID?: string | null,
    website?: string | null,
    phoneNumber?: string | null,
    stripeConnectedAccountID?: string | null,
    stripeConnectedAccountStatus?: string | null,
    headerImageURI?: string | null,
    ambassadorTermOverrideSingular?: string | null,
    ambassadorTermOverridePlural?: string | null,
    streamJwt?: string | null,
    latentSubscription?: number | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    designation?: string | null,
    detailsID?: string | null,
    details?:  {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateOrganizationSubscription = {
  onUpdateOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    shortName?: string | null,
    description?: string | null,
    locationID?: string | null,
    website?: string | null,
    phoneNumber?: string | null,
    stripeConnectedAccountID?: string | null,
    stripeConnectedAccountStatus?: string | null,
    headerImageURI?: string | null,
    ambassadorTermOverrideSingular?: string | null,
    ambassadorTermOverridePlural?: string | null,
    streamJwt?: string | null,
    latentSubscription?: number | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    designation?: string | null,
    detailsID?: string | null,
    details?:  {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteOrganizationSubscription = {
  onDeleteOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    shortName?: string | null,
    description?: string | null,
    locationID?: string | null,
    website?: string | null,
    phoneNumber?: string | null,
    stripeConnectedAccountID?: string | null,
    stripeConnectedAccountStatus?: string | null,
    headerImageURI?: string | null,
    ambassadorTermOverrideSingular?: string | null,
    ambassadorTermOverridePlural?: string | null,
    streamJwt?: string | null,
    latentSubscription?: number | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    designation?: string | null,
    detailsID?: string | null,
    details?:  {
      __typename: "OrganizationDetails",
      id: string,
      organizationID: string,
      missionStatement?: string | null,
      serveStatement?: string | null,
      doStatement?: string | null,
      costToDoStatement?: string | null,
      missionArea?: string | null,
      annualBudget?: string | null,
      currentMonthlyRecurringDonors?: string | null,
      averageMonthlyRecurringDonation?: string | null,
      percentageOfBudgetFromIndividualDonors?: string | null,
      numberOfMajorDonors?: string | null,
      averageOneTimeDonation?: string | null,
      percentageOfBudgetFromGrants?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      type: LocationType,
      name: string,
      details?: string | null,
      addressID?: string | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateLocationSubscription = {
  onCreateLocation?:  {
    __typename: "Location",
    id: string,
    type: LocationType,
    name: string,
    details?: string | null,
    addressID?: string | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnUpdateLocationSubscription = {
  onUpdateLocation?:  {
    __typename: "Location",
    id: string,
    type: LocationType,
    name: string,
    details?: string | null,
    addressID?: string | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnDeleteLocationSubscription = {
  onDeleteLocation?:  {
    __typename: "Location",
    id: string,
    type: LocationType,
    name: string,
    details?: string | null,
    addressID?: string | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    address?:  {
      __typename: "Address",
      id: string,
      streetAddress?: string | null,
      unit?: string | null,
      city?: string | null,
      state?: string | null,
      zip?: string | null,
      zipPlusFour?: string | null,
      longitude?: number | null,
      latitude?: number | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnCreateAddressSubscription = {
  onCreateAddress?:  {
    __typename: "Address",
    id: string,
    streetAddress?: string | null,
    unit?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    zipPlusFour?: string | null,
    longitude?: number | null,
    latitude?: number | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateAddressSubscription = {
  onUpdateAddress?:  {
    __typename: "Address",
    id: string,
    streetAddress?: string | null,
    unit?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    zipPlusFour?: string | null,
    longitude?: number | null,
    latitude?: number | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteAddressSubscription = {
  onDeleteAddress?:  {
    __typename: "Address",
    id: string,
    streetAddress?: string | null,
    unit?: string | null,
    city?: string | null,
    state?: string | null,
    zip?: string | null,
    zipPlusFour?: string | null,
    longitude?: number | null,
    latitude?: number | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateFundraisingCampaignSubscription = {
  onCreateFundraisingCampaign?:  {
    __typename: "FundraisingCampaign",
    id: string,
    type: FundraisingCampaignType,
    organizationID: string,
    staffLeadID?: string | null,
    campaignName?: string | null,
    introVideoURI?: string | null,
    textMessageTemplate?: string | null,
    initialMessageReminderTemplate?: string | null,
    phoneCallScriptTemplate?: string | null,
    followUpMessageTemplate?: string | null,
    followUpYesMessageTemplate?: string | null,
    followUpNoMessageTemplate?: string | null,
    followUpReminderMessageTemplate?: string | null,
    showVideo?: boolean | null,
    showText?: boolean | null,
    showCall?: boolean | null,
    showFollowUp?: boolean | null,
    active?: boolean | null,
    publicVideoID?: string | null,
    publicVideoProvider?: string | null,
    campaignStartDate?: string | null,
    campaignStartTime?: string | null,
    campaignTimeZone?: string | null,
    campaignEndDate?: string | null,
    campaignEndTime?: string | null,
    publicCampaignAbout?: string | null,
    publicCampaignIntro?: string | null,
    campaignGoal?: number | null,
    perAmbassadorGoal?: number | null,
    totalAmbassadorsGoal?: number | null,
    perContactDonationGoal?: number | null,
    progressChartType?: string | null,
    ctaURL?: string | null,
    pageLayout?: string | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    customHeaderImageUploaded?: boolean | null,
    customLogoImageUploaded?: boolean | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    ctaButtonText?: string | null,
    givingCircleBaseAmount?: number | null,
    givingCircleIncrements?: Array< number | null > | null,
    givingCircleAllowCustomAmounts?: boolean | null,
    ambassadorSpecificVideoUrlEnabled?: boolean | null,
    ambassadorCanUploadVideoUrl?: boolean | null,
    ambassadorSpecificCtaUrlEnabled?: boolean | null,
    ambassadorCanUploadCtaUrl?: boolean | null,
    crowbarVideoURL?: string | null,
    recruitmentForCampaignID?: string | null,
    classyCampaignID?: string | null,
    classyAutogenerateAmbassadorTeams?: boolean | null,
    classyDonationPageHostURL?: string | null,
    useClassyCtaURL?: boolean | null,
    useClassyFundraiserPage?: boolean | null,
    personalFundraisingCampaignID?: string | null,
    onDemandDiscoveryMeetingEnabled?: boolean | null,
    onDemandDiscoveryMeetingURL?: string | null,
    onDemandDiscoveryMeetingID?: string | null,
    onDemandDiscoveryMeetingInvitationCode?: string | null,
    CampaignConversationFlows?:  {
      __typename: "ModelCampaignConversationFlowConnection",
      items:  Array< {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultConversationFlowID?: string | null,
    defaultConversationFlow?:  {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    useConversationFlows?: boolean | null,
    campaignPageID?: string | null,
    ambassadorPageID?: string | null,
    donationPageID?: string | null,
    discoveryPageID?: string | null,
    projectID?: string | null,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subscriptionDonationTiers?:  {
      __typename: "ModelSubscriptionDonationTierConnection",
      items:  Array< {
        __typename: "SubscriptionDonationTier",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        amount?: number | null,
        features?: Array< string | null > | null,
        buttonText?: string | null,
        buttonColor?: string | null,
        default?: boolean | null,
        highlighted?: boolean | null,
        highlightedColor?: string | null,
        promoText?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    useActionCardView?: boolean | null,
    createdAt: string,
    updatedAt: string,
    staffLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitmentForCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    personalFundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    campaignPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    ambassadorPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    donationPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    discoveryPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    onDemandDiscoveryMeeting?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnUpdateFundraisingCampaignSubscription = {
  onUpdateFundraisingCampaign?:  {
    __typename: "FundraisingCampaign",
    id: string,
    type: FundraisingCampaignType,
    organizationID: string,
    staffLeadID?: string | null,
    campaignName?: string | null,
    introVideoURI?: string | null,
    textMessageTemplate?: string | null,
    initialMessageReminderTemplate?: string | null,
    phoneCallScriptTemplate?: string | null,
    followUpMessageTemplate?: string | null,
    followUpYesMessageTemplate?: string | null,
    followUpNoMessageTemplate?: string | null,
    followUpReminderMessageTemplate?: string | null,
    showVideo?: boolean | null,
    showText?: boolean | null,
    showCall?: boolean | null,
    showFollowUp?: boolean | null,
    active?: boolean | null,
    publicVideoID?: string | null,
    publicVideoProvider?: string | null,
    campaignStartDate?: string | null,
    campaignStartTime?: string | null,
    campaignTimeZone?: string | null,
    campaignEndDate?: string | null,
    campaignEndTime?: string | null,
    publicCampaignAbout?: string | null,
    publicCampaignIntro?: string | null,
    campaignGoal?: number | null,
    perAmbassadorGoal?: number | null,
    totalAmbassadorsGoal?: number | null,
    perContactDonationGoal?: number | null,
    progressChartType?: string | null,
    ctaURL?: string | null,
    pageLayout?: string | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    customHeaderImageUploaded?: boolean | null,
    customLogoImageUploaded?: boolean | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    ctaButtonText?: string | null,
    givingCircleBaseAmount?: number | null,
    givingCircleIncrements?: Array< number | null > | null,
    givingCircleAllowCustomAmounts?: boolean | null,
    ambassadorSpecificVideoUrlEnabled?: boolean | null,
    ambassadorCanUploadVideoUrl?: boolean | null,
    ambassadorSpecificCtaUrlEnabled?: boolean | null,
    ambassadorCanUploadCtaUrl?: boolean | null,
    crowbarVideoURL?: string | null,
    recruitmentForCampaignID?: string | null,
    classyCampaignID?: string | null,
    classyAutogenerateAmbassadorTeams?: boolean | null,
    classyDonationPageHostURL?: string | null,
    useClassyCtaURL?: boolean | null,
    useClassyFundraiserPage?: boolean | null,
    personalFundraisingCampaignID?: string | null,
    onDemandDiscoveryMeetingEnabled?: boolean | null,
    onDemandDiscoveryMeetingURL?: string | null,
    onDemandDiscoveryMeetingID?: string | null,
    onDemandDiscoveryMeetingInvitationCode?: string | null,
    CampaignConversationFlows?:  {
      __typename: "ModelCampaignConversationFlowConnection",
      items:  Array< {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultConversationFlowID?: string | null,
    defaultConversationFlow?:  {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    useConversationFlows?: boolean | null,
    campaignPageID?: string | null,
    ambassadorPageID?: string | null,
    donationPageID?: string | null,
    discoveryPageID?: string | null,
    projectID?: string | null,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subscriptionDonationTiers?:  {
      __typename: "ModelSubscriptionDonationTierConnection",
      items:  Array< {
        __typename: "SubscriptionDonationTier",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        amount?: number | null,
        features?: Array< string | null > | null,
        buttonText?: string | null,
        buttonColor?: string | null,
        default?: boolean | null,
        highlighted?: boolean | null,
        highlightedColor?: string | null,
        promoText?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    useActionCardView?: boolean | null,
    createdAt: string,
    updatedAt: string,
    staffLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitmentForCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    personalFundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    campaignPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    ambassadorPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    donationPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    discoveryPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    onDemandDiscoveryMeeting?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnDeleteFundraisingCampaignSubscription = {
  onDeleteFundraisingCampaign?:  {
    __typename: "FundraisingCampaign",
    id: string,
    type: FundraisingCampaignType,
    organizationID: string,
    staffLeadID?: string | null,
    campaignName?: string | null,
    introVideoURI?: string | null,
    textMessageTemplate?: string | null,
    initialMessageReminderTemplate?: string | null,
    phoneCallScriptTemplate?: string | null,
    followUpMessageTemplate?: string | null,
    followUpYesMessageTemplate?: string | null,
    followUpNoMessageTemplate?: string | null,
    followUpReminderMessageTemplate?: string | null,
    showVideo?: boolean | null,
    showText?: boolean | null,
    showCall?: boolean | null,
    showFollowUp?: boolean | null,
    active?: boolean | null,
    publicVideoID?: string | null,
    publicVideoProvider?: string | null,
    campaignStartDate?: string | null,
    campaignStartTime?: string | null,
    campaignTimeZone?: string | null,
    campaignEndDate?: string | null,
    campaignEndTime?: string | null,
    publicCampaignAbout?: string | null,
    publicCampaignIntro?: string | null,
    campaignGoal?: number | null,
    perAmbassadorGoal?: number | null,
    totalAmbassadorsGoal?: number | null,
    perContactDonationGoal?: number | null,
    progressChartType?: string | null,
    ctaURL?: string | null,
    pageLayout?: string | null,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    customHeaderImageUploaded?: boolean | null,
    customLogoImageUploaded?: boolean | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    ctaButtonText?: string | null,
    givingCircleBaseAmount?: number | null,
    givingCircleIncrements?: Array< number | null > | null,
    givingCircleAllowCustomAmounts?: boolean | null,
    ambassadorSpecificVideoUrlEnabled?: boolean | null,
    ambassadorCanUploadVideoUrl?: boolean | null,
    ambassadorSpecificCtaUrlEnabled?: boolean | null,
    ambassadorCanUploadCtaUrl?: boolean | null,
    crowbarVideoURL?: string | null,
    recruitmentForCampaignID?: string | null,
    classyCampaignID?: string | null,
    classyAutogenerateAmbassadorTeams?: boolean | null,
    classyDonationPageHostURL?: string | null,
    useClassyCtaURL?: boolean | null,
    useClassyFundraiserPage?: boolean | null,
    personalFundraisingCampaignID?: string | null,
    onDemandDiscoveryMeetingEnabled?: boolean | null,
    onDemandDiscoveryMeetingURL?: string | null,
    onDemandDiscoveryMeetingID?: string | null,
    onDemandDiscoveryMeetingInvitationCode?: string | null,
    CampaignConversationFlows?:  {
      __typename: "ModelCampaignConversationFlowConnection",
      items:  Array< {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    defaultConversationFlowID?: string | null,
    defaultConversationFlow?:  {
      __typename: "CampaignConversationFlow",
      id: string,
      fundraisingCampaignID: string,
      name: string,
      description?: string | null,
      default?: boolean | null,
      active: boolean,
      actionMessageDefinitions?:  {
        __typename: "ModelActionMessageDefinitionConnection",
        items:  Array< {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      restricted?: boolean | null,
      useDefaultCta?: boolean | null,
      customCta?: string | null,
      allowAmbassadorSpecificCrowbarVideos?: boolean | null,
      generalCrowbarVideoURI?: string | null,
      deleted?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    useConversationFlows?: boolean | null,
    campaignPageID?: string | null,
    ambassadorPageID?: string | null,
    donationPageID?: string | null,
    discoveryPageID?: string | null,
    projectID?: string | null,
    project?:  {
      __typename: "Project",
      id: string,
      status?: string | null,
      name: string,
      description?: string | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          projectID: string,
          isTopLevelTask?: boolean | null,
          name?: string | null,
          overview?: string | null,
          description?: string | null,
          descriptionRTE?: string | null,
          status?: string | null,
          complete?: boolean | null,
          mediaURI?: Array< string | null > | null,
          createdByID?: string | null,
          actionURL?: string | null,
          dueDate?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subscriptionDonationTiers?:  {
      __typename: "ModelSubscriptionDonationTierConnection",
      items:  Array< {
        __typename: "SubscriptionDonationTier",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        amount?: number | null,
        features?: Array< string | null > | null,
        buttonText?: string | null,
        buttonColor?: string | null,
        default?: boolean | null,
        highlighted?: boolean | null,
        highlightedColor?: string | null,
        promoText?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    useActionCardView?: boolean | null,
    createdAt: string,
    updatedAt: string,
    staffLead?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitmentForCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    personalFundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    campaignPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    ambassadorPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    donationPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    discoveryPage?:  {
      __typename: "CampaignPage",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: CampaignPageType | null,
      fundraisingCampaignID: string,
      campaignDisplayConfigurationID?: string | null,
      pageHtml?: string | null,
      pageJSON?: string | null,
      pageCssJSON?: string | null,
      pageAssetsJSON?: string | null,
      createdAt: string,
      updatedAt: string,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      campaignDisplayConfiguration?:  {
        __typename: "CampaignDisplayConfiguration",
        id: string,
        campaignPageID: string,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        gradientLeftColor?: string | null,
        gradientRightColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    onDemandDiscoveryMeeting?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnCreateCampaignPageSubscription = {
  onCreateCampaignPage?:  {
    __typename: "CampaignPage",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: CampaignPageType | null,
    fundraisingCampaignID: string,
    campaignDisplayConfigurationID?: string | null,
    pageHtml?: string | null,
    pageJSON?: string | null,
    pageCssJSON?: string | null,
    pageAssetsJSON?: string | null,
    createdAt: string,
    updatedAt: string,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    campaignDisplayConfiguration?:  {
      __typename: "CampaignDisplayConfiguration",
      id: string,
      campaignPageID: string,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      gradientLeftColor?: string | null,
      gradientRightColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnUpdateCampaignPageSubscription = {
  onUpdateCampaignPage?:  {
    __typename: "CampaignPage",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: CampaignPageType | null,
    fundraisingCampaignID: string,
    campaignDisplayConfigurationID?: string | null,
    pageHtml?: string | null,
    pageJSON?: string | null,
    pageCssJSON?: string | null,
    pageAssetsJSON?: string | null,
    createdAt: string,
    updatedAt: string,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    campaignDisplayConfiguration?:  {
      __typename: "CampaignDisplayConfiguration",
      id: string,
      campaignPageID: string,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      gradientLeftColor?: string | null,
      gradientRightColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnDeleteCampaignPageSubscription = {
  onDeleteCampaignPage?:  {
    __typename: "CampaignPage",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: CampaignPageType | null,
    fundraisingCampaignID: string,
    campaignDisplayConfigurationID?: string | null,
    pageHtml?: string | null,
    pageJSON?: string | null,
    pageCssJSON?: string | null,
    pageAssetsJSON?: string | null,
    createdAt: string,
    updatedAt: string,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
    campaignDisplayConfiguration?:  {
      __typename: "CampaignDisplayConfiguration",
      id: string,
      campaignPageID: string,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      gradientLeftColor?: string | null,
      gradientRightColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
  } | null,
};

export type OnCreateCampaignDisplayConfigurationSubscription = {
  onCreateCampaignDisplayConfiguration?:  {
    __typename: "CampaignDisplayConfiguration",
    id: string,
    campaignPageID: string,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    gradientLeftColor?: string | null,
    gradientRightColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateCampaignDisplayConfigurationSubscription = {
  onUpdateCampaignDisplayConfiguration?:  {
    __typename: "CampaignDisplayConfiguration",
    id: string,
    campaignPageID: string,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    gradientLeftColor?: string | null,
    gradientRightColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteCampaignDisplayConfigurationSubscription = {
  onDeleteCampaignDisplayConfiguration?:  {
    __typename: "CampaignDisplayConfiguration",
    id: string,
    campaignPageID: string,
    primaryColor?: string | null,
    secondaryColor?: string | null,
    gradientLeftColor?: string | null,
    gradientRightColor?: string | null,
    buttonBackgroundColor?: string | null,
    buttonTextColor?: string | null,
    headerFont?: string | null,
    bodyFont?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateNylasEventSubscription = {
  onCreateNylasEvent?:  {
    __typename: "NylasEvent",
    id: string,
    calendarID?: string | null,
    owner?: string | null,
    fundraisingCampaignDiscoveryCallID?: string | null,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateNylasEventSubscription = {
  onUpdateNylasEvent?:  {
    __typename: "NylasEvent",
    id: string,
    calendarID?: string | null,
    owner?: string | null,
    fundraisingCampaignDiscoveryCallID?: string | null,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteNylasEventSubscription = {
  onDeleteNylasEvent?:  {
    __typename: "NylasEvent",
    id: string,
    calendarID?: string | null,
    owner?: string | null,
    fundraisingCampaignDiscoveryCallID?: string | null,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFundraisingCampaignDiscoveryCallSubscription = {
  onCreateFundraisingCampaignDiscoveryCall?:  {
    __typename: "FundraisingCampaignDiscoveryCall",
    id: string,
    title?: string | null,
    organizationID: string,
    fundraisingCampaignID: string,
    staffProfileID: string,
    startTimestamp: string,
    endTimestamp: string,
    latentHosted: boolean,
    invitationURL?: string | null,
    nylasEventID?: string | null,
    virtualMeetingURL?: string | null,
    createdAt: string,
    updatedAt: string,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateFundraisingCampaignDiscoveryCallSubscription = {
  onUpdateFundraisingCampaignDiscoveryCall?:  {
    __typename: "FundraisingCampaignDiscoveryCall",
    id: string,
    title?: string | null,
    organizationID: string,
    fundraisingCampaignID: string,
    staffProfileID: string,
    startTimestamp: string,
    endTimestamp: string,
    latentHosted: boolean,
    invitationURL?: string | null,
    nylasEventID?: string | null,
    virtualMeetingURL?: string | null,
    createdAt: string,
    updatedAt: string,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteFundraisingCampaignDiscoveryCallSubscription = {
  onDeleteFundraisingCampaignDiscoveryCall?:  {
    __typename: "FundraisingCampaignDiscoveryCall",
    id: string,
    title?: string | null,
    organizationID: string,
    fundraisingCampaignID: string,
    staffProfileID: string,
    startTimestamp: string,
    endTimestamp: string,
    latentHosted: boolean,
    invitationURL?: string | null,
    nylasEventID?: string | null,
    virtualMeetingURL?: string | null,
    createdAt: string,
    updatedAt: string,
    staffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    organization?:  {
      __typename: "Organization",
      id: string,
      name: string,
      shortName?: string | null,
      description?: string | null,
      locationID?: string | null,
      website?: string | null,
      phoneNumber?: string | null,
      stripeConnectedAccountID?: string | null,
      stripeConnectedAccountStatus?: string | null,
      headerImageURI?: string | null,
      ambassadorTermOverrideSingular?: string | null,
      ambassadorTermOverridePlural?: string | null,
      streamJwt?: string | null,
      latentSubscription?: number | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      designation?: string | null,
      detailsID?: string | null,
      details?:  {
        __typename: "OrganizationDetails",
        id: string,
        organizationID: string,
        missionStatement?: string | null,
        serveStatement?: string | null,
        doStatement?: string | null,
        costToDoStatement?: string | null,
        missionArea?: string | null,
        annualBudget?: string | null,
        currentMonthlyRecurringDonors?: string | null,
        averageMonthlyRecurringDonation?: string | null,
        percentageOfBudgetFromIndividualDonors?: string | null,
        numberOfMajorDonors?: string | null,
        averageOneTimeDonation?: string | null,
        percentageOfBudgetFromGrants?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        type: LocationType,
        name: string,
        details?: string | null,
        addressID?: string | null,
        organizationID?: string | null,
        createdAt: string,
        updatedAt: string,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnCreateDiscoveryCallParticipantSubscription = {
  onCreateDiscoveryCallParticipant?:  {
    __typename: "DiscoveryCallParticipant",
    id: string,
    email: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    fundraisingCampaignDiscoveryCallID: string,
    fundraisingCampaignID: string,
    invitationSent?: boolean | null,
    icsString?: string | null,
    status?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    confirmed?: boolean | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingCampaignDiscoveryCall?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateDiscoveryCallParticipantSubscription = {
  onUpdateDiscoveryCallParticipant?:  {
    __typename: "DiscoveryCallParticipant",
    id: string,
    email: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    fundraisingCampaignDiscoveryCallID: string,
    fundraisingCampaignID: string,
    invitationSent?: boolean | null,
    icsString?: string | null,
    status?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    confirmed?: boolean | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingCampaignDiscoveryCall?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteDiscoveryCallParticipantSubscription = {
  onDeleteDiscoveryCallParticipant?:  {
    __typename: "DiscoveryCallParticipant",
    id: string,
    email: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
    authAccountID?: string | null,
    fundraisingProfileID?: string | null,
    fundraisingCampaignDiscoveryCallID: string,
    fundraisingCampaignID: string,
    invitationSent?: boolean | null,
    icsString?: string | null,
    status?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    confirmed?: boolean | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    authAccount?:  {
      __typename: "AuthAccount",
      id: string,
      volunteerProfileID?: string | null,
      volunteerProfile?:  {
        __typename: "VolunteerProfile",
        id: string,
        authAccountID: string,
        email: string,
        firstName?: string | null,
        lastName?: string | null,
        gender?: GenderType | null,
        dateOfBirth?: string | null,
        streetAddress?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: number | null,
        website?: string | null,
        enneagram?: number | null,
        enneagramWing?: number | null,
        myersBriggs?: string | null,
        additionalInformation?: string | null,
        availabilityStringified?: string | null,
        latitude?: number | null,
        longitude?: number | null,
        skills?:  {
          __typename: "ModelVolunteerSkillConnection",
          nextToken?: string | null,
        } | null,
        causes?:  {
          __typename: "ModelVolunteerCauseConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      lastSelectedStaffProfileID?: string | null,
      lastSelectedFundraisingProfileID?: string | null,
      communicationsProfileID?: string | null,
      name?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      primaryEmail?: string | null,
      phoneNumber?: string | null,
      dateOfBirth?: string | null,
      gender?: string | null,
      selfDescribedGender?: string | null,
      addressID?: string | null,
      website?: string | null,
      resumeURI?: string | null,
      bio?: string | null,
      profilePictureURI?: string | null,
      headerVideoURI?: string | null,
      headerImageURI?: string | null,
      headerAssetShown?: string | null,
      flourishAdmin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      cognitoAccounts?:  {
        __typename: "ModelCognitoAccountConnection",
        items:  Array< {
          __typename: "CognitoAccount",
          id: string,
          cognitoID: string,
          authAccountID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      owner?: string | null,
      staffProfile?:  {
        __typename: "ModelStaffProfileConnection",
        items:  Array< {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedStaffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      communicationsProfile?:  {
        __typename: "CommunicationsProfile",
        id: string,
        authAccountID: string,
        streamJwt?: string | null,
        notificationSettingsID?: string | null,
        notificationSettings?:  {
          __typename: "NotificationSettings",
          id: string,
          communicationsProfileID: string,
          allowPushNotifications: boolean,
          allowTextMessages: boolean,
          allowEmail: boolean,
          preference?: NotificationPreference | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      fundraisingProfiles?:  {
        __typename: "ModelFundraisingProfileConnection",
        items:  Array< {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      lastSelectedFundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      address?:  {
        __typename: "Address",
        id: string,
        streetAddress?: string | null,
        unit?: string | null,
        city?: string | null,
        state?: string | null,
        zip?: string | null,
        zipPlusFour?: string | null,
        longitude?: number | null,
        latitude?: number | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    fundraisingCampaignDiscoveryCall?:  {
      __typename: "FundraisingCampaignDiscoveryCall",
      id: string,
      title?: string | null,
      organizationID: string,
      fundraisingCampaignID: string,
      staffProfileID: string,
      startTimestamp: string,
      endTimestamp: string,
      latentHosted: boolean,
      invitationURL?: string | null,
      nylasEventID?: string | null,
      virtualMeetingURL?: string | null,
      createdAt: string,
      updatedAt: string,
      staffProfile?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateFundraisingCampaignAmbassadorSubscription = {
  onCreateFundraisingCampaignAmbassador?:  {
    __typename: "FundraisingCampaignAmbassador",
    id: string,
    status?: FundraisingCampaignAmbassadorStatus | null,
    commitment?: FundraisingCampaignAmbassadorCommitment | null,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    discoveryCallParticipantID?: string | null,
    fundsRaised?: number | null,
    initialTransactionID?: string | null,
    initialTransactionAmount?: number | null,
    ambassadorSpecificCtaUrl?: string | null,
    ambassadorSpecificVideoUrl?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    classyTeamID?: string | null,
    classySupporterID?: string | null,
    classyFundraiserPageID?: string | null,
    notificationsEnabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassadorContacts?:  {
      __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassadorContact",
        id: string,
        deviceContactID: string,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        sentText?: boolean | null,
        sentTextTimestamp?: string | null,
        sentInitialTextReminder?: boolean | null,
        sentInitialTextReminderTimestamp?: string | null,
        sentPhoneCallScript?: boolean | null,
        sentPhoneCallScriptTimestamp?: string | null,
        called?: boolean | null,
        calledTimestamp?: string | null,
        sentFollowUp?: boolean | null,
        sentFollowUpTimestamp?: string | null,
        followUpResponse?: FollowUpResponse | null,
        sentReminder?: boolean | null,
        sentReminderTimestamp?: string | null,
        isDonating?: boolean | null,
        donationAmount?: number | null,
        discoveryCallParticipantID?: string | null,
        transactionID?: string | null,
        isActive?: boolean | null,
        notes?: string | null,
        birthday?: string | null,
        hasTakenAction?: boolean | null,
        hasTakenActionTimestamp?: string | null,
        occupation?: string | null,
        selectedPhoneNumberArrayIndex?: number | null,
        actionMessages?:  {
          __typename: "ModelActionMessageConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateFundraisingCampaignAmbassadorSubscription = {
  onUpdateFundraisingCampaignAmbassador?:  {
    __typename: "FundraisingCampaignAmbassador",
    id: string,
    status?: FundraisingCampaignAmbassadorStatus | null,
    commitment?: FundraisingCampaignAmbassadorCommitment | null,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    discoveryCallParticipantID?: string | null,
    fundsRaised?: number | null,
    initialTransactionID?: string | null,
    initialTransactionAmount?: number | null,
    ambassadorSpecificCtaUrl?: string | null,
    ambassadorSpecificVideoUrl?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    classyTeamID?: string | null,
    classySupporterID?: string | null,
    classyFundraiserPageID?: string | null,
    notificationsEnabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassadorContacts?:  {
      __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassadorContact",
        id: string,
        deviceContactID: string,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        sentText?: boolean | null,
        sentTextTimestamp?: string | null,
        sentInitialTextReminder?: boolean | null,
        sentInitialTextReminderTimestamp?: string | null,
        sentPhoneCallScript?: boolean | null,
        sentPhoneCallScriptTimestamp?: string | null,
        called?: boolean | null,
        calledTimestamp?: string | null,
        sentFollowUp?: boolean | null,
        sentFollowUpTimestamp?: string | null,
        followUpResponse?: FollowUpResponse | null,
        sentReminder?: boolean | null,
        sentReminderTimestamp?: string | null,
        isDonating?: boolean | null,
        donationAmount?: number | null,
        discoveryCallParticipantID?: string | null,
        transactionID?: string | null,
        isActive?: boolean | null,
        notes?: string | null,
        birthday?: string | null,
        hasTakenAction?: boolean | null,
        hasTakenActionTimestamp?: string | null,
        occupation?: string | null,
        selectedPhoneNumberArrayIndex?: number | null,
        actionMessages?:  {
          __typename: "ModelActionMessageConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteFundraisingCampaignAmbassadorSubscription = {
  onDeleteFundraisingCampaignAmbassador?:  {
    __typename: "FundraisingCampaignAmbassador",
    id: string,
    status?: FundraisingCampaignAmbassadorStatus | null,
    commitment?: FundraisingCampaignAmbassadorCommitment | null,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    discoveryCallParticipantID?: string | null,
    fundsRaised?: number | null,
    initialTransactionID?: string | null,
    initialTransactionAmount?: number | null,
    ambassadorSpecificCtaUrl?: string | null,
    ambassadorSpecificVideoUrl?: string | null,
    recruitedByCampaignAmbassadorID?: string | null,
    classyTeamID?: string | null,
    classySupporterID?: string | null,
    classyFundraiserPageID?: string | null,
    notificationsEnabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    fundraisingProfile?:  {
      __typename: "FundraisingProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      classyMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaigns?:  {
        __typename: "ModelFundraisingCampaignAmbassadorConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    owner?: string | null,
    recruitedByCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassadorContacts?:  {
      __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
      items:  Array< {
        __typename: "FundraisingCampaignAmbassadorContact",
        id: string,
        deviceContactID: string,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        sentText?: boolean | null,
        sentTextTimestamp?: string | null,
        sentInitialTextReminder?: boolean | null,
        sentInitialTextReminderTimestamp?: string | null,
        sentPhoneCallScript?: boolean | null,
        sentPhoneCallScriptTimestamp?: string | null,
        called?: boolean | null,
        calledTimestamp?: string | null,
        sentFollowUp?: boolean | null,
        sentFollowUpTimestamp?: string | null,
        followUpResponse?: FollowUpResponse | null,
        sentReminder?: boolean | null,
        sentReminderTimestamp?: string | null,
        isDonating?: boolean | null,
        donationAmount?: number | null,
        discoveryCallParticipantID?: string | null,
        transactionID?: string | null,
        isActive?: boolean | null,
        notes?: string | null,
        birthday?: string | null,
        hasTakenAction?: boolean | null,
        hasTakenActionTimestamp?: string | null,
        occupation?: string | null,
        selectedPhoneNumberArrayIndex?: number | null,
        actionMessages?:  {
          __typename: "ModelActionMessageConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateFundraisingCampaignAmbassadorContactSubscription = {
  onCreateFundraisingCampaignAmbassadorContact?:  {
    __typename: "FundraisingCampaignAmbassadorContact",
    id: string,
    deviceContactID: string,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    sentText?: boolean | null,
    sentTextTimestamp?: string | null,
    sentInitialTextReminder?: boolean | null,
    sentInitialTextReminderTimestamp?: string | null,
    sentPhoneCallScript?: boolean | null,
    sentPhoneCallScriptTimestamp?: string | null,
    called?: boolean | null,
    calledTimestamp?: string | null,
    sentFollowUp?: boolean | null,
    sentFollowUpTimestamp?: string | null,
    followUpResponse?: FollowUpResponse | null,
    sentReminder?: boolean | null,
    sentReminderTimestamp?: string | null,
    isDonating?: boolean | null,
    donationAmount?: number | null,
    discoveryCallParticipantID?: string | null,
    transactionID?: string | null,
    isActive?: boolean | null,
    notes?: string | null,
    birthday?: string | null,
    hasTakenAction?: boolean | null,
    hasTakenActionTimestamp?: string | null,
    occupation?: string | null,
    selectedPhoneNumberArrayIndex?: number | null,
    actionMessages?:  {
      __typename: "ModelActionMessageConnection",
      items:  Array< {
        __typename: "ActionMessage",
        id: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        fundraisingCampaignAmbassadorContactID: string,
        actionMessageDefinitionID: string,
        actionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sent?: boolean | null,
        sentTimestamp?: string | null,
        response?: ActionMessageResponseType | null,
        responseTimestamp?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateFundraisingCampaignAmbassadorContactSubscription = {
  onUpdateFundraisingCampaignAmbassadorContact?:  {
    __typename: "FundraisingCampaignAmbassadorContact",
    id: string,
    deviceContactID: string,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    sentText?: boolean | null,
    sentTextTimestamp?: string | null,
    sentInitialTextReminder?: boolean | null,
    sentInitialTextReminderTimestamp?: string | null,
    sentPhoneCallScript?: boolean | null,
    sentPhoneCallScriptTimestamp?: string | null,
    called?: boolean | null,
    calledTimestamp?: string | null,
    sentFollowUp?: boolean | null,
    sentFollowUpTimestamp?: string | null,
    followUpResponse?: FollowUpResponse | null,
    sentReminder?: boolean | null,
    sentReminderTimestamp?: string | null,
    isDonating?: boolean | null,
    donationAmount?: number | null,
    discoveryCallParticipantID?: string | null,
    transactionID?: string | null,
    isActive?: boolean | null,
    notes?: string | null,
    birthday?: string | null,
    hasTakenAction?: boolean | null,
    hasTakenActionTimestamp?: string | null,
    occupation?: string | null,
    selectedPhoneNumberArrayIndex?: number | null,
    actionMessages?:  {
      __typename: "ModelActionMessageConnection",
      items:  Array< {
        __typename: "ActionMessage",
        id: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        fundraisingCampaignAmbassadorContactID: string,
        actionMessageDefinitionID: string,
        actionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sent?: boolean | null,
        sentTimestamp?: string | null,
        response?: ActionMessageResponseType | null,
        responseTimestamp?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteFundraisingCampaignAmbassadorContactSubscription = {
  onDeleteFundraisingCampaignAmbassadorContact?:  {
    __typename: "FundraisingCampaignAmbassadorContact",
    id: string,
    deviceContactID: string,
    fundraisingProfileID: string,
    fundraisingCampaignID: string,
    fundraisingCampaignAmbassadorID: string,
    sentText?: boolean | null,
    sentTextTimestamp?: string | null,
    sentInitialTextReminder?: boolean | null,
    sentInitialTextReminderTimestamp?: string | null,
    sentPhoneCallScript?: boolean | null,
    sentPhoneCallScriptTimestamp?: string | null,
    called?: boolean | null,
    calledTimestamp?: string | null,
    sentFollowUp?: boolean | null,
    sentFollowUpTimestamp?: string | null,
    followUpResponse?: FollowUpResponse | null,
    sentReminder?: boolean | null,
    sentReminderTimestamp?: string | null,
    isDonating?: boolean | null,
    donationAmount?: number | null,
    discoveryCallParticipantID?: string | null,
    transactionID?: string | null,
    isActive?: boolean | null,
    notes?: string | null,
    birthday?: string | null,
    hasTakenAction?: boolean | null,
    hasTakenActionTimestamp?: string | null,
    occupation?: string | null,
    selectedPhoneNumberArrayIndex?: number | null,
    actionMessages?:  {
      __typename: "ModelActionMessageConnection",
      items:  Array< {
        __typename: "ActionMessage",
        id: string,
        fundraisingCampaignID: string,
        fundraisingCampaignAmbassadorID: string,
        fundraisingCampaignAmbassadorContactID: string,
        actionMessageDefinitionID: string,
        actionMessageDefinition?:  {
          __typename: "ActionMessageDefinition",
          id: string,
          campaignConversationFlowID: string,
          fundraisingCampaignID: string,
          name?: string | null,
          description?: string | null,
          type: ActionMessageType,
          messageTemplate?: string | null,
          onPositiveResponse?: string | null,
          onNegativeResponse?: string | null,
          reminderActionMessageDefinitionID?: string | null,
          reminderDelay?: number | null,
          sendReminderNotification?: boolean | null,
          reminderNotificationID?: string | null,
          beginningNode?: boolean | null,
          parentActionMessageDefinitionID?: string | null,
          viewType?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sent?: boolean | null,
        sentTimestamp?: string | null,
        response?: ActionMessageResponseType | null,
        responseTimestamp?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    discoveryCallParticipant?:  {
      __typename: "DiscoveryCallParticipant",
      id: string,
      email: string,
      phoneNumber: string,
      firstName: string,
      lastName: string,
      authAccountID?: string | null,
      fundraisingProfileID?: string | null,
      fundraisingCampaignDiscoveryCallID: string,
      fundraisingCampaignID: string,
      invitationSent?: boolean | null,
      icsString?: string | null,
      status?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      confirmed?: boolean | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      fundraisingCampaignDiscoveryCall?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaignAmbassador?:  {
      __typename: "FundraisingCampaignAmbassador",
      id: string,
      status?: FundraisingCampaignAmbassadorStatus | null,
      commitment?: FundraisingCampaignAmbassadorCommitment | null,
      fundraisingProfileID: string,
      fundraisingCampaignID: string,
      discoveryCallParticipantID?: string | null,
      fundsRaised?: number | null,
      initialTransactionID?: string | null,
      initialTransactionAmount?: number | null,
      ambassadorSpecificCtaUrl?: string | null,
      ambassadorSpecificVideoUrl?: string | null,
      recruitedByCampaignAmbassadorID?: string | null,
      classyTeamID?: string | null,
      classySupporterID?: string | null,
      classyFundraiserPageID?: string | null,
      notificationsEnabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      fundraisingProfile?:  {
        __typename: "FundraisingProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        classyMemberID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaigns?:  {
          __typename: "ModelFundraisingCampaignAmbassadorConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryCallParticipant?:  {
        __typename: "DiscoveryCallParticipant",
        id: string,
        email: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        authAccountID?: string | null,
        fundraisingProfileID?: string | null,
        fundraisingCampaignDiscoveryCallID: string,
        fundraisingCampaignID: string,
        invitationSent?: boolean | null,
        icsString?: string | null,
        status?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        confirmed?: boolean | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignDiscoveryCall?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitedByCampaignAmbassador?:  {
        __typename: "FundraisingCampaignAmbassador",
        id: string,
        status?: FundraisingCampaignAmbassadorStatus | null,
        commitment?: FundraisingCampaignAmbassadorCommitment | null,
        fundraisingProfileID: string,
        fundraisingCampaignID: string,
        discoveryCallParticipantID?: string | null,
        fundsRaised?: number | null,
        initialTransactionID?: string | null,
        initialTransactionAmount?: number | null,
        ambassadorSpecificCtaUrl?: string | null,
        ambassadorSpecificVideoUrl?: string | null,
        recruitedByCampaignAmbassadorID?: string | null,
        classyTeamID?: string | null,
        classySupporterID?: string | null,
        classyFundraiserPageID?: string | null,
        notificationsEnabled?: boolean | null,
        createdAt: string,
        updatedAt: string,
        fundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryCallParticipant?:  {
          __typename: "DiscoveryCallParticipant",
          id: string,
          email: string,
          phoneNumber: string,
          firstName: string,
          lastName: string,
          authAccountID?: string | null,
          fundraisingProfileID?: string | null,
          fundraisingCampaignDiscoveryCallID: string,
          fundraisingCampaignID: string,
          invitationSent?: boolean | null,
          icsString?: string | null,
          status?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          confirmed?: boolean | null,
          notes?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitedByCampaignAmbassador?:  {
          __typename: "FundraisingCampaignAmbassador",
          id: string,
          status?: FundraisingCampaignAmbassadorStatus | null,
          commitment?: FundraisingCampaignAmbassadorCommitment | null,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          discoveryCallParticipantID?: string | null,
          fundsRaised?: number | null,
          initialTransactionID?: string | null,
          initialTransactionAmount?: number | null,
          ambassadorSpecificCtaUrl?: string | null,
          ambassadorSpecificVideoUrl?: string | null,
          recruitedByCampaignAmbassadorID?: string | null,
          classyTeamID?: string | null,
          classySupporterID?: string | null,
          classyFundraiserPageID?: string | null,
          notificationsEnabled?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaignAmbassadorContacts?:  {
          __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      fundraisingCampaignAmbassadorContacts?:  {
        __typename: "ModelFundraisingCampaignAmbassadorContactConnection",
        items:  Array< {
          __typename: "FundraisingCampaignAmbassadorContact",
          id: string,
          deviceContactID: string,
          fundraisingProfileID: string,
          fundraisingCampaignID: string,
          fundraisingCampaignAmbassadorID: string,
          sentText?: boolean | null,
          sentTextTimestamp?: string | null,
          sentInitialTextReminder?: boolean | null,
          sentInitialTextReminderTimestamp?: string | null,
          sentPhoneCallScript?: boolean | null,
          sentPhoneCallScriptTimestamp?: string | null,
          called?: boolean | null,
          calledTimestamp?: string | null,
          sentFollowUp?: boolean | null,
          sentFollowUpTimestamp?: string | null,
          followUpResponse?: FollowUpResponse | null,
          sentReminder?: boolean | null,
          sentReminderTimestamp?: string | null,
          isDonating?: boolean | null,
          donationAmount?: number | null,
          discoveryCallParticipantID?: string | null,
          transactionID?: string | null,
          isActive?: boolean | null,
          notes?: string | null,
          birthday?: string | null,
          hasTakenAction?: boolean | null,
          hasTakenActionTimestamp?: string | null,
          occupation?: string | null,
          selectedPhoneNumberArrayIndex?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnCreateFundraisingCampaignUpdateSubscription = {
  onCreateFundraisingCampaignUpdate?:  {
    __typename: "FundraisingCampaignUpdate",
    id: string,
    fundraisingCampaignID: string,
    public: boolean,
    message?: string | null,
    assetsUploaded?: number | null,
    updateURL?: string | null,
    createdByStaffProfileID?: string | null,
    live: boolean,
    liveTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    createdByStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateFundraisingCampaignUpdateSubscription = {
  onUpdateFundraisingCampaignUpdate?:  {
    __typename: "FundraisingCampaignUpdate",
    id: string,
    fundraisingCampaignID: string,
    public: boolean,
    message?: string | null,
    assetsUploaded?: number | null,
    updateURL?: string | null,
    createdByStaffProfileID?: string | null,
    live: boolean,
    liveTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    createdByStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteFundraisingCampaignUpdateSubscription = {
  onDeleteFundraisingCampaignUpdate?:  {
    __typename: "FundraisingCampaignUpdate",
    id: string,
    fundraisingCampaignID: string,
    public: boolean,
    message?: string | null,
    assetsUploaded?: number | null,
    updateURL?: string | null,
    createdByStaffProfileID?: string | null,
    live: boolean,
    liveTimestamp?: string | null,
    createdAt: string,
    updatedAt: string,
    createdByStaffProfile?:  {
      __typename: "StaffProfile",
      id: string,
      authAccountID?: string | null,
      organizationID?: string | null,
      role?: StaffProfileRole | null,
      name?: string | null,
      nylasAccountID?: string | null,
      nylasCalendarToken?: string | null,
      nylasPrimaryCalendarID?: string | null,
      createdAt: string,
      updatedAt: string,
      authAccount?:  {
        __typename: "AuthAccount",
        id: string,
        volunteerProfileID?: string | null,
        volunteerProfile?:  {
          __typename: "VolunteerProfile",
          id: string,
          authAccountID: string,
          email: string,
          firstName?: string | null,
          lastName?: string | null,
          gender?: GenderType | null,
          dateOfBirth?: string | null,
          streetAddress?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: number | null,
          website?: string | null,
          enneagram?: number | null,
          enneagramWing?: number | null,
          myersBriggs?: string | null,
          additionalInformation?: string | null,
          availabilityStringified?: string | null,
          latitude?: number | null,
          longitude?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        lastSelectedStaffProfileID?: string | null,
        lastSelectedFundraisingProfileID?: string | null,
        communicationsProfileID?: string | null,
        name?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        primaryEmail?: string | null,
        phoneNumber?: string | null,
        dateOfBirth?: string | null,
        gender?: string | null,
        selfDescribedGender?: string | null,
        addressID?: string | null,
        website?: string | null,
        resumeURI?: string | null,
        bio?: string | null,
        profilePictureURI?: string | null,
        headerVideoURI?: string | null,
        headerImageURI?: string | null,
        headerAssetShown?: string | null,
        flourishAdmin?: boolean | null,
        createdAt: string,
        updatedAt: string,
        cognitoAccounts?:  {
          __typename: "ModelCognitoAccountConnection",
          nextToken?: string | null,
        } | null,
        owner?: string | null,
        staffProfile?:  {
          __typename: "ModelStaffProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedStaffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        communicationsProfile?:  {
          __typename: "CommunicationsProfile",
          id: string,
          authAccountID: string,
          streamJwt?: string | null,
          notificationSettingsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingProfiles?:  {
          __typename: "ModelFundraisingProfileConnection",
          nextToken?: string | null,
        } | null,
        lastSelectedFundraisingProfile?:  {
          __typename: "FundraisingProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          email?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          classyMemberID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          id: string,
          streetAddress?: string | null,
          unit?: string | null,
          city?: string | null,
          state?: string | null,
          zip?: string | null,
          zipPlusFour?: string | null,
          longitude?: number | null,
          latitude?: number | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
    } | null,
    fundraisingCampaign?:  {
      __typename: "FundraisingCampaign",
      id: string,
      type: FundraisingCampaignType,
      organizationID: string,
      staffLeadID?: string | null,
      campaignName?: string | null,
      introVideoURI?: string | null,
      textMessageTemplate?: string | null,
      initialMessageReminderTemplate?: string | null,
      phoneCallScriptTemplate?: string | null,
      followUpMessageTemplate?: string | null,
      followUpYesMessageTemplate?: string | null,
      followUpNoMessageTemplate?: string | null,
      followUpReminderMessageTemplate?: string | null,
      showVideo?: boolean | null,
      showText?: boolean | null,
      showCall?: boolean | null,
      showFollowUp?: boolean | null,
      active?: boolean | null,
      publicVideoID?: string | null,
      publicVideoProvider?: string | null,
      campaignStartDate?: string | null,
      campaignStartTime?: string | null,
      campaignTimeZone?: string | null,
      campaignEndDate?: string | null,
      campaignEndTime?: string | null,
      publicCampaignAbout?: string | null,
      publicCampaignIntro?: string | null,
      campaignGoal?: number | null,
      perAmbassadorGoal?: number | null,
      totalAmbassadorsGoal?: number | null,
      perContactDonationGoal?: number | null,
      progressChartType?: string | null,
      ctaURL?: string | null,
      pageLayout?: string | null,
      primaryColor?: string | null,
      secondaryColor?: string | null,
      buttonBackgroundColor?: string | null,
      buttonTextColor?: string | null,
      customHeaderImageUploaded?: boolean | null,
      customLogoImageUploaded?: boolean | null,
      headerFont?: string | null,
      bodyFont?: string | null,
      ctaButtonText?: string | null,
      givingCircleBaseAmount?: number | null,
      givingCircleIncrements?: Array< number | null > | null,
      givingCircleAllowCustomAmounts?: boolean | null,
      ambassadorSpecificVideoUrlEnabled?: boolean | null,
      ambassadorCanUploadVideoUrl?: boolean | null,
      ambassadorSpecificCtaUrlEnabled?: boolean | null,
      ambassadorCanUploadCtaUrl?: boolean | null,
      crowbarVideoURL?: string | null,
      recruitmentForCampaignID?: string | null,
      classyCampaignID?: string | null,
      classyAutogenerateAmbassadorTeams?: boolean | null,
      classyDonationPageHostURL?: string | null,
      useClassyCtaURL?: boolean | null,
      useClassyFundraiserPage?: boolean | null,
      personalFundraisingCampaignID?: string | null,
      onDemandDiscoveryMeetingEnabled?: boolean | null,
      onDemandDiscoveryMeetingURL?: string | null,
      onDemandDiscoveryMeetingID?: string | null,
      onDemandDiscoveryMeetingInvitationCode?: string | null,
      CampaignConversationFlows?:  {
        __typename: "ModelCampaignConversationFlowConnection",
        items:  Array< {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      defaultConversationFlowID?: string | null,
      defaultConversationFlow?:  {
        __typename: "CampaignConversationFlow",
        id: string,
        fundraisingCampaignID: string,
        name: string,
        description?: string | null,
        default?: boolean | null,
        active: boolean,
        actionMessageDefinitions?:  {
          __typename: "ModelActionMessageDefinitionConnection",
          nextToken?: string | null,
        } | null,
        restricted?: boolean | null,
        useDefaultCta?: boolean | null,
        customCta?: string | null,
        allowAmbassadorSpecificCrowbarVideos?: boolean | null,
        generalCrowbarVideoURI?: string | null,
        deleted?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      useConversationFlows?: boolean | null,
      campaignPageID?: string | null,
      ambassadorPageID?: string | null,
      donationPageID?: string | null,
      discoveryPageID?: string | null,
      projectID?: string | null,
      project?:  {
        __typename: "Project",
        id: string,
        status?: string | null,
        name: string,
        description?: string | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subscriptionDonationTiers?:  {
        __typename: "ModelSubscriptionDonationTierConnection",
        items:  Array< {
          __typename: "SubscriptionDonationTier",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          amount?: number | null,
          features?: Array< string | null > | null,
          buttonText?: string | null,
          buttonColor?: string | null,
          default?: boolean | null,
          highlighted?: boolean | null,
          highlightedColor?: string | null,
          promoText?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      useActionCardView?: boolean | null,
      createdAt: string,
      updatedAt: string,
      staffLead?:  {
        __typename: "StaffProfile",
        id: string,
        authAccountID?: string | null,
        organizationID?: string | null,
        role?: StaffProfileRole | null,
        name?: string | null,
        nylasAccountID?: string | null,
        nylasCalendarToken?: string | null,
        nylasPrimaryCalendarID?: string | null,
        createdAt: string,
        updatedAt: string,
        authAccount?:  {
          __typename: "AuthAccount",
          id: string,
          volunteerProfileID?: string | null,
          lastSelectedStaffProfileID?: string | null,
          lastSelectedFundraisingProfileID?: string | null,
          communicationsProfileID?: string | null,
          name?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          primaryEmail?: string | null,
          phoneNumber?: string | null,
          dateOfBirth?: string | null,
          gender?: string | null,
          selfDescribedGender?: string | null,
          addressID?: string | null,
          website?: string | null,
          resumeURI?: string | null,
          bio?: string | null,
          profilePictureURI?: string | null,
          headerVideoURI?: string | null,
          headerImageURI?: string | null,
          headerAssetShown?: string | null,
          flourishAdmin?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      organization?:  {
        __typename: "Organization",
        id: string,
        name: string,
        shortName?: string | null,
        description?: string | null,
        locationID?: string | null,
        website?: string | null,
        phoneNumber?: string | null,
        stripeConnectedAccountID?: string | null,
        stripeConnectedAccountStatus?: string | null,
        headerImageURI?: string | null,
        ambassadorTermOverrideSingular?: string | null,
        ambassadorTermOverridePlural?: string | null,
        streamJwt?: string | null,
        latentSubscription?: number | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        designation?: string | null,
        detailsID?: string | null,
        details?:  {
          __typename: "OrganizationDetails",
          id: string,
          organizationID: string,
          missionStatement?: string | null,
          serveStatement?: string | null,
          doStatement?: string | null,
          costToDoStatement?: string | null,
          missionArea?: string | null,
          annualBudget?: string | null,
          currentMonthlyRecurringDonors?: string | null,
          averageMonthlyRecurringDonation?: string | null,
          percentageOfBudgetFromIndividualDonors?: string | null,
          numberOfMajorDonors?: string | null,
          averageOneTimeDonation?: string | null,
          percentageOfBudgetFromGrants?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          type: LocationType,
          name: string,
          details?: string | null,
          addressID?: string | null,
          organizationID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      owner?: string | null,
      recruitmentForCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      personalFundraisingCampaign?:  {
        __typename: "FundraisingCampaign",
        id: string,
        type: FundraisingCampaignType,
        organizationID: string,
        staffLeadID?: string | null,
        campaignName?: string | null,
        introVideoURI?: string | null,
        textMessageTemplate?: string | null,
        initialMessageReminderTemplate?: string | null,
        phoneCallScriptTemplate?: string | null,
        followUpMessageTemplate?: string | null,
        followUpYesMessageTemplate?: string | null,
        followUpNoMessageTemplate?: string | null,
        followUpReminderMessageTemplate?: string | null,
        showVideo?: boolean | null,
        showText?: boolean | null,
        showCall?: boolean | null,
        showFollowUp?: boolean | null,
        active?: boolean | null,
        publicVideoID?: string | null,
        publicVideoProvider?: string | null,
        campaignStartDate?: string | null,
        campaignStartTime?: string | null,
        campaignTimeZone?: string | null,
        campaignEndDate?: string | null,
        campaignEndTime?: string | null,
        publicCampaignAbout?: string | null,
        publicCampaignIntro?: string | null,
        campaignGoal?: number | null,
        perAmbassadorGoal?: number | null,
        totalAmbassadorsGoal?: number | null,
        perContactDonationGoal?: number | null,
        progressChartType?: string | null,
        ctaURL?: string | null,
        pageLayout?: string | null,
        primaryColor?: string | null,
        secondaryColor?: string | null,
        buttonBackgroundColor?: string | null,
        buttonTextColor?: string | null,
        customHeaderImageUploaded?: boolean | null,
        customLogoImageUploaded?: boolean | null,
        headerFont?: string | null,
        bodyFont?: string | null,
        ctaButtonText?: string | null,
        givingCircleBaseAmount?: number | null,
        givingCircleIncrements?: Array< number | null > | null,
        givingCircleAllowCustomAmounts?: boolean | null,
        ambassadorSpecificVideoUrlEnabled?: boolean | null,
        ambassadorCanUploadVideoUrl?: boolean | null,
        ambassadorSpecificCtaUrlEnabled?: boolean | null,
        ambassadorCanUploadCtaUrl?: boolean | null,
        crowbarVideoURL?: string | null,
        recruitmentForCampaignID?: string | null,
        classyCampaignID?: string | null,
        classyAutogenerateAmbassadorTeams?: boolean | null,
        classyDonationPageHostURL?: string | null,
        useClassyCtaURL?: boolean | null,
        useClassyFundraiserPage?: boolean | null,
        personalFundraisingCampaignID?: string | null,
        onDemandDiscoveryMeetingEnabled?: boolean | null,
        onDemandDiscoveryMeetingURL?: string | null,
        onDemandDiscoveryMeetingID?: string | null,
        onDemandDiscoveryMeetingInvitationCode?: string | null,
        CampaignConversationFlows?:  {
          __typename: "ModelCampaignConversationFlowConnection",
          nextToken?: string | null,
        } | null,
        defaultConversationFlowID?: string | null,
        defaultConversationFlow?:  {
          __typename: "CampaignConversationFlow",
          id: string,
          fundraisingCampaignID: string,
          name: string,
          description?: string | null,
          default?: boolean | null,
          active: boolean,
          restricted?: boolean | null,
          useDefaultCta?: boolean | null,
          customCta?: string | null,
          allowAmbassadorSpecificCrowbarVideos?: boolean | null,
          generalCrowbarVideoURI?: string | null,
          deleted?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        useConversationFlows?: boolean | null,
        campaignPageID?: string | null,
        ambassadorPageID?: string | null,
        donationPageID?: string | null,
        discoveryPageID?: string | null,
        projectID?: string | null,
        project?:  {
          __typename: "Project",
          id: string,
          status?: string | null,
          name: string,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subscriptionDonationTiers?:  {
          __typename: "ModelSubscriptionDonationTierConnection",
          nextToken?: string | null,
        } | null,
        useActionCardView?: boolean | null,
        createdAt: string,
        updatedAt: string,
        staffLead?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        recruitmentForCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        personalFundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        campaignPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        ambassadorPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        donationPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        discoveryPage?:  {
          __typename: "CampaignPage",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: CampaignPageType | null,
          fundraisingCampaignID: string,
          campaignDisplayConfigurationID?: string | null,
          pageHtml?: string | null,
          pageJSON?: string | null,
          pageCssJSON?: string | null,
          pageAssetsJSON?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        onDemandDiscoveryMeeting?:  {
          __typename: "FundraisingCampaignDiscoveryCall",
          id: string,
          title?: string | null,
          organizationID: string,
          fundraisingCampaignID: string,
          staffProfileID: string,
          startTimestamp: string,
          endTimestamp: string,
          latentHosted: boolean,
          invitationURL?: string | null,
          nylasEventID?: string | null,
          virtualMeetingURL?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      campaignPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      ambassadorPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      donationPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      discoveryPage?:  {
        __typename: "CampaignPage",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: CampaignPageType | null,
        fundraisingCampaignID: string,
        campaignDisplayConfigurationID?: string | null,
        pageHtml?: string | null,
        pageJSON?: string | null,
        pageCssJSON?: string | null,
        pageAssetsJSON?: string | null,
        createdAt: string,
        updatedAt: string,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
        campaignDisplayConfiguration?:  {
          __typename: "CampaignDisplayConfiguration",
          id: string,
          campaignPageID: string,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          gradientLeftColor?: string | null,
          gradientRightColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
      } | null,
      onDemandDiscoveryMeeting?:  {
        __typename: "FundraisingCampaignDiscoveryCall",
        id: string,
        title?: string | null,
        organizationID: string,
        fundraisingCampaignID: string,
        staffProfileID: string,
        startTimestamp: string,
        endTimestamp: string,
        latentHosted: boolean,
        invitationURL?: string | null,
        nylasEventID?: string | null,
        virtualMeetingURL?: string | null,
        createdAt: string,
        updatedAt: string,
        staffProfile?:  {
          __typename: "StaffProfile",
          id: string,
          authAccountID?: string | null,
          organizationID?: string | null,
          role?: StaffProfileRole | null,
          name?: string | null,
          nylasAccountID?: string | null,
          nylasCalendarToken?: string | null,
          nylasPrimaryCalendarID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        organization?:  {
          __typename: "Organization",
          id: string,
          name: string,
          shortName?: string | null,
          description?: string | null,
          locationID?: string | null,
          website?: string | null,
          phoneNumber?: string | null,
          stripeConnectedAccountID?: string | null,
          stripeConnectedAccountStatus?: string | null,
          headerImageURI?: string | null,
          ambassadorTermOverrideSingular?: string | null,
          ambassadorTermOverridePlural?: string | null,
          streamJwt?: string | null,
          latentSubscription?: number | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          designation?: string | null,
          detailsID?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        fundraisingCampaign?:  {
          __typename: "FundraisingCampaign",
          id: string,
          type: FundraisingCampaignType,
          organizationID: string,
          staffLeadID?: string | null,
          campaignName?: string | null,
          introVideoURI?: string | null,
          textMessageTemplate?: string | null,
          initialMessageReminderTemplate?: string | null,
          phoneCallScriptTemplate?: string | null,
          followUpMessageTemplate?: string | null,
          followUpYesMessageTemplate?: string | null,
          followUpNoMessageTemplate?: string | null,
          followUpReminderMessageTemplate?: string | null,
          showVideo?: boolean | null,
          showText?: boolean | null,
          showCall?: boolean | null,
          showFollowUp?: boolean | null,
          active?: boolean | null,
          publicVideoID?: string | null,
          publicVideoProvider?: string | null,
          campaignStartDate?: string | null,
          campaignStartTime?: string | null,
          campaignTimeZone?: string | null,
          campaignEndDate?: string | null,
          campaignEndTime?: string | null,
          publicCampaignAbout?: string | null,
          publicCampaignIntro?: string | null,
          campaignGoal?: number | null,
          perAmbassadorGoal?: number | null,
          totalAmbassadorsGoal?: number | null,
          perContactDonationGoal?: number | null,
          progressChartType?: string | null,
          ctaURL?: string | null,
          pageLayout?: string | null,
          primaryColor?: string | null,
          secondaryColor?: string | null,
          buttonBackgroundColor?: string | null,
          buttonTextColor?: string | null,
          customHeaderImageUploaded?: boolean | null,
          customLogoImageUploaded?: boolean | null,
          headerFont?: string | null,
          bodyFont?: string | null,
          ctaButtonText?: string | null,
          givingCircleBaseAmount?: number | null,
          givingCircleIncrements?: Array< number | null > | null,
          givingCircleAllowCustomAmounts?: boolean | null,
          ambassadorSpecificVideoUrlEnabled?: boolean | null,
          ambassadorCanUploadVideoUrl?: boolean | null,
          ambassadorSpecificCtaUrlEnabled?: boolean | null,
          ambassadorCanUploadCtaUrl?: boolean | null,
          crowbarVideoURL?: string | null,
          recruitmentForCampaignID?: string | null,
          classyCampaignID?: string | null,
          classyAutogenerateAmbassadorTeams?: boolean | null,
          classyDonationPageHostURL?: string | null,
          useClassyCtaURL?: boolean | null,
          useClassyFundraiserPage?: boolean | null,
          personalFundraisingCampaignID?: string | null,
          onDemandDiscoveryMeetingEnabled?: boolean | null,
          onDemandDiscoveryMeetingURL?: string | null,
          onDemandDiscoveryMeetingID?: string | null,
          onDemandDiscoveryMeetingInvitationCode?: string | null,
          defaultConversationFlowID?: string | null,
          useConversationFlows?: boolean | null,
          campaignPageID?: string | null,
          ambassadorPageID?: string | null,
          donationPageID?: string | null,
          discoveryPageID?: string | null,
          projectID?: string | null,
          useActionCardView?: boolean | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        owner?: string | null,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};
